export default {
  "13fe8d8c74cb94357d8e105686778dfe": "[ru]搜索条件",
  "33ac341a8748c430f721aa43dcf9f3b6": "[ru]物料大类",
  "708c9d6d2ad108ab2c560530810deae9": "[ru]请选择",
  "4e8365b7b7ef302d07d644229cb3055c": "[ru]物料组名称",
  "96cd48d7a10c1919a4d6bb6fb4892d49": "[ru]物料组编码",
  "31342bc2f6f90b324f6a4aaee4208c12": "[ru]自检类别",
  "bee912d79eefb7335988c4997aa9138d": "[ru]查询",
  "4b9c3271dc2f299dc3aeffb369187513": "[ru]重置",
  "98b24a8d085db4b7094f6f790542a408": "[ru]现场跳闸线设置",
  "66ab5e9f24c8f46012a25c89919fb191": "[ru]新增",
  "8347a927c09a4ec2fe473b0a93f667d0": "[ru]修改",
  "2f4aaddde33c9b93c36fd2503f3d122b": "[ru]删除",
  "55405ea6ff6fd823ffab7e6b10ddfa95": "[ru]导出",
  "8fd727180609a8164afad4b5eecc5544": "[ru]请点击“查询”数据",
  "50342d145a3523208973de01cf75bdb1": "[ru]请选择物料大类",
  "9aa8f711298fef621b1c74335c2a8670": "[ru]物料组",
  "712a68cb52bd8ff9eb3c0791ab58a67a": "[ru]请选择物料组",
  "b1b8dc681d9bfdc84571fc1658e280c2": "[ru]请选择自检类别",
  "f92ca5bc5af0491c68418cba5dc5cf81": "[ru]请选择bu",
  "027e15637bd10e0e7c1ae9c3432b95d1": "[ru]产线/工厂",
  "20712a58d6ebedd3922a62f849df36a3": "[ru]请选择BU之后选择工厂/产线",
  "cb1d298c5dabdecc8e64a2bde61c8791": "[ru]ppm底线",
  "77f406ad856a57afa934e53841ab2065": "[ru]请选择物料组名称",
  "6fe38ba19bf6ac047b579f509f738165": "[ru]请选择BU",
  "b15d91274e9fc68608c609999e0413fa": "[ru]关闭",
  "63a556b12ef62297e2bb04376c30c5cd": "[ru]请输入ppm底线",
  "e3b69dddd11724030f4467cfec827b33": "[ru]请输入正确ppm底线",
  "48343b3863b16e5b7c1f07e1824b31f0": "[ru]请选择产线工厂",
  "69be671786f62ce872f87de1ab761746": "[ru]修改成功",
  "a5bfd70d4ab989bd6abd3ac7a9d11743": "[ru]新增成功",
  "3961247a969c40c139238cff7d4a49c4": "[ru]请选择一条数据",
  "0007d170de017dafc266aa03926d7f00": "[ru]删除成功",
  "748c802d8fe36ada78520df791295747": "[ru]导出数量大于5000条",
  "f148292ae0c683ca6fe4246350d309f6": "[ru]信息提示",
  "38cf16f2204ffab8a6e0187070558721": "[ru]确定",
  "c35ac8e582c19741f77ac13fff054d71": "[ru]PPM底线设置报表.xls",
  "9e5ffa068ed435ced73dc9bf5dd8e09c": "[ru]基本信息",
  "97cadad0bbee7252a5db6351a8d8d5ca": "[ru]不良描述",
  "d2d4e3f71b25aa5c60478e71048c4f77": "[ru]../../assets/img/占位图.png",
  "52409da520650eaf339e1fe65f74fdd0": "[ru]联系人",
  "f390f22b58a00537509452d8c5910765": "[ru]EMR工程师：",
  "281e8c354f2d1a4ef739b1927ef322ca": "[ru]联系方式：",
  "da4495b1b41d6830f5e0c45404d8ab53": "[ru]邮箱：",
  "1949b53a6a6d4d23ecd0d09c274e72bf": "[ru]关于工单",
  "66ffb1aebc82f23f4f99ea4f1d75fa14": "[ru]的市场不良交互",
  "5b9e0c8033a9d66e6891b4e101f39da9": "[ru]申请SQE介入",
  "3980c191fe0abd19198b2d00ff9ae3d9": "[ru]SQE已介入",
  "4c785ff0ad36057ff6a7ce6b2f11ed35": "[ru]添加附件",
  "1535fcfa4cb8e4d467127154977e9788": "[ru]发送",
  "aa47962f095bf62c8e48cfa7c6d6299f": "[ru]SQE介入",
  "a5a1ea58c0258ca6817752507fd9fac0": "[ru]供应商信息",
  "a790803c161d5f63232969c039e9698c": "[ru]供应商代码:",
  "bef1852b76c31a26cf3b4e807d2adca2": "[ru]供应商名称:",
  "5a5546124377135a8b6c4b973919d53f": "[ru]物料信息",
  "61ce95c60d8cc94e16316eb02a6f402f": "[ru]物料大类:",
  "d3d82d46881ddede6be88387fa1ecea0": "[ru]物料名称:",
  "75f130f36f2e4ed3ce2cb997153e23b6": "[ru]人员信息",
  "935cb645fe49f6e9a9a7aa3550c9e738": "[ru]产业线:",
  "17c7d0d2a11b8b264bd8ed20adedfad0": "[ru]SQE经理:",
  "625fb26b4b3340f7872b411f401e754c": "[ru]取消",
  "15be0cbf984ead7733f52bbd01db11a2": "[ru]供应商代码：",
  "eb0e130294c8c3b3fa2cfecc849fec49": "[ru]供应商名称：",
  "7c7fefb36371a5a9ab5338c98790c67c": "[ru]专用号：",
  "7a0ae7305076f170b4a920ef5f3f04f9": "[ru]物料名称：",
  "a4c58ba9f0b5f2779e2c9e336ef6649b": "[ru]互联工厂：",
  "7c07548b53cc2164986960fee2fca0ea": "[ru]工单：",
  "7a24d3da963e820c88fdea1e7f59a0d7": "[ru]机编：",
  "045cd62da33219d06342b427c6d52b6a": "[ru]型号：",
  "9e0e267f7533ebceb1528b181c2e3371": "[ru]EMR责任位：",
  "bf4dacee50ea1dafefed69bf1a87f82b": "[ru]工贸鉴定时间：",
  "23868409356185a7c507feee52d99d00": "[ru]故障原因：",
  "4bfff9749230bda13b2b27ad96356d60": "[ru]连接没有开启.",
  "5dce10c181b156c9eedf298358a7c39f": "[ru]查询产线信息出错",
  "3dca46482e8752bb1ef932640a0d65a4": "[ru]市场不良",
  "94b52b3bce58e006dccabaa867b769d7": "[ru]申请介入成功",
  "93a0679ba98c020b4b2be75bf7197384": "[ru]申请介入失败",
  "9c4c6cb27ed020514b896f4b74195ecd": "[ru]请选择SQE经理",
  "78908d7f0b2f36f7f34326ff74343371": "[ru]] ：",
  "78e83b4255be4744633ecc2b0b50c3e1": "[ru]2：",
  "057ec01b21cf45f9e4b495558e9a4c42": "[ru]请查看你的json格式是否正确，图片并没有上传",
  "e9230aba2d19d5474c47355f69b85ec2": "[ru]1：",
  "3e29ba55ff2022bdc1c0c1f548e53db2": "[ru]请查看你的json格式是否正确，图片上传了，但是并没有回显",
  "f4a8f4bdc587a4aa30bf8532c3b10a14": "[ru]你的浏览器不支持 WebSocket！",
  "465260fe80b0c3338d06194bb7a94446": "[ru]年",
  "e42b99d59954ce6437e66f416850425a": "[ru]月",
  "254f6b8686babf31e48ebb1894981062": "[ru]产业线",
  "03490f3868798323211aa633194df2c1": "[ru]工厂小微",
  "1b7ecd2bdbd8a1a112dead57724f06df": "[ru]供应商代码",
  "2324a40ba7ca6de7c411b8d8aefd6564": "[ru]请输入至少两位供应商代码",
  "9190cc22c9ba377113bc54ac51013a0b": "[ru]供应商名称",
  "3097a85ddf1068b704c745c7b899ba7b": "[ru]注：仅查询600条数据，如无所需结果，请输入更精确的供应商代码",
  "f1edca9f040d256cee01ef89fa5499f0": "[ru]专用号",
  "3bdbd9312d3a6f04ebdb6b99ac0f2f4a": "[ru]请输入至少四位专用号",
  "56ca9a2de6d54b00fb98ab39cce17089": "[ru]物料号",
  "901fcadda8a5683e7a83a0c811ff4382": "[ru]物料名称",
  "a1fc8066cb705fef975d7db6b39eaa79": "[ru]注：仅查询600条数据，如无所需结果，请输入更精确的物料号",
  "aae11e21d2ef24d030976e023bc44ff5": "[ru]物料描述",
  "62e4158f7e1dd6d9cf5e808a73cb2dc3": "[ru]鉴定单号",
  "bde24601a1b2a403bb268d921992e9e7": "[ru]EMR状态",
  "fd6e80f1e0199d6ecc3ee81ae04aa9ef": "[ru]正常",
  "1abbb1748ef98f00486f7801a290fdb4": "[ru]无效",
  "ee8954b5b472d330658c8f61a8cd704b": "[ru]退换单号",
  "a462946a6f023fde059c950e41890ca7": "[ru]机编",
  "dd4a22dc1c307bf4661e314d1ad1f9d2": "[ru]产品型号",
  "b5ab7b04083cfb6d853b2f55db3212b2": "[ru]工贸",
  "2b309366daec59d9120490b2c9c89004": "[ru]网点",
  "c7ba1555c73fe8f667e02840a7d59102": "[ru]故障码",
  "6ff83162e3574b91a1353d6cab764238": "[ru]鉴定时间",
  "a3e3b88377c8a2f34e0f9ef6e67dbe62": "[ru]开始",
  "12f1d7ef38af6326c94fd11688f5b453": "[ru]结束",
  "7a4db87276994134bdc568c9f07449e6": "[ru]市场不良明细",
  "faaadc447b1c2b1adc920d9c9aedcc25": "[ru]序号",
  "8be579a49ad89adf491bcd7c42eca35c": "[ru]产品大类",
  "8779e39b05444a95e96e6940f68cc309": "[ru]工厂代码",
  "3da7274acb14c755227b3d2ba30f2d22": "[ru]鉴定单机编",
  "b8341333fef9e29cf514fc089e51aaee": "[ru]报修信息",
  "e40920ea00f9c6c604f40950f0a20137": "[ru]售后初判",
  "ef507d473312ee2dbe8c0823008ea6cc": "[ru]生产日期",
  "ce4fc84a8457f3349cf781f78516a7e6": "[ru]购机日期",
  "b8bec83c0d27d171ec75f6db6456a9b0": "[ru]反映时间",
  "2268a3f18807e44ef1419d3b5459df4c": "[ru]初鉴时间",
  "2c71b096c45341598c16759cb1c5610c": "[ru]设计小微",
  "88d6bee666e6a405b13f33654af18632": "[ru]接收时间",
  "204a535217a6d097ce6c484dcb5684d3": "[ru]入区时间",
  "c501aa4030f1bf4cd1bccf35819568dc": "[ru]故障描述",
  "1db51fd2fabdd05e2c729476fe55b64a": "[ru]责任环节",
  "23ac1e5100bb5350cafc0fe20451b602": "[ru]EMR鉴定单状态",
  "826d2a3c7b7c0f43ac5ca8dbf29298c1": "[ru]认责单状态",
  "c3c2bc951c4df51325738e122ba4717f": "[ru]保修类型",
  "86f5956deab7f8886be9e180e3ba606b": "[ru]是否本年",
  "3b66f6242ce829592e3e1bcd3a29dbc1": "[ru]用户使用故障周期",
  "ff306abe2725818928c8d56a5c5dee99": "[ru]整机索赔额(元)",
  "201d394151ef4b1eb1ff2792a99aea90": "[ru]一单一判",
  "89f7cc77524fbadaa10926f02ffb6de6": "[ru]市场验证照片",
  "3ff72cd6ae0c399da695be24e2fb59ab": "[ru]EMR鉴定照片",
  "5f411223ca5a01a5adf20fe735a433d0": "[ru]返回",
  "52dc3a1c87479531fb9e09d933025f34": "[ru]产品线查询失败",
  "acd5cb847a4aff235c9a01ddeb6f9770": "[ru]失败",
  "c54045d692bedb6365e073ce45b4e57e": "[ru]导出失败，导出数量大于200000条",
  "f59ec2b6c282f2c37663f524c2a318c3": "[ru]导出失败，导出数量小于1条",
  "be8f6eb1dd8bdb0a8e3ab76457d3263f": "[ru]市场不良明细导出中...",
  "ad41f526b0670a747ed5827e062c1ad9": "[ru]数据导出中，请到下载中心查看",
  "937902e1941d0feb2cd108ed4aa79d21": "[ru]下载中心",
  "9334db37f0aeafe49981c11640d4a991": "[ru]原纸定量委托计划",
  "7103a3f412b21c43cea6b1009af7b5f5": "[ru]检验状态",
  "4a35e03b857bf3cde759bb1390f1bbac": "[ru]待分工",
  "ae33b1183f3cc944bec162646b9b1e35": "[ru]待检验",
  "ee65aad469018b3ce7961de3854c5e02": "[ru]检验中",
  "fad5222ca0acfaee54f06458188d916a": "[ru]已完成",
  "f013ea9dcba3f5ca1278aa850931fec8": "[ru]加载中",
  "21efd88b67a39834582ad99aabb9dc60": "[ru]暂无数据",
  "4bf08f10337ef4f4fafe38fd6be8876b": "[ru]生成日期从",
  "4ff1e74e43a3586339251494117185ad": "[ru]日期",
  "d716f1e8a1f1ba9fb379749856f8551b": "[ru]到",
  "d2ee7282cedddfa2811959c5556e921f": "[ru]检测结论",
  "86f720320b77bb62311f0a4811db04fe": "[ru]合格",
  "6e5a122013138ad189517d5d0a1c0891": "[ru]不合格",
  "904f2117c958823c4e1fdcec9c75c406": "[ru]完成日期从",
  "607e7a4f377fa66b0b28ce318aab841f": "[ru]查看",
  "41442c4ac19a6e6e0a82605109bd8ec7": "[ru]分工",
  "ccc9d4b32429e48ca0819ac67f398c88": "[ru]检验",
  "6643ded0025cc29815fe4bd5ff7ae566": "[ru]检验方式",
  "d30aa057520512ea6b2dda9febf2996a": "[ru]委托实验",
  "9bf9d93c35fc19e3dc67fdabfb1cfc77": "[ru]工厂自测",
  "88fd9d3c556b689b9d38ef3f39f33319": "[ru]原纸定量计划单",
  "f716f07b0ba5bb21129ca9b3003ce458": "[ru]耐破/边压/戳穿委托计划单",
  "51767c1f61b8c0c80ed4f51680cda73b": "[ru]批次号",
  "cbda74c5c620f8b610fce150646e282b": "[ru]送货数量",
  "f2996845b6bf0a07fe26f74f35e42ebe": "[ru]单位",
  "09d97ca0ea5a6cc8915f74026596081a": "[ru]送货日期",
  "3e67b3dcfe3cd8fb94ee06a461b4429b": "[ru]工厂",
  "e922c9906137e38c2daefc7e38057bc6": "[ru]外检经理",
  "7769321b9c543a0267ae4d19d82c4654": "[ru]计划生成日期",
  "ec4119505191dc631568c7660ac25e38": "[ru]检验完成日期",
  "589a2a3b081eac7000558be56ae3a9a6": "[ru]试验报告",
  "5cf1077bb04916280c867787a0de0e00": "[ru]输入工号进行模糊查询",
  "8399b1342987c3410b3820d05e0cb9ea": "[ru]暂无外检",
  "939d5345ad4345dbaabe14798f6ac0f1": "[ru]提交",
  "695d5ee65b169bea56327949b3cd440c": "[ru]请选择需要查看的订单，只能选择一条",
  "c37d8bcafe92d1fac70ca6cb9e8b78fe": "[ru]请选择需要查看的订单",
  "2dc5368dff3ed518d1a70da8a4a26404": "[ru]请选择需要分工的订单，只能选择一条",
  "70f43e758af13a3bbf94057be818b468": "[ru]请选择待分工数据分工，只有待分工数据才可分工",
  "e691957d93d246421c065fb3eafcca06": "[ru]权限不足或没有待办流程",
  "1424765ad440bb6e2525df2fbfab4d20": "[ru]分工成功",
  "b5b710521e99f8a41bbb63b572572087": "[ru]请选择需要检验的订单",
  "f4ef89c8ca23787735998c9f9437d4f3": "[ru]请选择待检验的订单，只能选择一条",
  "527c5ef0c70d6c8915f85542f0d4e40c": "[ru]请选择待检验数据",
  "e1b198bfc661460100813e7e1121091c": "[ru]原纸定量委托计划表.xls",
  "ffe23427b3e7ab6f837da6510b078fd4": "[ru]原纸定量测试委托试验单",
  "0d9b6df0bdffd3766a5895164c72de8a": "[ru]实验委托书",
  "33418712f3f79338496222d07a678655": "[ru]试品名称",
  "53aed4419dd01dfbb706dd08a81683af": "[ru]试验性质",
  "4843646bf534af284667aa42bf5aed44": "[ru]监督检验",
  "5735d0b0156a7ec183021bf7d86b0a45": "[ru]试验下达时间",
  "8237abae562bfe79e9329a223e53d61f": "[ru]申请完成时间",
  "bedab333685296bea03a2830c0f43142": "[ru]试品数量",
  "2ca5173896217295f210705ab385c235": "[ru]送货批次",
  "11ac07811a8bd1798064f89fd2328723": "[ru]被试品提供者",
  "9250dbc97c6c86fdaec5d45df53d9c91": "[ru]委托试验单位领导(签字)",
  "1f73e72960b0286b70d7226116671454": "[ru]委托单位",
  "4c4ed23045c9ae8de304b3c398ce7619": "[ru]检验标准",
  "ae6c2f49100d90869604ee4af29e7f0d": "[ru]关联专用号",
  "c7e2ac1761c28a3725a57f383b6b58ab": "[ru]试验项目",
  "70bc04dc1461e4545f58a4ecff15736a": "[ru]原纸定量",
  "d224b244fec5f9929b351781a30c6abd": "[ru]无试验性质能力项",
  "0fc9f0ef7cd1a59627f0e8baedfc448f": "[ru]要求试验单位",
  "3f206473f0425a273a84834a89fb9ff2": "[ru]附加要求",
  "52ebbe400755842b5d419c1aa49b6857": "[ru]试品数量不能为空",
  "02d9819ddaaaeb1b7b22b12608c7e5ca": "[ru]提示",
  "bd5a25626dfe975a6c616b1e37bafeb0": "[ru]要求试验单位不能为空",
  "1641e7ebb8de5e308e1c4835939460a5": "[ru]无试验性质能力项不能下达实验",
  "25d850169b83ec9b89787efe0c5b8664": "[ru]附加要求不能为空",
  "30eafbba1d72fe46fbdab5f6766d18d4": "[ru]原纸定量试验下达",
  "4850ea222f13bd23bec1cdace19cb633": "[ru]表号",
  "f3737dbfae61193590bd513df85ff250": "[ru]单号",
  "ff55bde7a3dc704f80ad5a858699c8aa": "[ru]原纸定量实验方式选择",
  "83c9ee3af9dbbf307bc9820b9ff30df9": "[ru]委托试验测试",
  "19e89a11d139e00a36ce16afc1087f40": "[ru]工厂自主测试",
  "8183ea1d2767e7558ac7e2a816afcf97": "[ru]标准类别：",
  "7e217ea649098e03f615a99ae9c692a8": "[ru]标准编号：",
  "006efbdbae28c75b479bcf69d7265272": "[ru]标准名称：",
  "222c0f1a6341c9df01ca58fc982db93b": "[ru]检验项目",
  "f4aadbe7c1febb0b5cd8c1a9164319e3": "[ru]检验类别",
  "afb44627fabcf435b4633f1f6bd12eb3": "[ru]技术（标准）要求",
  "bd9d32f9b63c551e252decdf8b3c854b": "[ru]数据类别",
  "f96c63cc7406f89d0e2fe171d4d7c3b6": "[ru]计数型",
  "c5a52c27d6d73e6050d740ddade79fd4": "[ru]计量型",
  "9e23b61ce24cfada6fea1cdc2277976c": "[ru]样本大小",
  "9ad6f829b961e347a0c8233ea1e57e42": "[ru]判定数",
  "c5fb490f9763ca6e6320049b20e23a92": "[ru]实测值",
  "583b027719016a4906b6217095b1f681": "[ru]状态：",
  "d3a87e973ba69484a59635b285b73979": "[ru]试验员：",
  "d2ada8222027ff847cfbbdcf4ee24efa": "[ru]审核人员(订单经理)要求修改",
  "442d11878a77e98acad37cbbe68fb362": "[ru]检测-实验员打回",
  "02cc4f8f5a9aefbc03c778f7a5c989c7": "[ru]请输入",
  "4626e7457839719f5fa1b08526e5e3fd": "[ru]重要性",
  "0cf684d33849528278363c0e3991cb82": "[ru]检查水平",
  "df011658c33f610e9b9d3302909a7f2b": "[ru]范围",
  "0e8a40b9150d5f2aebbd153153f92bc1": "[ru]结果判定",
  "544fac400db790f57ea8ee4207cbeb6b": "[ru]标准",
  "7edfe462a3115964f77977746f86edcf": "[ru]面纸-原纸克重（g）",
  "aa88980aca280913a6c6b2634a9f3b6b": "[ru]瓦纸1-原纸克重（g）",
  "9855edf94f55a0c0b92ff3a9530af672": "[ru]中纸-原纸克重（g）",
  "056fbc2097872a17dbf1c28d3a3010b8": "[ru]瓦纸2-原纸克重（g）",
  "b4443f1517ddc481d76be98f67abd286": "[ru]里纸-原纸克重（g）",
  "54bbba803f13eaab0f5441d97b13247a": "[ru]结论",
  "2990e584c582181e5fd3161755bce7e1": "[ru]下达实验",
  "fa1ff41c2fbb0c645b06e157aceb0695": "[ru]最终判定",
  "4f718c72c8850078cde4293e98cde0f8": "[ru]抽检结果",
  "8e8dac5673805457d0e5ee80a00efaea": "[ru]测试人",
  "9eaa74af86fbe2c6f5234267a65f3902": "[ru]测试日期",
  "d740b70da74cb6f11554925b4daa495a": "[ru]不合格图片",
  "fd7e0c997d0005a132605a5be7a5161c": "[ru]选择文件",
  "0e1107dd16ed76b8336cd446366657b0": "[ru]其他见证资料",
  "be5fbbe34ce9979bfb6576d9eddc5612": "[ru]保存",
  "481e034e6026969aae4ce7ce7c8a7b6f": "[ru]文件上传",
  "d7fe269e595c6d8e34158b533de834a7": "[ru]*请注意文件上传的格式（JPG、JPEG、PNG），文件名中不允许出现逗号，文件不大于30M*",
  "e83a256e4f5bb4ff8b3d804b5473217a": "[ru]确认",
  "604fcff691521d03e8ccceaad494f202": "[ru]请先勾选检测项",
  "d90d33b62e7ab9295f07176d133b4c3f": "[ru]下达试验前,需要填写所有检测项的'样本大小','AC','RE'值,且系统会自动保存当前数据.是否确定保存当前数据并下达试验?",
  "17a4887790e7513f61d977767e0e172e": "[ru]不允许为空",
  "848cc1a16858cf7e4acf49e0939ed9e3": "[ru]请先下达试验并保证试验状态正常",
  "260b4ddd897e5fd7086ea0e78f67f790": "[ru]请选择图片",
  "c22129491761f2b08a74164b374f3c77": "[ru]上传不合格图片失败",
  "241d47a3ee97f044c1f043b9ea81855b": "[ru]在",
  "a746c0cfe6d450f653d021ce8006dad5": "[ru]中，",
  "74a4953bcfea21ba5e4832058409613f": "[ru]为必填项",
  "5eab6094e4a4e9c409c969d0bbb865e1": "[ru]请上传其他见证资料",
  "995e331488477141b06fe07891627273": "[ru]上传其他见证资料失败",
  "cc14aee3977f35851ed5437384a3c1fc": "[ru]生成抱怨单（重大质量降标）",
  "4fa019a377ebcac5ee8f92c79b0376ed": "[ru]出厂检验报告.xls",
  "9339113117a941b7c4c108fe58cbd746": "[ru]打印预览",
  "5148fcc0412bafcd98e04d4d183d8e18": "[ru]筛选条件",
  "1e496c1706e113b19791411c33cbc6a3": "[ru]确认人",
  "df713dfbe610b926ac70234219f1230b": "[ru]确认时间",
  "392a03794a4ca878f7cead8211a22d7c": "[ru]保密协议确认日志",
  "6fe4bf6e7d29587356656d70761b6d35": "[ru]确认人名称",
  "f50bf418323ee425eca7208c09a4577e": "[ru]请求失败",
  "c86a6a09d0c12b7727569346db46391f": "[ru]保密协议确认日志导出中...",
  "f9b253cfee79842b72923b6f80bb4cee": "[ru]文档编号",
  "8bd96a36ada0e54c28977d4f3628892b": "[ru]查看人",
  "d5c875856b8d3884dc7e1d24f152137d": "[ru]查看时间",
  "696876959ab59a6734aa6c12dc00000b": "[ru]图纸查看日志",
  "4c33db38c8d117186946c3e877d9de11": "[ru]图纸文档编号",
  "d2e2560089221ad15d2ec113e2f5b599": "[ru]文件名称",
  "d93d4e9100fb05cab157261b467bef11": "[ru]查看人名称",
  "ce877c7a1afdc6fb0a5a5b3ee85ab390": "[ru]图纸查看日志导出中...",
  "cb08af880c276d42e7773bcd88331d25": "[ru]--请选择--",
  "e5ad1f82e2026a11fa4709ea284ec979": "[ru]物料主数据",
  "e2520b26f2e1b8f68ab7566f8ed61665": "[ru]数据来源：MDM系统",
  "5d701a60a8010bc4b028078aab60d6e3": "[ru]点击跳转",
  "ffafb62f0a4f6ffa711dc2bc2edd3ea3": "[ru]物料类型",
  "233e95fd7b3b48592f865e9667b65a33": "[ru]ROH原材料",
  "9e8b1bacaa883922dc6bcf223c7f63a5": "[ru]HALB半成品",
  "35874e59c92fb5bdd0e2fce4230d43ff": "[ru]COUP商家优惠券",
  "6714dd19ae77d110c1f79cb3f21517d6": "[ru]DIEN服务",
  "da14626b7c4bf780856aa79b8bb1f1f9": "[ru]ERSA备品备件",
  "39dfb8a86bd308f530a62a8c5e4eb60c": "[ru]FERT成品",
  "29fc020bdf35c2858fa0704781654c92": "[ru]FGTR饮料",
  "c515aea43fc54c9c29039b9f479227ba": "[ru]FHMI生产资源/工具",
  "4811cf411f2f5aa9b38ba2e09b256d62": "[ru]FOOD食品(易腐品除外)",
  "44ff8c731fa8ba462958ff95ff896c33": "[ru]FRIP易腐品",
  "4467a56ca47ae6bea9ac6f7f6fd1bfef": "[ru]HAWA贸易物品",
  "3d005d17f618fd3adef9ba98348b0ac4": "[ru]HERS制造商部份",
  "c6c017f7b6c8fc1c85a8ea771dcae4ab": "[ru]HIBE供应物料",
  "c06ce014e14fc8b83fe06cad6450963f": "[ru]IBAU维护装配",
  "2b067086de558de48fa78d65c741a87c": "[ru]INTR内部物料",
  "156315edf89e433aa07045d8ef876a70": "[ru]KMAT可配置的物料",
  "c8e33be3187e1c758cd6453382c8a17e": "[ru]LEER虚拟件",
  "ecedeb2c4efb4c27c4c29f1303bb67fd": "[ru]LEIH可反复利用的包装",
  "40c32dd5dd2f82633affbf70303f4f1f": "[ru]LGUT空(零售)",
  "aa92479ba92f4ad9b6c498ea8eb64d1e": "[ru]MODE衣物(季节性的)",
  "53a6b9031a4843cb9c6c0114f53cd804": "[ru]NLAG无库存物料",
  "c9f8e8917fb6ecc83ffd2a44d754cef9": "[ru]NOF1非食品",
  "5cc4ff1329786d8606094d4258911d94": "[ru]PIPE管线物料",
  "18527f1c2a2bafa7c1ed7619ad0646ef": "[ru]PROC流程物料",
  "5790951003143e90c8a11062e92a7fb3": "[ru]PROD产品组",
  "d44661087d440c537bd84e3dd40a4f61": "[ru]UNBW无价值物料",
  "8487cc9d205275ea2ac9d27244ebb94a": "[ru]VERP包装物",
  "c4c850b966ea08ea3a681be39597203d": "[ru]VKHM附加物",
  "5e75ed8db50997902718168ae5602d2c": "[ru]VOLL整个产品",
  "6a2acfa8dbd12cc82a8331002b2f3804": "[ru]WERB产品目录",
  "7c3dbec7a342fd9f140d21ce2ae2dc81": "[ru]WERT仅计价值物料",
  "f4a68ef092f23c008057a4c9eaef73b0": "[ru]WETT竞争产品",
  "2110a700d83609a29b012ecfdc66783b": "[ru]ZMVS模具成品",
  "16c4ecbba90e448aeddf4ff349ea0e12": "[ru]ZTSP原材料",
  "74c180676f57ee56406fdf8425246da0": "[ru]基本单位",
  "03ac47d96af9e337a4f3f81678e763b8": "[ru]采购单位",
  "3f24d38e4df1fbc8c3644a714ff999a0": "[ru]WGG：SAP800系统，一般指白电产业",
  "6c3bc5f8c08b50c3099a070d21e83003": "[ru]EPG：SAP600系统，一般指智能产业",
  "86c931cb137ce967bcdc23569a60f09c": "[ru]图纸",
  "a001a226fdc34fd7121f9c4839c759a2": "[ru]更新时间",
  "e46eeab70f5efe260d0548e6854b3df9": "[ru]文档列表",
  "78e0c3556fb14229c1efb7c5abab3f86": "[ru]文档类型",
  "d0b29584322d8496aec3d9184457d6f1": "[ru]版本号",
  "a5de870add6e3ca5f2ef4894f49766fa": "[ru]更新日期",
  "2b6bc0f293f5ca01b006206c2535ccbc": "[ru]操作",
  "67aed5e722649f946333ab6e429b63ac": "[ru]保密承诺",
  "b4cb44ed36ebee0822f826b9f21e0055": "[ru]一、适用范围：",
  "37bf818ea4f40716aa2c7c0602e67216": "[ru]1、海尔集团在职员工；",
  "86423c52d2ff8658bd0e1673fa9ae1af": "[ru]2、在模块质量管理平台系统中有用户名的所有用户。",
  "e54bb6ad7711c15a853a0e7666d694a8": "[ru]二、承诺内容：",
  "d6c421d342d2c8eaf9c5965996900648": "[ru]1、承诺人应按照《海尔集团员工行为规范》、《海尔集团信息安全行为规范》等要求执行，对模块质量管理平台系统中的图纸内容需遵循保密协议、竞业禁止协议。",
  "ed8264ec2bdc9f420918caca7f14f140": "[ru]2、不管是以口头的、书面的、图表的、表格的、记录的、拍照的、截屏的、电磁的以及其他任何形式的图纸内容，不应在任何时候，以任何形式透露、披露、沟通、使用、抄袭、复制或者盗用全部或者部分的图纸内容，不论为其自己，或者为任何其他人士或者实体。",
  "703f7cd5f68aa066aa1b6fe09e1c8d6e": "[ru]3、用户进行离岗/轮岗的工作交接中必须通知软件公司相关系统管理人员进行系统用户及权限的调整，由于没有及时通知造成的错误操作及其它问题由该用户责任人承担所有责任。",
  "d584505205bf0dc44186226fc34851c8": "[ru]4、以上问题发生属实,用户责任人愿意支付公司为调查以上问题所支付的所有费用，包括但不限于人员工资、差旅费、代理费等各种开支。",
  "a3b85efbc4349eed5b54d0a2129ce8ce": "[ru]5、无论何时，只要查实用户违反以上承诺，均按承诺承担责任,并将按照《海尔集团信息安全行为规范》、《海尔集团员工行为规范》、法律法规处理。",
  "24731adbb101b434638516c925e6db49": "[ru]我承诺保密承诺的内容也已考虑清楚，自愿遵守承诺内容。",
  "e61f2cc4c39244f627b20e18788c3890": "[ru]同意",
  "7173f80900ea2ff9fec6568115611305": "[ru]拒绝",
  "7400ded453b5967560f7d4a14e8a0361": "[ru]请阅读保密协议并同意后查看",
  "915593a1d4fd928aaf3d29d880996d62": "[ru]操作失败，请重试",
  "2c0e00ff8b421a22e1a3a514fbde5769": "[ru]请阅读保密协议并同意后查询",
  "6437087ffa2f9ee3c0e78bb73c94841d": "[ru]请输入至少4位专用号模糊查询",
  "57532421e5416edbb754b294ad770f91": "[ru]请阅读保密协议并同意后导出",
  "24a58e1fdd6d741de3e734eb94e051d4": "[ru]物料主数据导出中...",
  "e9752e01d20698cea25ee959354bbb92": "[ru]&watermarkTxt=海尔受控-",
  "da89629c145e19f6c953e0d397fde103": "[ru]记录日志失败，请重试",
  "4b9f523828fb117163f8ba2be00bcd6e": "[ru]暂时无法查看",
  "e5b265f76a017d0c7c69829b990cbb24": "[ru]暂时无法查看!",
  "11df282fb81fd44c3e3403d643dc926e": "[ru]图物不符详情",
  "390ae5e3f11d95914e80602b646c458e": "[ru]任务单号",
  "9ca47b51e0d9f60e7644f5e596c4a547": "[ru]提报时间",
  "86d7b34be39df8d31b8bbc0c1c3fda7d": "[ru]反馈交互",
  "b5a4ecd83be6626725e1ee663cf09989": "[ru]处理结论",
  "78caf7115c5140f8913c581920239f22": "[ru]任务名称",
  "93735108c43a0c271c125b87db991bf7": "[ru]任务来源",
  "d5a57c1c4dc6f04018e0f73b658b35b2": "[ru]问题类型",
  "603c845369ffc3c7f02458510a68236d": "[ru]提报人",
  "bb8fc84bdef0c601235f4106c163e5f4": "[ru]提报人联系方式",
  "b7e63584b046bfec17cdc799f4da62d1": "[ru]文档名称",
  "ebb4b1e6b91d291d055017ecb158011b": "[ru]产品线",
  "5a4004d280ff74beb329402f267477e6": "[ru]供应商编码",
  "4c8c9d4f5d2b6a3a36445d5af7141003": "[ru]处理人",
  "c9a6ee90f5d43732e3f6cf4dcaa8493c": "[ru]附件",
  "0e794738d95aa7b0ec84246a6011aad0": "[ru]反馈人",
  "f7cdc6ed0c0570d9b9beb5aad69d3682": "[ru]反馈时间",
  "4376b15d1eefe6a5e8ccd1ac04c9d172": "[ru]交互内容",
  "d9e0e09f398b173a3e7b8bbefbe08ca2": "[ru]问题确认结论",
  "0a23fa338db25ee5726097a963d4fd28": "[ru]供应商关闭意见",
  "769eb37bdaf169d1f7dceda0639e765e": "[ru]工单号",
  "37d8e912fef567a69bc1c59e3e55b09d": "[ru]问题分类",
  "2c2a5de178412c335575d4daf4537505": "[ru]无图纸",
  "23253212519de89029eb66652a17bc7e": "[ru]图物不符",
  "e7a6f2536db4993f8361f305cc5d3ce6": "[ru]一物多号",
  "b60b4e991fb27dfd4cb9ef460e383ccb": "[ru]乱码",
  "39285ee83f58843443112106c81dd1ca": "[ru]打不开",
  "be074ec2894d1ccc0a87d7ebaf38118d": "[ru]图物不符标准反馈",
  "bc7e74f7ccf8ed6fa5b7b7649b221daa": "[ru]任务状态",
  "fc78751e55c5a4817fef5e6b4a9791b9": "[ru]导出数量大于200000条",
  "b39ee36ee1fba3b3ca39364de88816a4": "[ru]导出数量小于1条",
  "828ea380c92649ac5898d5d998b2c1f6": "[ru]图物不符导出中...",
  "134818abad563645ea9bba9c1e791162": "[ru]请选择一条数据!",
  "5fa30cae3f8373cf6041fd9a21723e8b": "[ru]只能选择一条数据!",
  "bc8a96444c0e3495d9042ebf356157a9": "[ru]查看明细",
  "9a53b2342b4657417f382f46d1f774e4": "[ru]耐破测试委托计划",
  "4ced958130fb30fb78b7c48112a37e20": "[ru]生成日期",
  "7d1090edb6e1497fc95f66916417995e": "[ru]完成日期",
  "979e166200a36bc470da64db14f8eb7d": "[ru]委托计划单",
  "8149127f0d8d55f1d7c5015f6c92af0e": "[ru]请选择需要检验的订单，只能选择一条",
  "73fcb6e2748a298678083b527c45eb2a": "[ru]请选择检验数据，只有待检验数据才可检验",
  "971d6934276873948330e443fc9f0060": "[ru]耐破测试委托计划.xls",
  "5c4cc8d92428f48aaba082859acc7e0d": "[ru]耐破/边压/戳穿测试委托试验单",
  "2a8be5798550557eea1bc2ccc6ccc3cf": "[ru]无能力项",
  "ae9b9e9cea1400387a36eb46740cf07c": "[ru]验收记录单",
  "a11cc7a65b27f3993d58438d275f3447": "[ru]请输入内容",
  "1d143a50ac501a8018908450a86154fa": "[ru]在序号",
  "61fee8ee9b3f1e9b4ef117f678640d9a": "[ru]变更申请审核",
  "b9307556ab6bc0eb3e43a9cdb16f2836": "[ru]单号：",
  "a57196877039a2d60598ac9e99a3ca8e": "[ru]物料类别",
  "0f083b36c38943d8fe08dd39977090be": "[ru]变更名称",
  "de938efc6ab4144b540a8a6accaa0528": "[ru]变更类型",
  "be51f5d7d3a77e7dfce395916fbc5365": "[ru]适用产业线",
  "96c8decae52dbc68e972bc6c8e70e3a8": "[ru]供货互联工厂",
  "8659947a2b9ec85926f3c96747f208e6": "[ru]申请验证互联工厂",
  "f9a81f6c757733aeff82aea90d05a7fb": "[ru]变更申请日期",
  "8963d558dc7c7ff01a52bf68e250b6e7": "[ru]期望变更日期",
  "ac92e4341fa934a0815960b6f5a99e3f": "[ru]库存数量",
  "a65db66b7039b0bb89f752f72e6b5d7a": "[ru]库存消化完成时间",
  "45a0bb592fe8e7dc78eac30ddb3814cd": "[ru]是否影响成本",
  "c9744f45e76d885ae1c74d4f4a934b2e": "[ru]否",
  "0a60ac8f02ccd2cf723f927284877851": "[ru]是",
  "96a8f64fb8c4b239c2b5b28f283a373f": "[ru]影响成本",
  "90aa3fe2e80321e8fe2802d753b28710": "[ru]变更影响",
  "60e9542b1af84c6484cdf00680979a79": "[ru]质量",
  "96986608c02982aff2e1cb310dc17818": "[ru]成本",
  "00ded5e7c3dbd4ce5793fc01723a9f10": "[ru]交付",
  "3a7170b92ecf13188fa0631c8d07bf7e": "[ru]质量",
  "7e237e9459140c4765b0c976c2669014": "[ru]成本",
  "de78900caa3322b893cf250ab869ea3d": "[ru]交付",
  "fdd9a6c5b7991b269c875f5aafd6b16a": "[ru]变更内容",
  "617699f4b7e4e4fe4d1ce09f7c94dcdc": "[ru]申请人姓名",
  "6a9135cbfe3f5452164ac35f14953044": "[ru]申请人邮箱",
  "795576c051b7281320f1114a9bf49ab4": "[ru]申请人电话",
  "0f005c2d04fd9837777c47a5d79117a2": "[ru]初审记录",
  "80500fc9d5eb7729d2f489bc92e92e3e": "[ru]审核方",
  "752d382f897c6e0a92fa531141e75c25": "[ru]工号",
  "60d0458ac6ebef0fff1331af196b3c82": "[ru]姓名",
  "19fcb9eb2594059036dfede5f4ec53e8": "[ru]时间",
  "3fea7ca76cdece641436d7ab0d02ab1b": "[ru]状态",
  "a6396f13c260444d561afaa9407467be": "[ru]意见",
  "01e0332fabf076fda64b0c489696f321": "[ru]SQE初审",
  "2839c8c87d814d9a1e592965fae86b54": "[ru]未处理",
  "23c1f39900b3af4c3263449782e288e1": "[ru]通过",
  "32525478cd5c1c93de9c71246021b595": "[ru]驳回",
  "96a4cd6882fb39113c79c69c6952baaa": "[ru]SQE负责人审核",
  "909aa58ac5cc5f99cfb8ef1f610ccaad": "[ru]采购经理初审",
  "bff9cef6c1e291c5e244b105d762e8f1": "[ru]校核记录",
  "8788ee873a247dd3aec65573b2cd33c7": "[ru]开发校核",
  "74c516ebdebfc626c914c0133faa382e": "[ru]模块技术校核",
  "6219c8e56b448dc63640af529c9022bd": "[ru]型号设计校核",
  "247dc777215bfa04240aeb93e91c55a9": "[ru]口碑校核",
  "3fd28b4e972c349e0302430b3c7c20a0": "[ru]工厂校核",
  "cf73456ce8e9934749de792070e5577d": "[ru]核对信息",
  "3773b44e160d75e59372c84b03243477": "[ru]采购交付率",
  "f8022ec6e086d50b6f59e40c359206f7": "[ru]采购降本",
  "503c26da7f55e0c6f8f03471901b63ea": "[ru]整机测试BOM附件",
  "fba11329c71ba0a947f66afafd6c955d": "[ru]审核信息",
  "acda736d85c260c17b9bbf0ccaf9278b": "[ru]SQE审核",
  "0ad17ef09f348c8374800237495c66e3": "[ru]口碑校核人",
  "194e3bce281551a1e05118e135e1c65b": "[ru]口碑",
  "debcf6e15414fbbe5aa34a8b3f20010f": "[ru]工厂校核人",
  "b20692fb8369fc156d85fbc2536e52fd": "[ru]开发校核人",
  "3ff3c3e26a68112c11c3e80f2a26896e": "[ru]开发",
  "eddfd18e4fa04a3f870e679b4e0038e7": "[ru]模块技术",
  "a95dd3e179418be1ecd2a719a22db70e": "[ru]技术",
  "0a646796b7583f301bffa55202cabe67": "[ru]型号设计",
  "b08890a6ef3b65218573ed90770b08fd": "[ru]设计",
  "9045a10f313c7ece34befb335c36af9a": "[ru]是否需要模块验证",
  "edc4a429dd7c370d279bb7302e5b97ae": "[ru]是否需要整机验证",
  "bf4620303bb18acd4179492c1ec208e7": "[ru]是否需要小批验证",
  "7b1d4be7c09718277380381cfaa68ca5": "[ru]模块检验项目",
  "2b96276b331155dbda6ffd29cc7c2798": "[ru]请填写模块检验项目",
  "6c2f971eb217581edae6fbaa9aa158cc": "[ru]整机验证周期",
  "1415bc5ea8eb93d034546f46980d9829": "[ru]/月",
  "a335bccf4ae48459f6309acdae1ea968": "[ru]模块验证预计完成时间",
  "a7788f49917f6a4f41f5644a4295c68c": "[ru]整机验证预计完成时间",
  "44e5f6973b470de4211deb4e68d990b5": "[ru]小批验证预计完成时间",
  "8f384519c2f4b21a0b1c80e614e93ba8": "[ru]采购经理审核",
  "4a1cd5cb09f3fb61d74a7001a8f9f6bd": "[ru]提高交付率",
  "39494917f03c4a099186dff30b29d5a1": "[ru]降低交付率",
  "722583027d3b5aaf52f749897368d14a": "[ru]不变",
  "7533206d940ff16848d96bed5f22df74": "[ru]成本下降",
  "4a991287a78d9e09cad4b014a7a2c758": "[ru]成本上涨",
  "279eb12051308cfc80516f67515b3f27": "[ru]成本不变",
  "5ad7f5a8b22e331abe82a6be5f4d6e01": "[ru]结果",
  "c5aa6dfe7bcd5ffe22da35054a7c388a": "[ru]请填写审核意见",
  "ea493fa7fc6e4573be8f8a9e2af38f6f": "[ru]*请传整机测试BOM，此BOM供应商不可见；请注意文件不大于30M*",
  "8ffe8dae6d15a5be77490834bff8d28b": "[ru]文件下载中...",
  "200525b8b8ce3247737c48ab9b91d50d": "[ru]已出具最终结论，不能审核",
  "4ea5f25df91562cd12f0f3ec3b1b43ac": "[ru]只有初审结果为待审批的数据才可执行该操作！",
  "fe210de56821d23887d61276d5c02fe9": "[ru]只有待审核的数据可以执行该操作",
  "08e2cfbc7f5ae9c2e4c50a87271eeee0": "[ru]只有初审结果为通过的数据才可执行该操作",
  "d6a450cf1efdf1ae21b6e0a827841063": "[ru]查询数据失败",
  "d66a602e640ba676a30513a47ca6abe8": "[ru]，Network Error",
  "d3b98f0c38a2cef93fe73cc33188ead2": "[ru]，",
  "5ff8e84edcae1f62b3fdbc17e25235c5": "[ru]请选择审核结果",
  "7ebd1f9fc247c9246fee2c924ddfdb03": "[ru]请选择交付信息",
  "9575c0a3318ea4ed59774f0a6b1992fd": "[ru]请选择成本信息",
  "1b8f72e5d95f98415d6920e8efb96553": "[ru]模块技术校核人",
  "d25dfd75a794cfdcfd97cc1c5bf954f1": "[ru]型号设计校核人",
  "abe2c5d2b9a91f822cb1c1ae6aefef08": "[ru]提交中...",
  "5d033055c73473ee79917bb7937cd410": "[ru]整机测试BOM附件不允许为空",
  "f13386f81c12a82c675b2c8de81e5b7a": "[ru]更新数据失败",
  "9febf31146d9c96bfde09a4a20dcf17d": "[ru]请选择文件",
  "d2f8889432e7cddc810c2a2365bc5916": "[ru]采购",
  "14813d00e7d0b7da94188523b904b822": "[ru]技术校核",
  "6edc9cec3e70051ab5358745aed77f4a": "[ru]设计校核",
  "cf13b1a67881f454af469aa874f087e5": "[ru]审核",
  "7bc523cd1a057c357befd8f39e15a90a": "[ru]校核",
  "08179ca5e1522af530de7f0cf2386497": "[ru]4M1E变更申请明细",
  "97e97108b40afafe6d7efb44ca386e5f": "[ru]模块验证信息",
  "7e9a6d8d38a85881398ed553935fd4e4": "[ru]模块验证内容",
  "89aab3902bcbbf9cf2c8702984a26c11": "[ru]模块验证结果",
  "4ff5cd9c5a6296c0cb1eb131d951bc59": "[ru]无需验证",
  "7c8332aade1f9b4bc3e4d9267b291b51": "[ru]待验证",
  "dba93f069f64bafeb9d82a86bf1dc202": "[ru]整机验证附件",
  "89acc87de70cc41104bd2ddeb9ca6150": "[ru]整机验证结果",
  "b39b586240c3af5e22dcff767c4319c1": "[ru]小批验证附件",
  "a65a656aa5ef81d54408f209bbb329e8": "[ru]小批验证结果",
  "b289de4c1f47c67561de77b4132e13a3": "[ru]最终结论",
  "915c2952f1f5e1d1d849eeca8b5d2b45": "[ru]最终结论",
  "0e486cd1416f6735cbb0c0af30455070": "[ru]不可变更",
  "979d3298039df6a61513cbeb709533d1": "[ru]可变更",
  "5821954eb8f1299507e373dbd7ef331f": "[ru]供应商主动终止",
  "3d23e0add6f9a4f0cb99ce23593ac61d": "[ru]消化周期",
  "313e421732a7e95105b12c3e05a6c62e": "[ru]在途品数量",
  "e6489c131ddc09e037f6a1408f173231": "[ru]在库品数量",
  "2a9eae031c77e5b61f2c5753f090227e": "[ru]预计消化完成时间",
  "c9af657bfee5da0cd4a828259d702ddf": "[ru]变更审批管理",
  "bdc97648440901d2f63c5cdf22d5492c": "[ru]变更编号",
  "502fa1e4556add0a00a8d94e299d551d": "[ru]工序设备变更",
  "7095ea041ea4d340d093dd5f82d0e494": "[ru]模具变更",
  "acd6c88a9ad5cfb044380c8c5d8109d7": "[ru]模块材料变更",
  "421ca7e944e2a5d4eabef2a24501bcea": "[ru]模块制造方法变更",
  "d963c8d9687c9349dcf9d0d0f04c01e3": "[ru]生产场地变更",
  "eeed90131103bfa26c2ac12fb621d9ed": "[ru]模块构造变更",
  "2ac72caae00ff68f1856892070b9e10a": "[ru]模块检验变更",
  "bd76ca8e6b66b95b3a3db3f87463e195": "[ru]模块包装规格变更",
  "f6e22ede84b20ada6ce3eeea579e0e76": "[ru]SQE审核人",
  "51f319df5a00ab66b2629ba13fd0d9c0": "[ru]采购经理",
  "f4f962818dbf8d3b008f55c06e0f9862": "[ru]SQE初审结果",
  "9a9e1b72c04cb429d969bd67e6ffe3a3": "[ru]超期不可审核",
  "c0ca14a75880b35bb1dba6f6c63201a8": "[ru]采购审核结果",
  "7d0d9d5a6a61aa1f3037e2514fe3a18d": "[ru]互联工厂",
  "bb525ee8a2dadc155cd3c6037cb85187": "[ru]是否维护消化周期",
  "1ac156e227d5452aa2087e1554006000": "[ru]待维护",
  "8ab9b9f92b7c2d19323f021047320277": "[ru]已维护",
  "617dc87a9c7bdbbe3b4379e82cc9533a": "[ru]申请日期(从)",
  "b44c0f337d2ffc27a09ff792a489b1e0": "[ru]开始日期",
  "c88d0e63ecab0cd02a378d98c4913137": "[ru]截至日期",
  "38332bba0b770c2e5f3c1fa90a91dddb": "[ru]SQE审核",
  "d0d355855d1b3b1701116e17549b705b": "[ru]采购经理审核",
  "1912cc6d90d995856d38f20e781b5299": "[ru]开发",
  "653691d4372f91be1e7a79074ceab7b8": "[ru]技术",
  "6717d9383e34ce4c1a7a12926c74ec3d": "[ru]设计",
  "22d23c9ef17d9f9e5f13fed527b2607d": "[ru]口碑",
  "bea2f8f5d21bb60f991792924ba92cf2": "[ru]工厂",
  "acea208117817c21a14c68b929110814": "[ru]冰箱",
  "9323fc443d28d1158811e016682578d6": "[ru]冷柜",
  "2eb2e635efa0cbaa1d32a37516ae517d": "[ru]家用空调",
  "0044f62f5599155c3578c6110f7a52f0": "[ru]废弃",
  "920368702a877e894a7680f186653c79": "[ru]采购经理初审结果",
  "8beefb1353a32743f7d67df0a113d264": "[ru]审核结果",
  "b0bf01a4a8655d44002ac29f69f12061": "[ru]待审批",
  "3ae6c0160cd3d66d2cec7ac4d41530e9": "[ru]不可审核",
  "9a1e10eec2fbac65c555dd56bcdd598b": "[ru]SQE负责人",
  "7c1f826b735ab751c040f2f35ead0eec": "[ru]SQE负责人审核时间",
  "cca7eaa163d739e2007f772ee044f69f": "[ru]SQE负责人审核结论",
  "64bbf918c116079394937fd2996cc8e3": "[ru]/月",
  "6d8614ddaa66dd578ff67aca8924aad4": "[ru]驳回原因",
  "f7f21116c7967627212c9eacaadb7d75": "[ru]空数据",
  "3496a465f03c279187d1f0d2a044918a": "[ru]校核方",
  "20063d2a19f88f9a5ea8ac9d13e5c82e": "[ru]SQE：",
  "b012265ce356c769a6aad218dfa38918": "[ru]采购：",
  "cc1efed302df4ed6885b8c1fcd210f78": "[ru]口碑：",
  "4a657dd6cfe670c19939afe933c4a3c3": "[ru]工厂：",
  "3498b27008e658f89827a0c87e90688f": "[ru]开发：",
  "34a7d0b15b8333510e34a3212e65c685": "[ru]模块技术：",
  "546feffef777cc8ca9c9f223111606f3": "[ru]型号设计：",
  "8af08a6fd2797b888887c6cda57648a1": "[ru]只有初审结果为待审核的数据才可执行该操作！",
  "b429f8aa520032cdfba3bebd920581c2": "[ru]只有SQE负责人为未处理的数据才可执行该操作！",
  "7a28fbeb2c7af03a2bedc1d6a653ada9": "[ru]只有采购小微主为未处理的数据才可执行该操作！",
  "2f8fdca5c0c99d54957620e062217f52": "[ru]只有待校核的数据可以执行该操作",
  "c8d7362a00c130352569b1af7e90881c": "[ru]权限不足",
  "0a464ea91d22d3a3acd445e97ccec9ba": "[ru]已出具最终结论，不能校核",
  "17f9e64b169cef7f8188f35595bc2236": "[ru]变更审批管理.xls",
  "105c8a51febafdf21cf88617dba29c0e": "[ru]导出成功",
  "ed7733df89fc3a89e7b54cccdc0fff10": "[ru]导出失败，",
  "dd51ab5026f7683c7ff40d8d71eda619": "[ru]导出失败",
  "19032e1d727e487e42816d112e243560": "[ru]互联工厂查询失败",
  "57738c8a6a20c40f544b2f5c17447298": "[ru]数据查询失败",
  "efcce57348c6f69152cefb43238ccb79": "[ru]大产业",
  "a384d1939d2c1747626b939dabf68e26": "[ru]整机品类",
  "1427d2dd7981c82d35594eaee0b16f14": "[ru]请选择大产业",
  "c39ec92a352b627847b439e5f5242f0e": "[ru]检查卡序号",
  "c6cc397661432878e10a24834460da0d": "[ru]有效",
  "f1f98fb723f1b89ccf690afff7384879": "[ru]发布时间",
  "c926d5670bd8c2d8c8a2e17bfe32416b": "[ru]标准编号",
  "fc9f9e85e7f1d33b9b18f8568559718c": "[ru]检查卡",
  "8170e939c99d18e1f64ca5a772001484": "[ru]品类查看",
  "9ee20a30578246620e2a10a59fb6a9e5": "[ru]最新版本",
  "770b0424e9613c81e98af8786bd4679b": "[ru]发布人",
  "43a802eb813b811a94f23e91cc3cc982": "[ru]更改原因",
  "c054fb6e7a4b8511a2cc90a55d70eae9": "[ru]更新记录",
  "7229ecc63125adf7fcf2867d792a77be": "[ru]次",
  "7ef44a7d1da94b0799368e3bc304fe77": "[ru]提交中",
  "68014b16b455b0fb5ab5fe1c1378330c": "[ru]最多关联20个企标",
  "e69abf6494bb03e4fadfd89c3af4cc71": "[ru]请输入2位模糊查询",
  "181ed085a630907ddb8f6b6d6e0c9b26": "[ru]标准名称",
  "675287569126d17eb14b7c4e762033ae": "[ru]检查卡上传",
  "b251471a58477a851c04f26d9fcebd63": "[ru]*请注意上传的格式（PDF），单个文件不大于30M",
  "6d846288e148ac7403c78739a6ee480a": "[ru]修改原因",
  "fab8a01373dc6c8b7ae422c4c9ae6d3e": "[ru]*请注意文件上传的格式，文件名中不允许出现逗号，单个文件不大于30M*",
  "ace138e97362a95ed4612f5bb85f0d30": "[ru]品类新增",
  "40dd0bddadb9d657cf0206ef23185cee": "[ru]品类修改",
  "f71f1bb3211224e63f3d0218538eab0d": "[ru]品类删除",
  "7ec062eafce6520b22a2491021b756a9": "[ru]品类导出",
  "113829053f5d42853f67c386f488cec2": "[ru]品类名称",
  "a6613a8cf40922917cbafd7ea7f3a837": "[ru]添加人",
  "ffc7ed1cd5288ff735a3c4a059125354": "[ru]添加时间",
  "cfe71a24304864e12f05f73424876591": "[ru]更新人",
  "264ddeec839f4d6313077e39fc041a5e": "[ru]新增品类",
  "258ec944853b610af7dbbd7d92c3d446": "[ru]整机品类名称",
  "f76027692eea118f882bfa9137aa57fc": "[ru]修改品类",
  "fe2df04a168059a153dcd0f18f75d789": "[ru]版本",
  "01ceb3edde98440157f199c292011dfc": "[ru]无数据",
  "24efa0a5346e008312c018309a73f8e5": "[ru]大产业不能为空",
  "8a2bc36beccb9c688f7ca020cf15ad48": "[ru]整机品类名称不能为空",
  "1b7435ae33ce371845daa799b754d7a3": "[ru]确定要修改吗",
  "4768294a538ab0b4e590b0207913b8c7": "[ru]请选择需要修改的数据",
  "4494be1e731b28deda9e5ef2918fcf88": "[ru]整机品类查询失败",
  "f3b6cd01a03b301597421159aeb43d70": "[ru]请选择要删除的项",
  "ddb774360277e655c6a2673584d47587": "[ru]删除后无法恢复，请确认是否删除？",
  "acf0664a54dc58d9d0377bb56e162092": "[ru]删除失败",
  "51cef0b50d5ef83883d4f2d37895cfff": "[ru]确认提交吗？",
  "23b62e9cbc868e024b80d2e3fad80ac7": "[ru]提交成功",
  "79a1d87bb377bed5daf8eba176ff5f89": "[ru]正在解析...",
  "a7699ba73144aad544eb9ac49f82749d": "[ru]上传成功",
  "54e5de428ca9d59119d4624706215a4d": "[ru]上传失败",
  "0d66ed02d74d0bd89431d6d59533ffb3": "[ru]查询失败",
  "555faa64377739889b7e9e14b72cd011": "[ru]检查卡导出中...",
  "ccce9f9d8b16a7001bc10ed932afd6a2": "[ru]品类查看导出中...",
  "1358ed5371278379f194804c927e08a7": "[ru]整机品类不能为空",
  "e7638a1d496113921d4755813ef0c0bb": "[ru]物料描述不能为空",
  "1569ee445eb35a5030dcd890db30e6b8": "[ru]标准编号不能为空",
  "9d429c1920977063ea99daa8ece3ad1c": "[ru]状态不能为空",
  "516ba2d3014f92a8de0300f06e5e1c4f": "[ru]检查卡不能为空",
  "9d821e4d1497124f04ed468b653f6c6f": "[ru]修改原因不能为空",
  "996887600b2750444e238ec787b0cd50": "[ru]新增标准",
  "c7e9035117f736e40d9748495c58c8c6": "[ru]请输入标准编号或标准名称",
  "0cdd14816c74e4af5f559cf515d04404": "[ru]请先选择标准",
  "6df615c1b8b2fd0c72148b80121329d1": "[ru]开发产业",
  "7d3192e9aebb60b67ff0e60f6fe08fb7": "[ru]开发工厂",
  "560882daa98af4d0a1a2e4ada918997e": "[ru]请先选择产业",
  "c5a5cf76955aef9b633bbdb5b084e956": "[ru]开发人员",
  "b7ca1a12dd788c9a07517ed3f1dc4414": "[ru]检验短视频",
  "048941b3db8933db078539439fdf8527": "[ru]+增加行",
  "fc09a73e52b76f697cff129b4dddecd1": "[ru]上传中",
  "717b7e01c5ee46c2bffb65b06b056026": "[ru]*请注意上传的格式（MP4、FLV、AVI），单个文件不大于500M",
  "2cc6c3a37cb1a7ff59bcc3b2e32e1b4b": "[ru]*请注意文件上传的格式，文件名中不允许出现逗号，单个文件不大于500M*",
  "aefd1994fe71520893e90223f04cd30f": "[ru]默认行不能删除",
  "55a5ce277e6f5e1bdcbf1c1d50f72f8a": "[ru]至少保留一行默认行不能删除",
  "fc9bddbc117613c249add134c92fc3cc": "[ru]删除成功!",
  "ac007746080a48f195815c62f8c1570c": "[ru]第",
  "6d3286727490e216a76eeb20d9e1b7ce": "[ru]行：标准编号不能为空！",
  "5ed5abc981e35ca5ce38b1179397ef41": "[ru]行：检验项目不能为空！",
  "c0056f3436aa8ac027bccee6f9d0ac83": "[ru]行：开发产业不能为空！",
  "98c0fd7ed36618cbcba77627fedc148c": "[ru]行：开发工厂不能为空！",
  "3e13f02ee7b40047fd13bb5d908d22ef": "[ru]行：开发人员不能为空！",
  "d8efaa6853a604aecb92e833271bba15": "[ru]行：检验视频不能为空！",
  "1fea9537ccde892bb555f1986cb45aae": "[ru]请选择开发产业",
  "fd6ddc2045eb18f5057fb4eb0ab92f48": "[ru]发布时间从",
  "981cbe312b52b35b48065b9b44ba00e5": "[ru]至",
  "23510f5d9a283eb7787326b1461b7a36": "[ru]检验方法管理",
  "6c256d8631cf91f3fbad6d7428f04e04": "[ru]标准号",
  "92edb43585f87a97715802c31af1271d": "[ru]检验短视频上传",
  "072880e15d889658cbc937c853111ae5": "[ru]检查方法导出中...",
  "72d736289a2b54c409854de048828274": "[ru]开发产业不能为空",
  "b7ac2edd34552cd1758004be99cae6d8": "[ru]开发工厂不能为空",
  "a378c371675b47e23eb7a45816830a62": "[ru]开发人员不能为空",
  "506ca53a3365fd9217ba87b4347a1636": "[ru]附件不能为空",
  "fbc22c2be4fc64d6fafa33f2ee62cd54": "[ru]检查方法.xls",
  "8190915888889ed18be44ea0351d0448": "[ru]月份",
  "96ad1b86c31e8f1965a3fdafae75975d": "[ru]不良单号",
  "d5d8573dbbc6c2925ebd391ae506dc18": "[ru]录入日期",
  "aa2fb1b6cffd7c9783c11047adcdbae4": "[ru]请选择日期",
  "5e383b34e48780b8a4e225bc148960f6": "[ru]现场退次非批量索赔报表",
  "92c95a3945fe66d44102305d7043b0e6": "[ru]金额（元）",
  "0bf60b32f9db93b87e08763b1c815469": "[ru]数量",
  "74c62f1fcddd7b5f905eacca4b6b3ab1": "[ru]缺陷类别",
  "0e73c6d4d0fd0664717ad4d66f98aba6": "[ru]缺陷描述",
  "2739c66a785c303a52967b2e511a2e87": "[ru]退次类别",
  "ae27d6f465386eb63210704c8918c6c4": "[ru]录入人",
  "0039880117c13787732d259f5bc9f7f5": "[ru]录入时间",
  "3dc2105ab835babf98f8e5227448f2d6": "[ru]终判结论",
  "0b502cec5dffcbb1cf611880b0cdd066": "[ru]终判时间",
  "62265bb68a3f1fc67c9893d4d9fcd56d": "[ru]导出数量大于30000条",
  "31a00849017d25539affaf5be1b48c29": "[ru]现场退次非批量索赔报表.xls",
  "06a6445c7a1bdac2d009fdf0ee8f5033": "[ru]不良来源",
  "93fbc4b2599c08ddc368dfc24ca259e2": "[ru]现场退次",
  "67ddc402facb39f023ed4858696f4b6b": "[ru]入厂检验",
  "9c13d89d30e0a5421568a5e47edd9377": "[ru]色彩不良",
  "34faf656e34872ef9399a483fa3e8633": "[ru]色彩编码",
  "e697479a249ee7c011bb719dffb47d44": "[ru]专用号名称",
  "1b7a425ee4880699ee43c6000d3161bd": "[ru]不良缺陷",
  "3c233e0cb3957edf79570412f2cba7a1": "[ru]不良录入人",
  "890b248f6266d9dd687f232a4fcddd34": "[ru]不良确认时间",
  "696f5a978bbeb2b4db9f282e64662eb0": "[ru]创建日期",
  "e0e727b69c8e3fa9db294636eb041684": "[ru]工厂小微查询失败",
  "d01eb34ac4c3419f2e66652c071960de": "[ru]色彩不良导出中...",
  "a88b99b28f287376becee1cf8e980c72": "[ru]色彩名称",
  "09307ce839527e1d1d86eb1163c103a8": "[ru]品牌",
  "50354a52f60d07b3ab1f46a6ddf9234f": "[ru]色彩创建日期",
  "614fa90c6184becf48903bd3cd476e87": "[ru]色彩列表",
  "c48d44ae69d1bc20a2923426ff5714ff": "[ru]色彩创建时间",
  "eca37cb0726c51702f70c486c1c38cf3": "[ru]创建时间",
  "939744bd8242995623ddcbd0489df208": "[ru]色彩明细",
  "986698fd31faefb9d56124ae015bcc1d": "[ru]色彩名称：",
  "25ed9074ad71dccbffccc296e107d6cb": "[ru]优选状态",
  "288ab4083fee8f39ab3c4f0983c5c3ca": "[ru]应用产业",
  "66746c5f5d451a2ceea43555bf634a6e": "[ru]色彩列表导出中...",
  "4707b4b78a8b51e777051d7586f05328": "[ru]色彩明细导出中...",
  "7f961ac800c6a29cee411b6457b1e1ab": "[ru]色彩明细.xls",
  "3c041972a8bae930bb6a90ab753c9f75": "[ru]纠偏单整改",
  "21ecb6f04cde6c590cb6fa87b8442e12": "[ru]纠偏单号：",
  "0dfedd58f37571cc86caec5f09366bdb": "[ru]样检单号：",
  "8046ef6f34e24672d629d8893713cee4": "[ru]产品在",
  "cb77c6bf5391e04e28f99211e3e1dc80": "[ru]新品检验-自制件",
  "b04298314253bc84fd897b34dac8c4e8": "[ru]中存在问题，应立即整改，保证同一问题不再发生问题现象具体描述：",
  "4b123f5f935609529ffab06e9666f0ca": "[ru]数量：",
  "4e5c37530588e2936295d4aac0532370": "[ru]地点：",
  "f887302359012344413403e42cfc2290": "[ru]本问题属于第",
  "eb4f56a34b14d34b908bbdb501f2e41c": "[ru]次发生。",
  "fc763c911b506a200c7d6eecb5b985ed": "[ru]不合格项目：",
  "372c7a20c284ae5d4f3b2419687945a1": "[ru]自承诺：",
  "14e6d83ff56268b2ace156ff8b1dca6f": "[ru]时间：",
  "6e5b960787a434bd9d590de50b6c9e36": "[ru]说明：",
  "f6f6f42f859edfa470f2bc0ad8224302": "[ru]要求整改日期：",
  "6052d9dd0ce5c2bafd22bc03dc656b82": "[ru]审核意见：",
  "a2499be9cc712858039786a220a10556": "[ru]签发人：",
  "b03096932d72557b79ae397f7e19ead8": "[ru]签发日期：",
  "93523a9c4f6e682e975a38fee3082db1": "[ru]暂无图片",
  "dd3a5d56a1f8b1ece6a77d4b701ce194": "[ru]整改过程",
  "9ab31c4ccc2fd91683751b8a3ad4680d": "[ru]原因分析",
  "85ee42e154555e7172ec5dcdfeab4336": "[ru]纠正及防止再发生对策",
  "e28e52d6c0b46dabae2117ecd0248209": "[ru]整改项目",
  "c8dc6683f94e5bccda80cf57f22fb690": "[ru]整改内容",
  "c7bff79d059a0b7ff9b02441959d8be2": "[ru]进度",
  "b2972522a041947d45978908e5ec8137": "[ru]负责人",
  "32ed7f169270fae8080481c8eb1ffb1c": "[ru]应急措施",
  "7a44d63bfcae580a2b2ec927ca7f3fa5": "[ru]过渡措施",
  "60ed8203f18e1c11da65fc1f8f2eb4f2": "[ru]根治措施",
  "97d7e7ac40b2a31b9cdbde20c724114b": "[ru]质量承诺",
  "c5589b557d94401def1d4aa087beb572": "[ru]管理责任人确认（首次发生）：",
  "c597656c45f5bf4b41bd3658c5a96801": "[ru]时间：",
  "a5feeee525ec11c2633b04fc2a11b38b": "[ru]海尔评价",
  "b39de5e3bb361bc7b6bade70b7c7e513": "[ru]可接受",
  "e4f3dc64ad9dda7e6c6c3e483a3cbe3b": "[ru]不接受",
  "324d3f39add68d35b9b3979e420457bd": "[ru]签字：",
  "602d0cf5c817971543da73c05618b45d": "[ru]日期：",
  "ab1bcd732b932ead763bf080d90e93ab": "[ru]审核意见",
  "321ff794aab8c6cd671990a98ef212a0": "[ru]不适用",
  "7ae22cc04c95c79d09ae4c9387f45b5f": "[ru]不接受 审核意见为必填",
  "e32cbb1cf0f51890cd2e39c0ad6916e6": "[ru]审核提交中...",
  "f5d008dea7d2e953195a5588dea3c8e4": "[ru]提交失败",
  "f2a88edc8adb598632ba1c6f89279b89": "[ru]数据查询中...",
  "e710df6eb5e7a3713cb34239aafadf3b": "[ru]自制件新品不合格纠偏单",
  "2bc4331e21f876d0ca7bc7cc698d9c37": "[ru]请将表单数据填写完整！",
  "a063f76e4737e9955ae4882687cb0dde": "[ru]整改提交中...",
  "d8f1d077591c6b3e89ff84e0b58b2221": "[ru]整改提交失败",
  "e14ee8f04bf76d9b8b77fe478f3944f8": "[ru]整改日期",
  "bfd5d6b5e79c46c862980fa1bc3ae7c1": "[ru]审核说明",
  "e6f0708789d7efc02f1a163224ae7fb0": "[ru]审核时间",
  "6c545c505fa3a4f3ffca3ddc4ae9b051": "[ru]纠偏单号",
  "a1c551876914ccaa587c641c79b2109d": "[ru]&ensp;查询&ensp;",
  "e17445c380a7667d92f87d01d6703e42": "[ru]待整改",
  "5cb424765cb101866f47ca115605ce3b": "[ru]待审核",
  "cea0671a77281d4923d26111191e4fd8": "[ru]闭环",
  "abad330f7fe92f41627d9a704ee5fc9e": "[ru]审核不通过",
  "62a67306728c07a3692a358a5df921d1": "[ru]下达日期(从)",
  "70af6d803b6981ddfaf3fd971972954f": "[ru]审核日期(从)",
  "bc2ba23c06d5bc16f7688ecc5a67efaa": "[ru]更多查询条件",
  "def9e98b60e3bfc493bcd7693e702096": "[ru]收起",
  "e9c5bc01074acab453d5090949410121": "[ru]自制件纠偏单",
  "59c1d28ffbf075894cb2684f702476c5": "[ru]整改",
  "ee4c724a4dd16bde53ccda20ed8a8fb3": "[ru]整改历史",
  "84f1de49ab1615128bb9a91f5042f8e3": "[ru]下达者",
  "e82da8a5ed89d557f32a2e784463fcd3": "[ru]下达日期",
  "383a6d166f8f60e16e726ccc9c483631": "[ru]类别",
  "81ec6814bff81247224cc6c0565ce573": "[ru]应闭环日期",
  "914ac0464c7a01aadb663771b1f258bf": "[ru]反馈日期",
  "54c63db7cc8cd7c7ee1d668354d7786e": "[ru]实闭环日期",
  "09bd5ada04876784bd4f03e9b429ec86": "[ru]累计整改天数",
  "84260c085ca8e8c331895c30aac19e14": "[ru]剩余整改天数",
  "7fe0b5998a211f8e7639cc6b9c6907fa": "[ru]当月打回次数",
  "03c836ec1d1ebbbb4f13522307cd6119": "[ru]累计打回次数",
  "adce0615e042581e3a64bee80c98e6d3": "[ru]物料大类与外检员关系",
  "d88fc79235801bb7ebe9abc9ee45974f": "[ru]检验经理",
  "d2b067386b474ba79331a30eeb536cf7": "[ru]自制件新品检验",
  "577a777123a23ef49b71b909da0af7a1": "[ru]请先选择工厂",
  "053e974523915dcfcd937eda61558be0": "[ru]只有'待",
  "d5f5e723c832e3b42351fecdedca1037": "[ru]'的状态才可以进行该操作",
  "9c21bad2eb9319afee4f53c1cbd427e4": "[ru]权限查询中...",
  "2bbd2bb7d8e5733b43eafcf8d39b2123": "[ru]没有权限",
  "26cba1c1ce224d9f3faf7ddd9c9f1df1": "[ru]分工失败",
  "4062b25e0de29c45349afa6510bf62ef": "[ru]导出中...",
  "3db715fbf441fd64d10265d8517ff7ff": "[ru]纠偏单.xls",
  "91846bb1caadfb68b71720465a2a3e6d": "[ru]工废确认单",
  "6ea1fe6baae671b49dde2bba85d5ed96": "[ru]基础信息",
  "bef73df511763f1f28a87946503749eb": "[ru]审核信息",
  "252ac36a192e26d9c29be37b0aebcece": "[ru]半成品号",
  "7200512687aa214e63d60020548091f4": "[ru]半成品描述",
  "c1fcb90f50319828d79871f435448d17": "[ru]不良产生原因",
  "75dba99ab8fb9991940260c0d6af5c3c": "[ru]型号描述",
  "767b3bea1695be77ce9c2785ef66ad72": "[ru]线体",
  "75237166e951947443eea058979cae11": "[ru]班组",
  "b68919a3b800cc4b543475966a1c5305": "[ru]班次",
  "e21b5a0345b4149110b80ce893d149fd": "[ru]责任班组",
  "0c5b77a14834daae88b98bacd7ce29db": "[ru]责任人",
  "f6f54a2ef39acdea82e1fd94a34965c3": "[ru]是否批量",
  "1abf0a28f0677da56aaacf703ce2c0b9": "[ru]不良类别",
  "0fcd61d6fea1d915b09cbda32efac923": "[ru]不良照片",
  "8402fcdd8d97edd86fb1bc69059db687": "[ru]岗位",
  "dec0624c91cfca219e1b41ce89c19780": "[ru]不通过",
  "c440aa79178a94b6f424bf68b7c167fd": "[ru]白班",
  "46c2d8df0f8ba1e4464025b82d36652d": "[ru]夜班",
  "d8acae3bcfbc9ec9ade58c2dbacf65aa": "[ru]暂存",
  "5a7f3fe1772e01a02cccc7dec17aea74": "[ru]待判定",
  "fb3ca08c9d1159c8927554476089e43b": "[ru]待公议",
  "9109d5ff67cfd588c1d5265d160a958f": "[ru]待终判",
  "af96e2b53622360b32c5564ffb7592ff": "[ru]已终判",
  "2554120a92c450a4e500fc9af7937c30": "[ru]已终止",
  "93088b3ee041cfcf2c25b1b3ddd5fef1": "[ru]不良类型",
  "32e4d3ae2dcc5e8eeb40f3a33d59af9b": "[ru]原材料",
  "932292d9e9a3f625b6e13090f71784c5": "[ru]半成品",
  "0d2f752dc4bd37fcba9b0226c991284a": "[ru]成品",
  "11daf0e021f2ae89520f7d644f9dc66e": "[ru]判定驳回",
  "227364a1e9bbffb023ddd14e37ec5761": "[ru]工废",
  "97c61c38ef75de936a3dd852843e6a92": "[ru]料废",
  "df16d956dd05a2d40a2e30f6073b068c": "[ru]返线",
  "707be0734800ffd39d6272add9cb91d3": "[ru]不良件",
  "c4a4d9f768737d3d24002eed65a3cbed": "[ru]作废",
  "bc018bdfc5f6945163844a163c05a759": "[ru]入厂报表",
  "bc6d7381aecad38cc8e2058bf0581aaa": "[ru]成品型号",
  "4b02fd7b848018f210a971ef07434432": "[ru]工废管理导出中...",
  "6687ad04f1afcc3b054db67dbf707de8": "[ru]此订单关联的生产批次报告信息",
  "3b321f677ee4b672111b194e0191abf7": "[ru]检验日期",
  "03ebcbeadf3d1509bd60840796cfb2da": "[ru]生产批次号",
  "cc6c1cdf53f2a43d497f5713acb39947": "[ru]出厂报告",
  "b0f1dfa8735f6448d44ea7951e0b2cf1": "[ru]报告结论",
  "181749a2418dccd48f59ef10d3fdf555": "[ru]本批交付数量",
  "1c54cb9fcb4ddf8ae7172371e3dcf752": "[ru]生产数量",
  "0671d7ffc13646ff574a977eb4929d43": "[ru]可用数量",
  "478a628b74754c7dcb1100af0d78bde4": "[ru]已关联次数",
  "3379ba1011dc1a2c4c09fada0c363bdb": "[ru]已关联数量",
  "a6d0cdccce2eb8f501ef0b290fde3fe2": "[ru]请填写审核意见后再提交",
  "af3280a3e1a20232c243274c362dc40b": "[ru]驳回成功",
  "cc8c80449d2881be33e3cb6fa935158b": "[ru]HMQM已提交，SQM待完善",
  "c82441c9fc62d346cb1b1d91c1c646cf": "[ru]SQM已提交",
  "871a30c0993c4e2a71557fe7f38807c0": "[ru]审核通过",
  "a6d10d5afe0a1528f8b6c41607894107": "[ru]订单信息",
  "3c6447dbf1e28726582b0eee84591631": "[ru]订单数量合计：",
  "f08f3f6e2d8c9e579512bb15238b2e43": "[ru]本批交付数量合计：",
  "932379babab02b2adbe47dda0e715507": "[ru]交货日期",
  "1e8dc255abf9f4b8c93d641ef559e6f2": "[ru]订单号",
  "bc4fc89e1c0936d030f9a313fffdc529": "[ru]看单号",
  "b3c3ba853df6e07368f785e6055a45a0": "[ru]交付数量",
  "e97405df555de838f1beb6723f542873": "[ru]订单交付列表",
  "1c57f258ae82654d9de4c68a427f7c40": "[ru]（请根据勾选的订单信息，单行订单可以关联一个或多个报告；多行订单只能关联一份报告）",
  "2d65236f2c662a5afacbae209774c726": "[ru]报告编号",
  "13b062af2976411b3f19c9820febe842": "[ru]生产批次",
  "1c3cf7f5f085596674018f3efc645be5": "[ru]关联",
  "d2acb7556778368993014a226f78ccb4": "[ru]可使用数量",
  "0d21c2ca31a8123e8808d9adbf02eafa": "[ru]本批交货数量",
  "bc60ed037ba2cff52e55ccbf0a69ba81": "[ru]请输入数值",
  "a5cd4ea1820d5c17c35e86885b1ef10d": "[ru]报告",
  "f5e626da7e14d2cd3996dcd2627e1c3f": "[ru]已提交",
  "6c45a69ddda20f948520529017f81a35": "[ru]数据输入错误，请重新输入",
  "0a50651c89a00f28b2808371ec3d6e06": "[ru]交货数量不能大于可使用数量",
  "eb546c7f530385555a004f382877a007": "[ru]请输入本批交货数量",
  "7096cada9c2c2885ee17e8e1a5a5bd44": "[ru]请先选择订单数据再进行关联",
  "f7ad6ba125a7bc3f2cc06ee476e7c168": "[ru]请先选择交付数据再进行关联",
  "49d150f98ce47ef66e5210db367ac6d6": "[ru]所填写的本次交付数量与订单数量总和不一致，请检查一致后再提交",
  "caced1db345976571bfc7892f2be1a66": "[ru]根据勾选的多订单信息关联时，只能关联对应一个出厂报告",
  "7c74d9b7f70cfc184d8c260693859559": "[ru]请确认此订单信息是否已关联完成，点击确定后不可再进行关联。",
  "55828c3d21f0fd6e4080eb7c68848736": "[ru]关联成功",
  "0668c7fd548e4c0d84150f0617b872f2": "[ru]待关联",
  "b3f16853fa2f55f6007d5e40433b4e8e": "[ru]已撤回",
  "998d15681b5128a6dc12c633d46d4917": "[ru]已关联",
  "1de8349a0ae081c3b8c4d4a1951e8562": "[ru]提交日期",
  "e080329c020dc42739b9c0a043845712": "[ru]提交人",
  "f2008e4eb2ff688b0a2f7786814f0444": "[ru]&ensp;多订单关联&ensp;",
  "0e300625a3047fa4021db139573f3d7f": "[ru]&ensp;撤销关联&ensp;",
  "6ba88a0be37a3a93326f7cd18a114ecc": "[ru]&ensp;导出&ensp;",
  "9e4605d08e639a5c43131783f525844b": "[ru]交付判定列表",
  "d995283a9ae5f1f3765e3850373a36e7": "[ru]（默认展示生成日期1个月之内的数据，可选择查询条件查询更多数据）",
  "2305051ed090135ea508478de4146a5c": "[ru]撤回",
  "dbf36ddc55bcb108170d85f41460b6df": "[ru]已驳回",
  "5356e9175fdcda2ff1d6d884d7176af0": "[ru]关联修改",
  "1a9766d0fe259eb6f38c0d7c40712544": "[ru]撤销关联",
  "9abce85f58ba000ac135dff8dd5b0f99": "[ru]请确认是否撤销所关联的报告",
  "3e97e8698a658cb6c634827275a99468": "[ru]解除成功",
  "70f54460f0d54a3152610b1ba006b9ee": "[ru]请选择需要撤销的订单",
  "406ceac82fac960d905d57d734f085b5": "[ru]请选择已关联数据进行撤销",
  "f041ebf603b0f79409945b40ff2e4e2f": "[ru]<strong>外检已出具检验结论，不能撤销。<br>订单号：</strong>",
  "860eb16bed071b95d9e67981aa2a8017": "[ru]<strong>；看单号：</strong>",
  "129e5bfeed26c5f9118ff66aa78c5318": "[ru]关联报告后超过24小时或外检已出具检验结论，不能撤销。",
  "00bcea8b811602ae54cee47e4d57be76": "[ru]请选择需要关联的订单",
  "3e7d135a18199ed5f38f99b007e3a1f2": "[ru]如果选择的单条订单关联出厂报告，请点击“待关联”进行操作。",
  "bf08d92a8e06f8127c7fa33929770755": "[ru]请选择状态为待关联，已撤销数据关联",
  "f7967ba8c01dfe0b971215a510415b3c": "[ru]请选择同一专用号的订单信息关联出厂报告",
  "88afce82e1529cd0b441a251c5658e4f": "[ru]交付质量判定.xls",
  "e6ea87e68679296e792b8b7520a2e7b3": "[ru]关联状态",
  "50239f4fee57468801a2964dfb7b687e": "[ru]已撤销",
  "dd63f0153538ad41712bc7655d0a8ded": "[ru]预约单号",
  "77750b24661091d0d0326c0689b290ab": "[ru]创建时间从",
  "be70899a98bd13d4ce6ddc4039932939": "[ru]事业部名称",
  "4e4c3191c5680b65744a0cece7e73a89": "[ru]交货日期从",
  "6423b87e7a49cab80dc603ffdaa7b3d9": "[ru]VMI交付判定列表",
  "80ad7d7efa564992b4908cd66abe58b2": "[ru]（默认展示创建时间1个月之内的数据，可选择查询条件查询更多数据）",
  "fb4cc0f776e82afd9c2b6ca157ddc639": "[ru]提交时间",
  "df5d3e35de55a377af3629776417bf40": "[ru]检验报告创建时间",
  "e4bc8f4cf9d7f615e52060529ead270a": "[ru]VMI交付质量判定.xls",
  "9c6c1df0e5ab661055353e5efd38c93d": "[ru]交货时间",
  "735aff8652f4ef32793264300a056984": "[ru]检验工厂",
  "d7db9b3a433c91f3b58a92e20203738f": "[ru]VMI订单交付列表",
  "45cfd4ffd89fd054be68853fa54cc863": "[ru]所填写的本次交付数量为0，请重新填写后再提交",
  "e80c7658e901a771f595fc0d06174260": "[ru]工程变更详情",
  "a788ff74dfe1c759e4ac3ece98c199a0": "[ru]产品部代码",
  "a041d615181a14cabe79c4c2efecb893": "[ru]提出人",
  "d399f7fd0b82ebfd48873c266abc5fee": "[ru]变更管理员",
  "e45f5e0199c244255622faf0b821a863": "[ru]计划实施时间",
  "8679e39997149952a7091d33e132b93c": "[ru]批准日期",
  "fa647c6079ececcb4d29477c9b63a74a": "[ru]变更成本",
  "fd3bbbc9a6f997dd2ad184f70cde3dd4": "[ru]产品成本",
  "32c65d8d7431e76029678ec7bb73a5ab": "[ru]标题",
  "254dd6d2171da29e092b8bc744f88ca4": "[ru]问题描述",
  "736176eb5f7befaa5f9b04f2ef308c65": "[ru]建议方案",
  "534c3b416e160e632cfff0c1f16a7a28": "[ru]通知部门",
  "8e0bb9bccac97ecab8d1b77e765e6dfe": "[ru]对象信息",
  "9bc89c142949ed80e6fd9d163e4f1d8d": "[ru]更改/影响对象",
  "226b0912184333c81babf2f1894ec0c1": "[ru]类型",
  "04ca2d93b2ce890f53655ac7e182458f": "[ru]是否外购",
  "3bdd08adab6ea90b9164b20a0e4151ac": "[ru]描述",
  "83050d965e30e94190d6dbb94ce1847f": "[ru]更改信息",
  "f084568396ed2dac97f5bb38300fad88": "[ru]更改信息CI号",
  "6700492c363825df1fc4bc8adbe6652b": "[ru]附件链接",
  "e36614bbebe80baad0cad3576bdcc4c6": "[ru]变更单号",
  "eb7f05c117703c25a488ae1bce590994": "[ru]变更关闭时间",
  "080d64480504633569aa1fc88d6499fc": "[ru]批准时间",
  "326c88b2e40b9623b710e5a9ef163d68": "[ru]相关性",
  "4296d7d293c9ea4a0e52c6415f0b5c96": "[ru]高",
  "19ac677ac052e0736310f8b475cededa": "[ru]低",
  "10342434582eb14ed3f517efb9343d3e": "[ru]工程变更",
  "268e7635daef6f0e9633b793b80196b4": "[ru]工程变更导出中...",
  "d9bcdd40b55107e97b9881d6e476bb20": "[ru]产品唯一码",
  "62eadaf8a7896d1d8cad08ee4131b959": "[ru]OID二维码",
  "54d52f565cc2e202d130dbb5e13c8ac4": "[ru]详情页",
  "6fce02a38267ac7ce89e3add5eeb1bae": "[ru]备注：请务必输入产品唯一码或者OID二维码进行查询！",
  "4fe28e7de0d2d2138a5fcdd9869bd281": "[ru]生产工厂全称",
  "6e3ef2295870257f741434e2f8cf646b": "[ru]生产地址",
  "24d6c9b03ed096d69b753505d691e3c4": "[ru]生产线体",
  "44c4227175922c94497714edab9db531": "[ru]检测时间",
  "22ec1277cd9a5f08ea93ec8aee06911b": "[ru]在线检测项目",
  "13dbc3bd9ab2901546e6efc9942b45c1": "[ru]标准要求",
  "337bffab47e921014ae18dea50127fae": "[ru]检测数据",
  "77b9b1d1720981ebe160fd67cdd61db9": "[ru]检测结果",
  "9a4f5889a1329226c5a3cdeff9ff2ae3": "[ru]请输入产品唯一码或者OID二维码进行查询",
  "e297b1a7803e53ec2de8ed9b3b84ff2a": "[ru]请输入产品唯一码或者OID二维码进行导出",
  "8acbf41bbeffe11af364eac8361b4730": "[ru]在线过程检测详情导出中...",
  "316e5040e2dde1b78b9d76dc8dbd6e7d": "[ru]在线过程检测",
  "499ea8638be6a4223d49d7562af9b0d5": "[ru]检测能力录入",
  "eb922f88d8c12b6442cbee3b86090312": "[ru]检验项目描述",
  "901c0de56e3d0915b902ba4936d73b2f": "[ru]适用范围",
  "26ce4837f3a0b6b1c98132e30fdb60da": "[ru]有无检测设备",
  "cc4ad2fd27e24ff9191e254d8576d2ba": "[ru]有",
  "d81bb206a889656035b929cd8bb1ef10": "[ru]无",
  "1c181a18d2e78aace89cfdadca7e5f96": "[ru]检测设备编号",
  "0473f284e7ec0a81742896e00550af40": "[ru]检测设备名称",
  "b8c25296cbe9ebf3030b20ba1193cd01": "[ru]关差",
  "4821bb1f66ec45d961cd4dbfb0fec1af": "[ru]应采购设备名称",
  "472017b92f2ffe9423d07f88ed2dde07": "[ru]请准确填写所需要的关键设备名称,且不同企标间,同一设备名称需保持一致!",
  "f4c3bd7ddea55966fee94b3ee3515e95": "[ru]计划采购到位日期",
  "44cffb6064a63c17e2370216bec47e9d": "[ru]①若近期有采购计划,请选择T年(当年)或T+1年内的计划到位日期;",
  "885ea6d9e8e4fe1baef5af007bee0d4f": "[ru]②若近期无采购计划,请选择T+2年及以后的日期;",
  "e9119efada40aff84bf40199bc9f6f51": "[ru]测试能力",
  "02c30bbc32cd1cc6e85e7a9fe12f6634": "[ru]具备",
  "3770aae0dd09e672366c092cf590da6b": "[ru]不具备",
  "ddbfd8ccf46752865f60ac216cbd597a": "[ru]是否适用",
  "ce69c9c5fe9e50e7c4bd3481ec5dcde9": "[ru]关差日期不能小于当前日期",
  "1ea6ef604fa4ac4db93a52d688666c4e": "[ru]当前内容不允许为空",
  "22f6682f9d4d78ad2bec52367854d824": "[ru]页，第",
  "8ff348f9ca167061de23b67c97df2c6e": "[ru]行的'有无检测设备'不允许为空",
  "f7ac3d75a5e5ea70c3804e95a52c787e": "[ru]行的'检测设备编号'不允许为空",
  "7bb20ae6b51fb2efbbd68b61ce1e0dac": "[ru]行的'有无检测设备'与'测试能力'不符",
  "8f58687d72abe7f93ed43058a95c1500": "[ru]行的'关差方案'不允许为空",
  "0d3325e3ad74fd8d17d58435564a29a0": "[ru]行的'关差日期'不允许为空",
  "094e287fef62c4799fb7666e2aa89aaf": "[ru]行的'关差日期'不能小于当前日期",
  "649c5dcc317c0be6ec9c13b305fa9097": "[ru]行的'设备已过期，请重新维护'",
  "4db61012580bba6afeb8f63507736c3b": "[ru]行的'测试能力'不允许为空",
  "d8738f2675839412987422cdc17c5845": "[ru]行的'是否适用'不允许为空",
  "bc5312ecb5b2e65f7801bb86c9022427": "[ru]您选择的检测设备[",
  "755a0a7f6d40733c595299ab7a263471": "[ru]]已过期，请重新维护",
  "3a4ba377ece08ff7d3d711ab5f556b92": "[ru]设备编号获取失败",
  "c3ef66a0cea6beb97c22dd26d4dd1728": "[ru]未提交",
  "94d8077aa84fc7122349fac0453dccc6": "[ru]数据有效性",
  "1202e67474d663287df766140918f089": "[ru]检测能力",
  "85b2bb10fe279838d643f174b05fa037": "[ru]物料明细",
  "cb80b71a94c06e3659757fa5906dbc60": "[ru]手工生成",
  "845b9368c726626501fc8bc1ce1550c7": "[ru]导出明细",
  "9194a8189c53e434456bfe7ce31f8499": "[ru]标准：",
  "be4f883cf02b0f4b75432d404402a7c8": "[ru]最近一次供货时间",
  "60b6e4d0bf9728ddf8bec7333d5c27cd": "[ru]手工生成失败",
  "187d1fe0248dc951304185d455ec5437": "[ru]确定要删除吗",
  "e68a39f1d60046b6f8a59de7ee6d183a": "[ru]检测能力.xlsx",
  "9ca5abe9044e385c79cbc1e8cf128e85": "[ru]如果导出数据量较大，请耐心等待",
  "8fbc7ff276e4531fd670e54bfbf388bd": "[ru]检测能力明细导出中...",
  "77da2f01d843c5341cf96b5d2031e1cf": "[ru]检测能力明细.xls",
  "c1a0413fa173e27323c05a1ad758eac6": "[ru]获取信息失败",
  "91c7c3931c05e4dd6214f1dc6d90cb2d": "[ru]请选择1条要修改的数据",
  "607eb1564a9fe6d9966a9c88989c044a": "[ru]企标状态为无效，不能修改！",
  "105db033c48a8ddb07f8cbc408fbc6e9": "[ru]请选择年份",
  "904393383755b88e61f5c242eafabdda": "[ru]请选择月份",
  "f69bf82dab3926873d849feae9f8814b": "[ru]检测能力报表",
  "2a6f1d1fc30e3e4468c331e18102953a": "[ru]入厂项目具备情况",
  "a246f630603ffc142a0a9c3fb91abf39": "[ru]总",
  "3c899c370646fe23a8e57098401c0021": "[ru]应",
  "1eb9260ad4801fd5d75ec644fedb9d8e": "[ru]实",
  "796a506e5f1b78b496fc6f0d23c974d3": "[ru]差",
  "4bcc9a5a9aa9852fb816113d74b4806b": "[ru]详细信息",
  "b683c82e9310494611d6a8c1db41bd34": "[ru]生成时间",
  "402e4691b1cbafbbc003f1b5fcab8c45": "[ru]年 不允许为空",
  "24ee6079765f1aed3ea12a0881ac73cf": "[ru]月 不允许为空",
  "abc15e11417f37cf9fb6a07e28418b8a": "[ru]检测能力二级报表.xls",
  "3b12f90e168231c3b955e2d2b9f1d6d9": "[ru]列表查询失败",
  "4ecf0e0f2301d00e7e11bdd28516ac2c": "[ru]年月：",
  "3032257aa3961a1ecdf8db231c73104c": "[ru]详情信息",
  "74739b032f80189ed5fcc6a487ac75b7": "[ru]设备数量",
  "d024ddde774fc8746c77687fef25730a": "[ru]企标提交情况",
  "bcd9970fe5ef36cc2a3788d51186c7af": "[ru]涉及企标数",
  "1724cf75f2f6c4b0556f7bae06414aa1": "[ru]完成率",
  "b7fa6248258da047d86f2bd4046e2c9c": "[ru]检测能力一级报表.xls",
  "de045d6bd7af3a60eb4e80dd7f4b8132": "[ru]工厂小微获取失败",
  "97d7ea73654e15b7d4b86993f558272e": "[ru]事项名称",
  "f56c0d9491e98eba2256c7ce18628502": "[ru]导出人",
  "592c59589144ddc68d05d528da17dcdc": "[ru]开始时间",
  "9f6f3b3949821876398b46174f9ebb91": "[ru]进度刷新",
  "4de47571f62e48d8749efb6f86b99365": "[ru]请点击按钮刷新下载进度（仅能查看当前用户的下载记录）",
  "f6a99887bba25ca35acda0456836dce1": "[ru]可下载",
  "236c7bbec6ec525ce55fd51e639b76ee": "[ru]不可下载",
  "3742370551bf03a4913f378242990251": "[ru]（",
  "0611d8741c03f4d44b07738a7db28075": "[ru]）",
  "7cbadbbea6412f1996e4a96cd30c8352": "[ru]完成时间",
  "a6f7f1353eaf386dc23aa426b887eaba": "[ru]条数",
  "f26ef914245883c80f181c4aade2ed04": "[ru]下载",
  "8987be48043d948ea9c974285c6580eb": "[ru]- 导出中...",
  "fafee8864833ed8f1725eb7652656e07": "[ru]删除后不可恢复，请确定是否删除",
  "330363dfc524cff2488f2ebde0500896": "[ru]成功",
  "43593d9a9591327cea1dda09c97a50e5": "[ru]删除成功！",
  "91dfda5b7e50021b211778852efab10b": "[ru]删除失败！",
  "5fa802bef51f52b1f7bcf35ade3512cf": "[ru]操作失败",
  "4177a2d54a7ef031841f1451ba67a440": "[ru]监控大厅",
  "bab268d5468de413a7158920799e354d": "[ru]供应商",
  "2367bc4a8fbbae22cbdb75d1c373be2f": "[ru]请输入供应商名称或V码",
  "c0093c96688fb92d6747cf00e98babc4": "[ru]厂区",
  "21e847912106ef323dd47fcd6492db30": "[ru]请输入厂区",
  "599c080fd76bb51729cc0dd9fcdc6d6f": "[ru]选择状态",
  "c195df63086a73016c53d6928444a061": "[ru]异常",
  "66e52127c06b44b746f3514c613ab509": "[ru]监控状态",
  "4694e64c666a3b74ba7a38595e2b200d": "[ru]异常内容",
  "3d14d1a1f9514183570a10fe80a32384": "[ru]省",
  "371528ffb7f95c7fddc0d60249e716ec": "[ru]市",
  "47c762206773ddd95bc0757bae8b33d7": "[ru]区",
  "716c3dc1bd990ccebc4fee34eb9171cf": "[ru]街道",
  "7650487a8758fd50c87d6c9cff0aa5ac": "[ru]地址",
  "d129528d4aa83e7663f8d9ec09356922": "[ru]绑定时间",
  "569f2930896824bd2faffa6eb64cd237": "[ru]查看直播",
  "e2d729cdd5da886ded4687535e8e5870": "[ru]李泽",
  "7efd3197ab5a01d6efee5cbd46aaea4c": "[ru]韩世民",
  "bc967ad031ae10e2ebacb74720b4cd78": "[ru]是否确定删除此条数据，删除后不可恢复！！！",
  "09f2fb82fd4772f1ace5f7e359b4eacb": "[ru]删除中...",
  "2914dc04e0f0ec58d1ebb5c09cc7210d": "[ru]失败：",
  "7bbe8e2fc717dcd127692b7ae1f1f76b": "[ru]直播",
  "5f1507784aea6d9e725008ca81c369ff": "[ru]录像",
  "bd784a8d11ea6be8d75a0d9d489f37db": "[ru]工厂名称",
  "cd9494688019881e5053299b6a6bc9fb": "[ru]工厂地址",
  "694fc5efa9e1d1c2c5eb6525e1c7fb29": "[ru]刷新",
  "369abff3bcc9a7f5a692b5ea2fd7769b": "[ru]截图",
  "25511c0ebdaa1d6bbf941c10477d89f5": "[ru]视频获取错误, 请重试或检查绑定摄像头",
  "810159542bf4e5a4634950664abdaf8a": "[ru]iframe里的视频播放成功了",
  "85d1ad2794ccbe0a1f6a6d95b1c51f75": "[ru]iframe里的视频播放失败！！",
  "102d013ba73b3880b7aa4b00f2b0d728": "[ru]是否关闭当前页面?",
  "900c70fa5f7dbc014e6f762d5e0e885c": "[ru]警告",
  "c64fe925ffb7532fcce6b89d4d54e8b2": "[ru]转换历史",
  "a32c14c2e6a214e16e8207559c2612a0": "[ru]规则：前推30天入厂不合格0批目标达成，系统自动取消出厂报告关联照片限制",
  "472f7bf5887879af2e5f3c5e5f955664": "[ru]转换前",
  "537b39a8b56fdc27a5fdd70aa032d3bc": "[ru]必填",
  "5d27242794abbf1935b2a8fe8b0a5492": "[ru]无需填写",
  "79eb0d6be6f1252708c7319435d85501": "[ru]转换后",
  "8f69344224d4c9cf97250d80cb72dd22": "[ru]转换时间",
  "e0ac3b9035b2a018c789753cebb44767": "[ru]转换原因",
  "f9ac4b2aa6b51d9578551cd06316d81a": "[ru]操作人",
  "49c01d49cf1931a6ac215b515abda814": "[ru]变更原因",
  "89ddc81fb9e324adc0948a4ce826b47a": "[ru]见证资料",
  "29f986479f7cf1f93d31172f343d4521": "[ru]下载中...",
  "5c193163eb792b6163b1082b22488642": "[ru]检验报告截图配置",
  "1c8a7bc5b6f262a51cdcf6dcf79042dc": "[ru]请输入两位模糊查询",
  "9ae2c84d356384ef0ab4af59ee23fe71": "[ru]是否必选上传照片",
  "820ab694b6bd1976a2b368cc64275970": "[ru]是否执行自动转换",
  "a8dc4d2819b056107d33eae2de2dc044": "[ru]手工转换",
  "740d63ba201a91aadec474431df0a19d": "[ru]转换后不能为空",
  "cd0c02f146699c99eb9fdbc6b77b89dc": "[ru]变更原因不能为空",
  "41c4be82a30b8358910aa775e23867cf": "[ru]见证资料不能为空",
  "0a94aa92aebd0d07cd2fffcb3c3b545f": "[ru]*最多允许上传一个文件且单个文件不大于30M*",
  "28231bbe68f7673c98d5432bbe6a2d7d": "[ru]是否执行自动转换策略",
  "723b1fb62a3966d6787a931c3e01e885": "[ru]是否执行自动转换策略不能为空",
  "cdf4057e52609b9840fef6e3e84fbfb6": "[ru]请选择一条数据进行状态转换！",
  "ec1e51d520eeba6e6cf987d536453c69": "[ru]请选择一条数据查看转换历史！",
  "e6382bdeeb98e5480fa403d7e081bb57": "[ru]转换前后数据一致，不能提交",
  "eb52940f413433139705600009010279": "[ru]手工转换成功",
  "f69126d8a71cb220b4b62007cddcaf05": "[ru]手工转换失败",
  "92cd554eff7896f979917f3ae449b460": "[ru]上传中...",
  "3a845c4dd82bd5a445333dfcbabb4350": "[ru]文件上传失败",
  "3b6b685e4704d8a582ee48933a56feb5": "[ru]请至少选择一条数据进行状态转换！",
  "81a389c61a2a8edc675d72e136b0cb8b": "[ru]请选择状态一致的供应商进行状态转换！",
  "83cf827daa87f851626b8ebe244f2b35": "[ru]当前供应商检验报告照片为必填项，是否转换为选填项？",
  "10f19b2031fac4d9849b27ef1d6f25fd": "[ru]状态转换失败！",
  "46de1b72b18995886b9a34bc56054c66": "[ru]当前选择供应商检验报告照片为选填项，是否转换为必填项？",
  "292f18395eaace0b9639bc079c692ef8": "[ru]</p> <p>期望:",
  "05d06199c080befb6edf8d657f5e36ff": "[ru]</p> <p> 实际:",
  "86c278b0635e68da4c9a2a7049f1c593": "[ru]别瞎传",
  "1d2a691eda00b5b04a5911dfb42c2e22": "[ru]样检单号",
  "3deb2bf4d97e348122c6010c98935b7f": "[ru]整机订单编号",
  "a2b7522ad74bec150260f5e91b13cb98": "[ru]整机订单状态",
  "3787cf7f043a450aa4cdddbe3ad9046c": "[ru]检测-检测进行中",
  "6cfb8400115dcb7ae81eef78b460e294": "[ru]检测-待审核",
  "8f3b1dc69b2322a932398b85167b258c": "[ru]检测-待批准",
  "968cfe6fbd755f36d5d31824e2ffbc5b": "[ru]检测-待修改",
  "ff14583e03f24e10c35ad59d46d9015a": "[ru]检测-已发布",
  "26912ccb6192e24620d9646e158bcc42": "[ru]整机验证结论",
  "5c6585e09b0ae14169393efb3bb7c8dd": "[ru]未检测",
  "37264dde25a744b5d022854bcaf285ee": "[ru]不判定",
  "1296c94c7aa9d9bc0d768639bd5323e2": "[ru]委托时间",
  "a00b81f1399508cd2f1c4da576424811": "[ru]报告发布时间",
  "6f77f4e430204ea017f83e6e23bf84a8": "[ru]整机验证计划",
  "cc961806762c4ad10412b02e4784ca3f": "[ru]整机实验室",
  "d1d5ca31b2d76140e648bbb6cd2fe1f3": "[ru]样检单下达时间",
  "7f830c5c7d097a06e47d40f4f572e56f": "[ru]报验工厂",
  "b753d37808a36eafbda10755c1fb895f": "[ru]整机订单委托时间",
  "9f3ace2765d73207552bfd8bfc96a6f6": "[ru]实验室收样时间",
  "b5d510f6efcabe40c1cbee8cbe00a018": "[ru]测试接单时间",
  "389aa5834ee0bd56eefab03c4cd3e9e3": "[ru]整机验证计划导出中...",
  "04c470ee59c5afc28be102f06c8d8d14": "[ru]检验标识历史",
  "cea216f1ee9ac8435cc12232b782c6a9": "[ru]物料号：",
  "fc8f448f0002af866e69ea8d4fdda30d": "[ru]转换前标识",
  "07ff530a1a67ba4eac9831c7ce8ea212": "[ru]转换后标识",
  "75d8bf0ee59e69f23c2b43b42678ea0a": "[ru]转换类型",
  "17df252a36315467dad83534fe2cd5a3": "[ru]上转",
  "424f685278d4c848c96c80fb74f7615a": "[ru]下转",
  "d663cf0406368e8486d4a7d107f96d6b": "[ru]检验标识",
  "b43fc64f12591384cf15cb8acca511c4": "[ru]集团检验标识",
  "c0cf053d5fc13fad06996729c7e16f3b": "[ru]查看转换历史",
  "95a43eaa59198a9a2f5271e4ab593593": "[ru]创建人",
  "7b6ae5ead0deb992e42683b7d9974899": "[ru]集团检验标识导出中...",
  "20ed9092e5ca496aa1587d5690021d8f": "[ru]模板号",
  "0c49e608aed336e8aba6c831d0665150": "[ru]发起方",
  "bfbad1baf6af69d9f4db37efafc64cec": "[ru]发起日期",
  "5b92e71e2c8c6b17af7d817a72306678": "[ru]审核日期",
  "b6d0e97218a470eeff7a2bed42b44e21": "[ru]审核状态",
  "3a3ae28c26a97e892eb1d688dacf0e80": "[ru]变更中",
  "d3c33b086a8bee641f066870305a9a77": "[ru]变更完成",
  "a094e5b7699ea4b61094cc4120170423": "[ru]数据来源",
  "3cfbd76af738e1ad6ed9b5e96035f27c": "[ru]海尔",
  "176ac03109e9091a19319dbf7591e720": "[ru]出厂报告模板历史数据列表",
  "d4285acb6dcce029eedc17f32a2bb8d1": "[ru]发起人",
  "82da895cd022775edf8ccb40b8f79e8f": "[ru]审核人",
  "ec0e35a2a24f46d6f1dede71a6ea43e4": "[ru]供应商待完善",
  "32620033ddf8dbbc4ce35d98da7516c6": "[ru]HMQM已提交",
  "f2cf263977bb4fd33b4fed19abfa61ce": "[ru]月中",
  "8b2c70fbed996fe6bb9b7e75f5253d47": "[ru]月末",
  "79101b9a4632dcc59011cbfd47f4bbcc": "[ru]产线",
  "0fa9d1590c4e12905a78e001e7332c5d": "[ru]纠偏单状态",
  "ef5db409ff725e8482b6eb65f38c48af": "[ru]供应商超期未处理",
  "faed4c5f6d0759abc15ec2971cad306d": "[ru]SQE评价中",
  "9d298bcaba9221bf30fd13a4b06e2683": "[ru]SQE评价不通过",
  "cc939a5a94d19ffb864a8f14200237fe": "[ru]SQE评价通过",
  "f950331889d2172fbdeb4ddfbd135510": "[ru]SQE超期关闭",
  "72d70086afce3d043fc51e0523192bd2": "[ru]当月跳闸",
  "88b3219b36f6266a0f167ce9b29a9896": "[ru]是",
  "8df14303f8eb277b1ade948458e7c876": "[ru]连续2个月跳闸",
  "aa1a29a3ee85b84086ff2f930288226d": "[ru]连续3个月跳闸",
  "e39e50979b1597d51fbca7db64dab8b6": "[ru]当年累积跳闸次数",
  "2814a61cb96c6a300616ec5bf2efb319": "[ru]请输入完整单号",
  "daff820eece267de918a5896cbaaa389": "[ru]现场跳闸线报表",
  "c9aa7de54e7670f7ebaa49e3de844668": "[ru]请选择查询时间",
  "43fe39f608ab4c13e950addea8c9025c": "[ru]PL单双点",
  "fd5a9dd14de11ddc59ac8bf5afa32f38": "[ru]现场_质量底线",
  "c2c40bdc6bd1814145f8f19255820f37": "[ru]当月供货量",
  "4f79fbe60da796e81fbfc91de173d1cc": "[ru]当月不合格数",
  "3bbb9d96a8440b6cb76b553e4e32f64f": "[ru]当月现场PPM",
  "5235606c697b5bff7509e5ebc2105f3b": "[ru]特殊场景",
  "629d18cfc39db616e975d30902277d58": "[ru]当月是否超跳闸线",
  "f4995df0f0e9d7a8baae6fa80e38247d": "[ru]连续2个月PPM超标",
  "d055984361167624fa6606d7f4c67bcb": "[ru]纠偏日期",
  "1327f89a362dbe6b435c62cd789f3f3f": "[ru]连续三个月是否超跳闸线",
  "b68f779e08a9306e5d7e4bc33ed26058": "[ru]停检单状态",
  "5a6bde275a52b16fafea34e62cb728a2": "[ru]停检单号",
  "05d6547b0261f659aabe09d0d60344b3": "[ru]停检日期",
  "464e4f7bff04b7dbd185fde81e0214f1": "[ru]停检单备注",
  "352547b50930fa984d4548fb943713a6": "[ru]当年超跳闸线次数",
  "1425f6d6263b4e8e1c14fb71e51da41c": "[ru]产线SQE",
  "9fc844103313303428c3b4a0b71ae8f8": "[ru]现场PPM超底线报表.xls",
  "69470b3a1796a68c1731e01dcc776980": "[ru]跳转页面携带参数调整：",
  "35c95794f96644fa4a45c03e6391d63e": "[ru]supplyCode：",
  "3c4cbdce48a054391f325fb25c1d8442": "[ru]supplyName：",
  "758b9d6478002eb4e214268639ce759e": "[ru]加西贝拉压缩机有限公司",
  "83b3ad72589e689c3df16e853331a54b": "[ru]青岛胜汇塑胶有限公司",
  "e379d97e0cfe75d44335746f4e5a42c9": "[ru]vCode：",
  "22da36c39dbb5501aaf7078e57b16c0f": "[ru]userId：",
  "e091cdacc8d72093bd99d6b736494284": "[ru]roleCode：",
  "61f287a1ff5dc7e3a62dec9758ca94fc": "[ru]roleId：",
  "303af6afe0c3dd7f5755a742c7a67a6d": "[ru]name：",
  "c19a59497569ce1969be0340b1e85b41": "[ru]nickName：",
  "5bd466a7da64ba963077e1ead3eb19db": "[ru]何邦兵",
  "66f843af6452a7134c7348aa07fddce3": "[ru]张光理",
  "fc16960706041612e748df8035a534bf": "[ru]宋红",
  "37dcb63cd76fd1915e8dc355d0557ca9": "[ru]trueName：",
  "e251f52103e11901d737b2d0516839cf": "[ru]userName：",
  "6743ad9261d2592d8fc3cade0808bbcb": "[ru]status：",
  "1bb3393452b2ff9675f77b3fafd4d2c3": "[ru]工作台",
  "b6bcde9ee2f8b6677507b96f7618d2ab": "[ru]新品质量保障",
  "e5260d48222e5608f2d5ba0549107ecf": "[ru]过程质量控制",
  "3ecaf40e3bc326ce5aa7e3f44ebd4133": "[ru]用户评价闭环",
  "fe4416f2f855997fac1145545e0368d0": "[ru]帮助中心",
  "9b83c7eb5bb6cdf4624de43b105bdbf5": "[ru]全路由",
  "1432c7fcdba00f248023082857b52281": "[ru]系统公告",
  "0ec9eaf9c3525eb110db58aae5912210": "[ru]更多",
  "b60ec8b0690bd9c0caeaa65ee80a6e01": "[ru]待办",
  "bfdd85e099565f0d30ee024c6a2f1d31": "[ru]去处理",
  "002548a0f05a29837b139fb20e457bb7": "[ru]Copyright©2016海尔集团版权所有鲁ICP备09096283号合规热线",
  "37449bad8f75c8a898df87140c13b186": "[ru]企业标准",
  "5a21fc3a56a003ace034e495154048e8": "[ru]图纸查询",
  "0398c352e892af3d3ec61bf0aaba5912": "[ru]检测标准",
  "f7ef9633c64559e80c654567ca5ddd96": "[ru]有害物质",
  "fbea1c48071d7e43df61837cdfbd8a96": "[ru]新品质量",
  "96b190ab78a6f3c744fa3d56677e1d14": "[ru]测试认可",
  "c3f4372cdea9e57b1b4738e808ed8130": "[ru]测试认可2",
  "aa2647b3b17d7e74d1730d9cd7a4bb2b": "[ru]在线检测",
  "6705412c7dd9b66f3b0918f963351164": "[ru]称重检测",
  "d524f5c6cdfa469b6de0e53917625b2b": "[ru]质量体系自查",
  "3e1cb90cfee90167d41ab7503eba5daf": "[ru]变更管理",
  "db18bb70398e600fad706d55fb3afb94": "[ru]过程检测",
  "515ddeee81af7132f758a3c4a18f1cef": "[ru]出厂检验报告",
  "0be0fcb5e2ef6b3333b475ae869a85c5": "[ru]大宗商检验报告",
  "1e186f08b3ffaaa601af98f9a9941e5a": "[ru]色板管理平台",
  "d9e8fa0de4638ad402ecb62062882349": "[ru]现场PPM超底线",
  "f426a7bbab7ac4abd7d4b94e5817eee9": "[ru]出厂天眼可视",
  "6678172a32b1b7a2d056bda472aee0fb": "[ru]市场不良品",
  "d1d05a6da1e62dd4a6462ebe2fd7aaad": "[ru]标准BOM",
  "7b57bae3d9823169ad1dcc26afd99109": "[ru]供应商BOM比对",
  "1d3da79822f03f22f73ca43974d8a15a": "[ru]入厂不合格",
  "0addf9d81daedc6979addd92d00e46c1": "[ru]停检单",
  "f37dba0758deb9ad0bead5f15776dd35": "[ru]纠偏单",
  "45f148242e1d295b25aebfecd99fa0ec": "[ru]抱怨单",
  "327b8141aa34a7e4294c6aba8f0d8756": "[ru]8D整改",
  "2fe2b52941e1580031f4156430ae38ee": "[ru]质量索赔",
  "daa0d8109abe1b8f64c2802b5bc262a1": "[ru]用户评价",
  "e0cc45dce91f8b0f92578d2d75ad7e21": "[ru]质量抢单",
  "8fca15422833b617f9ff40381a3a01a5": "[ru]大宗商质量数据",
  "4cbd267973099462346173a3cc9396b5": "[ru]不良申诉",
  "5964a6ed5db12b6be764e318d0fc4230": "[ru]课程学习",
  "e5d042ada56cafab87618e271c08daa0": "[ru]系统操作指导",
  "63151aab35e422ed72ed2a4e7c20a2d3": "[ru]流程文件",
  "50d52dd929a75bb9b0f4afb0b7d879e1": "[ru]常见问题",
  "0cbf83cc07c9d82ce42fdb94880b20d5": "[ru]联系我们",
  "23b3934a797cebd79ec35e743ad3c6dc": "[ru]全部路由集合",
  "9dff884c419bc5aeaf71071d38fee690": "[ru]环保承诺书",
  "3fe23c87907c4bdfcd5b54f4ddc66360": "[ru]符合性声明",
  "cec6876260f9cb712539bd8a42f54769": "[ru]报告库",
  "e64599c0b9a694a4668ebdfdcbdf75a2": "[ru]报告库预警",
  "c8466e16f14442976eeb35b0fddba6b9": "[ru]宣告表",
  "4723db872d576dc9378c863553c0915d": "[ru]宣告表历史",
  "802f9c15e5f598fd4d2c45424ccbebc6": "[ru]新品检测（新）",
  "e9b78029dd0f622fb0179d4b47f5a8b8": "[ru]衍生资料模板库（新）",
  "39daf2cf0f9360adb7a7c60f58229bd6": "[ru]适用性评价(新)",
  "1265d47650048ba7a64819ed528e83e8": "[ru]检验计划(新)",
  "b7584af624c9f9edc4ce76e33757390c": "[ru]老变更管理（新）",
  "b8fd5c6d8a6e6b652403c8fd7bbc79b1": "[ru]出厂报告模板",
  "415ae3781a9af95efc74ae1de4eb71c5": "[ru]交付质量判定",
  "c919da822120f25f53815a26a294cdf3": "[ru]VMI交付质量判定",
  "751fa9cb2974a1642ff89fda34ac8b36": "[ru]大宗商钢板检验报告（新）",
  "472757e782278f75d0e659959f4c8d90": "[ru]大宗商化工直发检验报告（新）",
  "743045d285df029b961c5f83234fe2cc": "[ru]大宗商化工非直发检验报告（新）",
  "4220ba67f8bfc25dfbd64b838494b751": "[ru]色板管理",
  "acc0e2103f1a99a5e4b663c67fa3cca8": "[ru]出厂天眼可视系统",
  "1038b623d3f09532a64d8a5d42f677bd": "[ru]入厂不合格（新）",
  "f9a60329410760cc3a4d079c20939534": "[ru]现场退次（新）",
  "1910cb855f1ad646170ca5b02b2abf23": "[ru]抱怨单（新）",
  "e78d8c023898c1838716db4aa4d349bb": "[ru]老抱怨单（新）",
  "5c03478a15de84c5c7b12513c015835e": "[ru]索赔",
  "c9ab726b62137e61d90fa654740a90dc": "[ru]用户并联",
  "59ee8c2270b97173b2a4671d03eeb98f": "[ru]问题闭环",
  "dc29a9159591189cda096cabe07980c8": "[ru]质量水平",
  "314ff4bc828852d29650691d73bc5104": "[ru]绩效策略",
  "ac5091dd8c5d83525eb87c616d6c914f": "[ru]大宗商钢板领料数据（新）",
  "608f512c9001bf3d346b6eb20750e3d5": "[ru]大宗商化工直发领料数据(新)",
  "c204fdd3f78861a07def98403788bbba": "[ru]大宗商化工非直发领料数据（新）",
  "499001e12254773fde4995349c8e5cb8": "[ru]待办载入失败，请检查网络情况后重试！",
  "4ca49bda8c6707e9dd8c2536ce4e2d8a": "[ru]测试认可检验标准",
  "cc1bacb5117aa3f27e5e430cd28dbaed": "[ru]条",
  "97a81dbd411fdc693cb469849557e2f7": "[ru]未审核",
  "2b36030a302445461f14e736a9ff05b0": "[ru]新品质量-APQP",
  "930882bb0a8c7b53565de4f4d59f5ca7": "[ru]个",
  "e82c77cba4f49617ccf1e75ae16d17de": "[ru]专用号未提交",
  "637e8ba4889140d9f2e7a26707a81e79": "[ru]未发布",
  "a92dca781ceae32533208acf6f4de3db": "[ru]用户抱怨差评",
  "1a88ac0ce7cda47b71f0703ade4b6d23": "[ru]未交互",
  "8e6f1fbeffda21c46b0c43df4608123c": "[ru]入厂不合格待确认",
  "cbb29a75ec5ff07065fbd8f2936deb9b": "[ru]入厂待上传",
  "7027296030d6697a53257712a23bfc50": "[ru]待上传",
  "a9c09d3297b708f0ff815a93ec5f4145": "[ru]待提交",
  "ffce46be20f8f5be82ee3eb396fb8261": "[ru]环保承诺书有",
  "5d4bdd5cbeed83478db6dfe177f62951": "[ru]新品质量-供方自检",
  "8556e8e115c933e48c8225ec4097f73f": "[ru]超期",
  "b577ca398cbf20fdf7be5e7e585dd00f": "[ru]新品质量-制版设计稿",
  "12258247648501647d50663328f0ab78": "[ru]新品质量-样检单",
  "c580a25a1afd0be7b6c80a6d310e0690": "[ru]送样驳回",
  "2f86334d978ce238df05ef655a71309d": "[ru]未送样",
  "aba89743c71f48bf9af9347ac142caaf": "[ru]送样超期",
  "f00d716bb77669fa5ce5dce0fc972bfd": "[ru]PPAP（新）",
  "d20255f043fab2128f9a9588ce6d7ba6": "[ru]新品质量-PPAP",
  "6c1ccb254cad381bc1935040dca80305": "[ru]专用号发布打回",
  "ecc3e9bb07ff5245f533df5b7d53580c": "[ru]专用号暂存",
  "9a937b064dca5bdc97a82b5eeba17d6e": "[ru]质量索赔-市场不良",
  "34d22f83ae2b434ad919397ed951b25e": "[ru]8D整改单",
  "ec006c91b72265f9e0381115b71dfe72": "[ru]出厂检验报告模板",
  "e990f7bec36cf975499c0f87a2185ced": "[ru]待关联出厂报告",
  "88e0cae9440988339c50917ed0c3cb5e": "[ru]RoHS宣告表有",
  "f38ab39a1640fcedc013a58fe1dcc9a5": "[ru]RoHS报告库有",
  "c10f502eae7a1921c8be2cbdf21caec2": "[ru]预警中",
  "df4619ffe6ebbc9aa1d162cb4e79f523": "[ru]高管和设备产权变更",
  "2cfa0c5c1ee14385a496046903ac7098": "[ru]退次信息待确认",
  "2679d3b89e5d3d47723502a45061fa58": "[ru]退次待录入",
  "a0894dcaf55c3621cd6afedb585f673b": "[ru]课程学习有",
  "a4960087a90ffadf6aed1ce2a7894167": "[ru]门",
  "c5840a4372bfd1e53bccf62cc72ed2a0": "[ru]课程未完成",
  "ebb6113ac5786396fa59ead80406b97b": "[ru]考试未完成",
  "027dd5cd76f641e1a222bb6c8cc6b93a": "[ru]物料大类与检验经理关系",
  "142c0fb844deb074a6834e5aed61a604": "[ru]检验经理工号",
  "576aa483bc85104d6a1d900c680e95fc": "[ru]检验经理姓名",
  "468954a9df7480032c8ccea661e5fc7b": "[ru]请选择一条要删除的数据",
  "e2266f27975cab8289c40b829fdcaf01": "[ru]数据删除中...",
  "b4d0d97e91f6784b46a632f0935088a5": "[ru]请选择一条要修改的数据",
  "10bad1e8931b2aa732114cca00ed9bb2": "[ru]分工提交中...",
  "d547bbcff87bad646e54ec8a46ddaa7a": "[ru]分工提交失败...",
  "4163703c113f68181a408c70784a9cc1": "[ru]按类别分工（自制件）.xls",
  "c079407b85fc231803e602b5962eadf2": "[ru]检测报告：",
  "987121b7ea66c4a22677a7e37bebd0c0": "[ru]外检经理：",
  "81d9f505441078e06980e0bd02616e94": "[ru]关于",
  "4dc42d8f0095ae8c36c2c0dc8f88e688": "[ru]的入厂检验交互",
  "70ab9180fbc7101df91637a8c7372a7c": "[ru]物料大类：",
  "62d773f2fea6b5cc3313bfa1d0af5df4": "[ru]检验方式：",
  "52f21c4160f2049b71475824f5cf1c91": "[ru]检验标识：",
  "8759aaac75dbe6add2ba8910d890f970": "[ru]供方等级：",
  "2d5376a6e5c2f44d8b6e11e9d9a89c2e": "[ru]检验完成日期：",
  "567aed9c0c08e0af28ee254e9c34afa8": "[ru]批次号：",
  "ebfd518e85e1b5ec37d4ebe5b629a3f7": "[ru]看单号：",
  "4b0fad1f0ade6deb68362d029444eec8": "[ru]检验原因：",
  "ba08457805f7c2787e400cfd87ddbd55": "[ru]入厂不良",
  "0e853f78c5f093cac2b3a0e67e7bdc9f": "[ru]供方等级",
  "9b0ce36bfb60e8517a60d4284d44f8ec": "[ru]重点检",
  "ca3179550e48755ebbf44397f7af708b": "[ru]免检",
  "bf20b94c7baf7ccaad7f3698eb6b383a": "[ru]需求日期",
  "93af469fa709be8e0aa066c402c6908c": "[ru]入厂检验计划",
  "3edddd85ac2c5e612fb71dbb89e7d1c5": "[ru]日",
  "9f5530d0c5c7a6ea3719d2c2dd4d14f4": "[ru]一键合格",
  "69e2130b2693ccbd7d80a0793e411f43": "[ru]APP检验",
  "ea835126caf417e200fdfe2018b9b0bc": "[ru]来料检验预测导出中...",
  "728b5fa5d5512fb680ea221dc7120459": "[ru]检验报告",
  "3be481c0536b047aa76438e2a8739c98": "[ru]表号：00074001AC98",
  "dd1e72f6a6271ab9d9f3d4a842d00544": "[ru]编号：",
  "fd5b64ec505f303e7c052ce0d5690b21": "[ru]专用号:",
  "be5067b9c3d89ddada898b2dfb7a40c4": "[ru]供方检验资格：",
  "92b39cbdc7c144eb4bbb064ef29335fe": "[ru]检验标示：",
  "53285596305f4f7508724d282ed9dcdc": "[ru]技术(标准)要求",
  "ecb23fa395b8579293fbf94f09583394": "[ru]包含批次:",
  "c6bbf42cfa95cbd26917ac5dbe0adf00": "[ru]订单总量合计:",
  "9b854b44c361205efbe070245a0c6fa2": "[ru]试验结论:",
  "72695a16ba065750755b494c7a389dc5": "[ru]测试结果：",
  "115f3eb6175460438fc89c737749f6f1": "[ru]测试人：",
  "11b89350eb7a3cca5223829fb7fbba66": "[ru]测试日期：",
  "6ef477cad8b23c2a86d2ea58ea3fbe23": "[ru]不合格图片:",
  "cdecfdba43a97982759d42b593228e76": "[ru]其他见证资料:",
  "8177e5fe9e704bb4da0da6afe0da0da9": "[ru]停检",
  "20e17e48d252c7cb14d60d7e9a4d1901": "[ru]计划状态",
  "4f56d4f05e662f44a6f867ed96f84273": "[ru]未发货",
  "228bd149fac3295a49a7a6820bde5946": "[ru]已检验",
  "c1f8bc0b5e65370566836924f3e731a9": "[ru]已入库",
  "4823713d024a8f787112ed7c32386e6b": "[ru]记录状态",
  "2cf2167c33de4df3749f24f05399d6a3": "[ru]待记录",
  "e024d09f2139ffdf5ed17fe58c59c4dc": "[ru]已记录",
  "eaf58ffa03a21f916d157e52682cb36a": "[ru]结论方式",
  "b30584197c8b7baa038a3a55fa72de5f": "[ru]APP结论",
  "92610e5f23b48fbfb50bf2c30dbd4940": "[ru]未关联",
  "9ee4af7e255a6c480696be16ea36a87e": "[ru]发车单状态",
  "de579025b9c95712ab399056d9c5ed59": "[ru]已入园",
  "47e5fcda34dda37f45198f6bfd920a25": "[ru]队列中",
  "f5267e68e7ce39425a60301eb7e7a31e": "[ru]月台呼叫",
  "51b2cf6ae3c9e5b9275cd82159dce7bf": "[ru]已到达月台",
  "84ade164a2fe85ce3e5c50eaae47de04": "[ru]卸货中",
  "39bb43705490eecba45d56d9f5f129f4": "[ru]卸货完成",
  "b892515723cef157e693ad8eab8b746a": "[ru]容器回收中",
  "63673e6833ecce18ddc0673791a25f35": "[ru]容器回收成功",
  "37769e25fffd760203c860702167cd26": "[ru]申诉状态",
  "31b88d82c7738269292a70555719d18d": "[ru]自动认可",
  "fcbda1a3b9a1f991de0b81f94ee7365c": "[ru]供方认可",
  "db6e70ed7144c383e800dd36fe849cdf": "[ru]终判通过",
  "85d8dd6ea355bf679c4af04dc3c611c1": "[ru]终判不通过",
  "57268209c5832c81556ae8d368a7d2cf": "[ru]是否有效",
  "335e70ab6407070a2a7a7a74152f99e7": "[ru]失效",
  "996aab1c1d47062b88f794aef45b2b79": "[ru]未生效",
  "5263655209a9dcab8db6a55163ec4273": "[ru]供应商打印看单时间",
  "ae42e5fc351e747b1e71267ff98c082c": "[ru]待检验生成",
  "117b813268f48ac8fd4c69474e8ad9b5": "[ru]生成待检验任务的时间",
  "ff6dd50be5cfce890e98837cae22a971": "[ru]出具检验结论的时间",
  "9c8a4537c76738179f07bb837a91ec14": "[ru]入园时间",
  "5e2aaf4f9eaa906ebc4460621fa92e38": "[ru]入库时间",
  "5a9ec5e297640c6f180e76ce04dece0d": "[ru]卸货完成时间",
  "4112c666805c8646fa5fc69a453f2f88": "[ru]外检结论",
  "1e96de429694e905c7d04b24652d1359": "[ru]质检状态",
  "1c1e8c28f945901bf6d8d77cfd3254ff": "[ru]解除失败",
  "fee28bb942a1d8f95b523cea190b6ec0": "[ru]无检验批",
  "e95ca60ea0cb9c8785d60ab793d102ab": "[ru]质检无",
  "4e328bc65ff98bab1055730ed612035b": "[ru]待检验生成日期",
  "8c0f6280ef5a832cd3cfa8cd664800b5": "[ru]检验完成时间",
  "0894b9156e4012cb368c797175174a9c": "[ru]发车单号",
  "886b93431e91b3142f7f90045887777d": "[ru]检验用时",
  "f965fea30858da6b154464a16271116d": "[ru]次数",
  "04a10fcb42d9fe865acf534e7a021207": "[ru]转化原因（历史问题）",
  "14f44ac7e56713bf95371cbb3990321a": "[ru]例行转换",
  "1eb2c0f719ef667f23754b3c729bab30": "[ru]看单撤回",
  "f88522cf1b8a99e869ee231ac97bbc86": "[ru]进程",
  "b840131723882ecad8ba02da8fcb7f70": "[ru]人员",
  "188c235b5e5a7a6d58ea74a8723e6058": "[ru]车牌号",
  "26ca20b161c33362d88eb0ba0bc90751": "[ru]来源",
  "615ae134135f25a1249517cc4ad47e3b": "[ru]缺陷",
  "6d7773b27155bd42c4c4277ce6211d1a": "[ru]请输入两位工号进行模糊查询",
  "3abe4bbce992abcd6fa9ec963695386e": "[ru]发车单状态-",
  "94861bbbdad18e92db30e6fe42679302": "[ru]发车单状态查询失败",
  "56ece2e57609ca01a30e41fe16af3325": "[ru]入厂检验任务",
  "b66ab1d6c0a7d7b35b6ad263fb6dab3e": "[ru]入厂免检任务",
  "4a19fea4739dba308c3e94e5d450456d": "[ru]入厂停检任务",
  "6989026763a752a8f30c45eafd83bc6d": "[ru]请选择已检验的数据",
  "109264143f37c365b3dbe13735dd94e9": "[ru]请选择待记录的数据",
  "ff61b29d38b93563004cc0fc5013cf00": "[ru]所选择的批次号组合不正确，请重新选择",
  "f00eac25c47ea7f6c64c540c4a770887": "[ru]请选择同一专用号",
  "797a6349504d98323f6ba82352ec0e86": "[ru]请选择同一供应商",
  "4666b57a334e87cc80343884d2d28061": "[ru]请选择同一事业部",
  "17ce2d1ac62197abe1650c649ad6ebcd": "[ru]请选择同一待检验生成时间",
  "0ccfaa5d63556bf902ca04bffc0fa84f": "[ru]请确认事业部",
  "96646f0c9d8ee628dc0e97b9e50920bc": "[ru]物料已入库，不允许操作。",
  "48b809ceac81904676daef825071a179": "[ru]请选择待检验的数据",
  "64dcdc12a4fbb20b4d3cf87eb2cbe03d": "[ru]请选择待分工的数据",
  "feb25c54ddc8dd4a931b9d5fe4d6a231": "[ru]请选择已记录的数据",
  "00a892ba644274c350ba89fce7395289": "[ru]解质检库存成功",
  "ddf25643f5c6c3d1b7cb3c3f79d5c749": "[ru]解质检库存失败，",
  "860b75d9712f49266a228e55fcb81576": "[ru]您没有权限点一键合格",
  "f595726eee52dea72008bfd6706a9525": "[ru]一键合格成功",
  "0a572b426284efe8a3a9035484a22eb6": "[ru]如下检验计划是否全部一键合格？",
  "dba2547d1a5f21823709f51254552343": "[ru]全部合格",
  "889400fc54e07c5b41804e458951eb10": "[ru]仅此一条",
  "02bfda214c9e0ff514035f6326e58f03": "[ru]一键合格失败",
  "fbecd9e3d43ae01d2c28e2954d51f1d6": "[ru]服务异常",
  "6477b96bf459a9a91e1da7a0e8caaa80": "[ru]文件导出中...",
  "c250c8a912eeffbe6d05d123b27a42d6": "[ru]为空，不允许分工",
  "c9102e86c9bc648691c21ca7f0c4016c": "[ru]请选择检验经理",
  "5dfb2a7107d4ad83dbfb694ccb6a07ce": "[ru]分工失败,",
  "0c6663564d6b3aaf77ed35591aa5f123": "[ru]送货地点",
  "07a295fd1e2876fa76f2ed3a8a039540": "[ru]需求工段",
  "43beb2aeded793247bd97efb7ce3d2fe": "[ru]按照产业口碑会签意见执行，只适用于非直送工厂园区备件订单",
  "01fc425642bfaf84eb0d5cd4421467b8": "[ru]备件差异检验策略",
  "5d829fbafe028ef471d2d88d53af6d0d": "[ru]所选数据不能全部一键合格",
  "7c15a0bf57696a4ea0333ce25535bd61": "[ru]一键合格中...",
  "34566a2d4ca7bc525dba188de500be29": "[ru]入厂检验汇总查询",
  "04acc3eedc998039dee04aca1f710a5a": "[ru]默认查询1个月数据，仅能查询近半年的数据，查询必须选择工厂小微。",
  "26b8270b4dd0268bb45de49d7e21b61f": "[ru]关联记录单",
  "cddcc3fe77f07a620e315e4fee1b631f": "[ru]手工同步专用号依据",
  "c515f3385e7740c52e22eefc10b62f2b": "[ru]编号",
  "24269b2782af70f01e96e1fa3d20b63e": "[ru]供方自检资格",
  "57b6eadf55b6a0abf5a20e18f7f4bdb6": "[ru]检验类型",
  "14fe100c5702b53e5226a36048abcd22": "[ru]封样单",
  "5b48dbb8dc710cffe6313bb56a7f6d47": "[ru]查看详情",
  "f8178ce31afe953ee92fc051676da154": "[ru]检验原因",
  "6b36c6f7ec834692ec6c8e3816349fdd": "[ru]颜色",
  "c002044068ba901616b0e772ea3c5f5c": "[ru]企标：",
  "832b6565865ffcaa933399710f6f15d3": "[ru]企标名称：",
  "b85270cd3c06d8eb635eadcffbb10119": "[ru]播放",
  "5d971fd19163b05640a0d04c894a3ea7": "[ru]借用",
  "5dbadc52d4b084c66be1b0e0874b9f0c": "[ru]自定义检验项目",
  "0df7ee6090e5a29696200e62e489146c": "[ru]添加自定义检验项目",
  "7ec67207cd1a6b2dc5aa2080d4648c99": "[ru]借用报告",
  "c6c9da2b96a9b0db7966620b94a15f5e": "[ru]测试结果",
  "8cf0438609262886a420135ac6281b0b": "[ru]录入不合格数量",
  "7b504164a03652ba7ec93ba77788b292": "[ru]退供方式",
  "96ab6b90c9409982ab0c63ad59083fd1": "[ru]批量退供",
  "f5c3193bcc5377e2255d264979b6bb7c": "[ru]部分退供",
  "8887e33b20e9d386d07026ca91435dc9": "[ru]总数量",
  "9ea83fc0113491900238c36bff49d6c6": "[ru]合格数量",
  "70519a8aacd452f9e43e49774bcc8731": "[ru]不合格数量",
  "6fb44cf7e9770062a9b35a381fb8159c": "[ru]模块的外在缺陷或检具实测数值",
  "edaeee2684b3ba0e0a72368e9a75bb5a": "[ru]借用报告编码",
  "f6dd1cd8f40e43fcfb8c34fca40a7777": "[ru]*请注意文件上传的格式（JPG、JPEG、PNG），文件名中不允许出现逗号，最多允许上传10个文件且单个文件不大于30M*",
  "5200e96048f0e20b851caf376bb6aaca": "[ru]*请注意文件上传的格式(pdf,xls,xlsx,ppt,doc,docx,pptx,txt,png,jpg,jpeg)，文件名中不允许出现逗号，最多允许上传10个文件且单个文件不大于30M*",
  "2ee257e6b3c91a5b247090648a9318fd": "[ru]注：只能关联同一到货天，同一检验完成天、同物料，同供应商，同工厂非免检的合格验收记录单",
  "cb3b7c13f71828fc659149599a5b2a35": "[ru]检验结论",
  "bdb47a855ebe341be9353e67f7ae8832": "[ru]请至少选择一项检验类别标记为'性能'的数据",
  "742e6efd35af20e5637df6fb2b98fe39": "[ru]方法视频",
  "7be3d62ded2e3edc1e7006916816bc3f": "[ru]只能选择一条数据",
  "8dcd270939e3bb21ba38992884f45e13": "[ru]关联后已录入检验数据会自动清除，请确认是否关联",
  "14e90457fbb97a83932878c3a5f04f23": "[ru]关联报告成功",
  "9f73c6c505b78495955c3026c232ac56": "[ru]服务异常，删除失败",
  "62c85d28ef905759477de00649c16bd1": "[ru]删除关联报告...",
  "cfd42bdffe54f0f01df7f64403771cd5": "[ru]查询关联报告...",
  "2559942d65dcd8b18ee49811f5c9b654": "[ru]关联报告：",
  "756857d4cf3321490f2cc278e071b25d": "[ru]关联时间：",
  "70c52ab034182274ca3fc037e5fe8c16": "[ru]验收记录单和APP结论不一致，不能维护不合格数量",
  "b3804fff1f4259e56f394aff6d1ded27": "[ru]验收记录单和一键合格结论不一致，不能维护不合格数量",
  "48cd68d5f250a9d40c4791ac96f673c4": "[ru]借用报告只能选择检验类别标记为'性能'的数据",
  "63701be2d536aa3632632698736f5034": "[ru]请至少输入4位进行模糊查询",
  "717b233da4078a7280b1c237e1321aa6": "[ru]借用报告查询失败",
  "c3442a98d1f5840808dc4b663834d1fe": "[ru]请在借用报告前填写样本大小",
  "b95edfc76d303b096c73f28caeb16cb0": "[ru]请在借用报告前填写Ac",
  "5b969788b1e6d79b5b759540c191b50c": "[ru]请在借用报告前填写Re",
  "2d6ead46fdf9325d0db4dbefeecaa1d3": "[ru]借用报告失败，",
  "e9c40129c2e16b116d1086da081d69d2": "[ru]自定义企标",
  "3044e7235e192323f508518407199171": "[ru]没有匹配的封样单!",
  "acb3aec4d12f6ca06a1e45302030cdb1": "[ru]数据处理中...",
  "713a9a4060025058434a6bab03d69d88": "[ru]数据恢复...",
  "1435bfab66981c801fec61fd09b16da1": "[ru]数据恢复失败",
  "c2bf37c0c33d5fe78794ebc2f566489c": "[ru]更新后已录入检验数据会自动清除，请确认是否更新",
  "8e1ab5b979d5a681ce001a47dddf0644": "[ru]手工同步专用号依据...",
  "9ee1785ebe08ad2dcd0e9af3e6c77f0b": "[ru]手工同步专用号依据成功",
  "20e3bc0dd657fa82089afd299a751195": "[ru]手工同步专用号依据失败",
  "1e30dc04c4a50cfa91d925b2902f7b3c": "[ru]查询或生成验收记录单...",
  "1cbe1f54c2952674d0701406baad9965": "[ru]专用号依据查询...",
  "74dab4837fab86d193d7c6ef823c215b": "[ru]入厂通用要求",
  "8a920f7250a218cd16f94746c1b8e864": "[ru]查询专用号依据失败",
  "15e92e8d70436852f5c923b320218edc": "[ru]明细查询...",
  "69e95a695a6462a0e4d4daf2ecad4420": "[ru]专用号依据自定义企标",
  "6cc74bbf51ae66bac1b2db0d205e1533": "[ru]专用号依据中不存在入厂检验项目",
  "824f239f86632efe082abda37f930a4d": "[ru]后端服务返回失败",
  "20a495364a9fa0812a97d68215b093e4": "[ru]复制成功",
  "6ab57a09184558bd18fc3368be82e795": "[ru]在第",
  "2b65f4e5a291d73aef8e5f274c05ded2": "[ru]条明细项中，\"",
  "f48ab54f727e512ea609812d299c7441": "[ru]\"不允许为空",
  "a03c84b92879bf717cc4a801479f78db": "[ru]条明细项中，\"实测值",
  "a88bd51cba1928b44b3d002a0e6f1a49": "[ru]条明细项中，\"实测值\"不允许为空",
  "3d434b9a4e7ccf5028aabb67a7df0c58": "[ru]请至少上传两张不合格照片",
  "fde25b4a438ee1117c8a9196715e8703": "[ru]验收记录单和APP结论不一致，不能提交",
  "648bf245f463cb7eb1c29ccc24a29c2b": "[ru]验收记录单和一键合格结论不一致，不能提交",
  "031922c203b3bc756072a8df7c950e80": "[ru]校验出错",
  "88c46af36b0d2757d1fe49c7172bc43b": "[ru]样本大小只允许输入正整数",
  "79a2a6df8127635756158fb56d7a90c7": "[ru]范围只允许输入数字",
  "fe17e7b3f899b4acc03a038a237b6d94": "[ru]最小值不得大于最大值",
  "59f315d9a2255285a7653038cba83e03": "[ru]最大值不得小于最小值",
  "ced4ed044a24f563200b495c2f0ed5b0": "[ru]Ac只允许输入非负数数字",
  "58762fdd8956a31648243d7d90df936c": "[ru]Ac只允许输入一位小数点",
  "5d633b94f5bd6e73e71ef9320aeb8064": "[ru]Re只允许输入非负数数字",
  "47a46803ec9ac91003b2e8e06d604782": "[ru]Re只允许输入一位小数点",
  "2a33020e5b56902e4a5609063f5428d7": "[ru]保存中...",
  "3b108349b93f7c8c4e2346f8d48c092a": "[ru]保存成功",
  "02f02ff3c66b8b3394a562d125152900": "[ru][成功&PC#",
  "b6b09b79df6d811d1cdc980bd2a4332d": "[ru]|批次:",
  "c42479581f779f21161b8626bfb3a224": "[ru][失败&PC#",
  "d6d950f3575ab681657f628691f72a02": "[ru]入厂检验验收记录单",
  "8fcc07aca5b2f9eff46b13b32ab75cce": "[ru]验收记录单明细加载...",
  "78ff7f44f7bff1f401d22f1e14dfc92f": "[ru]图片加载...",
  "94bc3cb83b8b3d883202bdfead495c9c": "[ru]查看不合格数量",
  "65f3410e3c5307b6db8e5aa2ca83533d": "[ru]产业",
  "f29c543fffb9d72aca40b1faef58d7bb": "[ru]维度",
  "7be49279ea411a18dd6aface64ede5a2": "[ru]事业部",
  "56806e5aad209ec2d60cd003fd31d65b": "[ru]注：每天更新当月数据，历史月份次月一号锁定",
  "5bbc461045024147b06ad4a91b5cf84c": "[ru]检验策略",
  "b60be31cd28db5dc095b5e6035ff5ffd": "[ru]来料批",
  "1851bdc720fd22d82a6e267b4d52f69b": "[ru]①入厂检验任务+免检任务数据",
  "432d29257d8445a7464200b190dd79c3": "[ru]②同事业部、同供应商、同物料号、同一天到货合并计算为一批次（待检验生成时间）",
  "314447537ea31c55d996d77a168b8a22": "[ru]免检批",
  "561cb74eeb520942b812d84d9d75a15b": "[ru]①免检任务中取数",
  "ca1f7bbeb9d6d14e391c562043d8cd5c": "[ru]②同事业部、同供应商、同物料号同一天到货合并计算为一批次",
  "323a6e301c031cb3c66908628c02cc91": "[ru]应检批",
  "f47dc12d8cf38735a390a04ce17b7021": "[ru]①检验任务中取数（取重点检）",
  "88490e974522a9c3d4d12a87096cef76": "[ru]免检率",
  "8f719da3b5af0347922cdeaf4879147f": "[ru]免检批/来料批",
  "3a703d54e7616a16e0b30615391192bd": "[ru]分工任务",
  "2d60cdba0462cea184e5c37c17a9095e": "[ru]IQC人数",
  "0f349f58862234c4cda224c737e50c9f": "[ru]①入厂检验任务数据",
  "ab63c259a31a5b1abc0fc1a39d21fd0e": "[ru]②检验任务供货批次对应的IQC人数，去重",
  "efb36687cabae84cb628d0d950350746": "[ru]③IQC维度报表应该算出来永远都是1",
  "8982ed7a69915d301d9b0d6d7e458777": "[ru]VMI应检批",
  "ff593c0bc5e3c842df41d48f5f2f6c01": "[ru]①检验任务中取",
  "c4f6a14c7044a1e25c0e448edbb3ccad": "[ru]②按条数计算",
  "6fc8eadd3de25d1fb285211c1cf9639c": "[ru]日人均分工",
  "3bbe45f6412f588c99a4c52a8db51ace": "[ru]①产业/工厂维度：应检验批/截止到报表日期的工作日总和/IQC人数，四舍五入，取整",
  "ec15e828cb40cbc7f66ffe44ebca126e": "[ru]②IQC维度：应检验批/截止到报表日期的工作日总和，四舍五入，取整",
  "d56a99c92aa9b6a3ed066640030fbfbf": "[ru]③工作日总和=截止到报表日期去掉法定节假日和周日的天数",
  "e5283bb9ee36a7e899b9329a3b442825": "[ru]实检批",
  "e045bd32ea70d72594af4cce7ba94371": "[ru]②同事业部、同供应商、同物料号同一天到货合并后，按“已出结论”条件筛选批次；（到月锁定）",
  "c31eca430efe2e11e96073e25bc77f85": "[ru]③免检任务取不合格的批次数",
  "4b8b3470dbb9d1a65aae8453a93ec303": "[ru]④实检批=①+③",
  "d54eb8778c472067ad5fbda4ba9d70bd": "[ru]未检批",
  "44857d66f38adecc4eb85755326098c0": "[ru]②按条数计算，未出结论的（同事业部、同供应商、同物料号多次来料，如有一批检验完成，全部按照检验完成取数",
  "ff743232ecacc31c0b399069466bb9a9": "[ru]检验完成率",
  "71e3fde6ba7479a022be050f2fbcfe4e": "[ru]实检批/应检验批四舍五入，保留1位小数",
  "e91aefffca49d309cdacede5eeadab6e": "[ru]不良检出",
  "ad0aef80f94c827d698b12f37447b2f1": "[ru]入厂不良批",
  "83c04ccd30823bde9665ee0fc24a3bc1": "[ru]①入厂免检任务+入厂检验任务",
  "fded61013bd9cc5d4ed67eea8d8e2cfa": "[ru]②按系统合并逻辑取",
  "aff3625ec980331eaaa436dca6b9727f": "[ru]入厂不良率",
  "dd597056ceb004e4a972cd15eaad2457": "[ru]不良批/实检批四舍五入，保留1位小数",
  "8995232b8db82519b843a940a48a5829": "[ru]检验报告",
  "02eda834991cbfa8eac333f92efb43ce": "[ru]应记录",
  "2214a0b170868ad31127a7ef946ba26c": "[ru]①入厂检验任务，按条数计算",
  "abe12de491666ca008e9afc32df575bd": "[ru]②取已记录+未记录",
  "54e1355dc54bbb94c3ffd0adb8f89410": "[ru]实记录",
  "2758447a86bd984ddc54ffb1138918b7": "[ru]②取已记录",
  "7f844dfbfebf8e3db3ee008f2a635293": "[ru]报告完成率",
  "f43e2f6e0215e7963bb01b65e3b1aa2a": "[ru]实记录/应记录四舍五入，保留1位小数",
  "2ce4bfdbb62847fb09533b0baf8946c2": "[ru]现场质量表现",
  "60dd49d19800c5e5396905c28f0016c9": "[ru]现场PPM超底线数",
  "f2a0c4b8ccc37412e409b446daaf2b2d": "[ru]取现场ppm超底线报表中,当月超标的条数求和",
  "14af6601c25a25cca4bf2b505d6b01cb": "[ru]批量漏检数",
  "612ff2299e8052fc104bd39729a6b32b": "[ru]取入厂纠偏单+入厂8D之和",
  "450efd2fceffcc237c2608b976a3872a": "[ru]合计",
  "e0e48a700b19fb54518f3459188fcba5": "[ru]①检验任务+免检任务数据",
  "22b466da22da39f5d229cf328e96e792": "[ru]③检验计划生成时间",
  "270f8d382e34405a88e77f969af7c643": "[ru]①检验任务中取数",
  "3a232e541597503e637d525cfed6e5ce": "[ru]免检批/来料批四舍五入，保留1位小数",
  "d1f4ce0a6c07c8436df8bbbb2c40608c": "[ru]③免检任务取不合格的条数按“已出结论”条件",
  "ed6799ba07346bdcbd5e6cd5e6d0b670": "[ru]超期检验批次",
  "8fbc4c1fe7684fedb8dcb3cc9b6eec16": "[ru]检验任务中取数",
  "a4ff10fb38a76693b8f182c150db8f4c": "[ru]检验用时超90分钟的检验条数",
  "4fe31cbabeca765ef85f8c653378bd34": "[ru]VMI不良批",
  "6abb5d389670eabcf73763361f31a804": "[ru]VMI不良率",
  "a9bc005c9d19fc750e8c2d32d4ffced5": "[ru]VMI仓",
  "c270fc6fc944a6686d996ab313a4fe7f": "[ru]仓库",
  "2a50246f87265157224de312d6173172": "[ru]取仓库管理",
  "8f7222a4b41af5939d482b012695d311": "[ru]服务工厂数",
  "2991628af423626d4a23af0950f1f455": "[ru]①取仓库管理下未删除的工厂",
  "c3e0acf162ddf85586fdaf0e99514df8": "[ru]②不考虑优先级",
  "8110fe0bc8a6ff115faa15d651f652d1": "[ru]入驻供应商数",
  "b4cf6281a2f2e67a209120a4da652e35": "[ru]①拉取VMI6个月入厂数据进行计算",
  "ad7249a4633e3a0d3e10dcb2e9ca9ed2": "[ru]②免检+检验任务",
  "1ba2a781b4e9d3b15679fe0e25141ba4": "[ru]③供应商去重",
  "3882e54e4a4cadfafcde001d9ff7c265": "[ru]①按条数计算",
  "a29c09392bd5be903eeecdb8fc800309": "[ru]②包含“不检”类",
  "78d0f179ac061fff81585fe7e1d81d5a": "[ru]检验批",
  "b350789633e2e00dfe397a722ce6f665": "[ru]③取重点检",
  "a7e5aa80f064852556c50805ac4d54a0": "[ru]③取免检",
  "dc5e29b4e9fd8384c0ac7676233beca4": "[ru]不良批",
  "3c8b0b818bc2d0733054fdcfee77051b": "[ru]②结论=不合格",
  "d7ade62c6f49410d5b398cd7d6762e17": "[ru]③包含免检",
  "5448436a1fb8cfb12a23eaf558378eb4": "[ru]不良率",
  "348ddcb48e3dbcc09e1003d9e9b753a9": "[ru]不良批/检验批四舍五入，保留1位小数",
  "1fddec796649defb14fb111091c0ca15": "[ru]VMI仓获取失败",
  "9f694f603cabcde88c70dac736ba29b7": "[ru]设备名称",
  "cf05392308493479776c7d792698e752": "[ru]设备编号",
  "5858832b73994f164473bd888fd98eea": "[ru]设备型号",
  "02f41e236ca1f78790f4c98f2f1aa11c": "[ru]设备类型",
  "4f83841a3ba507307092c5e1f0880ec8": "[ru]外观类",
  "083803211a563cf75d236bfcb3be423b": "[ru]尺寸类",
  "98058df25466e7506787131173ceeaa3": "[ru]重量类",
  "2dfbd6956524b8eaf080eada4102ed96": "[ru]性能类",
  "5a0afc9dbd6c2e98769d4620d4fb5b13": "[ru]其它",
  "c7cd821bad0e2b2928c9132d72f5cfb3": "[ru]设备计量类型",
  "cbbd94c921ea8ee9055c488e4d9b2677": "[ru]设备类型A",
  "a4f7d3484037a0ce98f0f6595f4d747c": "[ru]设备类型B",
  "1ed4b62d71b7c561b9889e01e2f9bde5": "[ru]设备类型C",
  "714bf19934e942ef1c774ba06912714b": "[ru]设备类型D",
  "f4113162653527ba615169d30706cce8": "[ru]设备来源",
  "b12abb9927708eded4951bdd3c348aa8": "[ru]外购",
  "f5f45a306153e09e6b55aa8989e62e29": "[ru]自制",
  "bb0ae97fa4e1ef6de884f3ce13029376": "[ru]设备状态",
  "324712a3114c9368ab589ae06b6a4dd6": "[ru]维修",
  "3ec8c93dfd3e82b28420d61e6b09e2fb": "[ru]报废",
  "2d512ec063f7a0badb5986c7671dc932": "[ru]校准证书编号",
  "4643f066ab7f3762a944076750ec52b3": "[ru]设备所在地",
  "2da08d0c550a852350cbfc7e480d84bb": "[ru]领用人",
  "00edf903db41538d6bc24c2609273b00": "[ru]校准日期",
  "4b26b9306422b6d9f53304aa4af8101d": "[ru]校准有效期",
  "7129859760c3983c1bfb3a7a3b4646df": "[ru]检测设备",
  "ffe13456005d72e16a2f282120d72a41": "[ru]模板导入",
  "2acd1bf99244be19f6c129feeec9651b": "[ru]设备单号",
  "14e5f9b45b34b967e2f05a287a0e0f7a": "[ru]设备厂商",
  "c61921fe8159cc05fb467d0fd50019a8": "[ru]测量范围/量程",
  "64de76109eca0b56e7e9dba82a06f39c": "[ru]测量精度",
  "06ab05b16b687e9e1a813a152dc22a09": "[ru]设备照片",
  "d5a73b0c7f2f052a5da435ca7072362c": "[ru]上传",
  "20faa88f0d2f0ab5f771e88deb352132": "[ru]操作指导书",
  "db547c476bed52ec7c8ea817e929b790": "[ru]模版导入",
  "dad68e95c85cae427d87073b45e57178": "[ru]设备清单模板导入格式说明：",
  "f3aae169cec60a25dc04fa222afda370": "[ru]①设备类型、设备计量类型、设备来源、设备状态请下拉选择",
  "a52d86b84a0c928ac1e388100a81b138": "[ru]②日期格式需填写正确，参照格式如2020/9/10",
  "c234c3262b2b3ec20a146fc86706f3a8": "[ru]③确认\"校验有效期至\"必须要大于当前日期",
  "1df0e662e23718a5282ef626a322338b": "[ru]④所有列不允许为空，没有内容的填“无”或者“/",
  "4d77c14cff9be999944aa47b3ecb9e53": "[ru]⑤按照本行所给的示例填写文件，特别是日期部分；",
  "8e77b01094f87097b4b0d552fac9b78e": "[ru]⑥示例行请勿删除，数据导入从第4行开始计算",
  "2fbbd2046edc98f1c8f5f60b15eeab9a": "[ru]⑦\"工厂小微\"填写与系统中名称一致的全称，不要简写；非本工厂小微下的设备不能导入",
  "89cb1ae8b8131de7791b32b0c3aee177": "[ru]⑧设备所在地：自由填写，不可为空",
  "7fb80e53ca16c62caa21a0a4459a542e": "[ru]⑨领用人：通用/具体外检员姓名（不可为空）",
  "09a2ea5eba50696bb12222b3786912ac": "[ru]⑩已存在的设备编码导入成功后执行更新操作",
  "2c808b021ecc8be9ba1c940acb3dea85": "[ru]点击上传",
  "1d7338fcfe796e2fff09d6aa22981dac": "[ru]点击导入模板",
  "6b6e6dfbe1204cc8f99f3cbaa3b4000e": "[ru]上传失败<br><p style=\"color: #3a8ee6\">(png/jpg/jpeg/pdf/xlsx/xls/ppt/pptx/docx/doc/txt)</p>",
  "b6d16a8173dd0d43f580bc6882dc5e9a": "[ru]导入成功",
  "fddcd7c6e456e5b131cfcf780b837e74": "[ru]导入失败",
  "4e18ae8f039487066d8b1221d36599d0": "[ru]导入中",
  "51be930878287310a56e1879b31334f6": "[ru]查看设备照片",
  "9349b8bca9726131625d4fd965a9aa77": "[ru]查看操作指导书",
  "3a5bbf0c3d4f23c3df79aec708f0cce2": "[ru]操作指导书-",
  "e385a63b27bd85124a2f90a9f6c97304": "[ru]该文件格式不支持在线预览，是否下载",
  "f82cf35dfd834085e650967450982c83": "[ru]文件大小不能超过30MB，请重新上传。",
  "245b0c83b4cf257fdff0440be66a1903": "[ru]请注意文件上传的格式，您上传的文件不符合规范",
  "43a6c1deeccb51bb1d894a5e6f3aeef7": "[ru]设备清单导入模板.xlsx",
  "50940ed76fb720f73efb6f5fa91d3ee3": "[ru]下载成功",
  "65e200d30c86a93c46dcafaa151028f5": "[ru]下载失败",
  "0b7da7ede9fae2ca88bfc8c9baabdfd1": "[ru]解析中...",
  "5b28bb8a42410b5cc614fd01613e5dee": "[ru]请上传设备照片",
  "78c8af2432328827906224d782602367": "[ru]请上传操作指导书",
  "f3bb9f629c9db608c6bdf95d04e7cdca": "[ru]更新数据成功",
  "977b025fd2cf4554a983ace28056b991": "[ru]请选择一项进行删除",
  "2cbfb1f92cfa368ced68141f54f929b0": "[ru]该检验设备已关联检测能力",
  "889ee5634fefd5f3a1dc9ec196545d32": "[ru]等，不允许删除",
  "5759ba067d8b6ef1bc9865429117032a": "[ru]，不允许删除",
  "ce4fefbae103d762f9836b83ef5d2c64": "[ru]若设备不再使用，可进行报废！",
  "5d5f26d5b4dda5e3dbacc3288a8f055d": "[ru]删除后无法恢复，请确认是否删除",
  "b4fcad2b61ab0cb05ec065fe2898044b": "[ru]检测设备.xls",
  "2909a48bc685173049d400e696e21306": "[ru]设备编号：",
  "f61f4cf6d0d544fad4507868b74696a1": "[ru]暂无",
  "16a11e66a09daac26326a7bd26382050": "[ru]报废：若报废该设备关联的检测能力将清空需重新维护！",
  "553ea80ece9b0714a1d14929d6d64488": "[ru]设备厂家",
  "762188b18f6b177997b8a9e309a7b127": "[ru]校准有效期至",
  "0fc8d8b3a9d5f2a425538f1eb6fe1be7": "[ru]检测设备录入",
  "c5365e2d417f792ae1a8bf4136a5510a": "[ru]设备照片上传成功",
  "3010eb0e2aa5ace452311a5f68ae81ea": "[ru]设备照片上传失败",
  "2b33492f96767377dc779d08293dfe0f": "[ru]操作指导书上传成功",
  "98466a71a5786596aa3ada6d4d590b0e": "[ru]操作指导书上传失败",
  "182886ac18a835aa1bdb32bd97605e7a": "[ru]检测设备录入说明:",
  "c51e80d57c23d230e4a217b09065ea55": "[ru]数据不允许为空",
  "9cab0c3459d715eee387482ad235c0c3": "[ru]校验有效期至必须要大于(等于)当前日期",
  "11742f86a43fa4fa3f659729207682ff": "[ru]设备照片大小限制为30M",
  "7896cbc15650694ff7fc502427181e71": "[ru]操作指导书大小限制为30M",
  "33b3e50bacbae34f6521a478c6b97fd0": "[ru]该设备已关联检测能力，请确认是否报废？若报废检测能力将清空需重新维护！！",
  "1e1534653b194d951cc733dc3f33ec64": "[ru]，不允许为空",
  "34c4d90c6d5a12d0baeb97b7d7d2896a": "[ru]校准日期 必须小于(等于)当前时间",
  "587178acc3802e4eb53a86b373c308e3": "[ru]校准有效期至 必须大于(等于)当前时间",
  "18c93c0915f2159bfdb7d1617a6f548a": "[ru]请更新内容后提交",
  "838efac737ccc3dc6a6ca9ab7066ee6a": "[ru]添加数据成功",
  "caa2e533da1ca7369f4bde15a1c423aa": "[ru]预约单",
  "b0bf68448bbccfed5577dc75c1b52807": "[ru]创建开始日期",
  "1d468be946f7be1133b3e2c682eee8c6": "[ru]结束日期",
  "5caab3927ee641f2aef6af616e702391": "[ru]检测开始时间",
  "f782779e8b5d709462c8e71e0d9019f2": "[ru]结束时间",
  "76768e10557b53cb8bf75623e5e023b2": "[ru]不检",
  "9c58505de3e05426b5443ff89518fc4b": "[ru]已关闭",
  "5d66371c7b2d444ff98e946fc654b367": "[ru]采购订单",
  "1b8e62f5a91a08425ecc7c665eea9576": "[ru]备货单",
  "097374c4f0045c859c4a6d00b19d3cff": "[ru]VMI检验任务（汇总）",
  "a1e5672cac658a8c41b54eebae0e870c": "[ru]预约单状态",
  "50c721d1b4731416f8e68351997857f9": "[ru]库区名称",
  "ef07e4bd3a6eb04ef8f3327be16a8004": "[ru]库位",
  "c5e4175df95c1a8a5cbc0fc183acade6": "[ru]检验事业部",
  "47136e34aa1f68cb1cd9bd70a3cc0e9e": "[ru]预约到货时间",
  "e1091076259c71311c2e80b0bc934ad0": "[ru]实际到货时间",
  "b5bfba3c7bc95f6e51c13743dc8eb7b3": "[ru]计划生成时间",
  "2dd284a03141c99d1fd7c492654ababc": "[ru]交集事业部",
  "da74b80932e7ba3d226528af78656d8f": "[ru]交集工厂",
  "b2ea07576c4d4c3ad808d1c836f3f696": "[ru]物料总数量：",
  "065f4fe3485e8818bb64206abd0d2f5a": "[ru]供货工厂",
  "4037ab9bef744ced4be12ef749f3f1f3": "[ru]配额工厂",
  "44f2a125bd9d22a2772402d448f10ae0": "[ru]行项目",
  "daf783c8cdf97643b4d2b4ec6e5b8f21": "[ru]分",
  "609b5f0a08dae0e0a7266acbdc2cf8be": "[ru]时",
  "325e03ee93c397b04a6295579584fd1b": "[ru]物料明细-",
  "62ae278a049655ea264e4bfdc0cd3280": "[ru]VMI仓查询失败",
  "54bcae3dae32b7cea303848e521ad7ce": "[ru]待送货",
  "61cf2430619d7e563f879811e6779b6d": "[ru]收货中",
  "09abce661dfb3a065d3ffe39f5182f7d": "[ru]收货完成",
  "7edcf0cd7e4c4923dba4f4b0e1b68896": "[ru]确认到货",
  "9e251ad116bec33b0b740324f9cd5063": "[ru]待验收",
  "74fdfc2b689883a048b11f7cd96caeec": "[ru]已验收",
  "2d4c5dcc74a1fd56c7c4ef5ac57cbde1": "[ru]已创建",
  "a0277385ce6bbf1daeb771109febee60": "[ru]记录中",
  "c3e17b8ceac68e26147b2ea468275ce7": "[ru]尚未维护验收记录单，请先维护验收记录单",
  "1402e074b20e18ef8419bbb29bf7e11f": "[ru]VMI免检任务",
  "995d28ff26d4516e05b11ca4eedee537": "[ru]VMI检验任务",
  "abe99b8e36fa2222e69f4836c613579c": "[ru]维护验收记录单",
  "6a0ddccf11e3fd8457b3b4a48142ac75": "[ru]解质检库存",
  "75aa7d741bcb1e4899a66f8005bdc22b": "[ru][序号",
  "e6a3067bd1c04a4f8ee40f3645695189": "[ru]请选择已检验、待记录的数据",
  "e73342e5f225626e0bcb859c6ff659b1": "[ru]请选择出了结论的数据进行记录",
  "94161342987e26d67eec86ba878d672b": "[ru]请选择同一天创建",
  "2b23ca58e04ac995cff098e79794dec6": "[ru]请选择同一检验方式",
  "195981e52c4b4f9c842449faf3c891d2": "[ru]VMI检验经理分工 -",
  "b041a26bef4c118c929a17e20c3bc9db": "[ru]验收记录单查看",
  "b87cd9bb827ec6a28dd29e5e5425dfe5": "[ru]记录单号",
  "2f0ca7d69466af7ae1497c0917468ce4": "[ru]照片1展示待检批物料的贮存状态和周边环境；照片2展示该批物料中随机抽取的待检样品",
  "4da150017e3302f0a3e8146f3c923f45": "[ru]现场照片:",
  "ea257f896f50993f9df36be21295a355": "[ru]VMI检验",
  "be8727441d91a9434ba55fbed476ee20": "[ru]该验收记录单无明细项",
  "31936150de5f1213d1388f27155a2d65": "[ru]*请注意文件上传的格式，文件名中不允许出现逗号，最多允许上传10个文件且单个文件不大于30M*",
  "59cd6f82070a0dcb697fe2c30e1a1302": "[ru]明细项中，\"",
  "b9507c0a3800bf15ce735842fcaa6e65": "[ru]明细项中，\"实测值",
  "0fc79502ae0e6fada274ee1743ecafc4": "[ru]明细项中，\"实测值\"不允许为空",
  "66ade9fc420cd633c937d4bb85d0688d": "[ru]请至少上传两张现场照片",
  "86a77bd27582e02fadea2e7b1aa80e45": "[ru]报告结论和APP结论不一致，不能提交",
  "0237a4dc676c564dd7aa6c34d1530256": "[ru]样本大小只允许输入数字",
  "c7ca840d3258cfd32073a36be10074e7": "[ru]VMI验收记录单",
  "9377db1f3d6a3e7f70eb77897ce98119": "[ru]现场照片",
  "e462bdb26d18dee606f7bb623d24b00d": "[ru]加载图片...",
  "7ea8abf21faf51ec55afd27a27e9552b": "[ru]VMI检验经理分工",
  "66df868fd7b9180cc5e9f71fee0ff3c2": "[ru]请至少上两张不合格照片",
  "a543423a9031bacc198dfd21add6d88f": "[ru]VMI质检解除",
  "2628a301c60406951ad6324da38ab650": "[ru]注：仅查询600条，如无所需结果，请输入更精确搜索条件",
  "87e5b94787772301bf8ff86fe8556dfe": "[ru]过账日期",
  "60a036329b364d73f88230258ccd585b": "[ru]采购数量",
  "2c1c8451d0f35d63ae968954073d973b": "[ru]未解除",
  "5436ce936717adad093067e9b0ec0ab4": "[ru]只可选择未解除或者解除失败，解除成功不可解除",
  "bd8e6a71d13db3685370bd7511b27ce5": "[ru]请至少选择一条数据解除",
  "98656e6e30ab2f8da794161f2446222c": "[ru]ERROR，请联系管理员",
  "04db2b8350fda629e2fde34e45559622": "[ru]VMI仓管理-",
  "302f276a934f5b3debc891512c311e91": "[ru]树",
  "3712972d84adf48acbd6ad24b4d75ad0": "[ru]列表",
  "df545cd7ae4f85f2c6f64abfe23c6d3c": "[ru]仓库状态",
  "7854b52a889b3ef0590d9f542efeb4c8": "[ru]启用",
  "710ad08b11419332713360d2750cd707": "[ru]禁用",
  "4bbef3634f60415c2bfe8b02168ce058": "[ru]输入仓库/工厂代码以完成搜索",
  "3065641ca3b6f85b4a9530ffe415a6d0": "[ru]仓库编码",
  "f967131d9d8eca19feef6cb6c7074cdc": "[ru]仓库名称",
  "341c722aac3c5cbff1a19ce4ec9ce850": "[ru]设置优先级",
  "8f30a261a83c395c84349b35964d42d0": "[ru]新增工厂",
  "c44b62aa75f715dfa26b6efada0a3f5e": "[ru]保存工厂",
  "7f56d964fe292144aa51187e3f9b6742": "[ru]删除工厂",
  "68f9e0557d1b9913f2390861d7ad1059": "[ru]1.优先匹配优先级最高的工厂（1：优先级最高，数字越大优先级越低；0：不参与分工）",
  "17fe48cae621db5e3f8769a908e327bd": "[ru]2.若优先级灰色不可填，请先在\"管理平台\"->\"组织结构维护\"中新增此工厂",
  "585e64a5a029b79ce0d8479ce211a144": "[ru]仓库已禁用",
  "3c2c5487b1f68369c256d907b304b11c": "[ru]工厂状态",
  "81a77b43727bb78c9dae12901e885c8b": "[ru]WMS删除",
  "8c609d40be26720672263dfee59b895c": "[ru]质量未启用",
  "4924baf77da8182d5de475e7934a4fef": "[ru]工厂更新时间",
  "08661d686a50e595aeea149781a93a78": "[ru]VMI仓列表",
  "07658b20b78807a78fc9d8cfae27d7b8": "[ru]修改工厂",
  "ee8ecb9ee03a10a2e6cb9a7471b964b4": "[ru]优先级",
  "5eb95824e9a7e9be537b6d906ccb8852": "[ru]正常：该工厂状态正常，可参与分工；",
  "5a3d944306f422e6a7e8d9f2841d59ce": "[ru]WMS删除：该工厂在WMS被删除，不参与分工；",
  "4ca92cf52149ce0c1852fef68aa6d466": "[ru]质量未启用：该工厂在质量系统组织架构中不存在或状态为无效，不参与分工；",
  "f7e5a2fafdb25d1ffab9dd1f02190173": "[ru]仓库更新时间",
  "64232b32608bf7377d71a6ca1a4d76c4": "[ru]请选择工厂",
  "ad311f321118edcaeb4c3679180199dc": "[ru]请选择仓库",
  "4c0b2715f15ffc61e81c200281da41e2": "[ru]已有工厂不允许提交",
  "665af3e679ca4896c78d79fa86e80912": "[ru]保存失败,",
  "6de920b4e4e08b261cda928d9beefab4": "[ru]保存失败",
  "6856a5e413347aaf7c291e016d3a6c46": "[ru]当前状态的工厂不允许修改",
  "754f1e41a2da4d53182e0ecbd55f205d": "[ru]工厂查询失败",
  "247048dbe3149877c604ef1fc0dc6146": "[ru]是否删除",
  "9202e243e2568db31e1033f2ba65cdbf": "[ru]删除失败,",
  "c27787c925a31a42e3fc67b131ea1dc4": "[ru]树查询失败",
  "0851698450f56ad98807d1b36336cd4a": "[ru]大产业线",
  "dcbff1a1c47601ad905fb49c3c54163a": "[ru]无效时间",
  "43a3d450d1677e42ec4c132bf6df6bd3": "[ru]特殊专用号",
  "3a8dd16ad9c518cf86e240714d02a784": "[ru]当日导入次日触发IQC；当日置为无效，次日自动变更为正常物料参与策略转化",
  "a105d598e7647ee2adc84fcb08678dc8": "[ru]无效日期",
  "ad71d36dd66dbe5c8f35981016c36ce4": "[ru]置为无效",
  "ba3eb0330d0ed607f55e53f9cc8a92d6": "[ru]新增特殊专用号",
  "48c0d5a76f7411c642adcc3ecbc2b64b": "[ru]物料号码",
  "d6948f550952d5b39a06ed5f14944653": "[ru]物料号名称",
  "454cc32d1016f36ce0b4f95f3f730bd6": "[ru]根据专用号自动带出",
  "e73c0a582a375f0775a0dc83e9965d12": "[ru]根据供应商代码自动带出",
  "5129554b43b2a25a5ffef3212cd222ed": "[ru]关键专用号模版.xlsx",
  "ffc903acb5517e8de52e2d38897f6109": "[ru]当前数据状态为无效，不能操作",
  "21aac6ae32ff33b5e00e18eda2d2285a": "[ru]确认要置为无效吗？",
  "a0141a92c9efc3bf7a340eb95779c62a": "[ru]置为无效后，信息不可恢复。",
  "8aee1fb2f47b4101b2aa4b507e1e6612": "[ru]置为无效成功",
  "a793f8e39ef69ee384c152b58b0e66cb": "[ru]置为无效失败",
  "44f54a0db426f765a913ba37485f7bee": "[ru]请从下拉中选择专用号",
  "c2ab51fce76bd38e6ba6ed64fb1360c4": "[ru]请从下拉中选择供应商",
  "2ce242933b2a57687368bec9cc4954a7": "[ru]请选择大产业线",
  "8cac537841848820601bceaef8d9da69": "[ru]新增失败,",
  "bac372f6cd7e039b4c5b0f3c58fc9887": "[ru]新增失败",
  "ba7dd37a34a3f593f060a0456e8adfbd": "[ru]低错描述",
  "8fe945f53eaf86e91915bf1f2f5c1518": "[ru]创建日期从",
  "fa6fdf15649a174a34ca49edbbcf5d7c": "[ru]更新日期从",
  "a13f7e84ce1b5b815a7feca5c881ca8b": "[ru]低错BOM管理",
  "b58c7549c0246c55b9cac96383200338": "[ru]添加",
  "7fe57135cbdeb6ce15ad31d88dd2b13c": "[ru]请选择产业线",
  "2737f7d1138f6542f106ee414ca0df2e": "[ru]物料大类查询失败",
  "47fada7494e4556df07576cdb5c989b6": "[ru]低错类缺陷BOM.xls",
  "f26513f569f48d450e613b457c28917a": "[ru]产业不能为空",
  "e846ca795f8b472a29979026b6b50eba": "[ru]物料大类不能为空",
  "5a84a49eebb0b8e3bc510f411691e83d": "[ru]低错描述不能为空",
  "33c386db79d1f6c7ed287d3d0e52588d": "[ru]低错描述最多不能超过200个字",
  "dd4520d651bfba79c682bd8d61ab4c8d": "[ru]添加成功!",
  "6452a05591d7402a8bcd9fadc950c449": "[ru]添加失败",
  "25725dbcd90508208c28553c252b5ff4": "[ru]产业线不能为空",
  "9844f9b323e8733b4f8c3dbd00f3530c": "[ru]修改成功!",
  "5badb3ba850fe144904d1bf6375fbd92": "[ru]修改失败",
  "b82063fd058fac45de11e669d3cf165c": "[ru]是否图纸变更",
  "d90587ae2b4d17e15e1645aa70c4e140": "[ru]是否需要图纸变更",
  "9f7cc9cd6b959af941b70f7872073e11": "[ru]图纸变更附件",
  "2c5d4f0540d1ce7ab576e3ed32719689": "[ru]图纸变更结论",
  "636f59bc3bee06dc2b5eaa893030cf2f": "[ru]无需图纸变更",
  "dbcbdf8c0275289b5fc8daa9dd6cde29": "[ru]待发起",
  "efa6ca40f3d4a9905be3a1a20ef08849": "[ru]图纸变更中",
  "2111ccbb190dca403b6f540adf08221e": "[ru]已取消",
  "14a82cf1b0a55fde0089de61f861289f": "[ru]未涉及",
  "25d41b1962156f03eeb623ab68a5955f": "[ru]是否涉及图纸变更",
  "ff0f532161b5908636ff69b5add95549": "[ru]请选择是否图纸变更",
  "9161997086cba857d3129b7bd7dce644": "[ru]4M1E变更管理",
  "034383d2cba2e491776da7745d87ecea": "[ru]4M1E变更-分工",
  "a0f6b138f3ada65c44d1e3ea7750742f": "[ru]是否推送图纸平台",
  "f630b9a4da10f81b7bb1c75bf6345558": "[ru]流程",
  "09b4cc07b50926b3e0499bf2b5ab220d": "[ru]流程图",
  "c284f42cce235b68c12331de42b82c0a": "[ru]4M1E变更流程图",
  "5656ad7a14918075b684be091ab5e75f": "[ru]空调",
  "803b8782bfa27ec1a9f0efad5e42130a": "[ru]只有SQE初审结果为未处理的数据才可执行该操作！",
  "e7856f2840584000a45799fb320ef955": "[ru]只有采购经理初审结果为待审核的数据才可执行该操作！",
  "a947d9024ff22abc6e527849e1f2ce67": "[ru]当前用户无操作权限，请联系",
  "8cfb80454e71bdc8bc9497890b127d37": "[ru]进行操作",
  "73ad4acf69901d02a25654178709e679": "[ru]供方检验资格",
  "6d2c01ad47709bd98fbc4dbbcea7c841": "[ru]标准名称：",
  "13b5c7509d81fefed45711381cd7ee67": "[ru]状态:",
  "3252e1722660aff48898ba6d45043f0f": "[ru]试验员:",
  "312250526f2d83319e59fd12d0ffe859": "[ru]不合格照片",
  "5a051bedca2b39511d3ce1010bad20fd": "[ru]其它见证资料",
  "d4223dbbff9ad16d1ff95a50b4e50ec2": "[ru]评估见证性资料",
  "64b84899710843d638894e5e60497904": "[ru]*最多允许上传3个文件且单个文件不大于30M*",
  "5ce438210f58d2e52ba8fccd3d99cb67": "[ru]星期一",
  "34e5216bc310f8c4db8fbfe772156237": "[ru]星期二",
  "711d996d87638acb6b93552fca140942": "[ru]星期三",
  "3df6af796b60302d6184ee1e02e090ab": "[ru]星期四",
  "450ea3af464ff9f8a08600c0c1f7b82c": "[ru]星期五",
  "1ae72f6826c2717962d123e8088116c2": "[ru]星期六",
  "2ff46ae69724e51658dcbda9c917a470": "[ru]星期天",
  "26b5bd4947df8be257c59dde927b400c": "[ru]加载中...",
  "6a5711d3336802791fc5637d4aa100f3": "[ru](变更管理模块检验）",
  "0da8dead5a54c967989257662e1088b8": "[ru]条明细项中，\"下达实验状态非“正常”或“检测-已发布”，不允许提交",
  "5e26e7a9514ba7760bb261cda170b9f8": "[ru]请至少上传一份见证资料",
  "012d8918e95262413dc93d5011b10868": "[ru]不合格照片不能为空",
  "50baed501abcfdd8f7027172ff58d795": "[ru]已经借用的数据不能再下达实验",
  "edb815afa4215e61cf83f83a131e1934": "[ru]此检验项目已出具试验结论，单项结论为不适用、未检测、不判定的不可重复下达",
  "e9006e0ce856e11140245d2258ab494f": "[ru]实验编号：",
  "8b2464809b09351adc8af1946f86b62c": "[ru]行中，",
  "017efda9fa54e22417db0fa1f3dae3ac": "[ru]下达试验前,需要填写所有检测项的'样本大小','AC','RE'值,且系统会自动保存当前数据.<br/>是否确定保存当前数据并下达试验?",
  "24df5db599e09b474015f503fbf8b93f": "[ru]已经下实验的数据不能再借用",
  "37af44378954787affb2f3f4a5d4f68a": "[ru]已经借用的数据不能再借用",
  "9beb91607d273b0a38529b9ccfc4bda9": "[ru]借用成功",
  "3cf181f728d7517693b7dec6c92c4b7f": "[ru]变更验证记录单",
  "d0c804ab7560a31bd529bfeaf8a3a822": "[ru]通知单号",
  "c2a4d0e2df195f1010b494f8d739a2a5": "[ru]标准编号：",
  "db06c78d1e24cf708a14ce81c9b617ec": "[ru]测试",
  "474d81f165d1f135e52cc9f70fb22bd5": "[ru]变更管理模块检验）",
  "ded5b53fd484374a45c75ea92beda6d5": "[ru]请选择是否需要试验验证",
  "c7863d67c83a46dc720d444821838cc3": "[ru]见证资料必须上传",
  "903eac35a85328e2f21b7dd5d10cc597": "[ru]自制件实验委托书",
  "6f8539eaa55ceb950251ed37eef44a7f": "[ru]模块检验",
  "46cb2e3378104fa4dc8c79abf6998e8e": "[ru]实验性质能力项",
  "017e5cf0789e41e9d8c064e3cf04db52": "[ru]请选择实验室",
  "d1b6905215072faf7edc0c95dbd82dea": "[ru]无能力",
  "0cc2e1218aacdf8ca7d59e2863963a58": "[ru]有能力",
  "1f24f412d5b15180e1282f4d3157945d": "[ru]-暂无数据-",
  "9d5fa8a187f09ed7954a6bd524a02cee": "[ru]至少选择一项有能力的试验项下达",
  "ca83cc9d831627383b9050de18e68f89": "[ru]判断水平",
  "42325f6c8ed44e2bc1c3601201167261": "[ru]是否通过",
  "8c4ab5982fcea30b260715ac494e7922": "[ru]审核结论",
  "15ae9a3b7597e93b15ecc01cbb0c6fc2": "[ru]审核结论不能为空",
  "eb171329eb7d9e58e5597d56c64a08bc": "[ru]模块验证计划",
  "4f099d251a15e5cd43de6aed1c9d5771": "[ru]模块验证单号",
  "a8b0c20416853bda54120bf19477ad11": "[ru]全部",
  "6d4e1224b97e2e4392c2d6aab7a4be16": "[ru]小批验证状态",
  "14871da03e4792eaf162ab2147bdf42a": "[ru]验证合格",
  "f23610097958d01cfe11f26c5d42f296": "[ru]验证不合格",
  "48f925d7cc024ec92076b4ce72bffaab": "[ru]产品验证结果",
  "504f64d7d1be56baaf9a0fe6461ad9b2": "[ru]变更检验计划生成日期",
  "25324fb2d043d5ea708f12c6d62e16b6": "[ru]维护项目",
  "378fe8135666eb280d69100c6386eca8": "[ru]申请变更日期",
  "f06fabd3bbb027dc396ef4515687a39c": "[ru]模块检验结论",
  "e1de4979e8c2c3dd88876914cdc3d248": "[ru]SEQ审核人",
  "06898c03c84b4f7578e8a7709e7eebfb": "[ru]开发审核人",
  "abaf3986e6731c88f2adb2add59104d5": "[ru]小批完成时间",
  "3158ede0f15bf83b8f341435f5b0b7ea": "[ru]预计完成时间",
  "f18ca9ef46e6ee28e37532f6eb5c51dc": "[ru]模块验证计划-分工",
  "470299ffb7c6c7d96585e5cfeba4e4e8": "[ru]已出具最终结论，不允许操作",
  "f04e254ebda28fb1a49592589677b3fe": "[ru]请选择待维护项目的数据",
  "5b79a56e839e800f3447a59a9719fad0": "[ru]该专用号不存在专用号依据,请在检验标准中维护",
  "8f3576557a9fad95899cc01db324b313": "[ru]请选择待审核的数据",
  "ffea6771fc8b1ad088674aaba4d8fed2": "[ru]外检经理不能为空",
  "a5ae37a396f75ed55214a32d2cb0bca7": "[ru]请先维护物料大类",
  "9549bbe86c9143b279b7476cf7c1debe": "[ru]模块检验收记录单",
  "1664a2ac24941839f343c0cb702828ce": "[ru]变更内容:",
  "58e9433164916422321914fd6cde75b9": "[ru]自动下达4M1E抽检单",
  "aa50fb4f3d0428925a3c35e7a814eed4": "[ru]请选择本次抽检的检验项目：",
  "15b303c7dc3de712a4b5af97e3d8dd4e": "[ru]检验工具",
  "2d842318fbd931286be387aaf5b2a7c3": "[ru]周期",
  "6bc2c14d1794c3c913106f61e9de325f": "[ru]检验方法",
  "8b9f2b5e08e98b9ab263071be29ece6b": "[ru]易出现缺陷",
  "abfd601ff0a205e4e22711f00c0b64c3": "[ru]是否型式",
  "c4b5324522d3aec6b5e3639387d9ce8a": "[ru]是否入厂",
  "2ec44018e5719be4350a7fee19cb4b99": "[ru]下达人",
  "58763be90569ac9bed106aa2cf1ceb6a": "[ru]供应商附件",
  "84d39926fb38a6332e88e19c6aa429c4": "[ru]请至少选择一条数据",
  "4d8d4eb39f2a148255ab3fc6fbbffca1": "[ru]请确认本次已选择的检验项目：",
  "9a672caefa880949de3452cf88bf57b3": "[ru]小批验证结论单",
  "0d53faf6a8f9e2b4dcb1c4a47b5931cf": "[ru]生效日期",
  "a5ca3122341fc24183a37f816b0d97c1": "[ru]需要小批验证",
  "c1ce231ca64704359007cadd2f61efe6": "[ru]验证时间",
  "779f7f3c52e50f85229bcf5af0b4abed": "[ru]图纸变更时间",
  "9703d765eef07e5e4f22da6f0d5c6dbe": "[ru]小批验证结论",
  "078eb4e109fe293554903a7bdb6f3406": "[ru]资料上传人",
  "2432b57515b3627faddccb1dd1df206e": "[ru]备注",
  "d92ec022eabb8de0ff78573cb1e89902": "[ru]产品小批验证纸质会签单上至少有工艺、检验、生产经营体负责人、质量部长四个节点会签，具体格式和内容产线自定义",
  "feeb187eb87285de6b0497deca5b9124": "[ru]请选择小批验证结论",
  "795aca2841230df7fa95f23f9db27b99": "[ru]小批验证计划",
  "148b0aa6bbb06b373e10680a528a2434": "[ru]流程名",
  "98ad234e849e1cadc8efff42afe19d46": "[ru]审批节点",
  "9d52b787ab5763e315d50e5f40645c94": "[ru]审批结果",
  "98a52a9e323816e1403f63a1b83e3454": "[ru]审批意见",
  "d22bddfcf4bce125d3cc491ec1f2f030": "[ru]审批时间",
  "9803c3e66e79fd6779d8aa0b4517b838": "[ru]操作人编号",
  "95c744314b911f602d3ce40f831751f9": "[ru]小批验证",
  "557fa959c08ce831ca2158114150912e": "[ru]审核历史",
  "74debe57d94c5f87dc355e2e7377b78e": "[ru]审核验证单",
  "8b8fed80d3c48f779ff7d0f03d687c0c": "[ru]部件名称",
  "8fd258852846c4fb573b295a89697d93": "[ru]外检/工艺经理?",
  "d03af4c7f2d5c051f83ee24c3da66083": "[ru]外检/工艺经理",
  "7298a200c9f7bcda0242e4353cb44780": "[ru]2023.10.12后生成的小批验证计划由工厂工艺经理进行审核",
  "a7e7c51ce647d54ad7551d8e6ef53e26": "[ru]是否标识转换",
  "d2be1fa38f06ac7c7c9767aa783dcd11": "[ru]周期检验(停止供货超期)-分工",
  "5f8c03bda7ddf392696db9b2fb637d96": "[ru]最终结论已出具，不允许操作",
  "400082f8f15dff7c8156864ab48ae4ee": "[ru]请输入变更编号",
  "5645b980443559e063b226cb286154f5": "[ru]请输入变更名称",
  "2b928541469c81e46ecc024b38e6429e": "[ru]研发经理",
  "359a6281e51e7c5ec218cce3458159ce": "[ru]请输入研发经理",
  "0d5b1c75b87b0ad282cdd445d701eb73": "[ru]整机验证结论单",
  "9616e721bdc4fe8a8eddfbc1ceb0546e": "[ru]需要整机验证",
  "d634eb4082317b351968acb56237af83": "[ru]整机实验订单",
  "672d148c8e153d5a5dfb23855ccd116f": "[ru]整机验证实验下达",
  "d0c06e8fe1987442423451b71ee47fa6": "[ru]只能借用一年内有效且合格的实验报告，选择实验编号后请点击“关联”按钮进行关联",
  "f2a4d0160ec6e742e2507d564aab1245": "[ru]实验关联",
  "3acaada618a4b8dcf622e25ddec8fa06": "[ru]实验编号",
  "128b4c390926e4ece738746f33d09a30": "[ru]只能借用1年内合格的实验报告",
  "6a60811e6992e2bdf4096a425d99d154": "[ru]输入4位查询",
  "0d7ff8e5332a6b31a53645ae6961dd9d": "[ru]报告状态",
  "fec3ca45405368bc225db7b7461df2f6": "[ru]最终判定",
  "cd870b08f21b6e8b8d4e5da723e11f63": "[ru]检验不合格项",
  "9af717f53a4bd0bd2bfd51f15d2a0d65": "[ru]下达时间",
  "dcc961ae4aa023191f0fd8611faac090": "[ru]已作废",
  "bc0aeddbb9efb9f004400021ff034da9": "[ru]见证资料需上传整机验证的报告",
  "18404a6f16da8690d9699f8f794d9e80": "[ru]验证人",
  "e87cc236001298a2af78dcb5a346db79": "[ru]确认上传",
  "e79c945926e404a18288ea8c3132b886": "[ru]只有待审核状态才能审核",
  "8675246f0b8f905c1e18a1c8d19137e4": "[ru]请上传见证资料",
  "4f2cbc4c3c09d7d9b043bf3be7a54053": "[ru]请出具验证结论",
  "1ad2f5818071bb08c94269c8ee7d5899": "[ru]整机实验订单第",
  "2d5aef4f2443b4694bd1dcc434636c6e": "[ru]行",
  "7e28adaab3291c001bf4ec0b555f648d": "[ru]最终判定为空，不能提交",
  "3235eedef729f56467bddd246ffae8a0": "[ru]有实验未保存，是否确认提交？",
  "a4ddfc983926bfbddff06cd5e16bcffe": "[ru]需跳转到LIMS进行后续操作！",
  "cd78075f5ecf0b944e4333f8d23f873e": "[ru]无lims系统权限，请先申请对应权限",
  "951820a9d58c9346165ab41901f34033": "[ru]请先完成最后一条整机实验订单的关联",
  "fdcea7383504d72fbe6528cd192b18e2": "[ru]报告发布",
  "db4b56147ae72e77a6438f6b6fb55223": "[ru]请输入并选择实验编号",
  "138a676635c31bde1e2c8b2c62432936": "[ru]注意",
  "3b7972174bab3220b385ddf0cd6ebe87": "[ru]正在删除实验订单！",
  "989a2384e594fa16b45ac0de02dec2f9": "[ru]实验编号为空！",
  "500c7ef94634a970a39715a38abe7d9d": "[ru]多看单号请用英文逗号间隔",
  "046179d46830837eb5fa3eeabde7c1cd": "[ru]看单开始日期",
  "6d04f1c96aabf40d2c924d0cadffa51a": "[ru]看单结束日期",
  "84b04b5f15b98225d60989440673bb1f": "[ru]生成检验计划",
  "173d194e04611a699db4df405ab7e276": "[ru]总条数：",
  "a3243b2553ac931d4187b5d4470e62f1": "[ru]未查询到检验计划",
  "eecaaebd4c2efd54b6a9108fef48f9c2": "[ru]每次提交不能超过1500条",
  "ac2d943e410474e5ccdd0a95000f10ef": "[ru]确认生成",
  "07e0015190e4684518b12bd63cf4169f": "[ru]条看单",
  "9ec42ad6542c764a275eba488d942fae": "[ru]备件明细",
  "4a126ad438996ce4ae706b369a6d507c": "[ru]维修备件-当期发生（保内）",
  "f46947a1daf92d553f3779b47e22b2b5": "[ru]本月不良量",
  "576d43a86b46b6a71e1d46dbd24b0022": "[ru]本月损失",
  "20d4c10c47d148f4438c4a48ea4c7d54": "[ru]本年不良量",
  "9730ae1b19b97480f97dcc5c4522e017": "[ru]本年损失",
  "200ab5326ee9eb4547c4aca55f42cbf0": "[ru]当年抱怨（前推12个月生产且前推12个月发生）",
  "f5a60ce86c30463fc958b5d9fae67ec8": "[ru]不良量",
  "a94af728555f1e79ba8993149a550a15": "[ru]供货量",
  "e3d05de041d80db4bda286a70ae5be90": "[ru]跳闸线",
  "c32d550c61a903d6881887ba3db63d53": "[ru]是否超标",
  "910a1df2a3f529102cbca5e4c42848ce": "[ru]工厂（CEI）",
  "b7612b71c08547dbd9309a2ec66b0785": "[ru]空",
  "00119639aaff86dd7c636af5c287efd2": "[ru]市场抱怨（不良件）导出中...",
  "f2a6f2cd849a682be6133a4793307e5b": "[ru]不良品",
  "765fc78d974311b5203a9a1a0de0f23c": "[ru]产业（海达源）",
  "4a273b3d227c2a62e03920da6dbbe591": "[ru]产业线（HMQM）",
  "7c0d18d294f6bb99b86809dd5260e0e9": "[ru]质量底线",
  "67ccb16ab7a694a00700d611ea6ef082": "[ru]市场质量底线(HDY)导出中...",
  "fd5d130081e3f4dd5149e4f8bb7a9db5": "[ru]物料采购报表",
  "a6d0cb568851f114d7008ad9ad8ce31b": "[ru]本月供货量",
  "e01e3519d94a53d976708c56607aff60": "[ru]最后一次供货时间",
  "9a8b6dce2b1912d76cf85330945d7275": "[ru]物料采购报表导出中...",
  "c5efc6c708ced65fa862671385e3ec1c": "[ru]研发模块经理",
  "464f3d4ea36eda2f87d65f7b2f4564cf": "[ru]角色",
  "2c683ef314dffadffaed40bcdae2a9f5": "[ru]研发模块经理分工",
  "5a8480af0cdedc2f5b381467dec76a39": "[ru]研发模块经理工号",
  "2312c7bb59542af30ef561fab6540ddf": "[ru]研发模块经理姓名",
  "947d6bf5d483dc922463b7cee781c166": "[ru]请先选择产品线",
  "7265dcbd6668d71cee6d5bf898143556": "[ru]请先选择角色",
  "56f0a1c0bc0408556c5810ea4f219dd4": "[ru]获取失败",
  "7dd0fae9244604c124013457c91014da": "[ru]获取失败,请重试",
  "f01b18d919bf33f4c58b0cf8db2e1944": "[ru]产品线不能为空",
  "fcec85ef01bf90cde81ddce17bd4c248": "[ru]角色不能为空",
  "e0b3e570cabb8de6c1c0a14b394f3cf6": "[ru]研发模块经理不能为空",
  "d6d345ddc3ed90c7854f1a3092cb7397": "[ru]分工修改中...",
  "c26a1cd4572b6f12b24491fb4a035176": "[ru]修改失败：",
  "74e97be70c4e4ac0fa3173812efd595b": "[ru]是否确定删除",
  "bc42bb8f945bbdaf2ef5bc7698d7e482": "[ru]删除失败：",
  "866b795eae73791792b09d33d6595fe5": "[ru]加载失败",
  "7354392be2837d5a9b27759cdbeea04f": "[ru]分工提交成功",
  "351bc223eedea638ce1ca55c0cabbda8": "[ru]分工提交失败：",
  "d1b86cf7e8896857be163761e463c7aa": "[ru]采购经理分工.xls",
  "a5e67039f2982468a836f1e427790200": "[ru]模具编码",
  "7499ceb55e904c0efc939c0f1fb64b2a": "[ru]模具名称",
  "ee359e3552245e7fc5938a32f0ef65ad": "[ru]总成物料号",
  "f53c4a787aed17b7081f884024354576": "[ru]模具物联号",
  "de8321e288ee6cdf4538442e0d998bb7": "[ru]调拨单号",
  "3a85d1eb5bf49f5422fd349187219a3c": "[ru]调拨类型",
  "f31b3ba2a1d0443da5bc6fb0b67c345a": "[ru]正常调拨",
  "97955109d0e6e0de4da260846c6ce658": "[ru]关差调拨",
  "28600fda8b3103dab318971599046be8": "[ru]异常调拨",
  "b996f707342f8626b1771989bb576c03": "[ru]新开模调拨",
  "f0c93faf3cf34e6e4b12a8b777f3a5b3": "[ru]内部工厂调拨",
  "dde485ccd345ce995da31e5fc0009667": "[ru]盘点差异调拨",
  "c22cf69029eb70530b7818ff31294745": "[ru]账实不符调拨",
  "5271698eddf8634102bf937fe1386d98": "[ru]调拨单状态",
  "a793b3a6f5fd4d2ce8b04ebd912712db": "[ru]已调入",
  "016eee88b945fc5f1a18aec5f8bcdabf": "[ru]调拨单已完成",
  "d7acd725f4901e407fdfbb05207f9f43": "[ru]调拨单待确认",
  "b439f8e2896fe2eeb49f4221fc3411c6": "[ru]待确认调出",
  "e08a5e0edac3fad2708a6334328af514": "[ru]待确认调入",
  "796298742d2b91db7a3343f6c6cdeaec": "[ru]供货产业",
  "bda554aeae85af4bfe2c1ce77bd108dc": "[ru]是否有NB模块",
  "08f7c3956b9a6e1d917c25913f6cffef": "[ru]是否超寿",
  "d393996eef8deeae89033c0224a8c0e7": "[ru]调拨时间",
  "2283ca055c1d20134a4164042fe921a3": "[ru]模具调拨台账",
  "e8798d03dc006463e0f85f730c4858b3": "[ru]模块专用号",
  "caff55d7169b43ca9bcdb1d641845944": "[ru]总成物料名称",
  "2016b1adf53e6c3d779b9170325591d7": "[ru]调出供应商编码",
  "14610e2df6ef6edd8d2a752a97e6460d": "[ru]调出供应商名称",
  "37c9b382b4d5b96b0e07fa1e5d320a17": "[ru]调入供应商编码",
  "991a0e3f4d4481130c00928a38c647cd": "[ru]调入供应商名称",
  "d072a3d1fe45ae0e7554d6eb5a70d175": "[ru]调拨状态",
  "cf8707cf20657f0ccf2b9c40d5bf590e": "[ru]模具调拨次数",
  "bca52e07c14961dbc393e217201b9775": "[ru]模具现地址（NB）",
  "655c33fed3c83fbc49e8066829f20ca2": "[ru]新品样检单号",
  "a07de10c5b0bcc77d42fb944bcfca1b9": "[ru]现场ppm超标次数",
  "58984b5ee482510dc4ae90ba4fcd20f0": "[ru]是否超寿命",
  "1d84e2f81b33e86d2e68bef5dbaf7813": "[ru]模具调拨台账导出中...",
  "e71e9dca806a78e787db83610550409a": "[ru]请输入至少4位模具编码模糊查询",
  "1ef2552fec7d73b04d202644bd4a0760": "[ru]请输入至少4位总成物料号模糊查询",
  "cd04efaa4e89813a6d47cd8552cdcb1e": "[ru]请输入至少4位模具物联号模糊查询",
  "43fb798995d3c19897bf496b262977d0": "[ru]请输入至少4位调拨单号模糊查询",
  "fda6eadf4576238006e70e46edfbe760": "[ru]物联号",
  "27c9208373a9031181ab72fa22feb9ea": "[ru]模具状态",
  "16b4c525a6a97b48e7d765616ae01b78": "[ru]未出厂",
  "7a70b1a7e8b5cd59fe9c3c413b9bf57b": "[ru]调拨中",
  "60136ec935423a8ae6c58d6cd3954bd2": "[ru]在用",
  "72d05c20c5166eb03aa64509e43b1752": "[ru]闲置",
  "8978a671bd55d75245588db6bf760f9c": "[ru]保养",
  "316e5abc166a336389234c61b71ea5a4": "[ru]报废中",
  "5dc883b148bb2afa91adc91406204253": "[ru]对缝",
  "e99db0ba053341a10f0d62b2b6bc5429": "[ru]已报废",
  "4ba834b70825f24db7066fa4863a416d": "[ru]冻结数据",
  "6795398c922bd7992f037c7564394c81": "[ru]转移海外",
  "7385a40297f267acb9694eec83b02742": "[ru]非资产管理委托加工",
  "91a2d578c53549ee88c23425578067c7": "[ru]需求类型",
  "acbd61152fd1bd073843f35d56ba0a37": "[ru]新模",
  "fe26bafd74d0248fc233d9796fcc92d4": "[ru]改模",
  "664b37da2222287adcb1ecc4e48edb73": "[ru]备份",
  "f41490655c56703dafc2f24012e2ec8d": "[ru]开工时间",
  "349a269cc199746e7b3ee10e0108a72f": "[ru]模具基础信息",
  "f28e64e136d41c343390d0b322c56613": "[ru]模具类型",
  "e9ae79905bc6c2aaa6eabef45639faa8": "[ru]四方验收时间",
  "c9100776df6a5ebaf770fd696295b24d": "[ru]首次调拨单号",
  "c16a9c3e5b836a9ae89401f4deb45163": "[ru]模具首次调拨时间",
  "cb95b8e9d5b7687c13465764c781e8e1": "[ru]模具合同号",
  "f1e8bead8680575b51ed573129508200": "[ru]设计寿命（万次）",
  "534faf7a78d145e0d7e230d12f2b0736": "[ru]NB累计模次",
  "39950b8c765ec38432b3a3339eece46a": "[ru]累计使用模次",
  "09cdf1a2db4fda64951a98a2b899e4a0": "[ru]超寿命时间",
  "baa9b9a6e3759dd5928393e9d895e447": "[ru]超寿命次数",
  "d6922c3d07f6f3188d643d72d5dd890d": "[ru]报废时间",
  "1f0fe140cd5ab00e671d1025ae211819": "[ru]纠偏/整改累积次数（模具）",
  "2a140de1796fe6d05e2aaf1e40368812": "[ru]模具调拨四方验收单附件",
  "7660eb30ca8250fa75b0996b7ff841c9": "[ru]模号",
  "889b64b06b9c2b34c465571e15ee6789": "[ru]合同编号",
  "28b988ce6ae6dd62d24bcb8a52119179": "[ru]文件类型",
  "b648361ab7e0edd9f2f032f91e01461d": "[ru]模具基础信息导出中...",
  "60858248d8ee2d563773e0a486510286": "[ru]请输入至少4位总成专用号模糊查询",
  "dd5a9876fb3d98f5b59a11aad43da10d": "[ru]请输入至少4位物联号模糊查询",
  "634898b20d81640498b8d06376b3efb3": "[ru]查看附件",
  "fb36f45f54ec9c9de745b566c6e60e25": "[ru]注：仅查询600条数据，如无所需结果，请输入更精确的专用号",
  "a207c4c2ad2a97bc21ec7b7a30622981": "[ru]年月",
  "bd29fda86b77588c35136edfd55fd447": "[ru]最后一次调拨时间",
  "20257b284c87689179c963524ae9af64": "[ru]当月超寿命次数",
  "aded1581ed4970c3bbf227d56f59ce10": "[ru]总超寿命次数",
  "026cff35cf1a87f747a54bc9ae6f4df6": "[ru]模具超寿报表导出中...",
  "10056f31a148dda832510d5f6a1f74ba": "[ru]模具统计报表",
  "46d2b17374497f30a587fa0210116515": "[ru]超寿命模具",
  "4e0523db2ba25cc91f631bf41b35e8f9": "[ru]模具总数",
  "af1715b1d57953c4765f69b4cf271d44": "[ru]模具超寿命数",
  "aeabdfc67f38425dfe6b888101131a8c": "[ru]超寿命率",
  "31229ccf4573fe827eec4592decbe180": "[ru]超寿命&质量不良模具",
  "b9e4e06dea2b02b3751a4a7ede39feb5": "[ru]超寿命&不良",
  "018672cac75a097e67e9005da22e41e5": "[ru]模具不良率",
  "e9c9dc870a34eb0f0af971e2d5ceda69": "[ru]模具统计报表导出中...",
  "d71378319f8f7c4369ec963c88b7f1ac": "[ru]模具编号",
  "3efe9cbdf37de13d969ade6b16671034": "[ru]工厂编码",
  "d9240c8961ef488ae30f7df471be1342": "[ru]模具号",
  "b4c7bebf414d42ef7fc96417d904dde7": "[ru]保养开始日期",
  "9a8b7ebd6500c0ebf17a194bdc1b90f2": "[ru]保养完成日期",
  "46bbcf51732efecff6ae08a938f8733c": "[ru]模具维保状态",
  "b2752a54514fddb85d7459738e38b177": "[ru]待保养",
  "1842870d4a71ec6349995e9ac3ff575a": "[ru]已保养",
  "4d5ccd01181095475e6d860358162e39": "[ru]已过期",
  "69b01ac579a6856a0fdb7e6996b9819a": "[ru]已扣分",
  "3c1643f376ccc693ee889553ec9a921d": "[ru]待维修",
  "924d32dcb31a9ded8f49b9997683fe00": "[ru]应扣未扣",
  "825180da5c971dea02fef317179e5834": "[ru]保养图片状态",
  "4814669349b534b9aedd5905d07f23fa": "[ru]异常原因",
  "8a5260b3ba181737296a6d8a19bf3a5d": "[ru]模具保养异常报表导出中...",
  "11352fabd780886b2ae48e11242df3b7": "[ru]超期状态",
  "ae4a461b7e810b1a3579951d8a00fec7": "[ru]保养开始时间",
  "c7964c074b339d69ab15a8c6c1c3575f": "[ru]保养到期时间",
  "dd484ba31394a699169d7c5d2e49d044": "[ru]上次保养时间",
  "6e3f4d934ef8115ab24aee2b0e10e39b": "[ru]上次保养模次",
  "7c76ffa36293ab6aca1e6a188e1177d3": "[ru]保养开始模次",
  "0d8de40fc3276924f76610a079141f55": "[ru]保养到达模次",
  "cd451fe46150fb377a22905fc8f95ec0": "[ru]模块商代码",
  "ad96194e6dc6c4ef2c665c506b8b759f": "[ru]得分",
  "20f1ee19ed57568cb6334889de92a864": "[ru]考核原因",
  "71f1e49662842fb37b95988b1a04ea2e": "[ru]绩效创建时间",
  "470501f0bc55c22c1c25452216982e2e": "[ru]未超期",
  "62b68ae211cf43857423fb9d9d32fbe9": "[ru]超期未处理",
  "5ad6056a2f09651c43c2a375042a9843": "[ru]已处理",
  "c5ebf9dfed9a7d21b36eb58a71842e10": "[ru]模具维保超期报表导出中...",
  "e450bd438755f0245e2cb52b410a2377": "[ru]问题发生工厂",
  "d999ebd73d65da2d3a7e94af9539bfef": "[ru]问题编码",
  "cb1c846904b51749e0402b4430cad46a": "[ru]问题状态",
  "fb852fc6cce168301447d1baff276dc5": "[ru]进行中",
  "653162b99fa587171d62aef542fb2b11": "[ru]已闭环",
  "67a5ff043ee568811855aab161a57e59": "[ru]问题处理人",
  "f848f4c02799266d6891a285754d7daa": "[ru]供方申请模具改进类",
  "11e0fdc2958d4477404a41e021dea0fa": "[ru]供方信息提报时间",
  "2b9f8faab76a587499e9197870a37d9d": "[ru]模具不良报表",
  "f242cbdb58ef1b0896f8e48b7fb93097": "[ru]不良积累次数",
  "e62cd51c9a561821c590899e70b9d5eb": "[ru]不良单闭环时模具超寿命次数",
  "8606a89f49a75ce97fe6a00aa7bdb817": "[ru]部件不良描述",
  "46f281497b13c79536a5e7e25db6d0f3": "[ru]不良发生时间",
  "d5685b864483d7c4a96631e2cdb474de": "[ru]供方申请改进模具类",
  "c6e8b038d5c4dec706a59054a5700c95": "[ru]模具问题描述",
  "b7dba1d9c3e7a85dbcb2bb66bb2eae1c": "[ru]模具问题照片",
  "e09200fc466957eb171e0fa2a5b1d386": "[ru]关差措施",
  "153e57d616c5afb8e869abdab6916573": "[ru]附件查看",
  "b60883d9e0705b1a30d04b0ae4481b54": "[ru]请输入至少4位物料号模糊查询",
  "68570ccbbeadf47ec238c86c4d7f2c98": "[ru]请输入至少2位供应商代码模糊查询",
  "d5221aec82c3bc9484fe52103898218d": "[ru]请输入至少2位不良单号模糊查询",
  "f175f1e695c7e4bcc619535dff51fe59": "[ru]损失索赔差额",
  "cf359dd541ab2708e991c6a458ce48ac": "[ru]现场交互",
  "68acd810d20fb295ff2cebdbceb5cbfe": "[ru]新品报验",
  "2748af5d288eaed9d1ee9ae399fd606e": "[ru]型式实验",
  "0d98c74797e49d00bcc4c17c9d557a2b": "[ru]其他",
  "f8c5001f7f406450f23e07e31e20ec14": "[ru]市场抱怨",
  "8a219a1bb2603f7b821980147dd9b4aa": "[ru]工厂巡查",
  "60223e68290c5314cd24c646e8a76a45": "[ru]现场PPM连续2个月超标",
  "d5772df36b9ef1e5a9bc1dfc627189b1": "[ru]交互并联",
  "85efeb18fe60a3a123cc0854af264698": "[ru]现场PPM连续3个月超标",
  "d2d100aed3a2a227dc0759560ad0508b": "[ru]模具不良报表导出中...",
  "06fa3d67bb001dbd838ea7d4f96be33e": "[ru]报告号:",
  "bb3f594e5b88e483e4ecbeb48bbd8117": "[ru]供应商V码：",
  "ab9171823cf0ff877181376ae3cefe11": "[ru]供应商生产批次号",
  "4b2f8dbe99855fdbcae45945efe19c82": "[ru]本批生产线体",
  "45874c85767113619ab5e110b87c69ab": "[ru]本批生产日期",
  "659d36500f21014ae4360729013f1fcc": "[ru]本批生产班次",
  "4bc70779dfcf23aefffe0e4175e410fb": "[ru]生产公司地址",
  "4088b9452f5cc640696039f845b2b2a1": "[ru]本批生产数量",
  "4158228943415a8cc85084d68ef18802": "[ru]单项判定",
  "93857b3e7110f600d178883ce9b9bbe5": "[ru]标准编号:",
  "815c8383e4d0e5642f8856a49e752c73": "[ru]标准名称:",
  "09334806287d60f5b2bb2a3719f30fa8": "[ru]通用要求",
  "7f8d0e059e1128349d44137989e27ab7": "[ru]认证情况",
  "fbd47964a9384edd9286d0ced8a14449": "[ru]认证名称:",
  "8cec96236fcf463d33b4373495a77b1f": "[ru]认证号：",
  "e65e9341562a7569baf0cf88025bad3a": "[ru]有效期至：",
  "b60042fc6c3d5bca58677094a92e9a27": "[ru]宣告表号:",
  "487bb72f29181cf97d58155646ef0b5e": "[ru]供应商判定",
  "2e0d9892075bc5322e7a5fb62729e2de": "[ru]检验人：",
  "fe29d3d7cffb862773a2f6f43127581c": "[ru]检验时间：",
  "9ea251b1d161e75872be246cf84b4c60": "[ru]审批人：",
  "247efdcc3c5a6289eefaa1fe66d9bf8e": "[ru]审批时间：",
  "c09e45e5b92cd767be3c844cdbd5006b": "[ru]本公司严格遵守海尔集团公司的工艺、图纸、标准、合同等最新要求，决不随意更改材料、工艺、模具、场地等，由于私自更换而导致的零部件不合格及在生产、社会上造成的对海尔集团公司不利的损失，一切后果由本公司承担。同时，本公司已对该批零部件进行了严格检验并符合海尔要求，报告（含系统电子版）真实有效，若海尔发现零部件不合格或虚假，本公司愿意按照《质量条款》规定条款接受处罚。",
  "96fcd35a18943619cfd1a1f80df740b6": "[ru]质量底线设置",
  "b643bb0be02662b6197f2ca0625f3990": "[ru]请选择产线/工厂",
  "c8b092402194b5f39dae7541bc9741e3": "[ru]请填写ppm底线",
  "af3b01f3d8f36edeeb17100ec28e8a0f": "[ru]点击添加更多数据",
  "d7ec2d0a6300a54865f488aa6a9936a6": "[ru]产线/工厂不能为空",
  "cf952ad6cfd1c53fa82429fca6c3991e": "[ru]ppm底线不能为空",
  "7a15659314b65f4eff3a79b5c1b4cab7": "[ru]确认提交？",
  "3b6eb9c667ec1e3a939d3d2b580e8335": "[ru]操作成功！",
  "12858e43f43712a6d964c3093d988b57": "[ru]请至少选择一条数据!",
  "07df7d38263f691001baa9881b1a3906": "[ru]确认删除选中的",
  "0176c40c6aa856fad2899532da35506a": "[ru]条数据？",
  "871f26f229e34bfb0cb91ae12fa29557": "[ru]底线设置导出中...",
  "8ad3fc971b0516a940c913b699625c7f": "[ru]请输入姓名或工号搜索",
  "29032be0fba1ac8a167b1d7e3e6d7416": "[ru]提交失败：",
  "301b2f60df1997ddf933b1d91cb4e419": "[ru]提交失败...",
  "18997e1537e754cc23b6ddd69f22f33c": "[ru]检验信息",
  "4cd67d60abc3c8b74e3231aab81b2c22": "[ru]开发经理：",
  "9e0ecb097dd458c98cc1e1d1300e02ad": "[ru]的新品检验交互",
  "9e2006e368c26ba578a878b369219384": "[ru]模块类别：",
  "49d25a6cf72ee8d80228d745bee6580d": "[ru]是否主关件：",
  "2e445cadd476dd602ebabc5206badd53": "[ru]配套机型：",
  "062ebef7f6ed5b281b24538315481c0b": "[ru]样品数量：",
  "54397ca9c9f35dc3616f05609785696e": "[ru]开发收样时间：",
  "96deedf84cb762ffd0e8b0b08acd5859": "[ru]供方提交自检报告时间：",
  "763723c576ff0b934e1251ecb59f8a6a": "[ru]自检报告审核时间：",
  "1ae98765ccc25e59454e1d544d6bcefa": "[ru]自检报告结论：",
  "03480e484aeed8582290ba861d199d89": "[ru]供应商送样人：",
  "80bbe17943e2cb9cfb4d22be0865b7eb": "[ru]供应商送样时间：",
  "aaa25da7f6b87119ead4bdcd1f1c4174": "[ru]检验收样时间：",
  "930aa3cf903c9eb4fddaffbff12be006": "[ru]检验报告：",
  "ad7e5453e3a015d59c4dcd93adbca8ec": "[ru]检验完成时间：",
  "8f6a7c28cdf0c09321dcd7c43d5bcf34": "[ru]检验周期：",
  "2540fc2f388cb0b8a2e2099777d3f23f": "[ru]模块检验结论：",
  "3ddc811916d8cc8c15f33b859d4c110f": "[ru]最终结论确认时间：",
  "7bd17ab7923adb083e719bcd3c6e4678": "[ru]模块新品结论：",
  "89b31be34e54d31e67a1a70f1eae1ce3": "[ru]新品检验",
  "449fba668dfd06d7c688a02219118c47": "[ru]采购经理分工",
  "022ddad55a44ca7921cf33b18675fbf7": "[ru]请输入姓名或工号进行搜索",
  "dc22a79152fb2959b63b44f48c925fe7": "[ru]采购经理工号",
  "2f33d6b0c37bac63333984f1d242a843": "[ru]采购经理姓名",
  "6aca3a72117ad6bde32d341493d30186": "[ru]产品线不能为空或者不匹配",
  "ce55c67252724ef2d770c3b3abae8e10": "[ru]采购经理不能为空或者不匹配",
  "d6b6dfe91df3f496403aecd09bddc401": "[ru]请选择采购经理",
  "bc0788fd917280085eb2abd0f138cd60": "[ru]数据修改中...",
  "1888cdeef5729473b37c0d2c34778986": "[ru]请选择要删除的数据",
  "3fdaeadf0e8a3154ae62784f04138c28": "[ru]添加成功",
  "fbb034dfc47a8b949dd41a14605c5333": "[ru]采购经理分工导出中...",
  "5c4d716a3ff52160d6ae365ebafd86d8": "[ru]张永华",
  "67d02cd999b25a4b049e048a8cbba243": "[ru]sqm权限中心",
  "642ab685aba1536a43228fea4ac9e11b": "[ru]报告号：",
  "2215f7bcdf0c05d895be5dba6d3104d2": "[ru]供应商生产批次号：",
  "24cbf02ccf7023ab5362d8ca17e8b037": "[ru]本批生产日期：",
  "8e8cffe28e6850d665237980d7329839": "[ru]本批生产线体：",
  "a88d5b2090d76368d95f6eaa05cee6f4": "[ru]本批生产班次：",
  "f693639ce689c2fd2c6e6454c59e5727": "[ru]本批生产数量：",
  "9abe0e520165966fed451b4a7874f4e9": "[ru]出厂检验可视化：",
  "494250b365a9f7f93c4183b0c613363e": "[ru]供应商暂未实现出厂可视化，暂无图片",
  "b13d24b2a36318f6120a1b039770b6a7": "[ru]入厂0不合格目标达成，已取消出厂报告照片关联",
  "7c98ddedde170cc8e6431e0d3abfffa1": "[ru]未达成入厂0不合格目标，出厂报告需关联检验照片",
  "4d60aab88d44218709493ef75cc45174": "[ru]厂区地址：",
  "48b28289e13a753857af781fd4d33de3": "[ru]生产公司地址：",
  "23803bdb1bedf46c553c11206a75d34a": "[ru]抽样样品图片",
  "713f77fe004d0583a8f903afcb9ad722": "[ru]检验过程图片",
  "55a3e6968f75c5f67c9f5ed0d4e5e520": "[ru]认证名称：",
  "78bdb82bbe4f8f7ad2a9d2526f422c31": "[ru]宣告表号：",
  "ce327ce33024c7de9008194745cc522b": "[ru]结论：",
  "6da8463c169bf64f7cedc5bd97f2a82e": "[ru]@/assets/img/vmi/编组4.png",
  "473f7c01345beae6c2dfe95b88b805f8": "[ru]@/assets/img/vmi/编组5.png",
  "fe770d56bbdcdf8a0a2a1a6721cc9940": "[ru]@/assets/img/vmi/编组6.png",
  "f31edee1eb1e4901f864b73c1689a93c": "[ru]@/assets/img/vmi/编组2.png",
  "0d8601f44bd2b37600be129346404098": "[ru]@/assets/img/vmi/编组3.png",
  "bd88bd30955a614a6e162e881adb62ed": "[ru]不良照片要求",
  "60fd1f1c8876e230141a3300dcfbb883": "[ru]使用检验APP现场拍摄至少三张照片。①展示部件的计量或计数型缺陷判定证据；②展示特殊类不良已执行破坏处理的证据；③展示不良物料已粘贴不良标识卡的证据；",
  "79e3553b7dcc718ebb4cd547f17c5798": "[ru]现场照片要求",
  "30d07a04d769d684984228e3458ee93b": "[ru]使用检验APP现场拍摄至少两张照片。①展示现场的待检批物料的贮存状态和周边环境；②展示现场从待检物料中随机抽取的待检样品；",
  "c0eafe6975d111df76bc974273eff35a": "[ru]周期检验（停止供货超期）",
  "8a12319dd3bd36615b61d0085fe4a6bf": "[ru]耐破强度",
  "da666f4fe0d3b53328a1ebfbe6f3673a": "[ru]边压强度",
  "01c101496d3685fec62802dfb085f8f4": "[ru]试验委托书",
  "916db86939d0b6bd4735a67e5c34344b": "[ru]周期检验",
  "b5894313c2d9cc88561f8cdc7071f9f5": "[ru]联系方式",
  "26b9c15a5211c7c0843ed9a2751f87b7": "[ru]评估",
  "8acae1ac523d6f30328fbb8f2c0fceb8": "[ru]风险评估单",
  "c9cc0d53fe43f1030208ae107ff057f2": "[ru]超期时间",
  "516cc6370a957b8eaf02718f688d7946": "[ru]是否需要试验验证",
  "df16ffceb35f392f98c59737bc6f0e63": "[ru]需要",
  "8755a53ccee7fa2da518b63e3097872e": "[ru]不需要",
  "ab3d9216a96830bb317f1e7d87ab8a0d": "[ru]评估人",
  "0ca2ffc4f2cd994a1cbde75fb71411ed": "[ru]评估时间",
  "7d5424d351df50b25c62f23776929938": "[ru]周期检（停止供货超期）",
  "d7dd0dc637ce83086e78e8807e7d9eb5": "[ru]周期检验收记录单",
  "c18b798a49e4bad4100bf763bd69970e": "[ru]评估状态",
  "0cdd8d87bb8a9498fb3038f1dbedb89a": "[ru]待评估",
  "bc1dfbb501316ef4648089ec2ae92415": "[ru]需检验",
  "1e12190235592f9f2a7cef7e2c75019e": "[ru]不验证",
  "0bbf1b4fe9cf5536e546d90b894ba074": "[ru]周检状态",
  "fe7f5e522defda8e8a358e1f6b6163b4": "[ru]供应商编号",
  "838416f27567063e783801d14bfcafa3": "[ru]最近一次检验计划时间",
  "362a1035b1b23e46126b8005fe5f9469": "[ru]最近二次检验计划时间",
  "e1317f673e37dabe7aff7c31134898f6": "[ru]时间间隔",
  "e9cfe6af4635959841327368f8cd638b": "[ru]请选择待评估的数据",
  "81aa89293b46275da56c771385756338": "[ru]市场不良件PPM报表",
  "694a25f29f5c5102b4486785f3991137": "[ru]供应商PL",
  "36f6c8834eab6076207e522645c510cc": "[ru]供应商工厂小微",
  "cfcd9c3c4a6331c8b1318736a8da4305": "[ru]供应商物料大类",
  "bcd5ba60f36bf43ad85ed5770c8e963e": "[ru]--请输入--",
  "cc6c35a3e0f97fb9747905dc13e9b625": "[ru]编码",
  "cba74bd8455f30d04434fc34e5b3ff1a": "[ru]单双点",
  "1c674781e3c559395e223bb4280e3a56": "[ru]市场底线目标",
  "966473fe8a3fbb93a36a34e138ee4010": "[ru]当月不良量",
  "7d37080d13dfcaae2512a776787543ad": "[ru]不良率PPM",
  "eed0d802d7770265e6ec3306c1da2686": "[ru]12月供货量",
  "4d9b7e21a5a7e3dd5226f31347c40900": "[ru]12个月不良量",
  "97695d47cd99888db66b70ca0927544c": "[ru]12个月PPM",
  "dc6fcd453fd959bf2f8c7267a371cc19": "[ru]是否超底线",
  "b144b3fc9ff1cb35484a7afde8bad160": "[ru]当月损失额",
  "735d49a299ac9bc2db6056ab586633ce": "[ru]认责单",
  "cb08ad6d69443335b9142e50786ad7aa": "[ru]市场不良件PPM报表导出中...",
  "7ef6eac88a182240de620cf439fe92a6": "[ru]市场不良件PPM报表.xls",
  "0483ab3b8a1addf8e15c140a9a8a2059": "[ru]市场不良品PPM报表",
  "871a4d520a4b9698ad36e06b8a03df8e": "[ru]本月损失额",
  "b75f40c3a29c571be626cebeccb1e0c6": "[ru]同期损失（月）",
  "a2e010093b7b6abb10402dbabcdc7437": "[ru]月趋势",
  "7cf412ba1d4f3dc17d0b0e7f27ea27f5": "[ru]本年累记损失",
  "c8eaf6addd35b16b95a4172c84781fff": "[ru]本年同期损失（年）",
  "6941ef3b68fcb254948303c99c870578": "[ru]年趋势",
  "dc327f4fed49c2811b40d2b767f02f85": "[ru]前推12月供货量",
  "9fcf62c091cb6b3e19ff32acbb5860f8": "[ru]前推12月不良量",
  "f23e13d213bde2c8069392b64cb8c3d4": "[ru]前推12月PPM",
  "782a7e978d37effbe5132b0281f73273": "[ru]底线",
  "cdf69235f449d974f495d8c3aad9dd6f": "[ru]“单/多”点",
  "5d8cc0fb6f490cbc8855325505b6b6fc": "[ru]SQE经理",
  "c5850e8d5e9bf4f8ce7347061cc18d63": "[ru]是否抢单",
  "e334a336b039008d10bda82eedab1dfd": "[ru]开放抢单编号",
  "ed119cd568c702008f98223026747412": "[ru]抢单状态",
  "d968fa57b0fc759bce7cf6bebcff76de": "[ru]市场不良品PPM报表导出中...",
  "a5c63da6ff9844a7ea01e07204e2f4ee": "[ru]市场不良品PPM报表.xls",
  "8ab92452d5570498cc9fac3f3a1496dc": "[ru]实验状态",
  "a3d0154996e33be987462870be26d0da": "[ru]文件状态",
  "24180f4b5aa44b93c2eb8e63a39b5607": "[ru]文件结论",
  "2dbb73b81760f1767dda27659aeb20de": "[ru]计划生成日期(从)",
  "e596a4369f9f622b044d366b1d13a0bf": "[ru]实际完成日期(从)",
  "5983936e9c307793edb72e03730026d3": "[ru]自制件新品检验计划",
  "9bc00dfcaffa57bf6a9b324b02e8a3b3": "[ru]样检单",
  "497c8434bc60bc8e338faea5d44a6b6d": "[ru]自检报告",
  "23ec39309965464235d52dc8d3769714": "[ru]检测报告",
  "d407639b6b638e4e05e64d5f25858fe3": "[ru]下达样检单",
  "8f5aa78d7ea46a3696bb861be5d0b55d": "[ru]自检报告上传",
  "4c27c3933aac98202b46b6118470926a": "[ru]样品数量",
  "e5f9182bbc48bef1c48ee00c4a1949f3": "[ru]检验周期",
  "50ea8ae3fd3e7dd7af522d1c34d636ca": "[ru]计划完成日期",
  "516d37e436ca866ebe56ae51f96374e8": "[ru]实际完成日期",
  "cb71230eeb38e0a834947f3d1ec123fd": "[ru]模具验收日期",
  "b95d09ccc2dbe84fff87f07d52e93ac4": "[ru]实验结论",
  "e7fabb07f8f9bd4d11240cacf2a648b8": "[ru]只有\"下达样检单\"状态的检验计划可以执行该操作！",
  "362b0ac9a97560271534c66a3abd336b": "[ru]自检待上传",
  "19ce8bd6b2b257e66dc7f3565612ad13": "[ru]文件待审核",
  "ea0276d648745f37217fc2f25865397f": "[ru]文件驳回",
  "38ead0262a0a25b9c4a706b53cb459e4": "[ru]文件审核通过",
  "1d8b626fc613558b92939a602c9e4ed4": "[ru]文件审核不通过",
  "209203d538edd4a89ed8d971abb3ec6b": "[ru]只有下达样检单状态的检验计划可以执行该操作！",
  "a01273df0c96d5b3b178c01a44698e76": "[ru]只有文件状态为'自检待上传、文件驳回'的检验计划可以执行该操作！",
  "94fd535c7f902e06a10077c1ca769500": "[ru]只有实验状态为'待检验、检验中、驳回'的才可以进行检验",
  "5d15d35ea11422a4773ea58f517e7f54": "[ru]只有待审核状态的检验计划可以执行该操作！",
  "4813e4213e576b04a4e6f98f58ae79ec": "[ru]自制件新品检验计划.xls",
  "e1e72891097553dfc841172439671cf0": "[ru]自制件结论审批",
  "144578558521fc961549ac0154d81e8d": "[ru]自制件新品检验通知单",
  "90728b958a859429a89f2223e0386366": "[ru]生效日期：",
  "619689faff12b0c21cff56a840c04678": "[ru]通知单号：",
  "19bee6a6b7fc674b84463fa7ee9c667a": "[ru]工厂代码：",
  "2153e04c74140dd4926dd724aad0d2a7": "[ru]工厂小微：",
  "222e3ac8bc88ec36a331f8639be6d029": "[ru]物料组：",
  "8f6862ebcb5e7af5991181adb0ec79f3": "[ru]计划完成时间：",
  "01fae90a796c02ab9563102096144935": "[ru]提交人：",
  "354cfed47adffdff6e15e79fb5695e9e": "[ru]提交时间：",
  "21bcce0805c2bae54dd87237be1437eb": "[ru]下达实验结论：",
  "8ab7e10ef943ba4cf0e00dbaedf14f8b": "[ru]检验经理：",
  "6970c3db32116771e7e6e4afeb2add55": "[ru]实验完成时间：",
  "5b5d991ed17dfd0f8a67c942f043ec2c": "[ru]试验周期：",
  "b6e15b7c0b86b2cd60cb1c31880ed633": "[ru]审核结论：",
  "5405ada94ec6727846b481be0834d384": "[ru]审核时间：",
  "ad9c406af98a1dc8d896b03b513b6c0d": "[ru]请填写内容",
  "4fce300663c3f2f9f1e2d7f729f8c1b6": "[ru]驳回提交中...",
  "3e20d5d1ce4f3ad70c5411aefbc7c76f": "[ru]驳回失败",
  "69d6005038fe5da6e6f1bd8906155349": "[ru]检测",
  "bec98b4d6a1c388cb3e49391a9bf80a4": "[ru]状态：",
  "32aefe85b32adaa8655d2a8dd498b18a": "[ru]实验员：",
  "00f70c55964b69ca328fd7fd206dab45": "[ru]工具型号",
  "d4de790ce46412d5d3b408840b60654e": "[ru]第三方报告及快速报验申请等资料:",
  "71fe3dec2fb57b1973ca9e48fe63d7c7": "[ru]要求",
  "992270bb8e9de4111d2b2f3192539261": "[ru]标准编号：",
  "45847db6ae619f4d14fce8954affd5a2": "[ru]标准名称：",
  "84cf5633a12b3db1fd998c9138d43bff": "[ru]标准类别：自定义类别 标准编号：标准名称：",
  "8a683deb0fa48ed8afe94d43be97f9a0": "[ru]检验经理分工",
  "303f85712d2b8df2ae0a0391e76265b7": "[ru]自制件新品检验通知单录入",
  "590d740e9c23636cb1f43b9d162c3ede": "[ru]请输入不少于四位进行模糊查询",
  "785d8db0b16782ab31f0d8890df1f9e3": "[ru]请选择专用号",
  "be3733754232a5fde59c578512d45726": "[ru]根据工厂代码自动带出",
  "bcb3344ce03724ec9a4f8529ece5898c": "[ru]根据物料组自动带出",
  "07776c59765079b72e7b52cf69d7724c": "[ru]新品标准检",
  "407f3df2c996cb376f253cb597127317": "[ru]批量导入",
  "288f0c404c4e546aa3683ff5054e85e2": "[ru]清空",
  "72fc9ba474c95d91c2339f4d07ac9163": "[ru]请注意上传文件的格式(.xlsx/.xls)",
  "6ad013b6049822a9ff94c5e5e771e367": "[ru]点击下载模板",
  "621b8df057fb03a0dc7a282ae0f0ff99": "[ru]确定上传",
  "1c2613cb90fbe516de0076b472471770": "[ru]供应商查询中...",
  "73528b3dcce04661e319362fd2406fd6": "[ru]请在组织架构中维护工厂对应的V代码",
  "325c947148542341a2907cdbf39a623c": "[ru]此数据在列表中已存在，不允许重复数据提交、暂存",
  "aed1dfbc31703955e64806b799b67645": "[ru]中",
  "29d37643b3851532be8bc81c97bb75f2": "[ru]此专用号样检单在该工厂下已存在，不能重复下达",
  "30766a01bdabd80a3d3384edf1c70f23": "[ru]请填写数据",
  "3b66d6bf4170cb25c317868ba96af372": "[ru]信息暂存中...",
  "85dc29bb117cb8640bb43e6cd04987ff": "[ru]暂存成功",
  "92c82a1a4e8bb2438974333b794b0b16": "[ru]添加自定义列",
  "63790a7e9148c6b0527757c49a17031b": "[ru]保存自定义列",
  "c42c2f882566e6b2d5eea5018666c9ce": "[ru]借用报告：",
  "4ac796be68a4305f0b518cacae51e311": "[ru]借用报告号：",
  "6dcd4345ec6fd0fffb5fcdc0084585f2": "[ru]实验报告删除中...",
  "4986056003b9584ac89091d859be8aa2": "[ru]实验报告删除成功",
  "578808239d9e0f38d1569ec7ab16a2d9": "[ru]借用报告只能勾选检验类别为'性能'的检测项",
  "cb30812a2571c8a4a3224b76fb94783f": "[ru]借用报告...",
  "b865617e1149f41b3f25e36921474473": "[ru]删除借用报告...",
  "304dce0236800192def51261f1b23b24": "[ru]标准类别：自定义类别 标准编号：-- 标准名称：--",
  "e17161141c17523a0999b9a44e717b4c": "[ru]保存-新增",
  "b94c8adab47e9b91bb865d3fc0261f13": "[ru]在序号",
  "60b0b106e083064a28a0655993b5012e": "[ru]中，",
  "40dda7406da9994319e1e46faaac71ac": "[ru]序号",
  "50c0bd7102c0090e7d97eecfe53b163e": "[ru]\"实测值\"",
  "df2c3cf4ad92b1e6e69712cf7c97eda9": "[ru]不允许为空",
  "a6b28b35e39466dc502cf2a1e710f1be": "[ru]\"实测值\"不允许为空",
  "0d72e415cc418d0915063652e75dff77": "[ru]下达试验状态均为'正常'或'检测-已发布'才可执行该操作",
  "77cb714fdb0860a22c1f3f062ecc5339": "[ru]保存失败",
  "4a5168c43f0b634f0323d6aed1efc1fd": "[ru]下达试验只能勾选 检验类别 为'性能'的检测项",
  "f78bc6c4316919d118d38fd1a780e5f0": "[ru]下达实验中...",
  "d47de13aea1caa4e997f410c710abe98": "[ru]试品名称：",
  "459f2cebcabc8a4660a95dedf1467c1e": "[ru]试验性质：",
  "cb903acb9b58cd9789b98378997d9404": "[ru]新品型式",
  "c572eb8d8269a876b46cf07a88c6ad52": "[ru]试验下达时间：",
  "10219d0509ae5fc2470bdebc45f6d14a": "[ru]申请完成时间：",
  "f99cbe4dfdf7734656e593c2b4558763": "[ru]试品数量：",
  "5a7bbb36870f36996f52dfffb4af5f2b": "[ru]送货批次：",
  "7b740ece14bbccfe5ab10692bc04b738": "[ru]被试品提供者：",
  "a534699e8dfeca08cd8c9d7fb18068f9": "[ru]委托试验单位领导(签字)：",
  "79bc0386aa7028058b8c026e0a06f130": "[ru]委托单位：",
  "0fb966bee7bdb70fde5626e1e531b305": "[ru]检验标准：",
  "9fc8f14fb323948524fbe0fc0323ac45": "[ru]关联专用号：",
  "5ab74aeb070a26381262d41065e01f94": "[ru]试验项目：",
  "0a36ca6243d75644487ec0fcf856512e": "[ru]无试验性质能力项：",
  "17d621f156ed05cbfc2c3c28f4745d19": "[ru]要求试验单位：",
  "e503f085c2a4bb3b854e34f94113d173": "[ru]附加要求：",
  "740b62cb85a01c036c777388dc9ddf6c": "[ru]实验室查询中...",
  "eb38b93dc9e81f7a3ea86f8cf357443e": "[ru]能力查询中...",
  "f5c5c37ac037971e59711d76a60a39a0": "[ru]无试验性质能力项不能下实验",
  "a737ca0e374fbbc99c1ff5f8257ff410": "[ru]申请完成时间不允许为空",
  "7a1be3838f8135c97d6189aa93d363fd": "[ru]试品数量不允许为空",
  "264b5176c83bc0264f38e3e922573197": "[ru]要求实验单位不允许为空",
  "f6e4c1f0d4cb1af4bbd59242191c648e": "[ru]预计完成时间：",
  "31ecc0e65b4cd3e6b12577382bb56d6a": "[ru]项目",
  "9628c97d0a76ac2f7ddc699f7c838054": "[ru]自承诺",
  "62c09ff262713e74b09f3648053e9220": "[ru]附件（文件大小不能超30M）",
  "44ca3630dfc05431df3426bc3ff26c7e": "[ru]测试时间",
  "f39329af86cf19398687550196fe79a5": "[ru]不合格说明",
  "6711cfb1fdaab45187aa226e56c629fb": "[ru]文件导入",
  "da22a356207eb911ac329220d244cfb6": "[ru]模具验收报告",
  "cb617e7488f7393bd22ce17eda5c6b32": "[ru]全尺寸结论报告",
  "68ea13ee8ca0e8a512f33dacf3e6d788": "[ru]请选择要上传的文件",
  "7b20931281591de6aeea8bbbaf1ac91c": "[ru]上传文件必须小于30M",
  "f18ddbff48f2de1677c08f7f8004789e": "[ru]数据提交中...",
  "c26fb6e1d10127af8a396d1ea36326b2": "[ru]自检报告查看",
  "bd2a3b32f507bfde357047ac89b346f9": "[ru]提交日期：",
  "1debe5504747dbc5776679b5a3b2c643": "[ru]自检报告明细查询失败",
  "c54d7da1e24f0d1f7b72667edc6de572": "[ru]新工厂小微",
  "d0771a42bbc49a6941f59913fcda35e3": "[ru]分类",
  "e4b7df00cf34b41391230c965a1fcc6c": "[ru]转工厂",
  "59ab62ddae2ef1c8839848f0b8b61ea1": "[ru]调拨",
  "42bdd92ab16605de6df80d7cce345f3b": "[ru]海达诚创建QM",
  "0a3eaae133ee5fa16f6af11626f2dcc2": "[ru]云工厂",
  "e25b516b5206a0265e301e1d0992716e": "[ru]QM手工创建",
  "b97256ffc68531f10a1aea827b5d36cd": "[ru]产业口碑人员",
  "faee9486132431ed5de9a4037bc6597a": "[ru]大宗物料QM信息扩充详情",
  "9a38b076c840f09bca997f694604984b": "[ru]原工厂",
  "a6ca9bf957ac000ed191592e3ae1a5c8": "[ru]原工厂小微",
  "3807be8527055c4795191eddbce82c62": "[ru]新工厂",
  "f9eadbe63b3ac83e07dc88aa5ee4abb2": "[ru]激活下达数量",
  "c688a2b24bcd1a35c07decd20ab19d98": "[ru]检验控制",
  "22e888c2df8488d3befa6959de9ab747": "[ru]到期时间",
  "8ac8da83627df7b14df32cdbc8d34c61": "[ru]申请人",
  "5ba072c60bad0e857ea4a9520d8d288a": "[ru]申请时间",
  "6bba997cf0d9552ba059990b59f68af5": "[ru]质量信息记录状态",
  "6893a1c5a186fa8b621926f8ee1e3cf7": "[ru]大宗物料QM信息扩充申请创建",
  "bb114ab9e5de7db0d548194e17b6cc01": "[ru]有效期",
  "12d7f9ec02676a365dd1c202933b3dd4": "[ru]不激活数量限制",
  "f95f473d752d89d0d870378cf7efa216": "[ru]X-激活数量限制",
  "8611a9da9408d301077e549e153eeb48": "[ru]下达数量",
  "d60cc0e0b45d421218891767222f80d1": "[ru]创建标识",
  "d51f8de3fd5aaf4ea73b35a196b705f7": "[ru]X-不检验",
  "95c5bc562a2e2fbcc567efc659eac90a": "[ru]附件上传",
  "d01056987fe56514f4ac0e7983650715": "[ru]需要产业口碑签字确认",
  "6b58808b8fe8c9630a77a5185bf2c5e6": "[ru]上传资料",
  "b00e5be2d732e07abf8546f824533713": "[ru]转工厂信息记录创建",
  "93461386c89895ca9b60b3767c9f93c6": "[ru]1-检验",
  "81531fda9ffe7224495093f820825536": "[ru]调拨信息记录创建",
  "79fc383436cd977c621e3d44a1a7fecc": "[ru]请输入供应商代码",
  "a022c3638d160c89c3ae275a90c0c22e": "[ru]云工厂信息记录创建",
  "7dd6e65958138cc51ab0e04e5ba30d72": "[ru]应用场景：创智云工厂委托加工项目全部通过胶州部品实现",
  "b22fd48fd428539340c94420f9873e6a": "[ru]原供应商代码",
  "1743a5dbea4505758ea7f2e3ba859166": "[ru]新供应商代码",
  "7b745aca9b1b8ca3d5836ad9ac2c52eb": "[ru]青岛海尔部品有限公司",
  "8cf2efb322b239c4620327f015bfdff9": "[ru]激活下达数量控制",
  "f9a7c3cdd38a57e607de98d37e5853df": "[ru]不激活数量限制：SAP质量信息不做数量控制，可批量供货",
  "964242cd12927bb2bbdd1c19b9f33d67": "[ru]X激活数量限制：SAP转单数量不能超过所填写的下达数量",
  "332513ced137598c776cf648d0416d71": "[ru]限制下达数量",
  "9ea2cfa029adb986e0a777e8fd24059a": "[ru]X-不检验：入库时不生成质检库存，不需要解除质检",
  "fdba38321774689a0299f6fab88e03dd": "[ru]1-检验：入库生成质检库存",
  "81e73ac0c1e95e8201a7fe9347fe17cb": "[ru]卡奥斯创智物联科技（重庆）有限公司",
  "926bf7cd1d01f54eb8e9b1ef65471b12": "[ru]卡奥斯创智物联科技有限公司",
  "ef790ea8a7a563ff5e085eca85046c94": "[ru]青岛鼎新电子有限公司",
  "ff978b3a80bc4685e01811a8ef1fc44b": "[ru]顺德智能电子有限公司",
  "380f1cbc4da719194f8b2ce1f3234e50": "[ru]合肥领智电子有限公司",
  "30c475f90218b3da51455b9ae736163c": "[ru]青岛领智电子有限公司",
  "a8fe0b6155c5edc7ee99a5c4835f1bd2": "[ru]海达诚",
  "965d023429f6b5e1df8fba1b506ca337": "[ru]未查到用户权限下的物料号信息。",
  "d9472243abd13dcfb80e6474cb2f7db4": "[ru]请选择海达诚创建QM数据",
  "81fb20b4b0bda30900e55cb1cd0ce26c": "[ru]请选择待审核数据进行审核",
  "be82b8ce2c70e58d36cc0d5504bafe45": "[ru]大宗物料QM信息扩充审核",
  "bcc48749dc1094ce251f5913fb951d74": "[ru]审核结果不能为空",
  "e08e608c9408e404b78b9baa03d0adf9": "[ru]审核意见不能为空",
  "6be874f10f98582f04c580345db454b3": "[ru]是否确认提交审核意见",
  "c98f3d84633c3e56828cf7f5d99debe3": "[ru]物料号码不能为空",
  "108537854bd155fd2d504d38736c1db5": "[ru]原供应商不能为空",
  "da9b0f31417a706121ca932b8cb869e2": "[ru]新供应商不能为空",
  "cdf2b911a6b7212793e8d27767ca136f": "[ru]原工厂不能为空",
  "f4db1053281a86baebaa34ec371a2983": "[ru]新工厂不能为空",
  "b777816fa0ecc334b5ca045b74be11c6": "[ru]下达数量不能为空",
  "54c092812f002f6408dd23b3cacd561f": "[ru]有效期不能为空",
  "4f07ab2ccc01ec71a5cd25896a711bc9": "[ru]检验控制不能为空",
  "43bc091ad2fb5257fc2b94083a835b1d": "[ru]工厂不能为空",
  "c7200b626706bae909a4ee7c31ab9785": "[ru]供应商代码不能为空",
  "238425a4aab8fd8a8fd67f83724ce662": "[ru]供应商代码请下拉选择",
  "7ed5faeab09d2e7c95c44fa0704b2d83": "[ru]BU不能为空",
  "7d67ec908a820686f8952385e179ef29": "[ru]QM信息记录表.xls",
  "65bc0a3c6889b360d3db312b6dccab2b": "[ru]物料号请从下拉中选择",
  "833103549eddc688429a547076f3b46d": "[ru]海达源审核",
  "74b2e64aae927a7572c3f7bdcb3f084d": "[ru]过程在线检测",
  "ce2400865ddf88aa1b25023099afd61e": "[ru]查询数据大于20万条，请输入查询条件",
  "1e6d2fe560a665d256b9a2033f9cc22b": "[ru]在线过程检测明细导出中...",
  "771e8ac38dab52f167d52217b787224c": "[ru]在线过程检测-明细.xls",
  "00bb3a5369829805b7fd3e6d078372c7": "[ru]现场退次确认单",
  "45e92638bfceaf705947840c44ee1abb": "[ru]部件类别",
  "41dfb0bf6167ca035b93caf3e06d6c95": "[ru]原因",
  "a7beb26b9737d5af012d9bb77c8eb59e": "[ru]是否低错",
  "d767b40d2d4b9bcf296eb26299c629c3": "[ru]操作工",
  "0749fb80ff4adad421b0dcd887ce3fd7": "[ru]产生原因",
  "04b94195c3339a2a45e68c0bd791b8eb": "[ru]数量/单位",
  "4066b6dfb9c9b613d3c8456bb855d847": "[ru]看单打印状态",
  "edfabd34db2c3e5fbf7e87165dfbbeb5": "[ru]已打印",
  "f606090b4930700ae08b8ce9cbcb6cd9": "[ru]未打印",
  "cb14c90de2d9b17fb82f1429a904d6c1": "[ru]是否接收",
  "332c30f077522716057d4970ff8af02a": "[ru]是否取货",
  "0f0cd6547b5961d6aed395d2237e818e": "[ru]是否出厂",
  "bb99ae73c87bd994d5c86fd51485c268": "[ru]已出厂",
  "5cb5c763a2eb83d76fa1f6ae06b64a08": "[ru]待出厂",
  "6aa985206100167e5ea7b0d38d578c0e": "[ru]合并单号",
  "3924575e64039abe490b873abd6a5958": "[ru]纠偏/8D单号",
  "192da253760c41cbab573083fc3c7d5d": "[ru]现场不良",
  "5eb749e63deea81823823c4861810afe": "[ru](默认展示1个月之内的数据，可选择查询条件查询更多数据)",
  "e4e5028c151b476e8a2342874e8a7c7f": "[ru]检验班长",
  "b5343bd0278257e894c02451f7e88842": "[ru]判定时间",
  "b4a6fa8e63cc855935735a90b68fc559": "[ru]判定意见",
  "17b82fdb1da502972f87900f98200454": "[ru]判定结论",
  "5c575fc2cc4143bcd9c754fdeeecb01a": "[ru]质量经理",
  "328be3219402586389765c3d081529b0": "[ru]质量经理公议时间",
  "de70861eb4a2faf36a2d6b62a5b0f2e8": "[ru]质量经理意见",
  "c004fe9538b210d5dc992fca900bb7bf": "[ru]质量经理结论",
  "0a1dc2c808febcb6b98af8df2f0b67e9": "[ru]检验负责人",
  "56734faa9f29756673ce5096fadb8cb2": "[ru]检验负责人公议时间",
  "9356e5a0d9ba4d518fe799c482e917e1": "[ru]检验负责人意见",
  "ac02f6d1652d495d7f487ac4f50dd26c": "[ru]检验负责人结论",
  "fc4ed0419f8799cba7678812a2e3eae1": "[ru]外检负责人",
  "81fbdda9de0fce582291a567a7f014df": "[ru]外检负责人公议时间",
  "81c8d40f332302fc4d428660c820637e": "[ru]外检负责人意见",
  "cce1df2b7d1e420145fcdb859423de25": "[ru]外检负责人结论",
  "4ed5b49161457958596caef59bfc60b0": "[ru]质量部长",
  "66c3ef64afc038fc2f7153e93f95ab22": "[ru]质量部长公议时间",
  "62fc321282a0d94d39532dc0b848f70f": "[ru]质量部长意见",
  "6576b099c0145d82eaa27b89771d08e8": "[ru]质量部长结论",
  "a19af9ee91060a6d52367246c581b92b": "[ru]补料ID",
  "74ce057cc5a7e510c692a82df61250de": "[ru]补料单创建时间",
  "9c964f42787a82efc27e581115d46d73": "[ru]补料状态",
  "8805bb834ee3b39bcb0539817bae3321": "[ru]接收人",
  "9e95fc3d05f9f1187afa034315192c2b": "[ru]取货人",
  "b432c11e3dec3500265a6644a49a7800": "[ru]取货时间",
  "86bdc6a0ccafe9250a1827eaf076bb74": "[ru]出厂时间",
  "d5de4baeaa9208c1078dcb7d7c8d6c8e": "[ru]出厂管理员",
  "307ede2bbb21376120f689112480913e": "[ru]现场不良管理导出中...",
  "004bd8c2df60ea0cd58f45fc98045239": "[ru]不良申诉单审批",
  "2d58a69c6a91d357189e946051794c35": "[ru]表单提交中",
  "b8834c1d965c66154e711b3a67253e8d": "[ru]不良型号",
  "e998e6528503388a3f348a8fc0ec072b": "[ru]申诉人",
  "8f22e1b0d934d2cfc729a71d5f0c74ff": "[ru]申诉时间",
  "f3e5b25f91e7707e5da2fe1668a680f7": "[ru]申诉内容",
  "becb72acc35cf99fa649edcdd79c0531": "[ru]质量部长终判",
  "ec3141f1fe7cc930186acaab1868a73e": "[ru]审核记录",
  "907990ffe2aa0d62fcd98926415253a4": "[ru]终判人",
  "bf0d24f4bd7516f8d000347b7c7f8bf3": "[ru]终判信息",
  "0e7201b59e75e7bb2bb4f35723011672": "[ru]终判状态",
  "1f5fb3daefc6a1a96c909ef8a684f173": "[ru]终判意见",
  "933f58ea2f64d4f06f205fe872dfa1f0": "[ru]内检员审核",
  "7d2c9c7ac7de402abeddb7d7e022a33b": "[ru]请选择通过状态",
  "20bf8923c1a281820699af462987e552": "[ru]请输入审批意见",
  "7f701747763e26906f9ff4c0ed208e4e": "[ru]提交后，审批结果将不能修改，是否确认提交？",
  "afeb8e0f887043d444e4f89a66361014": "[ru]表单提交成功",
  "4697099d63e6ad5543b4c0848fdefd3f": "[ru]表单提交失败，请重新提交",
  "fa8cddd1d9052320cf5dfdeecda0a284": "[ru]返回后，当前信息不保存，是否确认返回？",
  "d02d006b23737636c4d662fec1a75f6a": "[ru]现场不良明细查询",
  "26cb711afb8ff42c471f0dddbfaea6ec": "[ru]不良类型不能为空",
  "f5a6a3a1e5bcddf045542b92ff04a564": "[ru]实验不合格",
  "e31486583190b17ea157c82faabb585a": "[ru]不良单号不能为空",
  "e6e4e28bbc17cb5986272bc77cdadd7e": "[ru]输入不良单号，可进行模糊查询",
  "a64fcc8c79de269f19bd5746fe111b38": "[ru]根据不良单号查出",
  "b79c78d963694a6eea59f441ba8b452a": "[ru]申诉内容不能为空",
  "2c15033baf4a3116291e231f7e3909a0": "[ru]*请注意文件名中不允许出现逗号，最多允许上传一个文件且单个文件不大于30M*",
  "1bbbb204023e59eba03319c7c5848fd1": "[ru]注意事项",
  "99f6ff342360e244ce7351c3bba57f44": "[ru]申诉单只能提交一次，请认真填写！",
  "f5a67399a03a30de156bc9ffcd9ef3ff": "[ru]此单号已申诉，请重新录入！",
  "d26e7275f9cd553afc85b43d5cc99f45": "[ru]获取登录信息失败，请重新登录！",
  "ea26fd0c8e461561f8aca37302a4befb": "[ru]提交后，申诉单将不可退回，是否确认提交？",
  "d9ac9228e8564657bbe9ca5359f95806": "[ru]创建",
  "f26225bde6a250894a04db4c53ea03d0": "[ru]详情",
  "1bd374d2ec389f19c2fd1f874bcb2ef2": "[ru]不良申诉单详情",
  "43ce425fab944164c963194a85b3c9e1": "[ru]8d整改单",
  "5b15bb20b0530ea7336b62440d78d417": "[ru]申诉单号",
  "18e0acaab1807f303877094aaf6ec2b0": "[ru]申诉时间从",
  "7fc555fa2fb44456cd874c4ec136da86": "[ru]终判",
  "4abff7d1c8f7da51ea7165516c1f1d5f": "[ru]申诉原因",
  "596c53dd1d48eaa1beff6247a148d8a5": "[ru]请选择需要操作的数据",
  "d6636763fcb93e94dc94aaa450a33c55": "[ru]请选择待终判的数据",
  "c693c91c7b72302bcfb741b097a2ec87": "[ru]不良申诉.xls",
  "be7e9fd1652d817f831cff03fc88765e": "[ru]提交失败!",
  "c0f92e28b64a4268408f10aa60dc47c8": "[ru]请先登录或重新登录后再试",
  "82a5a964e5824da60ed4be9cf70c0c9a": "[ru]创建申诉",
  "0ad5c025a7bd9708d0a2d77647b036a4": "[ru]默认查询申诉时间1个月的数据。",
  "45e07169ff62da631919d80b3beffaa2": "[ru]申诉单状态",
  "df44473bef692a048da1381709f16098": "[ru]申诉日期",
  "03c92754679c53af03423938b1118fcc": "[ru]请至少选择一条数据进行申诉",
  "33ef688cad0e5b2b05ad13f8357d5ab3": "[ru]不良申诉导出中...",
  "f516033f8a9c927a4e8eb31aa731e88b": "[ru]不良申诉.xlsx",
  "dd878fe2d1d3331719a81a0754002837": "[ru]现场不良合并",
  "0907a9ff952e8d616076621aa4a78fa3": "[ru]同供应商、同物料号、同工厂、同一班次（白班/夜班）、同一天（终判时间）、同不良类（外观/尺寸/性能/安全）的料废数据合并。",
  "b6cc00f20bed59b999788262512420b0": "[ru]请选择需要查看的数据",
  "cf9a47e0f8f118f267e7a534498cbd91": "[ru]现场不良合并导出中...",
  "ec7c28fac5f5bf57d472829c255de78f": "[ru]现场不良管理（供应商）导出中...",
  "130de92a66ef6e0eb9fde34a87492a1f": "[ru]认责单号",
  "057efb37ce764b74be1b9a90d6caa4f8": "[ru]工单",
  "f33568db2661fc9ae0d5a126768f5bc3": "[ru]机编码",
  "0cdc75549704fdef753a081828bdb05d": "[ru]自动编码",
  "4cf24aba16658a855f07d171731226f6": "[ru]金额",
  "6a620e3c07048291fdb26b6edcee7aba": "[ru]同步",
  "2041f9eaa8ef1c5bcf4e502f5ef7507c": "[ru]不良品出门录入",
  "0da394eba0a916773ea6b8f975a03d16": "[ru]请至少输入4位模糊查询",
  "77bfa4aa0e929ea86c7c84b53df7a301": "[ru]根据认责单自动带出",
  "bbe367f85e7a8a7b0b64442944291a5f": "[ru]请下拉选择工单信息",
  "45fb32f186148282f8ee49f0fe658df4": "[ru]请选择工厂信息",
  "d7be58c93368dc1797cd10e4a845ce30": "[ru]没有可以上传的文件！",
  "266dbf962c3d7f5d1de0b80525dbd8b1": "[ru]认责单不能为空",
  "f83cdd1d34fc85bb3a3497ede16afc25": "[ru]工单不能为空",
  "aff6a7a000932a5b8a90316fd6d3deb6": "[ru]机编码不能为空",
  "406c0ea860478da3c9c141055fd160e1": "[ru]金额不能为空",
  "3b9c3ed7491aaa05700f4ebf11c24aff": "[ru]工厂代码不能为空",
  "1826ec85f7211ae0e2032e9663285608": "[ru]请选择单号",
  "c0c9a6a00434a0ae3245d4c4c0883d78": "[ru]供货大类",
  "eb13449afff17eb45c5eedb8f7ca244c": "[ru]发起类别",
  "89bdb58413b5a7e110f08677cc7c4120": "[ru]交互类别",
  "84f9624fee4357e396b8d57707ea748d": "[ru]交互性质",
  "ab0c72ccb95d779c819b12c3ca664771": "[ru]供货物料",
  "826a75295b1dcce76c0abbb307fbe5ae": "[ru]现场交互开始时间",
  "cfbd2a5c120ca3f0a7cbdefb09058b7f": "[ru]现场交互结束时间",
  "641312eacaf235c657d229acef28a645": "[ru]交互方式",
  "f83e611ab76638e2cfb5b08ebb8114e7": "[ru]互联地点",
  "04f1cccbaffacee448a3e538de2ffd9a": "[ru]交互团队",
  "cc3704d034a8efd9ae87db54f7158089": "[ru]交互符合率（质量）",
  "95e0d70d1809d5267c2419eda58e78ca": "[ru]等级",
  "037e59949571287348f183cf6c798925": "[ru]不符合问题数",
  "b30fcfc3cf21fc7b4b92368972188372": "[ru]整改反馈时间",
  "25da3f9a4ea6e6dd1f292f5d6886b854": "[ru]整改后符合率(质量)",
  "38cc93580f9e8cebf327ea7bb4e4dbbd": "[ru]未关闭不符合项数",
  "6a49cf9f5c7670b5a173ed3a8a9f67cf": "[ru]整改录",
  "2b3c6ed1d8840afd3da2b28719d75b14": "[ru]工厂IQC",
  "b96b16287a4ded136be309ed682aed52": "[ru]产业SQE",
  "f750ffd19492f47477a51951775d4ac4": "[ru]平台SQE",
  "aefc33b937f703b0c05b85816458ad0b": "[ru]指示书号",
  "d91cae2187703736bee4170a80c86843": "[ru]质检解除(虚拟)",
  "a9fe2730e8d397666ac5ad057faa6af9": "[ru]库存状态",
  "d3ae78aeaa0a7904f429cd47a023b41b": "[ru]解质检库存列表.xls",
  "45a040bccd97340283f7a94199d70156": "[ru]检验报告模板维护",
  "a3c8104efce300d33d85c1546f656b98": "[ru]供应商出厂检验报告模板",
  "a1c90d3995ef66764d6a0734ddc21309": "[ru]历史版本",
  "d257c81889ddd830f4d3eb71c5ae93e9": "[ru]请输入专用号",
  "53d6d751de6344a0a81cf18ee1535e5a": "[ru]确定删除吗？",
  "bb75f437133fb1fa63331cc8f0a58eed": "[ru]本公司严格遵守海尔集团公司的工艺、图纸、标准、合同要求，决不随意更改材料、工艺、模具、场地等，由于私自更换而导致的零部件不合格及在生产、社会上造成的对海尔集团公司不利的损失，一切后果由本公司承担；同时，本公司已对该批零部件进行了严格检验并符合海尔要求，报告（含系统电子版）真实有效，若海尔发现零部件不合格或虚假，本公司愿意按照《质量条款》规定条款接受处罚。",
  "ad0ca85cdefc015f7357765e030a2c9d": "[ru]说明：本模板为参考版，请供应商按照海达源中的图纸、企业标准等依据自主完善，供应商出货检验标准应不低于海尔标准要求。",
  "1bf19c1953d1351b341497c74715e83c": "[ru]不同意",
  "717283b275d3f55673435bb403e3afcd": "[ru]请输入标准编号",
  "09ee1768685b932b57f15cf26cf3eb6b": "[ru]请输入标准名称",
  "63edd678c0b5ff3dfa733ce2735c2010": "[ru]手动添加",
  "33130f5c465d732d68ebdfbb80f4284b": "[ru]操作成功",
  "1dd554cdfc1ddf7dce13453805523c16": "[ru]变更",
  "1e3ebb5c3f2035447c33400f7c8bfbea": "[ru]出厂报告模板列表",
  "857b01fba27523240d8781a39698e70b": "[ru]请输入专用号后进行操作",
  "ee1dfef67afe79135693b84b74f6185e": "[ru]我已阅读并同意",
  "cde4504ac987144144b5f15417c144bf": "[ru]新增检验标准",
  "cfe99187b32b2d9c7ae162ade4544aea": "[ru]出厂检验报告模板.pdf",
  "80412eb8162ecbc694858fe783183d44": "[ru]自定义标准名称为必填项",
  "6415850d27675103b8980781a292db5f": "[ru]请先由海尔工厂外检创建完成专用号检验依据，才可以发起创建出厂模板流程。",
  "fc090ec29467aa95c8456777e9cad400": "[ru]请阅读质量承诺，并选择已阅读并同意",
  "a43b5c6f5d35622bb7284f6c92430691": "[ru]该",
  "9907025c3fab325138738b540799f542": "[ru]检验标准下，第",
  "55eac29b1515b574cf383ba69c7dda0e": "[ru]条数据存在数据未填写",
  "743c292b4cd3997c2b4414c45c1f0525": "[ru]通用要求中第",
  "94129ac56bbb9ec5d87d07a849dfc63b": "[ru]审核成功",
  "b38bbfddf4008ba0eaa3a9534dda5e04": "[ru]供应商出货检验报告模板",
  "9954ee67959720a954f5b74e67fe6a7d": "[ru]完善",
  "05926fc0d6398b71ba48ad9cfb31769a": "[ru]备注：输入完整专用号后从下拉框中选择。",
  "55971ce1d2552f4e34793899e721b59e": "[ru]请输入供应商",
  "16484ac1c48679b4488ec62c4d08bd95": "[ru]审核工厂",
  "33586afd2266abb456a47bd7386c40cd": "[ru]发起工厂",
  "c4a1f4e9af53b17b014775bca8e9c240": "[ru]请将信息填写完整后进行操作",
  "b7d637701b72abcaa348ee3b734096ad": "[ru]请先选中行数据，只有供应商待完善、驳回或待审核的状态可以完善",
  "e1cf0f69696e8ecb74cc2cd450b1d182": "[ru]只有供应商待完善、驳回或待审核的状态可以完善",
  "205444af2e98f0ef4f8bff7dd702a593": "[ru]该条数据请在APQP中完善",
  "64f053908c35b207f45e26ba742abfda": "[ru]请先选中行数据，只有审核通过状态的可以变更",
  "78efa944a8f747735e9a023c1ed94da5": "[ru]只有审核通过状态的可以变更",
  "3009709c07ffbde6dfe17d41c70ef835": "[ru]只有待我审核状态的可以审核",
  "26790a645dc481e36d8380194e038ed5": "[ru]请在新品检验计划自检报告中审核",
  "53c9e994ebe723df41ad2707ef2aa910": "[ru]您无此专用号模板审核权限，需由“数据来源”列显示的海尔工厂审核。",
  "0ba99d4a6ab6258595892cee17fea6b0": "[ru]您无此专用号模板审核权限，需由发起方显示的海尔工厂审核。",
  "0f6f8638c248a9df64772dfc73806c10": "[ru]该条数据存在问题，请联系管理员或提交ESP",
  "943caad2c331b749ccc1b5bbb19b3753": "[ru]只有供应商待完善和驳回状态的可以完善",
  "2339e95f7c9ec40e7aa19b53dd9e9e5f": "[ru]此专用号已创建出厂报告模板，请在出厂报告模板列表中查询。",
  "21c73c605da442aba905bb23b2c4f42f": "[ru]出厂报告模板.xls",
  "dc6f3f35fdea3ae845d417b4c4127e20": "[ru]标准检",
  "0ab16539ed7be5709b361d350956ab43": "[ru]加速检",
  "5fe2474e2b9efd61bcaf58783973b171": "[ru]样检单查询",
  "5e9f2dedca1912e68c2d743cc8d68a3c": "[ru]是否成功",
  "0e73a1535b59ff07c71e2ce64873c8fa": "[ru]plm原文",
  "a17f5fd97d0f8072dc3640c828ec14e9": "[ru]查询错误",
  "18a5e0dfff6bf3e19c600d2bf419e276": "[ru]新品检验原始记录导出中...",
  "c27c3a10db9fed20539845a82072662b": "[ru]最终结论日期",
  "8db9694be1294bfb8cfa768fc6e71298": "[ru]最终结论人",
  "4525b6c7cba19574efb3ee03137f3a7c": "[ru]最终结论时间",
  "aad46622d3935a3c405e560a03d98ff6": "[ru]老检测样检单",
  "1e7c154a1798832d5cc459cb18cf7c39": "[ru]供应商检验资格",
  "96512dac3186143373b658d7f87b71b0": "[ru]是否主关件",
  "c78ed9f830e583dd5941adb97da31199": "[ru]快速检",
  "ee8f7fb06b35f57dca1eaa0e5c5f98fe": "[ru]检测完毕",
  "f4e9791794c7fc408f840dd1d1467e83": "[ru]外检员",
  "87ef43bc96bd1ba545bf00403e9dbefa": "[ru]计划日期从",
  "f5c96a23588a9d9a9e689d643096b193": "[ru]供应商描述",
  "1e99fcf015ac08852758e0950892853e": "[ru]供应商资格",
  "d4c250e95503cf7f99d5c372ea0b3c8b": "[ru]计划日期",
  "0b4be817218baf8aad27238054ab13b9": "[ru]停检记录",
  "4058acdaa05be7ec3351fcf6c2b50fea": "[ru]人员资格",
  "21ea64e26c3ca8dd4ea7d5b6488fd933": "[ru]IQC审核结论",
  "a7ddf419f5c8d591c728031e94efb45e": "[ru]文件报告",
  "8c326c8fcb36ce8403691de7cff4ab0d": "[ru]验收报告",
  "3134c27a702f54775791e4dbe2b24956": "[ru]请选择审核通过的出厂报告模板专用号",
  "d20c4af50f87e16bf0e991b1946527d6": "[ru]当前专用号不存在有效的模板，请输入有效的模板专用号。",
  "4753a8527cf3294ff95a8d3882d5813c": "[ru]该批物料没有出具文件结论！",
  "4716ecee940d71cde43168edddc1e7cd": "[ru]该批物料没有出具结论！",
  "9a57d2d383874fbdaa7ed9de7025b3e3": "[ru]完成N",
  "ff5cb06bba6284b88db3df130ddf1e0a": "[ru]完成A",
  "ac2861f9c4119244e33e5f632934216c": "[ru]检测样检单.xls",
  "7152939a9974a66a937492fb099fe22d": "[ru]新品自检报告查询",
  "b2008aaab3dcc910e4712da771d71998": "[ru]新品自检报告",
  "affac2ba884d0629f91b56fd97827e8b": "[ru]报告名称",
  "a1f04aa1d1b2382f3e0a7ce101cc67a0": "[ru]判定结果",
  "602ea77cb22627b55c86b34b9a3cf388": "[ru]文件确认结论",
  "bce69e9e1958507204cd25a0a49f547e": "[ru]应检（",
  "efaafc4a4d4df7ed7d51006323ee0cdf": "[ru]）项     不适应（",
  "6601695702d0f34e69b29a9d32fa8c79": "[ru]）项     实检（",
  "da3fbf78facc77b0c1b96a17abb69b0a": "[ru]）项     不合格（",
  "357f03d11ab53bec8b41f6588a912d66": "[ru]）项",
  "0c3f86e6cee780592fa655ce154971f1": "[ru]所检项目",
  "718ed512f37db3d9477b00b59759a86d": "[ru]资料提交人",
  "53d10cd0259c46a7a93a18842fb16fc8": "[ru]文件确认人",
  "be1fa802bb9d3e890344d1033fbf0933": "[ru]判别水平",
  "c50a57e9ee585a523bc184c7393a9f2e": "[ru]外检员判",
  "a6fb2eb8b46a78e92fd54fb2afa0f42f": "[ru]见证资料：",
  "200d6974c8f7c2e28fd8e87eef6b5489": "[ru]审核备注",
  "c80f2214a1737f717a02c20acd13875d": "[ru]OID码",
  "3da5531363bfff5f4ef89ac9e2faf2b3": "[ru]扫描人",
  "ba1dccb15963d0580339e9684bc021b1": "[ru]扫描时间",
  "d000576972848f6590e9662f8003feb8": "[ru]互联入厂扫描记录",
  "59115b556ce5b5af01a6be610b3ab911": "[ru]扫描结果",
  "324516f9c1fa3a415c818e62a8ea0620": "[ru]OID明细",
  "7822694730c9088600d8f6237e34d74a": "[ru]OID码：",
  "79d3abe929f67f0644a78bf32adb3a89": "[ru]复制",
  "6e060e8febbe66c8196c6e339637f470": "[ru]生产地址：",
  "ffa68727f96434467e0ff9d81ebf40fa": "[ru]生产批次：",
  "8faa1b3fc9b2be7e809184d11a202a48": "[ru]生产线体：",
  "b1caf5ee6181364a3e87e574fc79bc2c": "[ru]检测次数",
  "a6217a28e218ba1984b5a1f0deaf5f31": "[ru]检测时间(最后一次)",
  "f777b8e638774f6594156674064d49da": "[ru]扫描记录导出中...",
  "d42f93ae131539b9d507aab4c4218007": "[ru]获取OID明细...",
  "f4ed85dc6c1477c1824b0272d746400d": "[ru]无效链接!",
  "b610fc42e956bb2dee2ffbff925ea557": "[ru]预约入库单",
  "8bfe70d74f5cf9351679c1abfe1bf144": "[ru]预约单生成时间",
  "cfed5e7aebdc64920d9181c125c23956": "[ru]检验单号",
  "b47d6578e1c516c2c15ece78567101bf": "[ru].不合格项目：",
  "0341329b1dfdf11541d2375d20537a22": "[ru]【",
  "5942e7ebd051339cf5f314bf392f0d52": "[ru]】",
  "4fbc0aa900152c3c2b2d8289b3dfa8f2": "[ru]签发日期：",
  "c8f94003e0ca28145eb589b181e3c06a": "[ru]接受",
  "10798223367749984eb5a5665b3fcbc9": "[ru]审核意见不能为空！",
  "411a76bad39ad6e69e49b09bdfa87a16": "[ru]过度措施",
  "8610c7fa68eb9d8194aac87c21d22f69": "[ru]试验报告查询",
  "3d9fbf7036750107d8cb5b69d7121351": "[ru]不合格纠偏",
  "5fb3e02746e497ae961651a90b7e06bc": "[ru]检验报告明细",
  "bec1a78c61977443ce70c7b6ff218b33": "[ru]报告表号",
  "5b44a189ef63ff82342d25798df71213": "[ru]生产单位",
  "0036859e2c8488ebd6cc5f8103bf8220": "[ru]样品编号",
  "7de7fb6c135e4096ea9fa4137cbb3faf": "[ru]实验室名称",
  "9253083289d160d8ea1c332bb992c5c7": "[ru]要求完成日期",
  "95e4fd4018ae66bb0418eddfb92e29ca": "[ru]样品数量/批量",
  "2feb45aea5b2f8f0d20a8083a20ffffa": "[ru]检验依据",
  "af28d68af8c9c3b00b3c7756b3fe4de9": "[ru]测试方式",
  "6f4e07d67ffa80d9dfac2cbf4b1b9e97": "[ru]不接受原因",
  "48dea78aadf829f8ff44e3ad4c983bd7": "[ru]均一物质",
  "5682a384872f6fc6f1cd8968b09876cf": "[ru]检验结果",
  "cde16cddb7c94dfa80d78177be8b78a6": "[ru]最终判断",
  "04bd4f3ba2a0547936db4fa1bdf1f499": "[ru]实验员",
  "a22be23dedc079dddbdc7cb98a8b0d95": "[ru]审核人签字",
  "978c87d3e64d6c10e220b3b4af946a4b": "[ru]分包化学分析实验订单",
  "b8180289b99d4c1dd23f2892243c2f3b": "[ru]下单日期",
  "87fa0e0e363cb8286fa4ff99aa8e4d30": "[ru]分配日期",
  "ef3f56597a5ee27e574aa23c8c19f238": "[ru]承诺完成时间",
  "e414473c886072e393710563f201d7f3": "[ru]打印",
  "ae47e50f946d35b627bef02d65f71456": "[ru]检验报告委托单",
  "97f3be9e4820192b7c2471f5c30e8005": "[ru]申请完成日期",
  "d63a7a8d532a15278b3ba14088f557f3": "[ru]标准类型：",
  "e7e6a90a5768b54c562b8ab38b18fbf3": "[ru]委托人",
  "d23b63ea976541f430c7a366ad07d9de": "[ru]抽样型式",
  "312754338ec7990f3e0af26420710a3c": "[ru]分析验证",
  "f082c3a2d0747d7620e98aa7f391997c": "[ru]变更验证",
  "b4f7a5557894f73dc815523a45b4467a": "[ru]周期型式",
  "7e6248d532153f0095cff3aeea886bda": "[ru]试验编号",
  "86f6cfbe3927790b053441d88de488d2": "[ru]订单状态",
  "f07c7658864392199fa1ca43ce143dcc": "[ru]标签打印",
  "4ea928bedc70d7f83b9cae61a4b730e6": "[ru]查看委托单",
  "0e3de5a85a6065811866bf67eab2174e": "[ru]未分配",
  "fbfa6c18bf0a1c4ff90aadcbab5ee880": "[ru]已分配",
  "bf7dfc208d958e43c3eea4bec966b49d": "[ru]需修改",
  "67d2d344313d7dc6e75a879eb3ab903a": "[ru]不能做",
  "d0419c14b9b6ecd875b8b9d9cc459d40": "[ru]实验员要求修改",
  "3a6bb7e6022f3201862e046efb5332ed": "[ru]修改完成",
  "165292b10f8bb60324732fde57d50e80": "[ru]LIMS-待分配",
  "0a55cf3539fdded5aa58bec8173c1692": "[ru]LIMS-打回修改",
  "2f4e4a161732dd791e661e4460e0065d": "[ru]LIMS-已分配",
  "e651cfd0e08f07b5e61cb20bc8837995": "[ru]检测-未审核",
  "e5c1089fc8ad19906c6a2adf9d9fbd17": "[ru]要求实验室名称",
  "f130a1850521f0d183042a69ef37e6c0": "[ru]打回人",
  "121ec54191225db9029f2bc9810ad839": "[ru]打回日期",
  "181eda4b58214fdf4b6af2ffc2712d50": "[ru]打回原因",
  "1493b96fa72a43515c72a2ceedfabad4": "[ru]承诺完成日期",
  "ef4bc42dc163cceb86d91a8296646d6e": "[ru]实验总费用",
  "bde1a7ef818b4855b99fa5403ac5c5a9": "[ru]委托数量",
  "abb1991687139ef4b4d1d6925a40a915": "[ru]自制件验收记录单",
  "60fa5fc250b698e478462ea1e111b2bf": "[ru]计划完成时间",
  "938b60ee8c50011b6d81c311f1d22af8": "[ru]自检报告结论",
  "d64279995387c0f6e0bddcf619bf90d5": "[ru]下达实验结论",
  "e6e645d5f73e5cf42ac5ee461fafba5b": "[ru]实际完成时间",
  "7ce6bb4c9548d835202966ac3b4b51e5": "[ru]试验周期",
  "9e2ffe1243748c59ea3c0b53687f99dc": "[ru]第三方报告及快速报验申请等资料",
  "b44d00d11bcd96250f9d42b591bc392d": "[ru]自制件新品检验计划流程图",
  "7113ffe06bac47451791c068897b54e8": "[ru]检验经理-分工",
  "8d527e333ba49c91646bd809c0e55d5e": "[ru]只有下达样检单的数据可以执行该操作",
  "c8434cc08fb75ffac8be72dfef4b2041": "[ru]请选择下达样检单状态的数据",
  "b97edc9e300be49239fa4d4dcf609e4a": "[ru]只有待审核状态的检验计划可以执行该操作",
  "a28527e5dc4a6529e5632976a61d3592": "[ru]只有待分工的数据可以执行该操作",
  "1fd054c00bfd37d505193c45cc57101c": "[ru]请先维护专用号标准后再上传自检报告",
  "449383b4da2cdb8ef2e7de1f023b29df": "[ru]已经下达实验的数据不能再下达实验",
  "a71dfd5164f44e637e38f91f90bd2470": "[ru]*最多允许上传一个文件*",
  "34e226e1b66e97858352a69e601eadfb": "[ru]自制件检验",
  "912e10032c898238c1989416c9f3e94b": "[ru]请先选择专用号",
  "2bebddb468efabd029c860a9c6825a55": "[ru]选择日期",
  "8f688805e5245d6c98f777df50a4d2be": "[ru]自制件新品检验导入模板.xls",
  "0972eb747d2fd1037dc9d7c23219c297": "[ru]无法添加，请先维护物料大类",
  "511d24c45184d1eb999c3a10ec3f0c7d": "[ru]请先添加数据！",
  "c433b00435d13f2ba0bcb8cdeb67327e": "[ru]模板导入成功",
  "a6c03dcc243c5c371b1020310ac7cfb8": "[ru]关于出厂检验报告实时拍照操作说明",
  "b554483a5ad819f4a0a74c4dbe8f4c09": "[ru]提示：系统支持数据导入，请先下载模板，然后上传模板导入数据。",
  "f448ce54de4486f3af400142a8ee2602": "[ru]模板导出",
  "b96626929870187c15891ac9d25e6dc8": "[ru]出厂检验可视化",
  "0d86a1f9a509087108a1cc09b2559ec5": "[ru]请输入日期,如不适用请写 /",
  "1a58c1628876174eab86bc1547134164": "[ru]检验时间",
  "91693713809ffc48fcb8cd5f256bc626": "[ru]审批人",
  "a717a2e0e8a005a836fe3f747714a9f8": "[ru]导入模板",
  "020f1ecd624568693e40fbd1163e6339": "[ru]开始上传",
  "fa65e0b2e2675b5ffd35395b6c161741": "[ru]出厂检验报告模板",
  "35f2729258b7d0cf7965a24564434974": "[ru]自动暂存",
  "ef12e430fc32841ea2110c15b566aedd": "[ru]当前内容未保存，是否保存后离开？",
  "8e8682706b3b07a3e8d8797e3b74c8ae": "[ru]<p>系统无法导入数据，请从以下方面查验是否正确：</p><p>1. 导入的模板需对应此专用号的，专用号是否完整，是否少前面的0</p><p>2. 日期格式需填写正确，参照格式如2020-9-10</p><p>3. 系统自动带出的灰底色信息不能修改，只需填写白色空白框</p><p>4. 专用号出厂模板是否有变更，如有变更过，请重新下载最新的模板</p>",
  "38867a4c2e38c59f0c8009686f0ebb1c": "[ru]本批生产数量需填写数字",
  "d4e1c5e0f39fa75363e209da8abe519c": "[ru]<p>1、如果认证情况不涉及有效期时，请录入反斜杠：/</p><p>2、如果认证情况涉及到有效期时，此处需填写日期，日期标准格式为yyyy-mm-dd，如：2022-06-05</p><p>其他格式系统不支持，请检查后再提交</p>",
  "9d990c97863816289d46acfd069e87aa": "[ru]认证名称",
  "3d46faf3472658297226f1eaa2d3c169": "[ru]认证号",
  "369d21daf7e505f05a3f16a8acf67ebc": "[ru]宣告表号",
  "103d893628df5fb82c0dcc09899bf9d7": "[ru]检验人",
  "5c6881399f5d240f24a5555eb85f4389": "[ru]未填写",
  "f7b7e20f52dae5c4cb5a8c1f2252731c": "[ru]检测项目有不合格项，与检验报告结论不相符。",
  "90d5b37f2b6ac7b45f2accf8fe696708": "[ru]抽样样品照片或检验过程照片为空，请完善！",
  "cd38545e4f2c9cfe5b09d37f9dd91d7b": "[ru]①入厂0不合格目标达成，已取消出厂报告照片关联；",
  "96d5c39ce6bf11bce733a9d65b75b878": "[ru]②未达成入厂0不合格目标，出厂报告需关联检验照片；",
  "5e4b94e87bb08d0e5e199e9b5f84be6a": "[ru]厂区地址选择",
  "62ce054c84151740fa64d0064b7a9b3f": "[ru]厂区地址",
  "14025c39e6de242da9a7e8f223e5ba82": "[ru]*发货产地应和海达源认证通过产地一致，如不一致请联系Haier采购资源更新",
  "7363e486b45c9f193be34efcdf6f6f01": "[ru]抽样样品照片",
  "fd4a2caddedee481431a40b713cf3615": "[ru]即时拍照",
  "c18fba5e008b2b9b81a5dc4a759828ba": "[ru]删除照片",
  "d8132b6ff9de49ff14f218c1499ddac5": "[ru]*拍照后，可点击暂存照片立即存储，超过五分钟，系统会帮助存储！",
  "6fe491072e0a54c39fc371ba29bca1e6": "[ru]检验过程照片",
  "2cfd7acbb504355432476d6c34f491b1": "[ru]延时拍照",
  "5d63d228964ff1850ed0c734d1cdd8cd": "[ru]本厂区已经拍摄照片，切换会清空，确认切换吗？",
  "20be4e8754288a713b9ad759c78ba22b": "[ru]加载中，请稍后",
  "ba695e853cb99ea5390d11f4e14d74e4": "[ru]厂址获取错误，请重新登录后再试",
  "49e038b421344d4b8cfc75cacdfccf5c": "[ru]拍照已获取，请删除图片后再次拍摄",
  "defd18250faeaba28be484d85e14c5f6": "[ru]确认取消即时拍照更改为延时拍照吗？",
  "644f4ddee6d62e455a23700801a4f586": "[ru]确认取消延时拍照更改为即时拍照吗？",
  "f7d3cd75eb7b0c9244b769af14937fd0": "[ru]没有需要删除的照片",
  "24fef97bb8fa3c61cc1311783d1e7440": "[ru]确认删除抽样样品照片吗？",
  "c539acddb6f695e1a1eb1d58fb61d1fc": "[ru]确认删除检验过程照片吗？",
  "3a584f6812758118527636d765a95f2b": "[ru]摄像设备状态异常，请保持摄像设备正常运行后再次尝试",
  "6812fc7e70f974d2ccc95b33ec806dab": "[ru]摄像头连接超时，请检查后点击重试",
  "132c5cdcceb0f1f17c8c088a42959aa4": "[ru]重试",
  "b69f2f08e04c84e310251638a9bca08a": "[ru]连接断开，请检查摄像设备网络状态正常后重试",
  "775fc20a87e123f1e5f1c293f48a456f": "[ru]萤石视频并发数达到上限，请咨询萤石云客服",
  "2624b6fa5884b08aa7b02f8ebeacbc0d": "[ru]accessToken过期或异常，请联系管理员",
  "d2058b9c7e7535637817e6578e0547e9": "[ru]设备不在线，请保持摄像设备正常运行后再次尝试",
  "b634db0fa702e293d3102a254e745b40": "[ru]该用户不拥有该设备，请检查设备信息",
  "5e981a65617feb00409ddc70068c2e68": "[ru]等待拍照",
  "8a9866f96c6aab901b9cf52ab44e8389": "[ru]请先选择生产公司地址",
  "515c34841017059a1d4d450c6ddde432": "[ru]视频初始化中，请稍后",
  "792b4f1c5d316f8075515773243d3f2c": "[ru]已暂存",
  "6b2d80f330894d96723f827dc3c79e10": "[ru]生产班次",
  "74bcd083269b19030bfe9f45af1f3b0a": "[ru]生产产地",
  "0273ba5c9598bd3d6279fba5d8238e8c": "[ru]审批",
  "0d0e9640e280d0119448c99093534074": "[ru]出厂检验报告列表",
  "0d1bedb6afc95cebf2fa21ec2473666f": "[ru]默认展示提交开始日期1个月之内的数据，如无法查询暂存和已经提交报告，可选择更多查询条件。",
  "90c08b4c5049768c332d6c7589c7c4ee": "[ru]备注：输入专用号后从下拉框中选择。如果显示没有此专用号，请先维护此专用号出厂报告模板。",
  "7ae79c6df4d5a7656077e90877a5d1fc": "[ru]请至少选中一条数据进行处理",
  "f39658d60ab306a236f55a704b5a757d": "[ru]只有待审核、驳回和暂存状态的可以进行修改",
  "7c5c6e9538baf4a8cf101b93b9d07c8c": "[ru]只有待审核状态的可以进行审批",
  "0a281d0cef841bd8e0d89b853fb6184b": "[ru]请选择一条数据后进行操作",
  "e16141d15995e9a660c92fe99cf860aa": "[ru]只有待审核和暂存状态的可以进行删除",
  "0d21154235fdbaaf663690c3db54c290": "[ru]SC码",
  "d9628ca392b7533fe90be298d8327563": "[ru]SC名称",
  "d5a18d99d5c098b8ada2d603eaff8619": "[ru]业务范围",
  "5e4925b72f153b17532bfc067db81657": "[ru]行业一级编码",
  "91ffe91ba1c648f36a6aeddd6d573075": "[ru]行业一级类目",
  "73b40e65768f430166f0cb6a5ea97d55": "[ru]行业二级编码",
  "6ad4599bb5c49b0c28a61eca44ee7a1a": "[ru]行业二级类目",
  "3a3a057fe2dcdbf74d7ccfa19a1268f5": "[ru]行业三级编码",
  "e12f14bf2687b6dc8f00213b97f6dcfe": "[ru]行业三级类目",
  "ea6852d6655832777aabf6c5e9f11fa3": "[ru]行业四级类目(SC码)",
  "d382c85bf9e1c901b1dacbb5707153e2": "[ru]行业四级类目名称",
  "98f8efc09265557f1df1ba953a3eace7": "[ru]四大类",
  "08e54a002240906cdfdd8f89811013a2": "[ru]行业类目导出中...",
  "849568aa3c3184ec0761f6ff764a1f2f": "[ru]请输入代码或名称模糊查询",
  "ab27aa1310491f6c382cd1e92a3f8762": "[ru]需求工厂",
  "53dd6b605cef5ba0c1b23401c25bbb27": "[ru]是否生成小批",
  "e26d51795479ba3d610785c8793589db": "[ru]样检单创建时间",
  "d9c13d2a5e70b3ad33170cbde42bfaf9": "[ru]需求招标信息",
  "5d4d052a00276158daaee7ee436bb727": "[ru]小批生成历史记录",
  "24c8ba21d7655e92a6fc4a9a4e6fa286": "[ru]SC编码",
  "e5ff76e29e7cd12b3c5f1c7ca027ffb8": "[ru]需求招标工厂",
  "13d5f2438191ad5805660412bac52f79": "[ru]失败原因",
  "a955c9acc5cabde5c563e03127da38f9": "[ru]需求招标信息导出中...",
  "9c80fc344df4d4e4615686c642850e88": "[ru]小批验证单",
  "0cfe33ccbbb334b67cf864163c4b020b": "[ru]小批单号",
  "46be05a7326d782eedd698cc819fce24": "[ru]小批类型",
  "7610243c6bc620ef4c48a70af2b824c0": "[ru]老品开双点",
  "0099df42c9eeeb01a124ae64c8ff43c6": "[ru]部件专用号",
  "87018574a96f3aaaf3fcbe04e436dbc4": "[ru]样检单编号",
  "b0582da28227a3b59e599cf1c0a3d9bf": "[ru]新品合格时间",
  "b40fff7aebe0d7c24414e35912d3650d": "[ru]样检单结论",
  "798971eed4f5e0181027799e987e073a": "[ru]转单后工厂小微",
  "0c07b02a43aa134f5b011646f7a41710": "[ru]转单操作人",
  "a30b3f20023ac64d7f662cc0a03a887a": "[ru]JIT订单排产",
  "868d3624bcfb73faded95e500bcb4d0b": "[ru]验证标准",
  "b8f0f259203dd58416262e9596a984a8": "[ru]验证数量（台）",
  "346a73a72884b92758883b2e7336dc57": "[ru]验证内容",
  "75360144fbe95f68a711a2263a6b9f3c": "[ru]整机型号",
  "6439c6d3707f68419393b5850c0113e9": "[ru]工艺/新品负责人",
  "41320f4bc08bda5e0818fc4902ad5f1b": "[ru]验证数量",
  "c9f30cf22a96af52f4d8864c40cc57bd": "[ru]验证标准附件",
  "d45261ce60ad4ffe4b7b021bf8e168b8": "[ru]填写时间",
  "122368a7f5b5b933874902c65226f762": "[ru]采购订单号",
  "ad761ba34f9fa0537543fa80ebd0b4c3": "[ru]到货数量",
  "13f1f716744d19279802afe6ef6a6348": "[ru]预计部件到货时间",
  "85c0f4218580a32d45d99ed12ffe9715": "[ru]整机排产时间",
  "3160fc0d5fa713a37145a4a6e81daf4a": "[ru]填写人",
  "dda059ecd4dd9f16f3b63c94a0208348": "[ru]验证过程",
  "49ecc799926797e18beeeaa05d4ebd5f": "[ru]1、配送：根据生产计划将待验证物料送到生产现场,验证物料必须根据生产计划上的安排在规定的机型，规定的批次上使用；",
  "37822da04957a07bf6fdf02de105697e": "[ru]2、技术平台：负责组织相关验证线体人员，验证物料是否影响装配，是否影响生产节拍，并输出最终的技术工艺标准；",
  "79579941cf7e28e3093dcd5ec1d1573a": "[ru]3、质量平台：检验处负责对验证机器进行抽样审核，并进行产品的抽样验货，需要做性能试验项目的抽样做相关的性能试验并对部件是否可用做出判定。",
  "e15ec8445471bc9e545a32e52f73ac7c": "[ru]验证结论",
  "5f02c3a4d9d69c886f35f72a99b6ff9c": "[ru]工艺验证结论",
  "36e30bc6fcc80b83ff73d950a8878f4b": "[ru]请选择工艺验证结论",
  "2004e54ec61e096ccb83e945d9568988": "[ru]工艺验证合格",
  "70db62adc54b2eeace49ca8c5a3f54fd": "[ru]意见不能为空",
  "9a225090b0eab3bdfa599293305b8505": "[ru]质量验证结论",
  "a373b23a09bbe59e9de08da4a0d1d6cd": "[ru]请选择质量验证结论",
  "91fdebfc201c991e0f8eb1fc67783bcc": "[ru]质量验证合格",
  "f525852fea04f52a1228f3cbdeea53c2": "[ru]质量负责人",
  "8e4080bc4e150bf6587feec3e9156c38": "[ru]验证总结论",
  "85c1adb0a581c293c5ba1fa906c298aa": "[ru]不需验证",
  "39d58512bf15a53809f38909b53bf233": "[ru]待工艺验证",
  "d456da41ef7a4c70ba30f82f64d85991": "[ru]待质量验证",
  "cb86108b641dbaf532395758ca13e7c4": "[ru]最多允许上传1个文件且单个文件不大于30M*",
  "76396f1cf5ba018259140b5c12c73265": "[ru]确定给出不合格结论？",
  "aa90af9d4c4a78b60e33d255c1ec689d": "[ru]工艺及质量验证后，若最终结论不合格，会同步生成一条新的小批验证计划。",
  "b79130eb84ea34074a0d320d648876ff": "[ru]数据获取失败",
  "a5d78e120107586ac6351faae2dbcf05": "[ru]请返回重试",
  "16f76b6a9d85e3699ba84656d251083a": "[ru]采购订单号不能为空",
  "f7d5c20ad6c61494f165e9548830c5cf": "[ru]预计部件到货时间不能为空",
  "f3ee0ed0ec581f032cfcfbd4813fcca4": "[ru]整机排产时间不能为空",
  "3fc2a94c8c2686bdc1ff92b10281f8d4": "[ru]到货数量不能为空",
  "72f57a31d259a2b0e6af21a1031fa9bf": "[ru]排产成功",
  "76227c5fe07b3214b1a7e49ec420b852": "[ru]排产失败",
  "85c8bfac2409cb76cf7cb473eec70aaf": "[ru]到货数量应为正整数",
  "2ad5b32946d1a8479f9f9cdefa855f78": "[ru]不需验证原因",
  "031101779b20391665cde18ba51b5d87": "[ru]请选择是否需要小批验证",
  "b74043db5e5cc38f4f7bac6efcc923e8": "[ru]不需要验证原因不能为空",
  "b3539c92e3ef488253fed89db8a64283": "[ru]验证内容不能为空",
  "676614114b11e37f50aaa67817d8245c": "[ru]整机型号不能为空",
  "c6ed43443772aff4f5ed36853ecc7d1e": "[ru]验证数量不能为空",
  "7730b60d2cfdd4b1d0b76e7c945bacde": "[ru]验证数量应为正数",
  "e391dfa35018a17f599f5711759b077d": "[ru]验证标准不能为空",
  "979bb5425ac79f9ee485339056d2a5ef": "[ru]验证标准附件不能为空",
  "66e18da47c74ff0068f3635e38500dcc": "[ru]验证数量应为正整数",
  "877cf4a55bad20358348cc79f9a64172": "[ru]验证工厂小微",
  "c49e89e8f570ee59cb71caf5151a30dd": "[ru]不需验证（首工厂验证）",
  "0d9456254b0e5724865bcaf7f0fa2d90": "[ru]维护验证标准",
  "073bc33e9460862b33b6029b90b3708c": "[ru]待排产",
  "2d84afdac46e0f3b30df7b1ee593e5fe": "[ru]小批来源",
  "7b02eb6bd2f9e0f2441dc1cf8a8450fa": "[ru]招标供货工厂",
  "f00a59ea73628c54c99eba2e3db1f5df": "[ru]货源工厂",
  "af13976b2dda8523e056bddc4b679e82": "[ru]验证实际完成日期",
  "7b814344a8088f2b6cf422b2c80f8084": "[ru]验证任务",
  "5a7353411599788b4fe0681ea4653780": "[ru]未包含已出结论的任务",
  "2da479a64782db61410f0bcd46628aa2": "[ru]不需要验证",
  "5f384fa96f2505b7c1e5a137ae620431": "[ru]不需要验证（首工厂验证）",
  "a238202cb3b27d1fc76c814214889d84": "[ru]不需验证(首工厂验证)",
  "4a7b488bd7d2a1649162f5475a1c9710": "[ru]转单后工厂",
  "acbf58558777d3af871cd4a9f5a9ee21": "[ru]关联工厂小微",
  "5a869efdcafc077daa6d1579bbe54406": "[ru]小批报验次数",
  "559e9e675b7e67137a37ceaeed780481": "[ru]验证标准应完成",
  "fbdac206b7a659b24490626549b7033e": "[ru]验证标准实完成",
  "47594a3a18cd32c63a509c75421017d9": "[ru]排产应完成",
  "34cd693b4931a2dbcac214a7a4032c51": "[ru]JIT填写时间",
  "4d26e7488293294de90f16152abe4700": "[ru]JIT排产人",
  "9f68109531f5fbfe12a5afc64d351fed": "[ru]验证应完成",
  "f07803394f150b64f12170a4dfca9aa5": "[ru]验证实完成",
  "6050c1f5b57313d3e6f8d2c6c64836a7": "[ru]工艺验证实完成",
  "5c2f10fb0cd3736eb85e2f04f83f00d6": "[ru]验证工艺/新品负责人",
  "95e7038dfbd3b95ba710f1b440f7a4dd": "[ru]质量验证实完成",
  "711625860f60edc6145ff78a47a9abdf": "[ru]是否终止",
  "f1b489c8fed8a2628e07ada53bcb0bb6": "[ru]流程查看",
  "8eb4a232fdbb47301d6d4c599091b49e": "[ru]小批验证流程",
  "c35c84442f9ff2075666f4bfce0d2f2c": "[ru]小批验证流程",
  "4ec092774ce478a58e72278ee4075d2b": "[ru]工艺评估：工艺负责人或新品经理",
  "7a2073b04291283dff9f324307d358bf": "[ru]样检单：",
  "1f76855b6c35811e7c401a23f09f6c50": "[ru]小批流程",
  "ff46e55f488a98fb1de3a66969170ceb": "[ru]终止流程操作日志",
  "ff6c6ad72b241f79d8b8a12e0001edaf": "[ru]终止",
  "d2dd3f3a31262ac9c4d954df2d31b618": "[ru]解除终止",
  "b1b9b640ec4b817f75af83eab88a60bc": "[ru]操作人姓名",
  "7e951d56d99d790ec4383bfb7b187ddd": "[ru]操作时间",
  "4fd13c9e680e7c0a384c80e37944d306": "[ru]终止原因",
  "e395bfb667a689839fc58c23597bf795": "[ru]终止原因：",
  "1465ab28af2b4c4258079c14a6d30273": "[ru]请谨慎填写，确保合理合规",
  "732afae176b22aac2a2a1935e70362fd": "[ru]终止原因不能为空",
  "136e8695d253e8296541850756584c14": "[ru]请填写原因",
  "75976ffef354f6d15c86bb5d0ee308c9": "[ru]附件上传：",
  "8e3758f023b0a69b0365089856608609": "[ru]解除终止原因：",
  "7142a157d94606c674dc55461a898930": "[ru]解除终止原因不能为空",
  "b11d9c076afa7d46596c21d86e6aa178": "[ru]小批转单",
  "187d0e3a5b3b188271f4b8baf0a84cd3": "[ru]注：转单前请务必同转入工厂沟通确认；仅支持一次转单操作！",
  "e08a8b6d574810caa4cc8fff0eff42ca": "[ru]转入工厂：",
  "bcc075056647186b192a21820348df96": "[ru]转入工厂不能为空",
  "a39d2569fea0741ce42981bd6a0048ef": "[ru]转单原因：",
  "c1ffeb49eaed647b4aba883d6bc6c76c": "[ru]转单原因不能为空",
  "f00b2ea5247866de5ac1217d80036cc1": "[ru]转单时间：",
  "8146bbefe48adf8e8c98289c7cc4d59e": "[ru]操作人：",
  "5a0fe6ca084affe7652a5abe2648620c": "[ru]附件：",
  "321fdc2a460eb81dceba077cade8c172": "[ru]只能选择未终止数据",
  "90876b9ba1e87b51b4f922650a6eb70d": "[ru]工厂新品经理、工厂工艺经理、工厂质量部长、工厂JIT采购员才可以操作，若无权限，请登录HPC进行申请",
  "88b2b44e9b76ed5c6329620b0437427b": "[ru]只能选择已终止数据",
  "30866331a51ddbd13e67e6efc48ec95d": "[ru]确定终止？",
  "be73aca67ae7622e04dec409cb09930e": "[ru]请谨慎操作，确保合理合规。",
  "e7338f047031603ef47ce87e72770b47": "[ru]确定解除终止？",
  "6e49482646ad05abca113ebc19407159": "[ru]已经审核的数据不能转单！",
  "1ae8cf528a990164d25eddeffcb05ebc": "[ru]已经转单过的数据不能再次转单！",
  "e5fbd473f8a70c88ac317f983d761bdd": "[ru]关联工厂为空的无法转单！",
  "11c7134e8896f09b0832942c94f07aef": "[ru]小批转单成功",
  "b3b228fb110705b4efc1d5eac6bb21d2": "[ru]只有待排产数据可以进行该操作!",
  "75bbd8b66e138f029b1cccba65fe8cd0": "[ru]只有【",
  "ac54dbbbd24ef6e3fec52bdf47a6f0ac": "[ru]】工厂JIT采购员才可以操作，若无权限，请登录HPC进行申请",
  "979363fa21219a8fa36cb8735309f182": "[ru]新品合格",
  "5e1979ad0f45d924cfd502618a33df30": "[ru]实：",
  "8b4b0c03b7c93bcc879517413cff7403": "[ru]工艺评估",
  "662b9b245b8d56bcf124be83480f2e43": "[ru]应评估时间：",
  "3683df2186f620ce2b126c21ba6f381e": "[ru]评估时间：",
  "cb2d2657827ab0280caefc765d95b443": "[ru]工艺/新品负责人：",
  "69d18a42a6686b24bf2e887999709ba9": "[ru]评估结论：",
  "52fad81579f4f084b271ea286e21dfb0": "[ru]不需验证（首工厂验证）：按策略仅首工厂验证",
  "30a5e85d262569cf0a4ec8fc7dfa71f8": "[ru]评估结论：不需验证",
  "a9549effda60a7bd6615d05d03a37f13": "[ru]不需验证：按策略不需要验证",
  "5c5499ad605d04869217c972c8310893": "[ru]应验证时间：",
  "7b39bf1093409f98383e9a393359414a": "[ru]验证时间：",
  "b254adc735563a1ca572e4f52197fe06": "[ru]评估结论：需验证",
  "0eb849eff3c64712215e7d5e97fbd7e7": "[ru]JIT排产",
  "5259934c7ee4f1c5ecd06960f382889c": "[ru]预计排产：",
  "26c32d3a84facdc95cbb3bba3892f512": "[ru]应完成时间：",
  "97bcbb540de69d6b942eb038b31a2c9f": "[ru]填写时间：",
  "acbf9e36dae3e425fedede1f2ab90f3f": "[ru]JIT负责人：",
  "a389f505a77527faf11f230969cf5bc0": "[ru]工艺验证",
  "9d42193a65ac2007ebedf8303a1f7125": "[ru]验证结果：",
  "f68e0e19dc32bbabea96d616b74bac7b": "[ru]质量验证",
  "d75fbdb2ac65ebaae11a4a1f4f418065": "[ru]质量负责人：",
  "fd7da1dcac29f9a2981df13e3dab1d4d": "[ru]应评验证间：",
  "cbed71fb09ef0f77f2d93e7183de9e0c": "[ru]小批验证计划导出中...",
  "b007885d6100eeb7a2238fe0ed8abace": "[ru]只有待评估数据可以进行该操作",
  "36cb7dc3da87ceb2d5d1b59cf1689f1e": "[ru]只有工艺负责人/新品经理才可以操作，若无权限请提报HPC申请",
  "599988a375b5d323ee79855f9361136b": "[ru]只有维护验证标准数据可以进行该操作",
  "193bad5a2f1b63c9599af209b1d7a3ad": "[ru]】工厂工艺经理/工厂新品经理才可以操作，若无权限，请登录HPC进行申请",
  "b4e08ed0976c522c7450fa3a5fa82473": "[ru]只有待验证、待工艺验证、待质量验证数据可以进行此操作!",
  "25c86bdd3538489e72643fe548883f3d": "[ru]】工艺负责人/新品经理、质量负责人才可以操作，若无权限请登录HPC进行申请",
  "4ee601853e4a2c2026358066f4cc5433": "[ru]是否小批验证",
  "352a3e61bbbae70fa0facbe7e90057e8": "[ru]JIT排产验证",
  "7440e81efc828eb7da7ecb70aa36cfc6": "[ru]验证场景",
  "c320417e796e5ff4ace8f4291ccc34c1": "[ru]不需要小批验证",
  "e8a0fb69e1037deb033b45c05a40599f": "[ru]仅首工厂进行验证",
  "25cd325120b1d4bd30b8e8e21ceb29ce": "[ru]所有关联工厂进行验证",
  "170776e897558fca615699fb636fe6eb": "[ru]行业类目（一级>二级>三级）",
  "5433f4637e7fce496f5a74234eb16816": "[ru]小批验证场景",
  "6855e08cd2a429533a7b90e67c3de03d": "[ru]SC分类",
  "d0abce1101d9181026b6e55e4d8efc0c": "[ru]SC分类不能为空",
  "ffc0ddbd2f24b60620b52e73234d1c97": "[ru]小批验证场景不能为空",
  "a6d2a9568bae2d90c0418a322073fa35": "[ru]产业线查询失败",
  "73635fba91ea7e9bbb30fd7fa3cf8c8b": "[ru]请选择一条数据进行查看",
  "10048c5be4ddcd6d54404d8c90566bda": "[ru]请选择一条数据进行删除",
  "cef8391d593c48e2fa6a84da0aff3782": "[ru]删除后会影响小批验证单的生成，请谨慎操作！！",
  "9522df56a7896fbdde2ccc498af108e0": "[ru]请选择一条数据进行修改",
  "a3f0268d4e065b989ed699a0eb2d2623": "[ru]小批验证场景导出中...",
  "515638920e34512668e2b4e29bd75bc1": "[ru]SQE萤石验证",
  "54116bcf8272909b86d1b4f0eba8a212": "[ru]通道号:",
  "52f158385dad6790899c14b1f8c6acab": "[ru]选填（数字）",
  "f2e2431be64f002708d934373d6ad056": "[ru]设备序列号:",
  "cd8992b644e6c18367861a4d913fd116": "[ru]验证",
  "206eeec07c8cf01ebe60c4d3b15c1fd3": "[ru]AppKey或Secret或设备序列号未填写,请完善后重试",
  "66045a5f11a7704573cc191ed772e455": "[ru]通道号只能填写数字，如没有请忽略",
  "7bf2be6fb7b19250d25ce7f97564acbc": "[ru]请输入至少两位模块商代码",
  "aca38f22397ec3789f862612019ff66c": "[ru]模块商名称",
  "7c244ad1c726097ae714da60dff85888": "[ru]注：仅查询600条数据，如无所需结果，请输入更精确的模块商代码",
  "cf6e0a2984af16dd0375af5137db5839": "[ru]一次合格率",
  "086709421d8a0ba2cfbc1c8148487b40": "[ru]下线合格率",
  "d01ca7e3d16ef6d2ddfe543c150a8858": "[ru]（默认展示检测开始日期1个月之内的数据，可选择查询条件查询更多数据）",
  "f82e511ce6bdd31025bb4f9f8b5cb43a": "[ru]明细",
  "29579acfab8de1dd2103c27f10aa58a6": "[ru]检测开始日期",
  "cbb285e21363842af57e67db630b884b": "[ru]检测结束日期",
  "68bb4d5958284216a4191674afc15a43": "[ru]检验数量",
  "a15b31e1a456c94b4ccfae2ae3aec10d": "[ru]一次合格数量",
  "6771fc0fa5c82af8f3fa3ff7a97d3311": "[ru]一次合格率(%)",
  "b560dae8ac39f7e5006ae29e22953f19": "[ru]下线合格数量",
  "ce0943223d1460af58e7c61331fbfb22": "[ru]下线合格率(%)",
  "4138f614307e0922e25f6f723e38098d": "[ru]在线过程检测导出中...",
  "5e918af24d6756bed29794c63232a10e": "[ru]导出数量大于10000条",
  "a52d69d5f522b19481d0abb41474877b": "[ru]在线过程检测.xls",
  "56bc9ada2b19ec7b7c9a8473cf63baab": "[ru]设备地址",
  "c6cc2ae671e4f1184aafb5a1ce7691a5": "[ru]工序",
  "43f9db27516ff0f148e198f647d9d1e8": "[ru]过站编号",
  "042013c20e595b92c9e19a5122d76774": "[ru]过站时间",
  "e8fec6a30cbaf78f96a44b00f213ad91": "[ru]在线检测数据物联（印刷品）",
  "0a9fa11152b0b65cbd26b8704a2c75ab": "[ru]（默认展示过站时间1个月之内的数据，可选择查询条件查询更多数据）",
  "783a0e33cd35795bcd5feb2e0175deab": "[ru]二次查询",
  "f1d030b7977db8b7e5ac3d96798baf1a": "[ru]两段查询",
  "ab16f1baf0a8717177847e4627b713f3": "[ru]在线检测数据物联（印刷品）导出中...",
  "6fa40a7e76c9af09324c78c7e18b3db2": "[ru]登录名",
  "7eacb4d906910bddf002695f3ae6c790": "[ru]真实姓名",
  "9e80473796eaf3b9f1da8c60ca954ab7": "[ru]公司代码",
  "3bc5e602b2d4c7fffe79258e2ac6952e": "[ru]邮箱",
  "86a1be00f6ae394f41f7ecd19dce4c2b": "[ru]角色权限",
  "bb3eb116c1c133e1e475e5b8d209c158": "[ru]菜单权限",
  "cf1e57cf6dd1ef21b7ed5563435296c7": "[ru]供应商角色菜单权限列表",
  "4ccbdc5301f47f2bd0c79f92fad4bce7": "[ru]菜单",
  "e89dea940945f8cbb83fe052dac156a6": "[ru]抽样原因",
  "339916d7627cd80dcc1eecc698b6fd25": "[ru]故障原因",
  "3b7d4830b9916d4d0245347fb733c3fd": "[ru](监督检验）",
  "7a64e39dd87cb1380ded4e2032d56a54": "[ru]监督检验实验委托书",
  "87fba1de0c561c2c819c4a4012223f23": "[ru]监督检试验下达",
  "4a3ca37c513fb547b5498918d4f5f90a": "[ru]市场反馈",
  "3500eb84ef9c499c33a87384e25c3182": "[ru]型检未到期/超期检查",
  "dd5a3ca7f0e50c3a5dbaf6f211be770e": "[ru]风险物料抽查",
  "6f1acc7d9e2cbc551d7d52030de2b241": "[ru]计划创建日期",
  "715e41987c443522a35003eadfe9c93d": "[ru]维护日期",
  "5a412b591bea884c40c5f05e5222651e": "[ru]只有维护项目状态的检验计划可以执行该操作",
  "e5ed36fc29f1e80378c535f7c7076e5c": "[ru]只有待检验和审核打回状态的检验计划可以执行该操作",
  "e5e43c81f0e588165675cbc71bdbeb5f": "[ru]只有待分工状态的检验计划可以执行该操作",
  "e8a2e0158a305a5351c9a230aef2b519": "[ru]手动下达监督抽检单",
  "ad59d89e9986cce6e8a03750f5084fc5": "[ru]请输入至少两位供应商名称",
  "0825f81a75566790e0dae7731f95b5d9": "[ru]抽样数量",
  "0c09c67e1f108a6c09e59cf96d73b30f": "[ru]型检未到期/超期抽查",
  "b4503649cb495fe8f3036dbb1e22288e": "[ru]分析验证、变更验证，用于开发等部门做的改善验证试验，不会自动生成纠偏和索赔",
  "a139b4b4fcb9115e2ea47d6c551cea8d": "[ru]请选择本次监督抽检的检验项目",
  "8412fdafef2c77fe16a54a926f265d34": "[ru]请至少选择一条数据！",
  "c3758a549330a34718ec293454e78f03": "[ru]是否形式",
  "2f6ebbd1158bc89776418a4bcee5aa7f": "[ru]是否入场",
  "9b7741493c30c6dbdd2cd2fb34ac1875": "[ru]监督检验抽检单",
  "ce08cc6fea73f498fe755bb0653bba0b": "[ru]监督检验策略",
  "4824bc7d2d7c27fdf15a964bffbd7cc7": "[ru]物料大类名称",
  "41461fa09f3eec78c043c5d7ccf96b4a": "[ru]频次",
  "af10d68b57f0ae2114e2b9f2776a65bc": "[ru]录入人姓名",
  "0834dc217739d2d2414d5dcf94ff8c15": "[ru]更新人姓名",
  "d1bc2ca5acdba14bfc6b4e67a149b80d": "[ru]物料大类与频次关系",
  "3795544e733d6f7c3e314767a8d69e5b": "[ru]确定删除当前数据？",
  "78ee602f6550b7e5d81ef40d8e76cfac": "[ru]PL-供应商",
  "374261122ad3980fd92d4baa4620942c": "[ru]工厂-供应商",
  "2878282780dddfdbc54b9d2a4d7333ea": "[ru]是否物联供应商",
  "14131774ec2261aef204734113acfd54": "[ru]质量物联报表-PL",
  "996827285b94a887d7eecc732db40c4e": "[ru]质量物联报表-工厂",
  "b94939a9db136526a39e1d002f5ca82a": "[ru]质量物联报表-供应商",
  "017b52673ca3d553aba71200e3001b93": "[ru]供货专用号数",
  "4be32083bbef6d3a305d65b1fa269e92": "[ru]已物联专用号数",
  "ac0c3b81619da2fab1e32734477f0d0f": "[ru]未物联专用号数",
  "7d6096aa0213d34c92ae48ac0d6c4634": "[ru]物联率",
  "92a276941479ef56277a9fb451848878": "[ru]请输入至少2位供应商代码",
  "d0fd1b7709a847dc6a0a4d146a5202fe": "[ru]质量物联报表导出中...",
  "e3d5dfb0d7a0c18d26bf120e1e60188f": "[ru]质量物联报表",
  "4140244df232db4e2aacd0a16575672a": "[ru]物联供应商",
  "9e49311f3679408f4f3d8bb5770a30ea": "[ru]供货数量",
  "251f33ef233136002784426a664fe8d5": "[ru]供货时间",
  "c6686b0e4f426e444aaa01ffa37bb906": "[ru]是否物联(12个月)",
  "d0ec2734af4bde4c8d442d0680289be0": "[ru]最近生产批次",
  "646b1f57daea354626b68ff44cb051bb": "[ru]本批物联时间",
  "053787c0d440fdbf47a30b4917711338": "[ru]检测数量",
  "5c1dd890e797e067042a84d24b7cf89d": "[ru]物联供应商查看",
  "4775b5f39aa049ffc6eba61209449858": "[ru]请输入供应商编码或名称模糊查询",
  "624f72cc000d2dc91ac551bc5aab7b2a": "[ru]新增供应商",
  "e7dace4a84ace4089901b4649b157261": "[ru]根据供应商编码自动带出",
  "246e27d1d9d46007c96877aa7274cafd": "[ru]+新增供应商",
  "97d3597d350764a3118c543c3403d1f2": "[ru]供应商交互报告详情",
  "3056b905eceef16fd97ccf801240ee4a": "[ru]行业资质类别",
  "807b440a6362b8113d13ccaba9425033": "[ru]首选线体编号",
  "1a9e01313bcfc32bfc4eb4355674907c": "[ru]团队人员",
  "df0d3293ea395ab07e22f72c4c83038f": "[ru]交互得分（质量）",
  "97dcf42a57f2d7bc90779b8592243634": "[ru]见证性资料",
  "f48fd4ccbe3869edc27b4b65314def7e": "[ru]审核报告（附件）",
  "8301bb83ca8d40d1a0381602842a9a52": "[ru]盖章会签资料（附件）",
  "4f6278af23be27b4830ed58ba19afb7d": "[ru]廉政声明（附件）",
  "65019bdc37a09c818531a5993682e7c5": "[ru]审核总结（附件）",
  "ce049671a8aae1bf8a40436e321fe397": "[ru]供应商承诺函（附件）",
  "93b3f3a8bfbe10eceb540f677eeda8b9": "[ru]不符合项关闭",
  "cb9e704184d917be5fc9ec999cbef2d2": "[ru]整改次数",
  "6d8bf64024e7c2cb46cb378d6f0ed8f8": "[ru]整改资料",
  "29b2b586000f1a71f0d06155e2b66347": "[ru]整改后符合率（质量）",
  "43c6e5afdfd8cb68042d54484ce917f3": "[ru]不符合项未闭环数",
  "eacbf4c00d116f91656d3ee71389235c": "[ru]整改跟踪人",
  "e76aa9f0a24e092c170548bfff1cd694": "[ru]行业资质类别（新供应商）",
  "9fd473bcbc4c88b3fbb2b6b60fe6131b": "[ru]厂址",
  "3479a8294db0d80bebc7a19f57d84c9d": "[ru]现场审核报告（Exec版）",
  "dbd809e0063bfefd2f30a7284006b65d": "[ru]现场审核报告(盖章会签版，包含首页、审核页、不符合项)",
  "5ae3a9319615d8d028b6d435574eeaa3": "[ru]现场廉政声明（盖章会签版）",
  "b0d9440e4228d7610899d48fad19f921": "[ru]供应商深度分析报告及其他资料",
  "3b0fdd7e7adc7d4551c2285052edcf9c": "[ru]整改.pdf",
  "8d92a5ee8a289585e0b64758a7e80dda": "[ru]郑思雅",
  "af726a3fb232c28ff3e39c73757e910f": "[ru]新供应商-初审",
  "97a881c0edb41228dfa4c73ede793c1e": "[ru]新供应商-复审",
  "a3688a6a2fc4fce6c96fdfd9afa0a409": "[ru]老供应商-例行审核",
  "b971b1f897c615d2d1cd40c99966275e": "[ru]老供应商-监督审核",
  "f7858145a9cbdc8e9280478724c2668f": "[ru]老供应商-资质扩类",
  "836b43c40232c33c62f413caa1f824ab": "[ru]老供应商-新增产地",
  "72598b35c80ba7ce236920ad5057ea8a": "[ru]老供应商-约谈",
  "11d623a50c6c267be105e1d726cccd2c": "[ru]老供应商-首选线体认证",
  "39f661b83d1cc9ed2bfda5c0293a13fc": "[ru]老供应商-前置检验体系认证",
  "ac15746cb1b2855a0f34ff1c33a145a5": "[ru]老供应商-数据物联审核",
  "df539a73d022122a84c7e7d2c9156708": "[ru]老供应商-飞行检查",
  "0eac1ed12a05f483c74c96119c8b9355": "[ru]供应商交互报告整改",
  "016dc71bced642d68f45163a075cfa09": "[ru]*最多允许上传一个文件且单个文件不大于100M*",
  "a9785eaafb8925e0d035d32af3d9603b": "[ru]整改后符合率(质量)不能为空",
  "19895eb51e92d17c6c0584fb4b3a4133": "[ru]不符合项未闭环数不能为空",
  "b1cdfc0c398788248f6f2c1481d84d8f": "[ru]整改跟踪人不能为空",
  "68d780f698d68414833c42b344ebacaf": "[ru]整改反馈时间不能为空",
  "3ca38cac55e963411308a385fdc76995": "[ru]请上传整改资料",
  "2dde9646bf393c1d4050356c796d58e5": "[ru]只能同时整改一条数据",
  "a1f1d6d125ae66d71bf0bb7f8e543a35": "[ru]确定删除数据吗?",
  "d0f4ae246a1c94b7277758487c75a03c": "[ru]已生成8D，不能删除",
  "3e479d963a3c6c2485c85508da499909": "[ru]供应商交互报告明细导出中...",
  "db3ab47f177258fe6cc2cc347f9686fe": "[ru]供应商交互报告修改",
  "c7afcf516a16161552bbdbb3b8955d92": "[ru]供应商交互报告录入",
  "28b1b26df7f8578620e28dc500b332da": "[ru]行业资质类别(新供应商)",
  "5c017f106cfbad3db3ce7a723f198dc6": "[ru]老供应商",
  "0aaf410d06874190b1d4036467ebd761": "[ru]输入两位供应商名称或代码模糊匹配",
  "5505e6bfb8b11dcf9b412bacfb68c8f3": "[ru]自检审核",
  "07834729326e8f7fecdc34316ca49f64": "[ru]现场审核报告（Excel版）",
  "f83440786493633cff1f0d3321b037b7": "[ru]约谈",
  "695dbcabef861de190d33b2225b5b7ff": "[ru]现场审核报告（盖章会签版、包含首页、审查页、不符合项）",
  "9905064ad2157e4a96cf13ce5d54a3ed": "[ru]老供应商-新增场地",
  "730264d1380d2e4bcb9863f13d9a04f5": "[ru]体系审核",
  "fad4b8f6e0e85d2cfe840bc5d58e1c8d": "[ru]制程审核",
  "bc758a5dfdb493d1e70c512a1bb2e1b2": "[ru]产品审核",
  "7ba6b8aa15ca3924d7f3e61a81b2f601": "[ru]体系+制程审核",
  "1d6195ab7f2fb8f26a30ef7bcf5a7d59": "[ru]约谈报告",
  "43dec466b3937510bd30b8cbc668946f": "[ru]波轮",
  "c08b1a09f6a93452f53841249f000659": "[ru]滚筒",
  "db75a684d09259dbb83a5fd47535f3b0": "[ru]家空",
  "562f91ffa23e4a8ff39c0a931a75493f": "[ru]商空",
  "803d6b877b2a764dee1ae892fb406f88": "[ru]电热",
  "435ee0b6fa63efdc18d7d5a56ff8041d": "[ru]厨电",
  "2a2f67fb2e750646b90cc14aa8aeec5e": "[ru]大宗",
  "db4d826a64d403c2638d850b4a711665": "[ru]智控",
  "75c6002562acae39e77888195f0e1c5f": "[ru]模具",
  "137a51aa58b3fcb8b65d75ef05408b21": "[ru]科技公司",
  "3943f309601533f9e666315aab18f400": "[ru]净水",
  "0f8aabea54726f187a1fca95be10efb9": "[ru]生物医疗",
  "4d00301f396fe194477e54bf61a50455": "[ru]供应商现场交互",
  "32dc02c7b54b668eb639f1b4f57009dc": "[ru]来海尔交互",
  "e7d7d04af1c7049fa09d42adfcffeb26": "[ru]新供应商",
  "281bada7259f6bcb836f62aa0b3e8f48": "[ru]不能为空",
  "2e9c5120cb0716166f8f986684159d27": "[ru]现场审核报告(Execl版)未上传",
  "5bb1d88b0b7d3aaa0ace8a8a665006f6": "[ru]现场审核报告(盖章会签版，包含首页、审核页、不符合项)未上传",
  "24fb5df96f61744b97bcc004797b3451": "[ru]现场廉政声明(盖章会签版)未上传",
  "d94843273c04962c1dc0d1b84aed5076": "[ru]供应商深度分析报告及其他资料未上传",
  "e3aed2c1916a10b18aee067a04d32d96": "[ru]请填写物料号或物料小类",
  "698b76c740f28bdcbcc77b82ad61925a": "[ru]请填写完整的海达源系统中类别，如：电控模块-电脑板-电脑板",
  "c4701efcb7274227fccddca647ba2ce5": "[ru]请先选择供应商名称",
  "8a085f3e22c5cab85777f83903890383": "[ru]请将地址信息填写完整，如有多个地址，以“；”间隔开",
  "cb51f5ceff951da0a62867bbdf424cab": "[ru]请将认证通过的线体编号填写完整，重点是总装线体",
  "f746a7fb15af18d996aa1cff6681fbfb": "[ru]请上传完整版打分表",
  "2319a749c587f7869cd2872a6acc6509": "[ru]*请注意文件上传的格式(xls,xlsx),文件名中不允许出现逗号，最多允许上传一个文件且单个文件不大于100M*",
  "3ab0e464a60d9cf366d7865c3e6650c1": "[ru]请上传盖章版会签资料（包括不限于：结论页、不符合项清单等），如有多个文件，可打包后上传",
  "181f21c4e73425b07b4024bea54daafe": "[ru]*请注意文件上传的格式(pdf,png,jpg,jpeg,zip,rar),文件名中不允许出现逗号，最多允许上传一个文件且单个文件不大于100M*",
  "b7353715f779726b31d5d5f00271ee05": "[ru]*请注意文件上传的格式(pdf,png,jpg,jpeg),文件名中不允许出现逗号，最多允许上传一个文件且单个文件不大于100M*",
  "35ef90fbb68ff0f5c8418b951147e26e": "[ru]请上传PPT版本的审核总结，如大小超限，可转为高清PDF上传",
  "f15e3fc8e723e413433e93fcae436b17": "[ru]*请注意文件上传的格式(ppt,pptx,pdf),文件名中不允许出现逗号，最多允许上传一个文件且单个文件不大于100M*",
  "eace634002b936cc24703c22111ee9b4": "[ru]请上传供应商签字盖章版承诺函扫描件",
  "dd11069b36cc9dafdc84070fb8e219ef": "[ru]技术审核",
  "f2e82ba8821ecb11e19c6ced3fb80cb7": "[ru]物联审核",
  "22cfdbb2963dc88d15d0e6971ab76098": "[ru]交互得分不能为负数",
  "960aa0a91b22c235aae9333daa21a45e": "[ru]交互得分只支持2位小数",
  "adbc23eb067fb538374592d742440a99": "[ru]不符合问题数只能为正整数",
  "4f8d771dc675dfc42643661e17f78910": "[ru]获取用户失败,请重新登录!",
  "7cc64928476bad7c23d85b4972db1dfe": "[ru]供应商出厂检验报表明细",
  "d49be1625cdf567e468b0b15225641aa": "[ru]订单批次号",
  "bd9fcf46b4e5993f97fe04ee9ebcd7ed": "[ru]撤销",
  "a56f60a674cc8b4b680dbeb30d7708ba": "[ru]是否可视",
  "75971562bf384bd803820bd2f3c7aa7b": "[ru]PL-工厂小微",
  "bf134c91803a2604835a5c23614cee83": "[ru]工厂小微-供应商",
  "d97647eb768082c53661af79d2a0ea96": "[ru]供应商类型",
  "d00c491007440177fe1e4c1f16e90e0a": "[ru]出厂可视供应商",
  "226312e81ebe7758df098ec9b1cfde4c": "[ru]未实现可视供应商",
  "dd927765765ed7fa19fa9ae952bd10fc": "[ru]供应商出厂检验报表",
  "204f699b35ff9b26b620bdb29425416a": "[ru]查看供应商信息",
  "473d06839e4d1337be64f05fd64a1054": "[ru]供应商数",
  "c1aa64cd06c359b25dc8cebd203e7906": "[ru]出厂检验可视",
  "1119413f30166c26e432bfb80d52da9c": "[ru]应可视供应商：只统计清单内供应商",
  "13990b54e4259b67782eb78f453940f0": "[ru]实可视供应商：PL、PL-工厂小微维度只统计清单内供应商",
  "b4f3f8b58a1ee9722dcb0922301aa63d": "[ru]未关联报告：供应商未提交出厂检验报告，不能确定供货产地",
  "a5639fcac44dca956d1c6df5b7ddfcc9": "[ru]产地不匹配：可视供应商提交的出厂报告地址和可视大厅地址不一致",
  "84617b6301e32bcbeb24bd3b654060ca": "[ru]供货产地：供应商关联出厂报告产地",
  "bf5706b50318fd1b3fa6eae65a81b32a": "[ru]可视产地：出厂可视大厅上传的产地",
  "a046ecb7dee94eb53e016a0904053bf1": "[ru]应可视供应商",
  "01cd19afd0247a828f4259c72f6104df": "[ru]实可视供应商",
  "34b4f385fa590d3dca0f66041d4b283a": "[ru]供应商差异",
  "5ebc81de90ec389f5964249042ecd202": "[ru]供应商可视率",
  "f9f6c3a0747eccf8ca893b5234b4459c": "[ru]供货产地数",
  "27aeaeec0f8287d07f02cb60405fc89d": "[ru]可视产地数",
  "ae8be915df6cf29533549e8f9241a14c": "[ru]产地差异",
  "acd1302000eae29b6c8a13f5883ce7e7": "[ru]产地可视率",
  "1f6fb3c21e18b19e1433529ec559f026": "[ru]出厂报告互联",
  "ca18d0254f3de15eef12b748fd73b2cb": "[ru]供货批次数",
  "7168fb086c53d3221291a33952ca35b5": "[ru]关联报告数",
  "5fdfbade8eca46f2457f914705df7cec": "[ru]差异",
  "0658b6342422fb3a05a3b675600b880c": "[ru]出厂报告关联率",
  "1914c27551647f95555181d6b9363f67": "[ru]出厂报告符合性",
  "410a3e89ef2b3416f0b03175f23d8748": "[ru]审核合格数",
  "0318feefb9646ba2116e6df8df287da5": "[ru]不合格数",
  "29b525547b4dbb4470e16813a6aa0f48": "[ru]不合格率",
  "958ce72a2a20a988d5dda6ca25f77df3": "[ru]出厂检验有效性",
  "c39268f1ce68492614c32976620ef645": "[ru]批次数",
  "24da01cde863b44a17af9dab14df772d": "[ru]合格数",
  "cbbf8d9a5632bf2afa39a08ed1a06153": "[ru]供应商信息查看",
  "8d9a071ee2ef45e045968e117a205c07": "[ru]导入",
  "9c7384ddd4016a78b2e5e2f2c40065e5": "[ru]导入模板下载",
  "2529b2f138d585d30b24b57d6aa032d7": "[ru]*请注意文件上传的格式（xlsx），文件名中不允许出现逗号，最多允许上传1个文件且单个文件不大于30M*",
  "eb48451ba5e5034450a7f9dcb2685644": "[ru]出厂检验-可视供应商清单.xlsx",
  "f3fa289ec567f89c0d79ab8670d49f40": "[ru]仅能选择此供应商供货的父项物料",
  "b8e070b75de7fa0e92a8befbb91ed18b": "[ru]专用号不能为空",
  "ad6df92bffe8711175e8218e6ee46a60": "[ru]子项物料号",
  "a2ff713a06fde50cad118475fb05414d": "[ru]basicInfo/二三级物料导入模板.xlsx",
  "7f5c7b5908ad8c67a8a41e7ea2409b92": "[ru]二三级物料导入模板.xlsx",
  "9f8f5cf9eb6881050c686cdf22f9297c": "[ru]模板下载",
  "947fa341a6d676d7f25bae6bef8342cd": "[ru]删除行",
  "83cd2df73f66374fc10c4e5d6fbbdd9b": "[ru]子项物料号不能为空",
  "8bacfdbd14b821b2ea22019063651fa8": "[ru]装配数量",
  "e1efd35e85e54b2d292716995a72e2f0": "[ru]装配数量不能为空",
  "80a4d83a2625ac73759c7fc22fcbf60f": "[ru]子项物料供应商",
  "fc1414c8bde672a1885babfb39875ca0": "[ru]位号",
  "5b4d3a3e3b7305fa513c245c8b8d9238": "[ru]+添加一条数据",
  "b45ade891b54ce17bcc8276a898ab7c0": "[ru]位号添加",
  "79f54cb8da70ba2cedae1d57eba101f3": "[ru]请添加位号",
  "3b0a59a0ee08f8f6a6b96bfefa329037": "[ru]+添加位号",
  "8665a251fb71fc40714c59684e456aff": "[ru]父项物料",
  "47a7d84c3a4f18b977b19c42233ea596": "[ru]大产线查询失败",
  "f1447e91dec48c1abd2812e3e2b9cbdb": "[ru]至多只能增加20个位号",
  "38c968199b46dcb7634aae5835ffe28c": "[ru]现场不良合并.xls",
  "6eb73433541648a5d0a59d675f95e7de": "[ru]审核状态不能为空",
  "cda84be2f62e2367112059aa07ba1a95": "[ru]操作日志",
  "454c85dce5859604520c599b2d08db69": "[ru]发起",
  "67bc09d8483b0f9cbeacc428f5ad7e94": "[ru]未分工",
  "a77aa8243c77fd740d434e6e4997f0c7": "[ru]审核驳回",
  "bdfe622df1e3a041279584677e8b2d94": "[ru]待校核",
  "2795bf5645806fd3d28d32d80520fb4a": "[ru]校核人",
  "da215bce7e55679deec2c0b20cd36438": "[ru]校核通过",
  "a07f2093acb2ee1f7be85fc213a3dfc3": "[ru]校核驳回",
  "d5889f3b77590ac43378eab9d5c29a17": "[ru]变更中",
  "b9d19a7842bf0c90cfa857cf97ca7164": "[ru]变更人",
  "8fb8282712c4833e96ea2a5213db3bf5": "[ru]校核状态不能为空",
  "2a224c6ad97a725b45e7e980c0db96a4": "[ru]校核意见不能为空",
  "5b9db5463a3a437e852e59b442bc438f": "[ru]校核成功",
  "de7aeb6ff4dda6a81ba05151263de224": "[ru]BOM分工配置",
  "eb15965c46ed3bd6222029e06fd9a9ce": "[ru]大产线",
  "52ca342e56e6b6a16b7ce7e04d8d74df": "[ru]审核人工号",
  "a2ad73e493581d38891b4ab16f974fe9": "[ru]校核人工号",
  "1819a248ccd0dcbb2b7300c0b72774c7": "[ru]请先选择大产业",
  "ebd53827f7806e65faad6ca920e93327": "[ru]于怡",
  "e79a421b455b0a9cbf497cb8c96de842": "[ru]赵杰",
  "5c8513c9354af048bafa7bdcc6eb7fed": "[ru]审核人校核人查询失败",
  "64423f7be16831d9f37ce74d7566a396": "[ru]请选择需要删除的数据",
  "05368fdbccbf42392d63bce676319a91": "[ru]审核人不能为空",
  "e8a6af5960020d038ac0a17ece4e9c66": "[ru]校核人不能为空",
  "ec1943f1f52f36cf7857bbb5b4e4e903": "[ru]供应商不能为空",
  "c25e46f479955e4b2ec4b1fca15b6450": "[ru]首件BOM",
  "2a2ed1bdbb68a94233559439cb34733d": "[ru]批次号（制令单）",
  "07353d6a78ea889ef5edcc531ac51d49": "[ru]首件单表号",
  "cd6b116270b1e0364eae25a417aa980c": "[ru]请输入子项物料号查询",
  "d03eaefe10792af207f4d17d8211c61d": "[ru]子项供应商",
  "fd25dca4ceb803d6fa6399d15d5778d6": "[ru]请输入子项供应商查询",
  "86c0991bc2cc9465fe5e20cfbaa9f737": "[ru]元件特性/实测值",
  "31eb05354e944a58a647a82dc049eda1": "[ru]首件单表版本",
  "a3f26f09f0c511a334747f1dabfccfdf": "[ru]表格制作日期",
  "6eb810f9c5fa18c7d1c35b7b71146a46": "[ru]阶别",
  "f60307d7122d948dcfe5467ae47a9f6a": "[ru]线别",
  "bfaa62fc9dc44b3d3b7044e9c1fe5b37": "[ru]制令单",
  "6301194f37045c0a0cc9ec265bd8b396": "[ru]班别",
  "0f51296be27d42169692607b81828476": "[ru]PCB专用号版本号",
  "abf6ae6dfb37ddad19d48824636d44e3": "[ru]首件",
  "c485bcd54a3c589ab9809f8642b8f2fb": "[ru]末件",
  "f125cc16e2249aad128e4afd6b2d6a5c": "[ru]防静电标识",
  "38e71f5232ef58c77f15458497842ca0": "[ru]所属元件",
  "f00d52d5f97525e6d03f684199fda959": "[ru]PCB描述",
  "f435bb2ed0299b5694f44646c4940d29": "[ru]PCB变形",
  "5e3bdb7248e01a6a475158b31a8b7ad4": "[ru]板面清洁",
  "296591498cc6fed3fdebec8ddad6c559": "[ru]元件浮高",
  "3fb666ed67c974b14b08c1462442ed20": "[ru]管脚角度",
  "c2722c7eb31d3a4b995d7b8374968627": "[ru]管脚长度",
  "bcb96ad69cce107cc4177244f975f96f": "[ru]管脚长度测量工具",
  "a92d2f9cfd66cf4dac17b48d5568e741": "[ru]首件确认人",
  "7083e93f0139dc6b0247823f3aa28fe8": "[ru]复合人",
  "5612b01419e8444336b0eedf4f85c0e4": "[ru]工艺流程",
  "cb1cb42dbb676ff1ea87be780ec45d52": "[ru]贴片",
  "bb5895ed50668405dbefd4e2a0b5868c": "[ru]铆钉",
  "405d3897ec0642b72dafdc7abeefa32f": "[ru]轴向",
  "34540a4fb8824780482d15909c46dc59": "[ru]径向",
  "c27696c455c4840ec222da54ad3d7813": "[ru]手插",
  "d5909c33688b64afc6be256556a9a24c": "[ru]数据导出中...",
  "d71bad0268b8e73891b65a8d2b0ff093": "[ru]首件生产BOM",
  "def12aeaeca54624063153e445f1cf99": "[ru]技术BOM",
  "cf8a033371392832130a4a058f32e67d": "[ru]校核时间",
  "84446750e7a45750b6baea7a707b0214": "[ru]首件生产BOM不存在",
  "4bc408a506d64f8eff4a996b835d7733": "[ru]技术BOM不存在",
  "bdbf6bf5b4d53ccd32f080eafe66e0fa": "[ru]BOM不匹配",
  "91bb7059c3b8b9267b0238a6149fa167": "[ru]校核结果",
  "4e08bedd66f2c747395f0eab390b6d83": "[ru]校核工厂",
  "d3ff7f6f95a1df4e1c8a195071270192": "[ru]供应商不一致",
  "2bed0a566c282c5faa96bd0ea81f09d7": "[ru]数量不一致",
  "0c8c8f11de6e6892fd16d1eb31b1e049": "[ru]位号不一致",
  "0f1b0ab926db573f9aea2ce633a2d618": "[ru]技术BOM：",
  "35f49aa08150254740d6fadbf453b578": "[ru]BOM编码",
  "9be2ebd18b333057d831ee6d9d8cfb87": "[ru]未分工",
  "4457266820aec59e3a6ae4d3d59337eb": "[ru]有效性",
  "4634e25308f301816ff2738bf2e19aa8": "[ru]供应商二三级物料清单",
  "3272272da100febb122f593a107eca90": "[ru]BOM版本",
  "8751cf5de718fbd9cc2830cfc59dc6ef": "[ru]请选择需要审核的数据",
  "740bf86109e33d787c50fdcdac39f139": "[ru]请选择需要校核的数据",
  "d69d12aa7bde050ed02e4a47b56e122b": "[ru]请选择待校核的数据",
  "ebfefae1bbbdcd50f8f02e4fbc929051": "[ru]请选择需要变更的数据",
  "c9a89acc922977c7e86d3789285f6bc1": "[ru]只有校核通过&有效的BOM才能发起变更，变更校核通过后原版本会删除！",
  "d47611bb3ed6eef6b855f8b19dd455e9": "[ru]所选数据已被删除，请重新选择",
  "e6f24724089df46c2e2184edb03dcc11": "[ru]<p>删除后不可恢复，请谨慎操作</p><div style='color: red'>若物料继续使用，建议发起变更流程！</div>",
  "054f51f96dbd884c7bd6aacf5a2f361c": "[ru]确认修改吗？",
  "50cdf79087df5b3a135161f5c161fe02": "[ru]地址来源",
  "2bb72eed4780779478e6134ca957b3d0": "[ru]海达源",
  "61a0ec8a090e2ea2d973d9ec9d0dac2b": "[ru]详细地址",
  "bca1ea039f43ad2dbac8e894699a7444": "[ru]地址管理",
  "759f4cea196570321c6acb6f8a61ddcc": "[ru]供应商V码",
  "d7009d07f04d208f84e6c343fbc80ab7": "[ru]省份",
  "f7d29dfae05b5d049b64b040b14d9a00": "[ru]城市",
  "2560b304e691da78ee2e02f5af9b494d": "[ru]地区",
  "f0c2bb602dec88e2dca8616a149521d2": "[ru]请输入供应商名称",
  "77f45ef3acc07d189c83c239d8f06f72": "[ru]地址列表导出中...",
  "1319a47592bf98ccd9cb2dc00787414a": "[ru]信息审核",
  "ead481bde12ded4a4346baab6ac59a16": "[ru]人员资质",
  "83231a79a5c48cfeb4097406c7ecb275": "[ru]测试实验室",
  "6b3e246306dc9a59a55af4b3e0d1371c": "[ru]实验室认证情况",
  "0109c9135ba8fe0ff54f9f1a4f803c31": "[ru]是否经过认证",
  "3d4bcaccf76162ad7004896ba5d7972c": "[ru]证书编号",
  "03bb5b46b2ca1bb1e7feb6be875c443e": "[ru]证书名称",
  "4bc25e9a6ec5dd07455980c11251ce77": "[ru]发证机构",
  "56816285254449739e6084ea6259ed00": "[ru]签发日期",
  "6460f46b3607ac4b78225902f085048d": "[ru]有效期至",
  "9d3326c417f194b31172b2fab812e3c4": "[ru]证书附件",
  "b1898e7517c7f8a07332c965d9919cb2": "[ru]认证项目",
  "7898ce906d7006f4665f27741660b535": "[ru]实验室类别",
  "c9e78b3053a1bc0ccb406b957c3ad446": "[ru]检测实验室",
  "2212098e7431754b7b35149e8796b077": "[ru]开展内部校准的检测实验室",
  "a8979e86fec7f1630c9bcf8ca7d5079d": "[ru]校准实验室",
  "f10c86569a1a976be9b5fdb816b67803": "[ru]实验室组成",
  "a51ad1ccf9d6c3a65d2279f95f10ce79": "[ru]实验室地址",
  "0a63945bac23dec841ae135e556cff12": "[ru]仪器设备套数（套）",
  "a42fda4de30e11888919f28e01539daf": "[ru]检测实施类别",
  "1ef8fd21130d17cb7c1613eaed6ca1e4": "[ru]固定",
  "596fceac199bb8ae6bbfc540c634dc34": "[ru]临时",
  "c19639326396d2527268484379a671d8": "[ru]可移动",
  "5908474c515322e7888764d2e58973f7": "[ru]成立日期",
  "ffa5cca28648114fcd2a8a45f6cd8745": "[ru]体系建立日期",
  "496555232adc93f31a02e36fb51a38b7": "[ru]占地面积（m²）",
  "aba49f631662ad4ef491f8dba6553a90": "[ru]检验占地面积（m²）",
  "7f393510c2e3f2513f5caee0f01f2289": "[ru]总人数（个）",
  "a6e2a0f0706899cdc694730357105b34": "[ru]技术人员人数",
  "95fa16e81915821e5a6ce671598bc252": "[ru]管理人员人数",
  "35c9d6f9ddd2fda89201dab8b2423074": "[ru]责任人或联系人",
  "77ec2ab508e0037b0bdd1f01d5d4eebc": "[ru]职务",
  "09a1f6985a9fb0915ecea9874daa4780": "[ru]联系电话",
  "4d8e094ac4913ab43009b365cae194bb": "[ru]邮编",
  "9f9d36327d96efaefe09f6bda9796531": "[ru]手机",
  "8b35f78d3ec00ddd308883c542f8cf3f": "[ru]设备制造商",
  "2f8ff031ca3e8fd0dfe852894ed2442f": "[ru]设备生产年份",
  "dec19f0e8960fa5bcfc00e1c4ded13ad": "[ru]设备有效期至",
  "8c8cbe0e2b1f3640f4dbf423f168f859": "[ru]设备图片",
  "c78513ea8dcef1ef0f6ec4af2ec2c9b6": "[ru]测量范围",
  "35899273ca515c003934ff468f2b23b0": "[ru]岗位编号",
  "b6a74e080eeb3de8652b3b5a6befbcd0": "[ru]岗位名称",
  "787b5677e325beec788727cd1a327f1f": "[ru]性别",
  "a01a9963238df560a9b974f45c7e253a": "[ru]年龄",
  "483597c148d351b22a2564191485b584": "[ru]文化程度",
  "333091274e915d04c4bb0d50388dcec2": "[ru]所学专业",
  "30dcdb6949b25912703a3836499d5183": "[ru]毕业时间",
  "36aff1b25f01d91d44f46ffbd75ba5ef": "[ru]所在部门",
  "b2604bbff30f1676358a34667529152d": "[ru]从事本岗位年限",
  "bd505f5893fb3eab35ad5896b814b85a": "[ru]授权范围",
  "b66601599a26d249277de14fcf4dceda": "[ru]授权单位",
  "205fe88501999a6b156ff62bbc0daadc": "[ru]授权凭证名称",
  "2510cec26b81529bd0ca67a1a352b7e9": "[ru]凭证附件",
  "9393b30d8604c26f6635fe913a159703": "[ru]实验室状态",
  "d3c39e6b2a036d336a35a58c0e98b335": "[ru]实验室简介",
  "1e7232b0c04a711024706d29a1c95da7": "[ru]实验室介绍",
  "74515d8d83bfafb5bd41fbb3ec02644d": "[ru]测试能力范围",
  "40c1a18af8b6d1181eb41d0fe004cc58": "[ru]实验室图片",
  "59b981fad9e6aabad313cbc2b5b6c457": "[ru]校核信息",
  "777cc4e0e0da7cb566fc433df0458cf7": "[ru]校核意见",
  "e6d16bc8d7244ef60a0febeed83d09fe": "[ru]校核结果不能为空",
  "9c570f6b0df609f6a3af3668fdbf0488": "[ru]校核信息错误，请返回重试",
  "4dfd519872a4e054e5b5b666d45e4fdf": "[ru]是否确认提交校核意见",
  "8fb7b94519009c974453652e46689cf4": "[ru]校核不通过",
  "23fc1ea8c4e2350a1ad7ddb88a453d99": "[ru]信息列表",
  "ca871bfd3437a464ff15b6d9cf3b8b7c": "[ru]输入2位模糊搜索",
  "dc40f71534d3bb2ce20cfdd79ac2d990": "[ru]无结果，请重新查询或选择",
  "c3b811cb608c0abf3ec05a7e1c015664": "[ru]只有产线SQE经理角色才能校核",
  "13d63abdaa0280350cf8a66719570b2e": "[ru]请选择审核通过且待校核的数据",
  "cc3ec1782405339a0e7acaa98c4bc954": "[ru]测试认可信息导出中...",
  "c8fc6a8a117ece588fd5e20826899a5c": "[ru]标准详情",
  "ecad68cb6ee2e60b86fed5ca2ecdf35c": "[ru]标准类别",
  "65b2e1993aad87041cf1c964309f8491": "[ru]检验标准描述",
  "911929dc101b1ab5d76a94e0bd0124d9": "[ru]是否与海尔标准一致",
  "a6f60d7c84ead22919c02987071c3e74": "[ru]不一致",
  "21901b1658b52dab192f068c7a71e6fc": "[ru]一致",
  "2de91de57590d575df2f5897e9118b14": "[ru]模块商检测标准",
  "b9670afdf3f4ee44dd120a5e7141e6f9": "[ru]关差计划",
  "675ab50f5e86305d03ea0308fc5d813c": "[ru]第三方检测机构",
  "008214ea589bdebf37eb18d36e142426": "[ru]自购设备到位日期",
  "4ce4ca4a229f73dc173fa7811dc99672": "[ru]SQE校核信息",
  "1db6eaa5034b28e2ffb31314d02547fe": "[ru]校核结果：",
  "979a551a516c9f880b9b28c5530c2aeb": "[ru]校核意见：",
  "08c88f730c03c2c117e13e92bd7797a6": "[ru]SQE负责人校核信息",
  "8ca8c092d654b85d155de19f6b459e08": "[ru]SQE经理校核结论",
  "8f92a378f15dde363c501c1f3fa66acd": "[ru]SQE经理校核通过",
  "1929997316eed6748e2af99ec87c7ccd": "[ru]SQE经理校核不通过",
  "c4d4cd99141352ca69cac1510b38a40a": "[ru]SQE负责人校核结果：",
  "a8e1bb14aa40e632ee3dd0c9a0bba453": "[ru]SQE负责人校核意见：",
  "d06ef979ec2924b23fbc9881f1c66a4e": "[ru]SQE校核意见不能为空",
  "87275750ac0eadb0eb28833723120457": "[ru]SQE负责人校核意见不能为空",
  "b01a15629955eed30ff00bec744fe9ec": "[ru]国标",
  "445d730c90f5f07c7c239898ef3be23d": "[ru]企标",
  "3c3eecfe37423e74772378bb236003a2": "[ru]规格书",
  "1592772c6c3168a49d58b680341d079d": "[ru]技改单",
  "c1df9fcc4191e32d2471d67bcbf7f16e": "[ru]物性表",
  "afcde2611bdd13c1e65b4fb6a2f13425": "[ru]外观",
  "c8339fd2a85af4ba66084d28df808de4": "[ru]尺寸",
  "fcd9436296f1a4b17e75892d0dd4e5a0": "[ru]重量",
  "c3318eaaa3bd15fa40b3a4d381c4ee15": "[ru]性能",
  "45235f6c8fa2f6bbb0d5b69742eb1076": "[ru]标识",
  "ebc9d9e6f23866c769fd200f5aa434c4": "[ru]材料",
  "b7158a42ca1c2845b3c08111982b0494": "[ru]认证",
  "5a009134f36dd6ea110bc429ad19ae19": "[ru]包装",
  "b3a3c161507940a68eccae574512ee53": "[ru]装配",
  "8f8fd5cec97ab869bf4df0cb446f4cfb": "[ru]包装运输",
  "fdbc77bd19b9ce6318b00649645095cc": "[ru]安全",
  "a7551e966f3a59737dfa89b9778d157c": "[ru]致命",
  "44a3bca37df19a7b4fafad245852d682": "[ru]待SQE校核",
  "39998b55b8c3dea6f5a419d97b1e5372": "[ru]SQE校核不通过",
  "79de62ebcc9d2127b76679be78db0588": "[ru]待SQE负责人校核",
  "36b79186c9fbd8ed15ce796571c93e49": "[ru]标准状态",
  "35b6fa5bcac2c9a0734cb24b4d81837a": "[ru]标准列表",
  "204ac3fc3bd212dcae33df573d0c9a55": "[ru]变更校核",
  "4ab78fdc4b13ef8198c5876752994116": "[ru]供应商标准库",
  "d372ffba253324785f9d6a6be4d92980": "[ru]流程记录",
  "cb27bc4a7e3536c7f3827afc878189a7": "[ru]能力版本号",
  "823394df6a8fd707235add41b1fad32d": "[ru]供应商：",
  "7035c62fb00576fed9b3a1f2b7d48e6c": "[ru]账号",
  "7bf958a1d498cbfdc75ee8e8959e5206": "[ru]请输入标准号或者名称模糊查询",
  "1c23046d431de39c0596cd441b6af6c4": "[ru]*①列表中的标准不会推送供应商维护测试能力，请谨慎填写",
  "3ca1eebac65c6faae23a57c7c9a8ff4b": "[ru]*②提交后会同步将已推送供应商&非校核通过的测试能力置为无效",
  "4853f53caad00bf27de2e6dc37caafdc": "[ru]新增供应商-企标",
  "226c200e7b611246c8b5bfa5354340bd": "[ru]测试能力历史",
  "67fa0c0ad85f001c92428ba3e8a96078": "[ru]请先维护检验标准",
  "3f4642e34e595f6619e26669810bfc8e": "[ru]请选择一条数据进行变更校核",
  "c402a341aa067ed8be53ae998a4b99b5": "[ru]请选择变更的数据进行变更校核",
  "11a74de956095254a6cb78fe1726a613": "[ru]请选择审核通过且待SQE校核的数据进行变更校核",
  "8f5388d5b4780ff4a3cbc64214a1a281": "[ru]请选择待SQE校核或待SQE负责人校核的数据进行变更校核",
  "07e6fe1f539d778a695a84291b1b7212": "[ru]当前变更数据需要SQE经理进行校核！",
  "4c0f8a0fcd9ee07621a6aa00386e888c": "[ru]您没有变更校核权限，请联系SQE负责人进行校核",
  "881128efe18ea40ea27e10c68a809897": "[ru]变更的数据请使用变更校核进行操作！",
  "0f3909a3dde629754f94f2a074a6abb7": "[ru]请选择待SQE校核的数据",
  "ebb2b79fdfa34a81ad5c6283456171a4": "[ru]请选择审核通过且待SQE校核的数据",
  "61dcb0fbf43285e5895d31a5b6010eae": "[ru]检测标准导出中...",
  "f81568938e9ed3ac3121503f0b299b6c": "[ru]待SQE经理校核",
  "10cf8b2e4c9e52dfe954fa339b6743af": "[ru]SQE负责人校核不通过",
  "ad19ed075fabae104ffb2f446aa81295": "[ru]质量经理提交",
  "31a80e51e55ad63f1507d9f6a52b135d": "[ru]质量部长审核",
  "1d4d2b667ee529a96ebc6c53aabc0ba2": "[ru]SQE经理校核",
  "c6898e4cc00cf522bc544f508d4c2ab7": "[ru]SQE负责人校核",
  "068f8929de4e451fba1120ac6633b146": "[ru]请至少选择一条数据进行删除操作！",
  "a366b70e4d2efafbfa7fef51150fda7d": "[ru]是否确认删除？",
  "d7199047ebd596af1e7845aba0d68b1b": "[ru]报表日期",
  "507b52d3a19e590fd06173527a513b12": "[ru]企业标准号",
  "8e925255863dba9bec70c3e8866754a1": "[ru]企业标准名称",
  "4e17a5b388861bd7839de3c02b57b5b1": "[ru]测试能力报表-产地",
  "f9eb56abf1e0eadf5e6f6691acdfc6a9": "[ru]（企标“Q/HR0603001”、“Q/HR0603003”不参与报表统计）",
  "19296bf576502c46ce9df91ba17d10ee": "[ru]出厂项目具备情况(适用范围只要包含“出厂”)",
  "9fe822e0cc4c6eaf4f99c9e2b077ec8c": "[ru]出厂项目具备情况",
  "40ef1de175283e067908a7664d0826a9": "[ru]适用范围只要包含“出厂”",
  "0bb2748ac9c7467c017977a327886a0f": "[ru]出厂&型式项目具备情况(所有)",
  "50c174c4cde2537928df9f57f28cafa8": "[ru]出厂&型式项目具备情况",
  "9a7b52fc8659f1786907fe93efa85bf7": "[ru]所有",
  "acbe6b9fef13c37a02903d66d7f70f09": "[ru]报表日期 不允许为空",
  "46311d916fed7347f5b96740d95a05bf": "[ru]测试能力报表-产地导出中...",
  "2b6d31bc1ca8d1e360ba62e8c14f2b40": "[ru]产地",
  "2731e52a2e4c32476e05e5962219c35b": "[ru]涉及\n企标数",
  "68d349ff469eace5e22d57ef3802db3e": "[ru]关联\n设备数",
  "539d3e5db4d5a10438883c8f31f00070": "[ru]出厂",
  "0f0d251811a7f22c212d43266057ef17": "[ru]测试能力报表-供应商",
  "48aeb53991640302389d893222e5dcbb": "[ru]企标暂无明细，请先维护检验标准",
  "45d6b30385f4c0443b3cb795de6fec89": "[ru]测试能力报表-供应商导出中...",
  "94999457c55ac9fdd6339cd16d432d89": "[ru]提交数",
  "16ea38a12a6d071c796b302c210caa02": "[ru]未维护",
  "4109d5de2fb04f7923ceaec3237b9fd2": "[ru]维护中",
  "3f76f6bfc25432d1e52c36172995bd83": "[ru]测试能力报表-产业",
  "113b3a4bfcf83ea0fb5ba21670eac321": "[ru]涉及产地数",
  "1b3a5edd4a08683c5464ccc5478845be": "[ru]供应商提交",
  "fed85d5c21b09bd232f3de7753cfbe53": "[ru]应提交",
  "20b4d6e525d52078d2fd8a44e816dfbf": "[ru]SQE校核",
  "d912c39d69dd884b56d61a2a2aff2df0": "[ru]应校核",
  "acc2bb93a1a73ae754a7f3c6baff0b3b": "[ru]已校核",
  "102244d40f09b2c12a7a3a5b7e7d74bf": "[ru]测试能力报表-产业导出中...",
  "cd9e8e30f7ca44217aedb3da338010bc": "[ru]产业查询失败",
  "7555b622fafc139ba921773add6bdbcb": "[ru]供应商\n数量",
  "35d8270aef72443c486c97e9ac72df99": "[ru]涉及\n产地数",
  "efcbf4dac8beba372a3d28e42a749aaf": "[ru]标准编号：",
  "d1f798a447520bdd0028036b9e6074db": "[ru]标准名称：",
  "4e6adf359699b06145347ca18873dc93": "[ru]判定水平",
  "f247d36c479737754d8b63926ac29429": "[ru]检测结果：",
  "95a967967e46fa49eeed0639a183d5ab": "[ru]检测人：",
  "baef2afbd7957bd858d211ce5ee7508c": "[ru]检测日期：",
  "4b0b7caa957a978fe91c3d3642483489": "[ru]审核人：",
  "03f6de59f29389e1d7b9eaca11319596": "[ru]审核日期：",
  "443d7ea063b7f0a0bbc5cc6235374ea2": "[ru]尺寸见证资料:",
  "d41655cff03f938e41bbe58a03c4d35c": "[ru]url获取失败了！",
  "ec46bb5e826a9e2d3dd26aad97946925": "[ru]问题节点",
  "d245956f4ce8128218f811c6d9ccdcd8": "[ru]请至少输入二位模糊查询",
  "dc7de1f17ae03cd9d65936ae5953e715": "[ru]请至少输入四位模糊查询",
  "453ed232e162fee84e865214991d5b29": "[ru]物料名",
  "8f30e9f8678c24496921bebae6ca2ac6": "[ru]年份",
  "6e725d25a187e2f4b4bf74bc557196da": "[ru]现场索赔报表分析",
  "bbb8c2b9eb27e1bd8a29089000156733": "[ru]请输入物料名称",
  "922fc538ced2550954b61fec25cf4114": "[ru]认责单类型",
  "38484a93d62fdfdd5dc808da53657825": "[ru]入厂",
  "498bd05ebc689dfde8c4a3a59ace4a42": "[ru]现场",
  "9f50ccd8efc555216580ff1a87051f5a": "[ru]实验",
  "bfc6d3d1ec310d70f3ed2013778d3057": "[ru]现场索赔报表.xls",
  "8f6b36d4a84a97a756db1ed43af52a9c": "[ru]输入二位模糊搜索",
  "61a398c89895823e88e0f8ab1fad4ba6": "[ru]输入四位模糊搜索",
  "ba898eef03f6ca4b9aa59bf628bae799": "[ru]现场索赔详情",
  "41716f87c3755bab459a2cbc7219e60c": "[ru]公司",
  "21f695cfda35456de5403862989d74a8": "[ru]合计金额",
  "146a18381105d881060cb68aaf307bde": "[ru]签发人",
  "fe74c576c4a82b87e6eaeff36fc48433": "[ru]附件：不良明细",
  "b379842b1845387b6609022e7d834182": "[ru]不良原因",
  "111bf3546339b7d2a454e514828daf98": "[ru]不良数量",
  "1bbe6ebe11a361d576f88cda2d2e32b8": "[ru]发生日期",
  "eec9575cbb72f7ffd775c3a20ca9cf1e": "[ru]检测经理",
  "400110332d6f8da509dfb886f05cf5f7": "[ru]VMI仓库管理",
  "4e5e4b1f43257451b54d81005a44d94d": "[ru]VMI仓库详情",
  "c67e4b0202a6d6131044f5683fce6f64": "[ru]仓库编码:",
  "cafefec6ef6f68c09ffe96b9d6df0497": "[ru]仓库名称:",
  "b0f2ca56ac8e6692f9acc54360a0ff8b": "[ru]是否有效:",
  "31937f8c52478273218a13e4f9beb9cb": "[ru]更新时间:",
  "23940cce85b874b979031a084c90dc3f": "[ru]工厂到VMI仓优先级(横向排列，点击展开)",
  "e78e4b2dc4f8ac783d9502fdb5be2206": "[ru]级别",
  "00ee5d8218d34502b9796d40c92e1ade": "[ru]说明：优先匹配优先级最高的工厂(1：优先级最高，数字越大优先级越低；0：不参与分工)",
  "c5575b3f607708d43a74904961352478": "[ru]保存修改",
  "a339c45b171fe2e7f5253c1c69862fa9": "[ru]工厂代码:",
  "7f555b072efe6cd93c4169b54ba0f4c5": "[ru]工厂名称:",
  "98162b1b55e7e38ae6ee8c64fd2d708f": "[ru]工厂小微:",
  "a0301ffba85ecf6bf1c187aebf058a41": "[ru]是否设置工厂到仓库的优先级:",
  "2db3045968285b9f704ba7a551204f18": "[ru]工厂到仓库的优先级:",
  "748323c7afc8c68cee26d51ddb7e0d9a": "[ru]请填写优先级",
  "85af343c8dd28d098e0262ff52163ed7": "[ru]树状图查询中...",
  "45b1daaeddd8083da3dfadc470c97f72": "[ru]树状图查询失败",
  "b4c866792c0303900bbc59acbd6155e8": "[ru]仓库对应关系错误，未知问题！",
  "93ff7f799a76a1ae21fe24af4d883a84": "[ru]工厂对应关系有误！",
  "0c2e0715cbbfc29d66231c7b3cfc3807": "[ru]新增工厂-",
  "67685e6d445d090910e4a49aab122ccb": "[ru]修改工厂-",
  "0d1d4e4cff5f1f1d674ada2991777be6": "[ru]当前工厂将会被删除",
  "f3328c38fc089dc894530f12aa484a30": "[ru]请先选择数据",
  "9090b92f4867eac815b3d8dfefd2de32": "[ru]优先级请填写数字",
  "4fd19f41133047383c0fbcee2fc8aa0c": "[ru]工厂新增中...",
  "f438e0529c3ad4cc70ad488a97a81436": "[ru]工厂更新成功",
  "9d2dd615d892dda576aa58905e5a4fde": "[ru]工厂更新失败",
  "f75b6b03448cd5e606ee38d936fbd131": "[ru]仓库更新成功",
  "179c2bfe3ee676a99c4d8090e4f3ea5c": "[ru]仓库更新失败",
  "6c04106c408995840bea72a1d7baa856": "[ru]的现场退次交互",
  "a5ff4fff86d0a4be5ff48513defcfcff": "[ru]部件类别：",
  "5f4b98f3059e4a2191984381fcaa115e": "[ru]数量/单位：",
  "aa4c19f71245ca6d331ea0e74da6c124": "[ru]线体：",
  "19fe3c6314ee28a60b4711de782d53a8": "[ru]班组：",
  "7bc98460fc05a989fcb036a5f4f99bc8": "[ru]操作工：",
  "7e87cede03097b7006f46290649bb73a": "[ru]原因：",
  "412800431af31f76f72c9b13c5e0d882": "[ru]缺陷描述：",
  "3629a91bbd67599733719f6166a2eaed": "[ru]退次类别：",
  "905ed1a5856b37c9fb99b5c7cc468017": "[ru]缺陷类别：",
  "5789d02a24de586b57870f5fab47c631": "[ru]产生原因：",
  "d3c6161a066764eaa2b9d0f0b16097e0": "[ru]意见：",
  "5a89637ad3b3b7023dde114237d77b4e": "[ru]录入时间：",
  "9221bb10f861e20c96971b87cff33aec": "[ru]不良单号：",
  "6fb634943594eeaaa00b36fdfd4d50ba": "[ru]录入人：",
  "f2f65c783e55fb27a344d6551dfbd732": "[ru]只有待审核的整机验证计划可以执行该操作！",
  "4ab085d591d40157e118ed9e2cc6c122": "[ru]整机验证计划.xls",
  "eab1293c98ed5068dfa21a2507603f2b": "[ru]个人信息",
  "e7fdae5faa95aec6ea9fad82c45143fa": "[ru]../assets/images/个人信息头像.png",
  "1211a84a5a38911aad0d69e27cee9054": "[ru]每日都是新的开始，抓住机会，做最好的自己。",
  "6feeabc2110fc6f2a8b36d10f757b9bc": "[ru]我的数据",
  "79d3506722d496c8e6eb5d4e3717e45e": "[ru]新品报验数",
  "f99f1782be6b50a8b3f0d4f090fdd46f": "[ru]停检数",
  "a99004fa2089ee2eeec6a940b24685c0": "[ru]抱怨单数",
  "3b9d92eca3709a56edfed5be784406cb": "[ru]质量改善",
  "ab49455cef77b5ba5df5aea1f604780f": "[ru]标准查询",
  "7b6c98d3716aab14ac250aef9fdf6079": "[ru]芯片质量保障",
  "a22da82fdca28ed11bed397e21b0c8b4": "[ru]整机送样",
  "941566ff4288037319f067545f6f7e3c": "[ru]GCCC认证",
  "8593ad610fffc49e27ce2cc35c92ca7e": "[ru]暂无权限",
  "7a4bf767a46b328eb61fca6ba1659b70": "[ru]过程质量",
  "21b7c71be5da16a8e5a84440fe0d1327": "[ru]模块停检",
  "a0d74f6dc6eab5984313736ec1910bf6": "[ru]质量损失",
  "92bf57b7dcb38847b483bb3a7ece3ae3": "[ru]月份区间选择",
  "8749d983883ab46745aaac730f398a97": "[ru]开始月份",
  "3b0575e9cc5ccd3824e6461b8b1f7107": "[ru]结束月份",
  "a3a0cbcd55f8f7a9a401d5f8800c4c00": "[ru]供应商赋能",
  "536d2e8eb010fd96198373de9012ead8": "[ru]我的待办",
  "44406eaf8750d430f883a9981c1fbcb2": "[ru]暂无待办",
  "cb71d190d592b9f07b51aff3b4b7a3ec": "[ru]集团综合绩效（分）",
  "28bf152af335a830d2c6e392bb7ad316": "[ru]集团质量绩效（分）",
  "a04e9cf5b59d94cad7a50e1dce475d2c": "[ru]绩效得分",
  "361d732070b539ff6266be0e25d06ed9": "[ru]供应商/产业：",
  "c7b786712113f41292cc11cedad25e04": "[ru]执行策略：",
  "69f42c7c1d563b03c8a8fbbc3be1ebe8": "[ru]执行月份：",
  "44a1f0c7642ece07d7ed23c47da42b4c": "[ru]查看更多>",
  "a7deb625ed114b6ec7e180526fe00a5e": "[ru]关于供应商市场生态圈功能上线的通知",
  "ea994e85a852564a51db05d5b381e632": "[ru]为提升市场用户口碑，降低退换机损失，实现母本质量问题归零，模块质量互联共享平台（SQM）增加市场生态圈模块。2024年8月7日上线市场退换机分析功能，将市场退换机改善上平台，分析过程实时可视。",
  "603af4e742cf8eb3a072643258c85dd5": "[ru]相关要求如下：",
  "84f8c0f448da4ec58a41e90586e9e8bd": "[ru]1、供应商建立市场生态圈改善体系，对退换机不良件按期完成分析，明确问题及故障现象。",
  "8c63eda2e66d64bc7dc92f06b355909e": "[ru]2、分析完成周期，按系统数据生成时间+2个月，2个月未完成分析，系统自动显示拖期。",
  "9e8ae1e00afe4dd91d23872319daa854": "[ru]3、市场分析进展将纳入供应商质量绩效，每月评价考核。",
  "483897ec0c3120a91c72f8c2c7eb9279": "[ru]4、其他生态圈改善功能持续发布中，请关注支持。",
  "1177126c9088de02f8bc890ea72e993d": "[ru]注：市场生态圈模块具体使用方法见附件",
  "76d9a8b786c396065fe0a91c38f2fbee": "[ru]《操作指导书》",
  "81197c2d02b3a7c54cbd498ce55a73c8": "[ru]。",
  "351f023ca65048d35f5ba9a678397849": "[ru]测试测试测试测试测试测试测试",
  "6e0c7d9c413ef2e4eb51f3e0bba90419": "[ru]假数据假数据假数据假数据假数据假数据假数据假数据假数据",
  "15992027ad912146532ef9d141b46e2e": "[ru]不能任意调节铁观音",
  "a0c83707b5438e080655df34a78142f4": "[ru]测试测试",
  "b0da132423073fbcca7bd295ac4e8b89": "[ru]测试测试测试测试测试测试测试测试测试测试测试",
  "857e00deaa295ff6373822c19bc5f98f": "[ru]假数据假数据",
  "0775628dc1ed861c4f99ff33274121c0": "[ru]关于有害物质全面升级上线，原功能于2024-07-23日下线的通知",
  "de7fe827318468928f23e056b9c50d5d": "[ru]有害物质功能已全面升级，并对系统部分功能进行了升级优化，原功能已于7月23日下线，新系统使用过程中若有问题请及时反馈。",
  "3b160a5d483ec67f8c4687d76928fc5c": "[ru]系统功能升级点：",
  "a941c736949686a6f85e3c33c4ca2b00": "[ru]1、供应商替换多个报告时，对应宣告表未做报告更新。",
  "39905a504ac7b6c2c4d86529f37b2931": "[ru]2、作废报告库时，原报告仍在有效期内的报告库及宣告表未进行还原。",
  "5602a63e3e8ef5321b58fc602d5f65cb": "[ru]3、宣告表无法提交或海尔方无法审核优化。",
  "d6b693a600b054f418d177c99c0d4aca": "[ru]为提升市场用户口碑，降低退换机损失，实现母本质量问题归零，模块质量互联共享平台（SQM）增加市场生态圈模块。2024年8月7日上线市场退换机分析功能，将市场退换机改善上平台，分析过程实时可视。",
  "5b13e760367093a58b4a23df89784c95": "[ru]注：市场生态圈模块具体使用方法见附件<a href=\"https://sqm.haier.net/readFile/basicInfo/%E4%BE%9B%E5%BA%94%E5%95%86%E5%B8%82%E5%9C%BA%E7%94%9F%E6%80%81%E5%9C%88%E6%93%8D%E4%BD%9C%E6%8C%87%E5%AF%BC%E6%89%8B%E5%86%8C%E3%80%90SQM%E3%80%91.pdf\">《操作指导书》</a>",
  "52258897ad031b04f6d1bfe093adc195": "[ru]关于智能客服上线通知",
  "26df25307781d4d912499f1688ef0a97": "[ru]具体内容如下：",
  "7691db29ec6b9f60eb17471abe564351": "[ru]1、海尔集团ESP运维系统将逐步下线，现已接入智能客服系统。",
  "505fee7ebf0a6e6fa55c88b1c7c82a01": "[ru]2、请点右侧智能客服按钮，进入“模块质量互联可视共享平台反馈您的问题。",
  "06fca431f4ad5efa7871eb756ead58b6": "[ru]总经理",
  "976abc7f8a55866ae953295f7982c619": "[ru]发货经理",
  "4c9dcca57920fd8d0eed82311cf80f7d": "[ru]销售经理",
  "69f28bab80d16769dbf1d0d6c70c7d77": "[ru]暂无权限，请联系管理员",
  "036a60c992f848e9b9625ebc0688f2a2": "[ru]代办",
  "bfe3388bd4aa0b5949e9e64377bec6fb": "[ru]矩形备份",
  "fbbebc027388442c33d94870ea9eeed5": "[ru]矩形",
  "9efa4b1b2ba8bdd7d98643dc9957b725": "[ru]矩形备份 2",
  "b57c985d38dcf9f296e3ee3d479a79e7": "[ru]矩形备份 19",
  "4f35e80da65927f09dd314de120fe5f9": "[ru]路径",
  "65f9a5da5f1089e0265089458951b66f": "[ru]不良出门",
  "188dea14567672518c4f1d26ef12852f": "[ru]部门（或公司名称）",
  "cbfdd38a110c022342dc06c3efc0e995": "[ru]工厂小微名称",
  "619a501ce271e92f3ed931e50e22ad63": "[ru]是否打印",
  "0833e24f3fc6cb5639f5b85ef0c488e5": "[ru]打印日期",
  "6f73365a9e473a0c05aa0c8e51bfa08a": "[ru]是否出园",
  "e4788eafa0739fbb69718fbf3980199b": "[ru]出园日期",
  "8f26e69ef238e2e5b275b239b897fce5": "[ru]作废人",
  "33a2c48a57e8ce1850fcd5dd53941d75": "[ru]作废日期",
  "dd481af72568ce061d1962ceb2214664": "[ru]不良品发生地",
  "f6edd7115c8995dcba4ff513799ed000": "[ru]发生原因",
  "f5c25b49ccf6a3f99d0e37dd1f653864": "[ru]工厂小微编号",
  "bcf765e0e0b77154aaa67a7a86f163ab": "[ru]放弃不良品",
  "9bdbd7104d90d29ff2c7fcbc809f3ec6": "[ru]作废中...",
  "65247c8444b4109a9002bdfc95f8e552": "[ru]作废成功",
  "b574bf3dfc12224d52ccfb2178df0543": "[ru]作废失败",
  "d988f91b2ca3354a6b9a81bbedbb8fce": "[ru]部门（或公司名称）：",
  "71099ae7394761056fa70cd047cfcf31": "[ru]⼯⼚⼩微名称：",
  "a7776f7bc891c729d50326c30c9a1558": "[ru]创建⼈：",
  "5263d3c8c9cb68cb25cd9f4e57364600": "[ru]创建⽇期：",
  "80bfce5c90fd778351a3cdc04c96d8bc": "[ru]经办人",
  "eec15f183b881984b7011321e3ba23b9": "[ru]部门负责人",
  "641f7f1273b824bea9a8cfc5d578cab1": "[ru]持出人",
  "2734ed4c1082b1b78ea8963212f691ef": "[ru]备注:我司认同上述质量问题，并同意按照双⽅合同约定接受处罚",
  "8b76a6808e9c39eb4d4d3fa4b6fdfc05": "[ru]更新打印时间成功",
  "6ba9cca606b326cc736c5f702dda4350": "[ru]更新打印时间失败",
  "8fa0f9aefdf89bc8a33927d0542d8f4a": "[ru]出园证编号",
  "b467aee6eec94aefe6ed1a9e48ab7631": "[ru]作废人编号",
  "ada6f5a8e938e37ccb115f6cf182d376": "[ru]作废人姓名",
  "26068dad4bd373b38e5494279842765b": "[ru]打印时间",
  "6fafd0a0c04ccc9ce4ae27c400e4f911": "[ru]出园时间",
  "4215875545eef559f64085111caf417e": "[ru]作废时间",
  "563b75e45e2c97e1ff6c16386976c976": "[ru]PPAP检验计划",
  "bb38243d2cb65ba81c69d265a012b692": "[ru]JIT确认",
  "79bb5f42befd767e79738df0bc2d3ac8": "[ru]只能选一条数据进行JIT确认",
  "7b3a1931ac86b917fa9c4d17e09853f9": "[ru]请选择超期的数据进行确认",
  "ea5415c8a4fa7ecbadc78f585b97b8f4": "[ru]部件类型",
  "12fd92465883744aabba15cd7e1cf1cd": "[ru]缺陷原因",
  "147ba3d438f10d0868d9298e4619d789": "[ru]维护时间",
  "023139996dcbbaf6642c6eb6752577f0": "[ru]缺陷描述维护",
  "8e850a534aaf732e504e24ed46f7fa59": "[ru]部件类型不能为空!",
  "fbeb422c99f0d3a90771138c49a91cb2": "[ru]缺陷描述不能为空!",
  "15b90b3e035e118158bbc51925620863": "[ru]确定提交当前数据？",
  "51dfe024f491644d30be2f46d7cd154e": "[ru]使用部门",
  "1586f589254cf2c3d378da309a02b98c": "[ru]管理类别",
  "e6a7a9fcee6836d3fcd0198dee2b2ab3": "[ru]设备台账",
  "fb796b8e7929a1ca6eeb71b71d1c1a67": "[ru]设备型号/规格",
  "0248810eed7043c81736baf615c96018": "[ru]校验方式",
  "b1dae9bc5cabbc13e4bee21af11cdb8d": "[ru]管理员",
  "075fdd51f99320f39b275a16d7ecc6b6": "[ru]计量员",
  "bd83ec8664843061bddb1e8d373153fc": "[ru]请选择至少一条数据",
  "c635aa940b63e5f412a839dc4a95147e": "[ru]确定删除选中数据吗?",
  "62929dad662e8b20339eb4de1f01a10f": "[ru]设备编号:",
  "52b2a2bd92265358b1bc107054720ad4": "[ru]请输入设备编号",
  "b9d298777c2647248f20200428dc9844": "[ru]设备名称:",
  "dd73090ab7ef512186895839bda6b88c": "[ru]请输入设备名称",
  "4953b7732e5601767aa7212acab5b490": "[ru]设备型号/规格:",
  "3330c04368c3e853ea4edde69aa572e5": "[ru]请输入设备型号/规格",
  "e428ba1f1adc7337e3c2617770350011": "[ru]使用部门:",
  "af8584b2a32811f22790784b541d734c": "[ru]请选择使用部门",
  "d547c2f30fe25d1d4f4aa6c0bfdb00f6": "[ru]设备类型:",
  "dac33a2c507daefc519f3df752c36d0c": "[ru]请选择设备类型",
  "02d8d600fb823a79bcf8f6ce5f5ea859": "[ru]校验方式:",
  "e491d3d6e65c34ab12d21bb0e849f410": "[ru]请选择校验方式",
  "932f229077a8cadcc16adf1ab12a408d": "[ru]出厂编号:",
  "49ebf41dc10b77ad451f7d352606cafb": "[ru]请输入出厂编号",
  "b86ed691781d927763c7ec68337b2f04": "[ru]存放地点:",
  "a7d7dc7f3c61b1ca8fb6ae0812822db8": "[ru]请输入存放地点",
  "86e74aef2944fd82bb6abb00347b9d82": "[ru]管理类别:",
  "7ea3b8414c75216451b7019696ac4d5d": "[ru]请选择管理类别",
  "972471d1830e327bc43d02fb48002dcc": "[ru]检定单位:",
  "76964a0e490dc84f5257d2ef9c90bb29": "[ru]请输入检定单位",
  "d8dca7b7aa109d163e70da3645dd1e03": "[ru]鉴定周期:",
  "fe2513a170170ab3b41c993c3f9b4adc": "[ru]设备状态:",
  "b0ffae553ff6f8b937190751035f2026": "[ru]请输入设备状态",
  "68657d2506f0f22a78e92f87622962ad": "[ru]精度等级:",
  "d076a229812bf7fd193f9eb12e25ea3e": "[ru]请输入精度等级",
  "01922c947e6648c50a9b396a1be53039": "[ru]分值度:",
  "fc571005219cb0bd54ac447709d1c706": "[ru]请输入分值度",
  "26863dcdec2b3aa3776e895e6fd6fd64": "[ru]准确度:",
  "1578f4ca3f3baa2ee1994691a7390df7": "[ru]请输入准确度",
  "b778b7c4d7270b057d961c8f5b4a4785": "[ru]生产厂家:",
  "db028d0cdd10fad5ea8c0c6027970a08": "[ru]请输入生产厂家",
  "e0a361aa36bdcf8a488bfb2c2a593ef7": "[ru]测量范围:",
  "b48748e196a61f8618962ca5bc771763": "[ru]请输入测量范围",
  "a1dd71f2643d0fd3d425431801f69c30": "[ru]生产时间:",
  "d6274abc762b7d738615d726985358f7": "[ru]请选择生产时间",
  "00d243589efbb89d3e60f150961a2e53": "[ru]购入日期:",
  "beea7d3362587fa9a344d4c27fe38550": "[ru]请选择购入日期",
  "084033e161d78b58ac181582ec26862a": "[ru]购入价格:",
  "cbd8fa3a43a085f37dee85a8d2611697": "[ru]请输入购入价格",
  "38e24c4b20692985312738a0de218a78": "[ru]采购员:",
  "f9081f656f53262d8623a8448b8da384": "[ru]请输入采购员",
  "7de1381dc5ff9e48123474002bb98f73": "[ru]法制类别:",
  "407e37d5fac2df7981737f0e9050a8bd": "[ru]请输入法制类别",
  "57d919da756afacab054b55d982bf5fd": "[ru]管理员:",
  "9bafb0b677df54b9c7320e85cc0160b5": "[ru]请输入管理员姓名",
  "9e1a96d4c659020157a400f953c3a670": "[ru]计量员:",
  "51fff8c86e4f16060498b582d7717013": "[ru]请输入计量员姓名",
  "cda47e8c916da53602e7e034f63f7b7d": "[ru]附件:",
  "435d09c3eab65b4b6720390b99327e36": "[ru]请上传附件",
  "8e2f993840e3108c7f6d8f23d6a8a08d": "[ru]上传失败，请重试",
  "2b329fa407dd1e9a99c2b83c8f600a7f": "[ru]获取手工策略失败",
  "8615a9ecef1c9c48c4d641adc84330b2": "[ru]确定保存当前数据?",
  "745f75eeac36883865e94f2bfe974aaa": "[ru]设备台账明细",
  "049665083e0993651db6355216300065": "[ru]线体名称",
  "315c621b0f065d55abb422d225f76e8f": "[ru]线体编码",
  "f6b8cb22b70c77cfdf2c7d07b02d016a": "[ru]线体管理",
  "ad767f8230ae6f2d9bbf3d99e6498630": "[ru]质量经理1",
  "f0c75e5c66659c273f8107262608099f": "[ru]质量经理2",
  "dc29d215310e7d9c5a22fe7cd2f39bfc": "[ru]线体维护",
  "13d71e1ad820edb8e7336c1fb9e5caed": "[ru]请输入至少一个字查询",
  "99307d099b74749dde745c006ac164d1": "[ru]员工工号",
  "35cf1d90747189728d369bfbf674aa43": "[ru]员工名称",
  "2a67afc34bc81f9ebe31512c0f751a10": "[ru]线体管理导出中...",
  "46434753b71b28280e7a409a3bd42ead": "[ru]确定删除当前数据?",
  "7f6fa84495164c97652ef2072d05bd5a": "[ru]线体名称不能为空！",
  "1e77f0d363d8f1e3d3659d1950b77a1f": "[ru]线体编码不能为空！",
  "75eb1d83b3c6077fec5bcba1573c808a": "[ru]物料类别ID",
  "78bd99c9369245ac57d859c82c3379d2": "[ru]物料大类维护",
  "03b5aa784e59e3224f8ee471f7d577fc": "[ru]物料类别不能为空！",
  "2f6c3dbf666e3cc9aedb44346caa746f": "[ru]组织结构维护-",
  "44dbfcab8c837bab7af1a9b26c91d345": "[ru]部门名称",
  "24f422a41d14a7b741a3ae1ba57fc26c": "[ru]部门编码",
  "08db74782db6949e5e353c1001fe6c13": "[ru]部门ID",
  "4890f6fbb06667377cfc491c6d55db00": "[ru]冰冷",
  "ee698d2ca11649f6b37862ff94a92ac8": "[ru]洗涤",
  "2be23105fd367df443ad9a32b9acc35b": "[ru]楼宇",
  "03a2c64caccc5a84dcf4ddf2d3e53ab5": "[ru]水联网",
  "2b197344b1b44967864eb7de5c9bb823": "[ru]视听",
  "cf0b6b2bf8da18cb19a9fa8c05302e0b": "[ru]公司编码",
  "8faacaae3955d3d39ceb7bc306087a12": "[ru]V码",
  "bfb37b1cdc51fdd6c102f952b0765c15": "[ru]工厂是否有效",
  "245301237a9d804fbe507907cc16316a": "[ru]V代码",
  "aaf30c04b2f57107a1339ea17e505e32": "[ru]组织架构管理",
  "cbbb40290f0100a102235f252df9bf59": "[ru]产业线ID",
  "fd140d1463151413a0c2631e7c3e546e": "[ru]工厂小微ID",
  "ae42cc913123042d0ee51e768d1fdf87": "[ru]工厂BU",
  "6d3e338f15176ef4fb7e71cd8c8178d6": "[ru]添加产品线",
  "c26d207f91ccdc6b60c30ca7ab98d849": "[ru]添加工厂小微",
  "9fe7a9337b43d250e09cb909322bce11": "[ru]添加工厂",
  "d1679d55bb744029f140291d401189b9": "[ru]部门名称不能为空！",
  "2d6c8c6998212ee099498e2238af8936": "[ru]部门编码不能为空！",
  "6bc70d23560a30aa6bf3fa8aeea5adac": "[ru]部门ID不能为空！",
  "b512d1bd26993501b4de62ca8db678c9": "[ru]确定要删除吗？",
  "8d1c5cff82bed0b35268e619fee6a4de": "[ru]类别不能为空！",
  "d117cd189a4e587b148b37a09ee9ed1c": "[ru]大产业不能为空！",
  "9c9949ae5a39bb788e8aa697acfb90cc": "[ru]公司编码不能为空！",
  "911a665201ae28143f8fcc5e5f5d6f6a": "[ru]V码不能为空！",
  "84ec514376f761956c2f862720d66e68": "[ru]工厂名称不能为空！",
  "ca81f2b7f630389c74881db97a83e128": "[ru]添加失败,",
  "d1a9cf7bef07be67a97ed4b64ba796ef": "[ru]组织架构维护导出中...",
  "b7c2345db10ede81a042347aa93627dd": "[ru]供应商考评标准",
  "226720b9134ded6851a165f2369cf7e9": "[ru]入厂权重:",
  "8d5f580c5cf8a338ebc9b7917f4e250a": "[ru]请输入入厂权重",
  "e8cd833e594082968755c4826dc98ad7": "[ru]停检扣分:",
  "03e784484b83d656875fa8d131f49a52": "[ru]请输入停检扣分",
  "f1ab1239271f0e331102cf34353f313e": "[ru]入厂PPM满分线:",
  "5f44d14eb815cf188288422af4eb8c99": "[ru]请输入入厂PPM满分线",
  "9ebd982d7d63ff31954ffeb64de3547e": "[ru]入厂PPM否决线:",
  "046e5d776c78c579a7724933b27d2313": "[ru]请输入入厂PPM否决线",
  "3a8b26aaab5ef36c561fc25fe8fd5feb": "[ru]现场权重:",
  "52f61ed0ef0a683a525f9182f14e2ab4": "[ru]请输入现场权重",
  "78ad2f72950047ea29082cfe26006647": "[ru]拒收扣分:",
  "b9cc7c8fd08084863d6e8116712fac45": "[ru]请输入拒收扣分",
  "e0d7b85159fd62453c57f94eaab6493c": "[ru]退次PPM满分线:",
  "04afcd93d1959862b818af2590da85f1": "[ru]请输入退次PPM满分线",
  "6eca012934b4b692e183ba2ba501ab99": "[ru]退次PPM否决线:",
  "842812ff82e8e44b932e86555aa8da18": "[ru]请输入退次PPM否决线",
  "02f587b038d1f6e004a1277e36aa0239": "[ru]市场权重:",
  "5306d962fd2383fef907937c1747d5d4": "[ru]请输入市场权重",
  "d73d949bf2711cdcc5e0422ecd52a59d": "[ru]不良品扣分:",
  "2dd944bafbc2ac858a7fc993fe7acfee": "[ru]请输入不良品扣分",
  "040a9062bced86d03a15a928767fd878": "[ru]不良件PPM满分线:",
  "b22393d9b7e29d920a65268b524a45b2": "[ru]请输入不良件PPM满分线",
  "b404f32bd8d682195e30caed50a6ff63": "[ru]不良件PPM否决线:",
  "aee8dd00d8bd0ca1950372557b4637a6": "[ru]请输入不良件PPM否决线",
  "bd80e0042ce24b9e5ddc0465411e9a18": "[ru]整改权重:",
  "4717425f0b66e0c4754025534253960c": "[ru]请输入整改权重",
  "f407e63c91b67fe4b5fd50cb7d05a44f": "[ru]重复发生次数:",
  "6ac5c953e33600b1df877d4ddd786721": "[ru]请输入重复发生次数",
  "749d57cce174fefe435515aa467529a7": "[ru]索赔权重:",
  "0b3f93d4d6f6ad7f1788d649efb45128": "[ru]请输入索赔权重",
  "b20e82dc88e285d953a2384f30f1eab9": "[ru]新品拖期权重:",
  "39ada8ed2c95088d61732b51385a0964": "[ru]请输入新品拖期权重",
  "6235cfcfb83243b8671a4625c4853638": "[ru]新品合格权重:",
  "1229c267c468c4f60fe904fc1c5f7d7e": "[ru]请输入新品合格权重",
  "e9a09f911074189ed12d5342adad3e92": "[ru]非重大违约扣分:",
  "1ea5bfd9fdf207ed7a4ec2dae3fefef8": "[ru]请输入非重大违约扣分",
  "aaf20ba2fbf7ae9373b7b87fd94625cc": "[ru]入厂权重",
  "bbccbad0e6179638997bee17b0fbaff9": "[ru]停检扣分",
  "f2ca25056a9e72f70627e7e96977625b": "[ru]入厂PPM满分线",
  "29be50340be7bfffb8bc66532d659328": "[ru]入厂PPM否决线",
  "afa3d67ffbc3ef38a4e743092d65cc62": "[ru]现场权重",
  "4f4ed71883c36fb4604853a6188e6ef4": "[ru]拒收扣分",
  "1b94dc08f181eeaf85a6fb2fee1c7fa3": "[ru]退次PPM满分线",
  "0500d3bd5f2821581978bae41d6d2f80": "[ru]退次PPM否决线",
  "55a98b3a89c4fc91346d478292c0a367": "[ru]市场权重",
  "907a48925e493f82f97a9ba1ee0efc2e": "[ru]不良品扣分",
  "808a1e0478ee566ce5b720ec9bdee968": "[ru]不良件PPM满分线",
  "ebe25475f35adbbd99ce8fae6090af91": "[ru]不良件PPM否决线",
  "ac3ca9f9d0d71f257aeb10fd2306f7ef": "[ru]整改权重",
  "e242c4e20b5003323d65ad0a33257828": "[ru]重复发生次数",
  "78204105cfad90ae5c81a1909a36c906": "[ru]索赔权重",
  "829e5410dcda9817f77f72496d37850e": "[ru]新品拖期权重",
  "3552056f9184cc46cb1321ea293a53af": "[ru]新品合格权重",
  "eab7662aac664670032af43c2f0c618a": "[ru]非重大违约扣分",
  "dd9721834a1e8ec53437ee9b9c884d93": "[ru]供应商分类",
  "96f58252fc54c4a1e8614182a8c02b3d": "[ru]供应商状态",
  "86f89fb268309ec5e8011d8e4c142be9": "[ru]非正式",
  "3c07bbc431e70f53929daa89c69e057e": "[ru]正式",
  "35d48c6d92248a2ca9fdf3592914ca6f": "[ru]引入时间",
  "ff99683b7f4818dcf8c9f07aa9aec619": "[ru]供应商维护",
  "c63692128c6ae23d666bcfbe0a1054c3": "[ru]分级",
  "6a59b7e2829be3e01cc7ef9101d1e787": "[ru]能否供货",
  "09f2aef4e9a012d48592b29d3ec6dfcc": "[ru]供应商修改",
  "88c6573e3cf25b1bdaf78f3869d35903": "[ru]供应商分级",
  "b9c06b11e5231b75f293d08d596e500c": "[ru]现场质量目标",
  "9b6e293a07a77a338e00f5279d6076a3": "[ru]入厂质量目标",
  "b3d0a2d48b03d2ec8e5ac4e4ad8da414": "[ru]市场质量目标",
  "2a1c2d8f284450afca42924e8134c94c": "[ru]供应商维护导出中...",
  "98de3810ea761dae3f7005c738edda4e": "[ru]请选择分级！",
  "c8e76179787d624eb858fe28c99621d4": "[ru]请选择供方检验资格！",
  "f83cb9bc2729774a663f07b9af407cea": "[ru]请填写现场质量目标！",
  "91ba0b690946feebefb40dc6c0e796b2": "[ru]请填写入厂质量目标！",
  "5b2ab2b894f608936668f3aa82ff7f46": "[ru]请填写市场质量目标！",
  "c8ef48d1cbe60a11d68b274b180d6f0a": "[ru]请选择供应商分类！",
  "6b23f163c6fc7db682416270445b1dcf": "[ru]请选择供应商状态！",
  "ebc6c3de0ffe17de872c86d6f25441ae": "[ru]班组类型",
  "6d48d573ce80570f259d1f8412e7c763": "[ru]班组编码",
  "7b05f534e869042baf39a89693d91219": "[ru]班组名称",
  "1aeef507a1f0f8ffd81cde6bbae67dad": "[ru]班组管理",
  "2338268ed1d1fc62e09c45282fbe3e00": "[ru]检验班长1",
  "3db909b03ba980f87d9d9651565c3743": "[ru]检验班长2",
  "7b4a953f444a99f283827d7832ba018b": "[ru]班组维护",
  "1de31eddd8b33d1533b87d56ba3b13bc": "[ru]班组管理导出中...",
  "f00dd546435066d7407d4c688c246a32": "[ru]班组名称不能为空！",
  "5b65119b46db38e01d8238123951d715": "[ru]线体不能为空！",
  "098e18fe472c4d68a550b63a685a5586": "[ru]班组编码不能为空！",
  "6c73f615e757e0eeb099045b595f6a38": "[ru]班组类型不能为空！",
  "d5a70455391ab82849b49aaa64e22340": "[ru]待办查询",
  "0559534aa2ee391b3b477df053ccdc11": "[ru]物料种类",
  "cc2f4d018d406d1d89cebe675d8883b6": "[ru]组织结构",
  "942d1cb5c74974cf41c47c927fada77f": "[ru]查看待办历史",
  "63f5b12fab8185310d5f5d935509e9b2": "[ru]没有流程数据",
  "e875a937699c91caf5589dfe38d646e7": "[ru]批量检验汇总",
  "b412111dd1db5fa3edcf95f993990477": "[ru]批量检",
  "adc58e510e0ef74d6225d61c9cd39128": "[ru]默认查询3天数据，仅能查询近半年的数据，查询必须选择工厂小微，历史请至“汇总查询(历史)中查看",
  "97cc5d10946e423a42c45f1b87d80f23": "[ru]批量检验任务",
  "60b375f001b3776b467b6bb0acd9494e": "[ru]批量免检任务",
  "d00fa0e57299cb1aa40b5c12b2f169b6": "[ru]批量停检任务",
  "82faefd4bd45765532834b937baa8c86": "[ru]自主检验任务",
  "4b8f8476db9e12695c4a738f6f3e7acc": "[ru]请选择同一创建时间",
  "c240703f08172f22f2bda6cb165a8485": "[ru]批量检验-售后备件",
  "9fd0c715398c447efa529e25a8225efa": "[ru]自主检",
  "32a567b5d3c04e1a3a7d3b153084e412": "[ru]请选择已检验或已入库的数据",
  "4eaa7fa93fb12590f7fa465d2e24d74f": "[ru]批量检验-历史",
  "84b9dfc86e395627bdd35b118e327dc2": "[ru]工厂号",
  "c7cd55a322cc4f7ae4de8865f2383ae2": "[ru]批量检验",
  "0457b9f08fe021f93fd9ab2bb1571033": "[ru]物料已入库,不允许操作",
  "0239324174f12542141f0df050ffa3c6": "[ru]权限不足或没有待办流程，请联系[",
  "ea0e05f38e5a20df787472d6fb6001d5": "[ru]生成代办成功",
  "dfd6e2ebb023c8619e70c4000a2ab44a": "[ru]生成代办失败，",
  "57af35759258c1bc3e6d3fc9ead8dc72": "[ru]*请注意文件上传的格式（JPG、JPEG、PNG），文件名中不允许出现逗号，单个文件不大于30M*",
  "cb2a037ce081157f9de478daa057c46c": "[ru]*请注意文件上传的格式(pdf,xls,xlsx,ppt,doc,docx,pptx,txt,png,jpg,jpeg)，文件名中不允许出现逗号，单个文件不大于30M*",
  "ef0dc7c56ff4395df6757864d35959b2": "[ru]专用号依据中不存在批量检验项目",
  "14d52dad440d2600d161a3f3efdee13a": "[ru]验收记录单和列表页结论不一致，不能提交",
  "404b0d32557856426856c133ab230be7": "[ru]样本大小只允许输入正整数或0",
  "3164b1c41333f4e6c57b6b8ee3f9faa8": "[ru]批量检验验收记录单",
  "898944f8f426b41d9d0afa314aa08494": "[ru]看单日期",
  "70a444bf00e0e476789015c3696f3f14": "[ru]大宗商编码",
  "7b36e6eff2b59194e65124dbcd79d1c8": "[ru]大宗商名称",
  "8cbeaabc491823d0467d4ed1b4cd25e0": "[ru]园区",
  "c9f9c9817fdfafcb42c4f5d076e87ec1": "[ru]捆包号",
  "0fd49c1ae84b6fda6e93b2cae175a51a": "[ru]创建开始时间",
  "8d8d0899e4fab760bb0159301314a6dc": "[ru]创建结束时间",
  "b7e6520dbedbdade4720a894c44bc603": "[ru]附件下载",
  "5a66d9ecf44ad48a69fe3d1ada7529ec": "[ru]大宗商检验报告导出中...",
  "aa19a28c695402aff0c24d82f525db1e": "[ru]提单号",
  "2c173bc37483dad67943e2f643b1e7ce": "[ru]入厂检验结论",
  "ba1ec95765e96f14718f6e9a7578a2be": "[ru]模块商编码",
  "197909ade3d06ad3428cc9f8dcea75ed": "[ru]领料时间",
  "b3fcd50c7a5bd9ee9cfe7632747e6447": "[ru]入厂不合格确认状态",
  "d1d17cc64d2b1fdec242d4a93eb4a37e": "[ru]现场退次确认状态",
  "63ce02f4fdf33670bb779c40ad6af001": "[ru]入厂终判状态",
  "cac8645835198f0162390ddcca99aaa5": "[ru]现场终判状态",
  "1f8074db75722aaa2ef4f94c963b4266": "[ru]入场不合格审核",
  "54889d64e93698ab8bfe91d2024a2376": "[ru]现场终判审核",
  "70ef2f0859d4c3e5bfe47fb7f2d71077": "[ru]大宗物料信息",
  "875575f05b758c0f57f3709672654386": "[ru]检验报告书",
  "3548d57fce76962fc41d0b277d4fcf6e": "[ru]双经销领料质量信息",
  "8b40e83da21c46d650b7b08328c5b536": "[ru]领用数量",
  "f0a27a9fff6071d1f1f7a8db7cb15f29": "[ru]入厂检验报告书附件",
  "cae2552740b0076930b4589082149956": "[ru]上传时间",
  "991190c79051ae7ffbf5f560044880c5": "[ru]入厂不合适确认",
  "2a2772fa8f6d68423b4656905884c5b4": "[ru]待确认",
  "9f34a9f8d547ba55c67524dabee4efe0": "[ru]不认可",
  "191a39634a0499cfbe8b6f5fc822d74b": "[ru]认可",
  "825720cf0b7f73db6eafe0ed871387b1": "[ru]入厂附件确认",
  "19616860d20eeb763d9fbcfa811b2a6f": "[ru]入厂检验终判结论",
  "b292d4102839b0f5bf6c000ef945776c": "[ru]非大宗商责任",
  "ea29ca4134c2a33aeee8ffab19d2eba5": "[ru]大宗商责任",
  "1be28beea0921565ac52dd7b1b086157": "[ru]入厂终判附件",
  "069bbfa1c720e30d7933a51a9c8b3bcb": "[ru]退次不合格数量",
  "c8448c007df05c7d6a41a8345de88be1": "[ru]退次缺陷描述",
  "6a994c223301da35e6cf390a9ac3b36e": "[ru]退次附件",
  "e6885878784130c79636e0a4477d1769": "[ru]退次不合格确认",
  "675b4d838540c723173b4fb12aa4d03a": "[ru]现场确认附件",
  "cc2f009ed1b0541847f0750b9cd0e76a": "[ru]现场终判结论",
  "dc0e76cfdabe841223c6cfb37f573d18": "[ru]现场终判附件",
  "7284feda8eee0d6e5b20ccd50718155c": "[ru]现场终判数量",
  "e334e916fdda30d81fe74a8cdeb97d65": "[ru]没有可下载的文件！",
  "991f7595e0d6e3ad004c70a5c928152e": "[ru]大宗商质量数据导出中...",
  "6ee8faa48ba016d10814a2e07f46be87": "[ru]请选择一条进行审核！！！",
  "24ddf73e6a800e7cb6a186ce96a8ae8d": "[ru]只能选择一条进行审核！！！",
  "9e1500d99705274ee842c3b88ad4295c": "[ru]只能选择待审核状态进行审核！！！",
  "302813311827e110b6424db6b790c644": "[ru]现场终判",
  "deab16eca806fca359b5e54fe70d01a2": "[ru]大宗物料质量数据信息",
  "df70562e7a3677ae97baa3e3bc4c50c8": "[ru]捆包号：",
  "ad91905df2b53b88f1c024f2697fd67f": "[ru]提单号：",
  "ffa55a84179c9a96f3c23cef85479182": "[ru]供应商编码：",
  "4a3ceb7c383793e3f78a3f03286a4472": "[ru]领用数量：",
  "70d821c3bd9c80fd2191192de72c68b6": "[ru]领料时间：",
  "7dfbd8ba823f3abe9e3ae504c4573877": "[ru]单位：",
  "d702cbb7ac909d3204989ced6bb8493c": "[ru]现场终判：",
  "fd4f08ec05297fe4ec2bcd3490ec8665": "[ru]现场终判不能为空！",
  "bb09e89deedbd34a72db88e9eb12b8bf": "[ru]终判附件：",
  "d5ebfbb52bba119a86ff3661a22ebe18": "[ru]终判附件不能为空！",
  "36d1d80fa8b5545958fd0a11f35d8a4b": "[ru]*限文字不超过100字",
  "29a3f4fd71e79a18c3f9f9f838927b50": "[ru]入场不合格审核：",
  "0034c606be2eb2bf5f855a011a81b0f7": "[ru]入场不合格审核不能为空！",
  "e5df1bfc50fc7297c5c98b275e844b4c": "[ru]入厂不合格信息确认",
  "c77fb0b5050be8e01ce238537870ddc5": "[ru]入厂检验报告附件",
  "b820b25a3b69aa70aca18824c58e151f": "[ru]上传人",
  "3bbe20761e98f76a6b67e4b16170fe56": "[ru]不合格确认",
  "183f7502b17e39b7f22714800ea57480": "[ru]不合格确认不能为空！",
  "976b1a6ada3c917e1932d347140c5b15": "[ru]入厂不合格确认附件",
  "b97e899ebcb9dad5a27d552fe9bb0cac": "[ru]入厂不合格确认附件不能为空！",
  "37a8919140c50277702500f3e8810216": "[ru]*请注意文件上传的格式(pdf,png,jpg,jpeg),文件名中不允许出现逗号，最多允许上传一个文件且单个文件不大于30M*",
  "af9b9ac0a1788e0a8eefae24f862a06f": "[ru]原因不能为空！",
  "ccba96af0d8e6991da323ff186abdb47": "[ru]上传成功！",
  "7efd5f4c9a96062fd67d7e090087e750": "[ru]现场退次提交状态",
  "295050c6af1af6dfe33e517ce3def3aa": "[ru]大宗商化工非直发领料数据",
  "db4e6a213c2b114fc5ced44aea48a14e": "[ru]领料",
  "aefce2f63d6d8df0c6a17a27581c0b2f": "[ru]入厂检验报告",
  "37eee186d95848dd7dc06d7c6b4a0f39": "[ru]入厂不合格确认",
  "9fdbcb4fad4b2244830054c781d24047": "[ru]入厂确认附件",
  "b2af9414ce2533e3841d91f0647a5833": "[ru]入厂终判结论",
  "7efa313943d1ccc118840be1ed39e4ee": "[ru]大宗商钢板报告数据",
  "7b4cf3ea2d34518f4fccc832215acde6": "[ru]检验报告名称",
  "b1cd2e660a701eee8f8d2306c7dc9130": "[ru]上传报告",
  "ba7f57c5e8c8c5ee90b04380eb85fb54": "[ru]已上传",
  "bb59a04e59b20b4cae2682a9e39e3faf": "[ru]大宗商化工非直发领料",
  "72bba0e7380ec7a5f3f245db70bddd5e": "[ru]单号不能为空！",
  "c46de5c92f0bb671d543d9723e2dd26b": "[ru]请输入至少两位单号搜索",
  "b27a11e98b2ca5fe9c4266e2f1e688f8": "[ru]物料号",
  "dc8628e1633caee67b3386e64a209dea": "[ru]提单号不能为空！",
  "ef8d89f481b3ce34b1a0495c08aab5c0": "[ru]领料日期",
  "b8e82240b03f6a9a3bab2201966eaa8c": "[ru]领料日期不能为空！",
  "cf82ce3547dd308a426f5cfab59ae3f0": "[ru]请选择领料日期",
  "de5d3ad93b7199757a5c343fb8d41aab": "[ru]领用数量不能为空！",
  "c21afb99d312e9fa0deda4aa73de9130": "[ru]领用数量不能大于总数量！",
  "7b1131b005ae4ca1d5a6acf4528fe9eb": "[ru]大宗商质量数据退次信息确认",
  "2edb3ed9e315592a0a57fc52f51576b1": "[ru]不合格确认附件",
  "450e4a0324c4d1f25081fda0a4fa155d": "[ru]入厂检验报告上传",
  "c2471975c54d0621229104b039d4f2eb": "[ru]大宗商质量数据入厂检验报告上传",
  "1cbbfd5d3fd39768023adc4ba1681780": "[ru]捆包号",
  "17ad01db3114a14a58be736382ab8142": "[ru]入厂检验结论不能为空！",
  "d1348d53965c97e839638da575d78c08": "[ru]入厂检验报告附件不能为空！",
  "b680a7ec922c1476e75d92025573d0a4": "[ru]请上传（png,PNG,jpg,JPG,jpeg,JPEG,pdf,PDF）格式的文件！",
  "db2e26a4ef12f536536a95aac9fa05e5": "[ru]文件不能超过30M！",
  "20f7a6a2b721ce0b9b2c6063ff5f1719": "[ru]退次信息填写",
  "5fdf9292ccd49590887f12de9255bc6f": "[ru]大宗商质量数据退次信息填写",
  "5891d49c98e5a99c6d37b27ac5632cf6": "[ru]退次不合格数量不能为空！",
  "111a32b1d6ad4b297a068ad31ee0ef76": "[ru]退次缺陷描述不能为空！",
  "a9fc57fa4af5b7d4c426f93e9caf623a": "[ru]退次附件不能为空！",
  "27b09d3797d331553170159dcd9bc18b": "[ru]大宗商检验报告上传",
  "01be6311e44c3d65998bce595ec6d2c3": "[ru]大宗商代码",
  "80651925d5045d6d7459a21045e1d93f": "[ru]请先上传附件",
  "50c4ee72dc086ae3aaa7af7c3c2e72e6": "[ru]变更类别",
  "ddcacaff2a5347fe2cb14c2c3438d93b": "[ru]适用产品线",
  "121f3d53c95b33bc9f258f05bd3a4a5e": "[ru]是否需要产品验证",
  "269ece09667fdeb048bc12fd26d5e63c": "[ru]样品检验结果",
  "0b7da4c2f4e2307086c1c8c5888ca061": "[ru]开发产品验证结果",
  "18dd502b5e3792cf74d876f1e9a2a433": "[ru]开发产品验证附件",
  "a58fb4cf5c9a97f9f6bfc1b76ee933af": "[ru]4M1E变更管理-老流程",
  "34a73fdf2df070c79749c66670946a4b": "[ru]初审结果",
  "c41b1e101e9a60e443ec7b215aeb6539": "[ru]变更申请时间",
  "13f8efbb5ab50ba326418f8d0799d6fe": "[ru]物料编码",
  "80847a42d22c07ec72534426850602d0": "[ru]申请验证工厂小微",
  "6f32a8967be1ac346a5fc38b5d478179": "[ru]变更管理导出中...",
  "625cf4d2fb4024165908b71ee31832b8": "[ru]变更管理.xlsx",
  "e7332e4013f0bea58f9f13846262f811": "[ru]色板单号",
  "7aadc5f1d43c0f7bf804117d00caa683": "[ru]色板色号",
  "030f1b54354b7aa3f52055b8056d178b": "[ru]色板编码",
  "49799437d0c3f01c43417ac0678d1fec": "[ru]已下发",
  "ecfe75ea4845f1c06361dc9b3fbde68c": "[ru]待下发",
  "b4554f4c35f54f309c93f9e86abfb795": "[ru]已接收",
  "6b7c4972f892c19a43a4058a4b9186e6": "[ru]色板状态",
  "584cd19544947c964861b3f47bf28b75": "[ru]过期",
  "9ea126e07cdd3d8604b448edc2b1443b": "[ru]下发日期",
  "d0212de6bbcc6feb9cbb17f237bd3fd7": "[ru]供应商具体工厂",
  "c1c6a5c94dcc1378b9a7a220aafa279b": "[ru]色号名称",
  "ed01f4d3ed8a3a178a537ded22268dac": "[ru]色板条码",
  "09c9767d060689c39c9ad5b200cba1bf": "[ru]工艺材质",
  "7e8b2fa2745e37dfe2e609baf04e319f": "[ru]效果",
  "222cdd092a63d356b6b58cf881a95971": "[ru]下发人",
  "2ade78d0370481a43986f603d8f91eda": "[ru]接收日期",
  "2e2110c79765b9b43e1d192c698c4407": "[ru]报废日期",
  "e82938c6c978167ae8dfc3bdc1ae7568": "[ru]色板平台管理-新增下发",
  "f2cbff95e47120603f4775801de07dd2": "[ru]色板平台管理-确认下发",
  "de8c2a4b733c4772365f3a78173cfc13": "[ru]供应商名称不能为空",
  "cd49f130eb427b92d43eca1ff27d4019": "[ru]滚筒洗衣机",
  "904c4bb814ee9d3371a149d8ae73beb7": "[ru]波轮洗衣机",
  "e46f3e06775c81f9fea7e4a1141386eb": "[ru]供应商具体工厂不能为空",
  "41faedb4a0f21d5979bf324934b516ed": "[ru]色板色号不能为空",
  "2efab50cfda7961502ee28dd6e226fa2": "[ru]色板编码不能为空",
  "78a93e209094785b2e922a22be59eb05": "[ru]效果不能为空",
  "57b026b745aca7d1c4d4e38b42dc5135": "[ru]高光",
  "30cd5626e5d4d8f6b90d5fd769223178": "[ru]哑光",
  "18977e01daf3abfd3f1b21b84275dcca": "[ru]半透",
  "af05b53f23179f959477a00e3aad41d0": "[ru]工艺材质不能为空",
  "7157933fd0b9e6531641898c9f4e4e6e": "[ru]注塑",
  "e27154d24dfa71b20c7c17456d4afa5d": "[ru]喷涂",
  "a92b1f9121d934ea7d471e867a2ba274": "[ru]粉末钢板",
  "5932236007ade967d36c9bf4ed35e237": "[ru]pcm钢板",
  "d9c0aec3ac9b0798b73c3f587bfff998": "[ru]ppm钢板",
  "4c7a39b5db7aa2727259bbb75ec53c73": "[ru]vcm钢板",
  "cb1020f854236e0229ffc4338a1a933a": "[ru]有效期至不能为空",
  "a12eef651b3dbcf76e394391b9f9b87f": "[ru]驳回备注不能为空",
  "ca887e898fdae129a5200b40ac9579f0": "[ru]色板平台管理-下发成功",
  "6908ffdaf0afda7f5e52c7b6028dd291": "[ru]确认驳回?",
  "e16b9dc46e3871b4a1fa1447f2133ec0": "[ru]色板申请已驳回",
  "551b0869cdbdfb4104cdca33347bc1d4": "[ru]色板下发成功",
  "42a2ac0e707cba24c8e7a243c62ebbd8": "[ru]大宗钢板",
  "9f9178369dfdede9bca6b2ab15e7b48e": "[ru]大宗化工",
  "9824097cd881b122296815709575371c": "[ru]大宗有色",
  "b61195b76a5d2de71353a05960a4edc9": "[ru]数据已经下发",
  "5a4e2ad631c3c7d1b82d0a06f2ea7b5e": "[ru]数据已驳回，不可下发",
  "6b9201eaf62f131bccc8cef5fb658ca1": "[ru]该色板无效，不可下发",
  "e761dfacfb33343e9b0898fbf4c14ba1": "[ru]该色板已经过期，不可下发",
  "f51828d88257fd34648147b26deaed42": "[ru]波轮&滚筒产业请在iHaier手机端搜索“洗涤色板管理”应用进行操作",
  "9904363c8135bed345c4ff47d1405b2a": "[ru]供应商申请确认",
  "3320fd1af0c56943d7590dfa4f34619f": "[ru]新增下发",
  "90c833ebb27666eec2866dca21acf440": "[ru]申请状态",
  "d40c226a15eda9a1f7f2bd7011f18ecb": "[ru]新增申请",
  "2ffee3b7e46ad5d73d0783bfde483227": "[ru]确认接收",
  "abbb1db48d3e18cea362b23690499658": "[ru]确认报废",
  "3368a719c5560df4cba4c845ccea4236": "[ru]色板申请信息填写",
  "15e9238b799e13a8bf8b7980129c38e2": "[ru]接收",
  "780daae2fea0bd2eb6285a8f28c7a9c2": "[ru]色板信息接收确认",
  "3be790f4bea45a69e586c13007ee55ab": "[ru]色板信息报废确认",
  "5fac7568429909fd6f036af4edf5b956": "[ru]色板",
  "adc28732e2e34e27a7d5316cd256ad3f": "[ru]色板申请提交成功",
  "5d11f64ddbaa899949fcdecee0185f2d": "[ru]导出失败，导出数量大于5000条",
  "c481667043aa50a5be49cca9959f17a9": "[ru]色板导出中...",
  "054dbda22caaf9a89dc7949c16ec653c": "[ru]色板.xlsx",
  "1aa503920b05f6cf408787703881d200": "[ru]只能报废一条数据",
  "2433fb3fde2c313d54671a448716e3f9": "[ru]该色板无效，不可报废",
  "188dfe15e32d44493fe3731df8b7a231": "[ru]该色板已经过期，不可报废",
  "fa63f065ecbd5a060d847e71544284c9": "[ru]只有已接收并且有效的色板才可以报废",
  "117f1507d7ad6b8a9cd942667b93310b": "[ru]只能接收一条数据",
  "540f76be02e54dffb839bfca87ebbaa3": "[ru]该色板无效，不可接收",
  "100ee566ffccb988e8fb21b788043e52": "[ru]该色板已经过期，不可接收",
  "e1fc6dd1b28dd71238722f3056adb5d9": "[ru]只有已下发并且有效的色板才可以接收",
  "95901ba4fdb6a8b0cc391afb810f05bb": "[ru]不良备案`",
  "7c73ce91de3d29b32da513a0384b2422": "[ru]`不良信息备案",
  "7db20e2cb4a6a190a765a8b512b025db": "[ru]不良类型：",
  "3dd47f2e12e4952bff1dd1faedcbb365": "[ru]不良类型不能为空！",
  "ea29fdcc14da49917ceabf0e207c213e": "[ru]不良单号不能为空！",
  "cd11be8c9291c04d9fef147b708d4c1f": "[ru]请输入关键词",
  "f1fdbef3b406bcf35594f9e480353c0b": "[ru]请先选择不良类型",
  "1158fc8eee213bbe077186deddc7f257": "[ru]可根据不良单号查出来",
  "aa7627881ef67231b754e18f903eed6b": "[ru]不良描述：",
  "fe99196673e9522a2f05ec225af9b46a": "[ru]备案原因：",
  "27b8fe11bba77586b4c730c73e100427": "[ru]备案原因不能为空！",
  "f97e74b5191c2129807e9b391c67943e": "[ru]见证性资料：",
  "eaeaf7b8774a4011172e7954cd46b7b1": "[ru]见证性资料不能为空！",
  "b673f9897521691836ca21ea8a06c096": "[ru]备案人：",
  "e79cb9881434c25fd8a15aba5982fe41": "[ru]备案时间：",
  "b88918dce93e0baed7a0b4b58987afd5": "[ru]注：",
  "bfe75d897d797f655c1fb39827ae33c7": "[ru]1.工厂小微人为原因造成的信息更改，必须拿出案例：找出责任人、分析出原因、有措施并有索赔激励；",
  "eeab06fa99e372c083c60bd959520b16": "[ru]2.案例必须有责任人、工厂小微主、人力主管签字确认；",
  "634bae037d0552a85cfdb004e9a43475": "[ru]3.因涉及供应商考评、索赔月底数据锁定，故以上数据务必在月底之前完成备案。",
  "5ffaf6164aef56c08060205264e6319c": "[ru]资料不能超过30MB！",
  "3ec22da00e6f2169908626a0885eddcd": "[ru]不良备案审批",
  "6a30ca7a01ed60bdc9f40995b9d34b67": "[ru]不良信息备案审批",
  "5236d9e96736aa2936cbff9968297317": "[ru]申诉人：",
  "25356d67326071b4b6d9db598126ca6c": "[ru]申诉时间：",
  "0a2d2ab9f55385056f13103bc26be100": "[ru]申诉描述：",
  "86d73f1a976f53dc10d22d64747e9563": "[ru]申诉附件：",
  "edcbed3e5c6a312bcbd293a5f4c5dd0f": "[ru]确认人：",
  "7a15706e6d6696f69c1e43c77ef1b34b": "[ru]确认时间：",
  "f0fc47cff7b4f3bd118bdf2e8e5f9296": "[ru]确认结论：",
  "232d0c9ebcb75c61ecc1f9a084af25a3": "[ru]申诉通过",
  "2332a0f12bcb25040c08c880748c197e": "[ru]申诉不通过",
  "949b2a7a1dc9fd621f013de32ff491ad": "[ru]确认意见：",
  "7e941535c0fd9a057244d874a7b6355d": "[ru]质量小微主审核",
  "531e744f5bb424a8dd429abfc537971e": "[ru]本部质量小微主审批",
  "5b656bfbb4a3932597d47691983dccee": "[ru]审批结论：",
  "942e393ea60ef509dd41372f6337e00b": "[ru]审核结论不能为空！",
  "f5c361d5c4369e1bb513e170fcf16835": "[ru]审批意见：",
  "b1fd61eb553450f3ab1da48b03eccb52": "[ru]确定审批当前数据?",
  "303b39f78116f4cfc12b0ae0f45f6839": "[ru]不良备案确认",
  "5c5c48b4c7f4299d9055782f0f837952": "[ru]不良备案单",
  "0963c95a2fb0b23da5a0ea422f6eef44": "[ru]确认结论不能为空！",
  "01adae17b570da7c87a09dd6cf593eb2": "[ru]确认意见不能为空！",
  "2e61b55d2ef15377ec21cac9e5a4068b": "[ru]确认提交审核？",
  "dfa0a5cabb844a36e532bd1abfe3c769": "[ru]不良备案查看明细",
  "5905732b210cb8d3ad98bc36a2a8e30e": "[ru]外检经理/EMR确认",
  "9181333d273e99ff8bcade61f2668fa6": "[ru]质量小微主审核",
  "4b6284da8efbe8816319b43b903d0e20": "[ru]本部小微主审批",
  "08137acd3db9c9a366f6351743798330": "[ru]SQE评审",
  "08d2e19ac2d616b005dfbc0809f2115d": "[ru]SQE评审人：",
  "99789d24b7b847cd50ea555811ebdb6b": "[ru]SQE评审时间：",
  "e67878a20ac98461ca47e41d25746a38": "[ru]SQE评审附件：",
  "c4d57f13a79d935890ebc6ac1f1d54ae": "[ru]SQE评审意见：",
  "291f7977f8f423effdb08845886e8adf": "[ru]3.因涉及供应商考评、索赔月底数据锁定，故以上数据务必在月底之前完成备案；",
  "0e5d1aebcbca467cad630194642335d4": "[ru]4.SQE上传的附件是公议的结果。",
  "ff0ad8c226451ce776fca84b49e9ab3e": "[ru]不良备案审核",
  "51292768beb359ac96235f5dbeabd23f": "[ru]不良信息备案审核",
  "a9dbe23552379db23a575fdda0895a10": "[ru]确认审核当前数据？",
  "07f1026013e1f9d9394cae2d7e933204": "[ru]不良备案",
  "c5f60dd880d9155750fbb864afa0e4a4": "[ru]EMR确认",
  "ec36c07076cf5bf5526d8b1178736d1e": "[ru]SQE评审",
  "1f5244ac86bb7b49c64a09bfaeb3455a": "[ru]除认责单外其他不良备案信息请于当月最后一天24:00前完成",
  "33ca9a0ccc00f0f8be019ee395084bf9": "[ru]备案原因",
  "6375019e2395c6198f830e3c6a603129": "[ru]SQE评审人",
  "da198fcb77cd410b8656f26f9ba2af6a": "[ru]SQE审批时间",
  "5fb0f3d1c9d520b287be3e51eae7a766": "[ru]不良备案导出中...",
  "e99696be11b63f693705e9e8a227d71b": "[ru]已确认的数据不能修改",
  "e6c51d6a0e5e3b82e3ea07558cbf5cdf": "[ru]已确认的数据不能删除",
  "f915ee566fd47a12378648ae6875ade5": "[ru]不是SQE待审核的数据！",
  "6ce4bfa9ea3f58ff05a3b2b9686d3bb7": "[ru]权限不足或没有待办",
  "f07c83e86334ca11eb98fdd35b5a6f4f": "[ru]不是本部质量小微主待审批的数据！",
  "a3982cdb51e854cc6726a55dfc5190f4": "[ru]不是质量小微主待审核的数据！",
  "2d775217021ecb3e110c17ff1ba27077": "[ru]不是申述EMR待确认的数据！",
  "e728dfd34dfc7ae08733289db0f9dccb": "[ru]不是申诉待确认的数据！",
  "dbbfb085a63ebc136b7c89c95c368de2": "[ru]不良备案SQE审核",
  "932c7db94e403a6b589b37efb97d3438": "[ru]SQE评审结论：",
  "89781d5e283b3c9336963185a2fd8f58": "[ru]供应商责任",
  "551c85f28f6ce3fcf5bbb3a9d7a68839": "[ru]非供应商责任",
  "70541594b7064123c596d7a5eab4d4c7": "[ru]SQE评审附件不能为空！",
  "4cdbeeac81e852f222e603c31878dae1": "[ru]备注：SQE上传的附件是公议的结果",
  "e611f28433d9f38ef0ccde8d60c84bdd": "[ru]供应商认责单",
  "f6d477fd2f9fbb498ca53812be0a9147": "[ru]公司：",
  "7fbdfc938975d725b7abbb5c1f985e52": "[ru]问题节点：",
  "b4792a480466fdf23a9d17c0563f12c9": "[ru]合计金额：",
  "eb75c9704c8438348aefb0932dd6fe12": "[ru]系统创建",
  "c5ef3766d50759e48b07ab218fe9c488": "[ru]交互状态：",
  "d744c03d5b1d489635f52945a71bef05": "[ru]供应商认责：",
  "599f3d5e60f1c278032a33aabba602f6": "[ru]我司认可上述质量问题，并同意按照双方合同约定，从我司应收款中自动扣除上述款项。",
  "658576af39248df06fff8408acebc9b0": "[ru]电子签章：",
  "2443ccf296437f2df1a7824adbace984": "[ru]确认日期：",
  "60dda3b6b697c48fe269c1a31880d786": "[ru]附：不良明细",
  "ce6326e846e2c23e9a83fcfb9774685f": "[ru]申诉",
  "d4b52e5184870c8bc7e6fceb992e0660": "[ru]签章",
  "b6127e7c6824d9a0b6ba410cc0fd4c36": "[ru]未签章PDF：",
  "c87b9df31961ecf977f6ceb53bc2be26": "[ru]签章版PDF：",
  "04ad79c119070f38851ad300ee95bed2": "[ru]生成PDF",
  "6b1240b031962eff772bc02e8356ecff": "[ru]确认并进行签章",
  "b9dfd9350e420c46305535bb006537f1": "[ru]1.上传申诉附件，请先点击\"选择文件\"后选择相应的文件，再点击\"上传\"按钮。",
  "a5cfc22cf01551544f43193e3956aedb": "[ru]2.如果想上传多个文件，可打成\"压缩包\"后上传压缩包即可。",
  "ff6f217821d12f6e25b0bf676d21cac7": "[ru]3.文件大小不能超过30M,文件支持格式包含：txt,doc,docx,jpg,jpeg,png,bmp,pdf,xls,xlsx,rar,zip,ppt,pptx。",
  "970e00d7b7bc049fc5308ca871cd21d2": "[ru]申诉描述不能为空！",
  "719533e4df8c0ecef6a6c3e4ca404f0e": "[ru]*请填写申诉描述内容，限文字不超过200字",
  "9bea099e73febc729868997bcd5654e6": "[ru]文件上传：",
  "44fe4c66c48dd3fbe7cc6b5b931415b4": "[ru]附件不能为空！",
  "c25f2a686e09a708746002ac49c9ba7b": "[ru]抱歉，只有供应商质量经理角色才有申诉权限！",
  "fb2b7b2878d4121b7c830873a943a178": "[ru]该认责单已申诉，不允许重复申诉！",
  "4a661f20d632dc867c5295948b7c6189": "[ru]确认提交申诉？",
  "78e53631ae3ca999c22a3983fc32c2a8": "[ru]签章中...",
  "26430ba03bcfc728f4dd4f42218ac257": "[ru]证书Subject项获取失败，请联系管理员!",
  "235efacde3fb0e7a39d8a6fe508f3fe6": "[ru]证书O项获取失败，请联系管理员!",
  "ca91c936f34f4a60c204c07963b1a4be": "[ru]签章成功",
  "65804d0a9151694369ef103151ae81e0": "[ru]加载数据失败",
  "a0a8a703eca5700bcb7bb41b9bab290e": "[ru]抱歉，只有质量经理才可以签章！",
  "4d020ba388eda6ecec2a70197fc688ca": "[ru]生成中...",
  "a889286a51f3adab3cfb6913f2b0ac2e": "[ru]创建失败",
  "4e225329570ec564d12e1f5a66ea73c6": "[ru]/qualityClaim/signaturePdf，签章失败，请联系管理员!",
  "8e66e95910ab41cf44496adb1c40277f": "[ru]签章查询失败",
  "8e44a23a0a482a36e7a17cb2f4d06499": "[ru]CA签章工具未加载，请刷新页面",
  "f9707cf0d21826afb0d2d4a088a5ba85": "[ru]扣款月份",
  "7f83cefc6354ed7819de9ca50d15c5ed": "[ru]选择月",
  "a872323deec0f6d8541fb8f448c375ca": "[ru]合并签章",
  "95136f280d955a54664140fea62936a8": "[ru]签章日期",
  "628d9b1d0636d63e358f2f6e3bcde714": "[ru]扣款日期",
  "2f0ee0799c127d34daabcaaf367cbf8b": "[ru]是否重复",
  "82a673eb8e5d6ade54eb3250a3d93f5c": "[ru]请选择年份！",
  "e8e4b01cf7b657ae473fd5279ccdda25": "[ru]索赔列表导出中...",
  "c7cf0422dbd07f420d208c3268f522d9": "[ru]索赔列表.xlsx",
  "3ec0a3258677dd8bcf209b2d7d99f9f8": "[ru]无法签章，取消选择",
  "5b08aa8e5d9f01eecab92d8b558dc92e": "[ru]请选择要合并签章的项目",
  "d05d459be8e7deaeee2927a346b435ae": "[ru]创建PDF失败2",
  "1f7eff2b41184292c9aa92fde6d86f6c": "[ru]SQM的V码是",
  "68e0f86b8b51272fa339a45d2d187870": "[ru]获取证书的V码是",
  "ca5f860b0d53b16659281f068502ac17": "[ru]登录用户与证书用户不一致!",
  "d17e8449812f65c7a71107612bb48d82": "[ru]签名数据:",
  "c759f53b640117aacea82228e3863e7c": "[ru]签章成功！",
  "e3d41c21207f58954b4a237a94e9fd54": "[ru]交互状态",
  "7a1529e1c89f649e92e922f4cc51c5b9": "[ru]供应商交互",
  "ce470d57ea7508bf969b5d7f94a346f4": "[ru]交互中",
  "5bf65eb86235565b185f07252a359e1e": "[ru]工单编号",
  "ac4190dfda1d11d558c1d44d0f6697a3": "[ru]型号",
  "dd1fa6298110c6046a127de9373dd3de": "[ru]机器编码",
  "0e9fd9896867f16a2ac5e8256f279b0e": "[ru]价格",
  "e10e3f255a4a413a3a09abc9fe719e24": "[ru]初鉴网点",
  "938e6b7378f0c6dd5a9a054d164c9cfd": "[ru]网点鉴定时间",
  "5623708adf2a9fb03d51af2b7283bc47": "[ru]工厂鉴定时间",
  "02c7746b87e2bc894de07a03b1dd0b63": "[ru]供应商交互确认",
  "8f8ed64769bf633cc18799b8f3787f24": "[ru]已申诉",
  "1789ffa8dc0f942e61bba0ade2c7f44a": "[ru]已认可",
  "070c356cf3b36e780d62fbdd19790065": "[ru]交互确认",
  "f5752b26c037b17e6bcf21a05e69abba": "[ru]申诉附件",
  "74c7244fa6b2deee2e8a0bce3305ad87": "[ru]市场不良列表.xlsx",
  "e38dc9a7595ba64e09896c66f1bcb598": "[ru]电子签章",
  "bab666a374cf12bd14d81817a534d9b4": "[ru]供应商认责",
  "36a5d2e23d3454167254f10a406f059d": "[ru]确认日期",
  "69574c583a0a52dfeca5920040d220f4": "[ru]供应商代码/HDY-V码",
  "8a1dab362ff10ef012523c02081722f2": "[ru]故障现象",
  "b14494137c805dc66bdc9ed88d7fd2de": "[ru]对象",
  "5917a709d6f2ef729b236bf78b0d0e17": "[ru]考核日期",
  "0e44ad1edf52a88182599d5759f6aa3e": "[ru]报修日期",
  "1bbdf502152ab0e3f2bd1b2344ec25f9": "[ru]维修备件不良明细",
  "f548df734e32315ad55b566949040083": "[ru]每月4号数据锁定并触发8D整改",
  "d436154938e3bf7b857c6ec2bb1139da": "[ru]事业部(HDY)",
  "d3dabddd26cfd5e0612c24d6a5dbf806": "[ru]型号编码",
  "8ca79404a1f5fac7b37cafa216759f60": "[ru]用户反映",
  "924f67de61fc9e07fff979306900dc6a": "[ru]服务类型",
  "ac48baa2aadb42c9b29fcdebc30c35f9": "[ru]HDY匹配V码",
  "e881dfc457be6cd9c63171708ffc3406": "[ru]HDY匹配供应商名称",
  "252b2cdc1b980ee6cd53fbd818b5d409": "[ru]HDY匹配规则",
  "94e6b455648c0166aa7dc2834ccb636a": "[ru]维修备件不良导出中...",
  "46a65345581c1ed2e9b0843b1a0abdfa": "[ru]触发工厂小微",
  "7adb354f759bfd7d0eb3e20e7df2d398": "[ru]策略是否成立",
  "640b192428e556fedf92056c29e4730e": "[ru]成立",
  "e405d03d14759192df9ae0494a6abbc0": "[ru]不成立",
  "9c2c91cfb4071bc40bdd55a5add409b9": "[ru]是否触发整改单",
  "183b71ea034c2ae3dd53c4888ca8c843": "[ru]整改单号",
  "ef80ccc6b9487e8fd94a7caa4923c44e": "[ru]维修备件不良",
  "23bf0ad8f71cbac17b5f91d133f20b51": "[ru]产业特殊物料类",
  "b79a74f4923987e875d26ffc570f22d3": "[ru]产业(HMQM)",
  "35f1fc3a42110281346a893b2c2ea11c": "[ru]产业（HDY)",
  "cfcea3d175a07d6c53e8336c10b3c8e5": "[ru]物料类TOP",
  "a0ae68c68ee6cd77511c95dea26ae305": "[ru]物料类不良（条）",
  "23df84b2a07267321db4855aa0da108d": "[ru]物料号TOP",
  "8d063d1b5607ef1dafbaae5300167453": "[ru]物料号不良（条）",
  "ec8d321acffe11207a37eb7487871404": "[ru]包含工单数（条）",
  "bfbc690f44a7358c95b30575b45d1d7f": "[ru]整改策略是否成立",
  "1a287a62705b971710be814729e1de10": "[ru]不成立原因",
  "8b834de1df2ccc43eff81cbef072ab48": "[ru]未触发整改单原因",
  "d64a1a7b2bfdb8a1688baf9c472f8860": "[ru]整改单状态",
  "d054e5b75853e5a0d307bbcde3bbcfd5": "[ru]外检",
  "13adabaf69e88085a073c0e6d7a7672a": "[ru]维修备件明细",
  "4972d4185840e08493f212c0b1a8b848": "[ru]手工生成中...",
  "9f53c17ba247fb35200acb9295bb8c6b": "[ru]检测能力导出中...",
  "8a5c3b76e16345806173be7f34da1d87": "[ru]检测能力一级报表导出中...",
  "a6d2144beaf8234b900201950fc2cf89": "[ru]检测能力二级报表导出中...",
  "5973c4bc43a834b63abddc3b378c8713": "[ru]关差方案",
  "7629670a8af6a5ab6d67faaf2c1e3f07": "[ru]关差日期",
  "9a7b15dccc5cda2e3db1110678576104": "[ru]打回",
  "6265d095fda40520557a7c9d3a92d2c0": "[ru]合同签订日期",
  "ad539fd028219141d81a234286f290a8": "[ru]保证书编号",
  "d503a29b7898f3f97ac773c542a70eb1": "[ru]附件（环保承诺书、加盖公章）",
  "03b6bec14efda3c773689cee04bd4e02": "[ru]只有待审核的数据，才能进行审核",
  "1888e4b62c586903d9e2b4bb191a5305": "[ru]抱歉，您没有审核权限",
  "a69e1d06cbc6803fa5cf49e9966e549e": "[ru]环保承诺书导出中...",
  "656a196753d0383ab0f44b72e0291f0d": "[ru]只能选择有效的数据进行批量有效性处理！",
  "b68339f8b691aec0e97468eda0b987ce": "[ru]抱歉，您没有批量处理有效性的权限！",
  "0965a2428ead8af9b1a96506065ff079": "[ru]批量处理成功",
  "02b9cd9665000416bd18b7875e43c2b9": "[ru]批量处理失败",
  "20982bbcdd7c5b929f427f654ea93f59": "[ru]环保承诺书明细",
  "27408deccc1964f2a3c891cbfe77d453": "[ru]请选择审核结论",
  "84277bfd30e176b22f729c031ceb1287": "[ru]意见不允许为空",
  "d848a36eedf516d714dc06ab46fd558c": "[ru]1.环保承诺书：是指模块商与海尔签订的《模块化产品采购框架合同》或《大宗产品采购框架合同》中的附件，注意是盖章备案的生效版。",
  "27d9a20033921818e1ff70818004d461": "[ru]2.环保承诺书版本：需模块商签订最新版本，如果不是最新版本，请联系资源小微重新签订环保承诺书，联系人为资源小微接口人或对应的采购经理，详细内容请查看系统操作指导书说明。",
  "676f2b994cdb44efda8f546e5301fca1": "[ru]3.系统提交及审核权限：",
  "c5b91036b4e2d299b8f372bc6dc8cdad": "[ru]提交人-供应商质量经理：",
  "faa23fb77c9adaf6f19c93fd2e6248e3": "[ru]审核人：如果是海达源的供应商，审核人-陈丹丹，邮箱：chendandan.cg@haier.com，电话：0532-88932403",
  "b260dbf964e8868a75a51f5aaf0b8ffe": "[ru]如果是卡奥斯的供应商，审核人-李亮，邮箱：liliang.gt@haier.com，电话：0532-88932034",
  "533e964b2babbbce2dc1e4e0db509b7a": "[ru]如果是生物医疗的供应商，审核人-李金俐，邮箱：jinli.li@haierbiomedical.com，电话：17854250878",
  "b748ef6566aff87d0f677e431a2038b0": "[ru]审核打回",
  "7c8421b2dbffef74ba4b169304c8747d": "[ru]有效性状态",
  "8918869fe13fcc2732d2d225158a8018": "[ru]录入状态",
  "db60bdf4b728c2156567e41540625334": "[ru]环保承诺书.xlsx",
  "25146ac66928d5d3ff3bb263dc16021d": "[ru]请选择合同签订日期",
  "4daf6c89e01a3a7d07debbb2c44e9e56": "[ru]请选择类别",
  "c7df2bc496873040622d0fd9f5c82e21": "[ru]备注不允许为空",
  "046998923ca2fb63f55573599820ad71": "[ru]请上传图片（.jpg、.jpeg、.png）",
  "f9c90440987d2ed9325e742d03d2017d": "[ru]图片大小不能超过30MB！",
  "55aa6366c0d09a392d8acf54c4c4b837": "[ru]更新成功",
  "930442e2f423436f9db3d8e91f648e93": "[ru]更新失败",
  "6c233eb0b8979ffc2f57d3c501f9f572": "[ru]检测设备导出中...",
  "442740e491ae78878ec7a828f7630daf": "[ru]检测设备录入修改",
  "fe5a64f6ac5a7ff63d3d5126f7f7b8e8": "[ru]确认修改？",
  "a4d21f25700cae33f5c5800ab7ac5ef2": "[ru]文件大小不能超过30MB！",
  "2133219e13885e854a70c0c6a589fbc5": "[ru]检测设备录入明细",
  "c8e8ee29e799350ace1a295ca32cb359": "[ru]供应商生产批次号:",
  "b8fbaa583ff73989211624be1414623a": "[ru]本批生产日期:",
  "cc25f3610216df222b35f3f7dce22434": "[ru]本批生产线体:",
  "c01c0e854c1f9f00e5f7c3d2abd92c8a": "[ru]本批生产班次:",
  "eacc5904f51d94762f1f31ac89359507": "[ru]本批生产数量:",
  "91b3565dcab9afc50ada0e3914bdb04a": "[ru]出厂检验可视化:",
  "5abc888751ec65a563ad1644f0109e44": "[ru]厂区地址:",
  "a180cef89396d5d7b2810dd45a4ace7b": "[ru]输入至少两位供应商代码",
  "0f9e55ef15b59b3a15e2d7821d714468": "[ru]（默认展示提交开始日期1个月之内的数据，如无法查询暂存和已经提交报告，可选择更多查询条件。）",
  "a9f414ff06ac30b8644229e3010b7af0": "[ru]检验（标准）要求",
  "e72f6b7e684f6c9d0424c2817010a2ea": "[ru]新增检验项",
  "1fdc12aa8a314536edea729663996f9e": "[ru]确定删除这条检验项目？",
  "b9245df23437154a2060103e407556dd": "[ru]新增企标",
  "ba1de94169de5a3b9543c8ed29154a1b": "[ru]暂无数据~",
  "d5b1d036097aeb26456527e4bc06f76e": "[ru]请点击选择",
  "7bf54e288c1828b84ddbc4ea8a014c51": "[ru]已选",
  "28b2cee9eb2b013dfef701a8ac5f72ac": "[ru]中第",
  "d1fac8c96737bca4dca0ac1ef0b35349": "[ru]待我审核",
  "536677329125ba2ffae5a6ded711ddc6": "[ru]出厂报告模板-新增",
  "197be9630128dc95a64c249971698c04": "[ru]待完善",
  "ce5c4212119d8631cfcb8ea2fed1355a": "[ru]工厂:",
  "bc88d7f7000d6a76e90d6ceacb1b5bd3": "[ru]供应商编码:",
  "47360478cf67c095b63ec188ee75fe11": "[ru]Q/HR0603001,Q/HR0603003不抓取",
  "1141ee22f2f50427af450af9dd6a7eae": "[ru]手动添加企标",
  "b40055a5bbcb606401f3d790c4234a67": "[ru]标准名称不能为空",
  "d1cb178210f03bb7ad5ed2fad00d20cb": "[ru]已发起",
  "3298943bdd9e28e17718a27e0588082b": "[ru]请输入完整的专用号",
  "4d295d78d449dc65588b0b005f99a827": "[ru]此专用号已创建出厂报告模板，请在出厂报告模板列表中查询",
  "eeaa8d06ce280796bba0cc9890bc844e": "[ru]请输入日期,xx-xx-xx",
  "89151df5543015c6222e27c05640949c": "[ru]当前内容未保存，是否保存后离开",
  "c6848f26de2d97b7f5a656035edbb4bb": "[ru]系统支持数据导入，请先下载模板，然后上传模板导入数据。",
  "0a88ad9805ed9bffd9e36d6302f74058": "[ru]出厂信息",
  "22893ee4487d6e0ff5e2fd2b44c71ed4": "[ru]请输入认证名称",
  "b48824f6eab57bc677c1e7e75be24f5d": "[ru]请输入内认证号",
  "89984a8de5128063debc839f3c66bbf6": "[ru]请输入日期,如不适用请填写/",
  "b04a7f4a058374b8a7a8ff456be98d7a": "[ru]请输入宣告表号",
  "3ba97bd751e79dff382d6ca65e4e3553": "[ru]是否合格",
  "5401ae1d4192129f5665f06b4229fcd0": "[ru]生产公司地址:",
  "93e59c03e8779469e601bb2678623879": "[ru]若入厂检验不合格，关联的报告自动失效，失效的报告不可再次关联",
  "9819d71aee02fbbf06971776c4cb32ca": "[ru]请选择一条数据进行",
  "02a2914b91cc408cbde118bc04eb2260": "[ru]请选择厂区地址",
  "fd09587cab49aa52ae744666e8aa0115": "[ru]照片上传失败，请删除照片后重新拍照",
  "1f15bb285da2d365d417823bf164954e": "[ru]请输入本批交货数量1",
  "e3d961c25ad952125c2bdf0e31452af3": "[ru]多订单关联",
  "77fc2148df3dc5d19c3aacd8d378f3a9": "[ru]质量交付判定",
  "b281ae24818067b51ad35a22330b7501": "[ru]请确认此订单信息是否已关联完成，点击确定后不可再进行关联1。",
  "78816d0a3798e9fd4c3048ab1ed30855": "[ru]请确认此订单信息是否已关联完成，点击确定后不可再进行关联2。",
  "99c74120cc62f4bf31d661e3212b7121": "[ru]提示信息",
  "dfc32c20739844bda397f9f38dc87dca": "[ru]（默认展示创建日期1个月之内的数据，可选择查询条件查询更多数据）",
  "744624dccd613c9a57bf113cb7ceade0": "[ru]VMI交付判定",
  "629d39beef160c8d21bd7ca9d27e862f": "[ru]期望时间",
  "588701bb21f70dba58d0b6e4e5a233d9": "[ru]实际时间",
  "3a4766792473ed2fbd9dc0e06018efbd": "[ru]样检单下达",
  "b4bc694bb6226c9a38fe9574a6542bce": "[ru]检验分工",
  "1f015ffcfa930c5aa356e5658b26bacc": "[ru]分工人",
  "bc7666b60a45d105eb6b17dbab863cf8": "[ru]分工时间",
  "771287f67a2903174f9b4e1843b41827": "[ru]标准维护",
  "9a3c25d5c138ed300953cd543376da39": "[ru]维护人",
  "29c43cf1a6de2d0affe76265cacb46bb": "[ru]待批准",
  "337737f5ae5c5412c9192434beec147c": "[ru]已批准",
  "d97cc7079f2a5a6551ca2c85762f8e3a": "[ru]供应商变更管理",
  "02625cb82a2a2055b96852f01c693cb9": "[ru]变更批准人",
  "0b14730aeaa04bda1454e310d5233e18": "[ru]变更批准时间",
  "4da52143c1ec18aadd0358a59617577a": "[ru]变更申请模板.xls",
  "40c54268786117eeecdbcc45dfa7f862": "[ru]GEA供应商变更管理列表导出中...",
  "ff90ae44b05145cf791e55422e08f10a": "[ru]删除后无法恢复，确认删除？",
  "e31c2232647ce1e13961c75bf535f740": "[ru]请选择待批准的数据",
  "ee98571c3589fed91af0c0527bc75793": "[ru]供应商变更申请审批",
  "38a487d4c7670f055002db47f70af9c9": "[ru]供应商变更评审单",
  "772376e911a51236b0ad65bdf9670632": "[ru]变更申请：",
  "e20cd6c92fde1e5ef3d01610a050b6dd": "[ru]物料类别：",
  "ffeaf63f2174dd957315a6048efb270e": "[ru]下达日期：",
  "993d3bc2ace59630efa9911f12e5e4bd": "[ru]变更批准：",
  "71cdc6ea161675fb292fa6be60e53bd7": "[ru]该模块已在通用电气-BPCR系统申请并审批通过？",
  "43d5fc1b0e1edf9f9357a24b8266c94c": "[ru]评审通过",
  "361f63005cfd73108b99aa62b94718b5": "[ru]请备注应用的产品型号：",
  "94349d579f7bea08a165d12d6f301f6d": "[ru]请备注应用的产品型号",
  "bab39e83b5b9542068a74709247b55c9": "[ru]请将通用电器-BPCR审批通过的系统截图上传：",
  "d249cf467981fb106c32b5d0c8630206": "[ru]批准人：",
  "3f0cc91f0a515f1192015a584c18c8b5": "[ru]批准日期：",
  "ec35bc74b26d70113ee880ab1f889cd3": "[ru]产品型号不允许为空",
  "b6f0b0b3fb8027d6033e10e803069206": "[ru]附件不允许为空",
  "af4e28b5646f7d4c435d264b0bfa80cb": "[ru]供应商变更申请确认",
  "ac2f930b293c5312edfcbd84e36113d6": "[ru]螺钉",
  "32ed5d97bf423e786f17e97ba33134ff": "[ru]螺钉紧固件",
  "7257d2467654319a9092d089294d3a7a": "[ru]冰箱中二",
  "f344b666e145273c47c571adf1008758": "[ru]南通华夏电子科技有限公司",
  "a6a0a8751e054a095f0e3dbb1ea4798e": "[ru]变更确认：",
  "1e745680fd3534aa1708210aba2e8ff6": "[ru]确认人：张永华",
  "065bb8cb95e78d0b5553aea0d24f9771": "[ru]确认日期：2023-11-24",
  "6cc85565b728f7295649ea3fae735bf6": "[ru]供应商变更申请明细",
  "3f323ce736b6af775edcb2735587307f": "[ru]应用的产品型号：",
  "de01e001bfad93126bd78966854218f3": "[ru]评审不通过",
  "7510af26e0522149a2c290d8d9154af1": "[ru]未批准",
  "74525289f2c84488c17cdbd5e61a6c3b": "[ru]通用电气-BPCR审批通过系统截图：",
  "17c0437d386a5811042f362675b56ffc": "[ru]查询中",
  "361fd87a6aa49e4bb2d9be298f57c95b": "[ru]现场退次详情",
  "d8a7a2fb091271f113f0cb152024e59e": "[ru]不良照片查看",
  "d17f22a7d4885ad074a6e11a63603990": "[ru]请您务必在收到不良单5日内进行申诉，否则系统会自动判责！",
  "71de786302ccfb91781f054c4fd02ec8": "[ru]请点击查询",
  "99652ba7c48d6bba558e3b2182e9c31a": "[ru]认可后将不可发起申诉，是否确认？",
  "a7846753f25b1da6cbca4f5d82ace859": "[ru]&appealStatus=供方认可\r\n                &usercode=",
  "27f5ab725ba1a4caa5cd918d6057757d": "[ru]认可成功！",
  "f98989cbae9990c8ddfe4d0e2d1d0d7c": "[ru]认可失败！",
  "28b56e9ecf8f2fd66941460fb688aa57": "[ru]申诉后将不可发起认可，是否确认？",
  "71c9cb24c7a83ced8d89f2008a2ae8a6": "[ru]现场退次导出中...",
  "2a2c24302f81793ea5c074e59031f7c6": "[ru]现场退次.xls",
  "8eb2a4a856b448d9a6feb4d2db47be4f": "[ru]检验频次",
  "ba9dc6d2d4b42e43d88de6f105e74eed": "[ru]历史记录",
  "249aba763258bbe488af3e79a381d265": "[ru]天",
  "39ea2d02a3b79bb0617542b51e481f6a": "[ru]A等级供应商批量检验策略配置",
  "7946901fa3b35102119a10fcbfb31214": "[ru]B等级供应商批量检验策略配置",
  "30e28d0c9a462fe9fe6ca1b58a4bd4f8": "[ru]C等级供应商批量检验策略配置",
  "5231951babe95f5341726a8e508c81c0": "[ru]入厂合格",
  "fecbae9b16e0ba16ae8e270946346a06": "[ru]0/连续",
  "394fb761419ac5b685e896e5fe13756b": "[ru]批",
  "d0882fc35f20f5fdf25d3d98d57d57b7": "[ru]转换代码",
  "789864e3010c3e9c478e8e2d00bee7dd": "[ru]全工厂",
  "454f83efc734230f208b79c25ed3151e": "[ru]现场批量",
  "6cac9ff3fd90a567f81fb09cdde07741": "[ru]单工厂",
  "5f02b7a604c22563c239324c93a0c86e": "[ru]现场PPM超标",
  "4ae626cb260514b48bae3a7976001988": "[ru]市场PPM超标/TOP",
  "f78c85fb3443651eb8e7c4ef33d0bb5c": "[ru]实验问题",
  "7639a39160198d4527e6fb74f9a16963": "[ru]整改单",
  "0a1d2d6316152f463f4cb131a728a327": "[ru]4M1E变更",
  "e6b516aa106f9570e7ebad35efce8a59": "[ru]模具异常",
  "5cc1e17a50771557c595ef028e693c4b": "[ru]手工调整",
  "69fbb2e5fc9eb3ba06096cbedbf5a622": "[ru]条件",
  "51826d554de1466309136806379e4a40": "[ru]任一条件",
  "b59c8ce6d8e4fc36f956767ac593093a": "[ru]均满足",
  "788bcd8599be5c1154c89619f617cd11": "[ru]检验频次历史记录",
  "7c18ad6b6b11314347ce436ddd0b8561": "[ru]IQC转RDI历史记录",
  "e2e7dadaf62e2ebe97456477d406acaa": "[ru]A等级供应商批量检验策略配置历史记录",
  "86ca02e034af483fcf754c3dccbdb477": "[ru]B等级供应商批量检验策略配置历史记录",
  "feadeafac61b827e65ba26e9a2356f52": "[ru]C等级供应商批量检验策略配置历史记录",
  "9baca0054eae22ed3ed689f503a50dc8": "[ru]修改人",
  "1303e638b5ff6d3c4d78b76be2d19756": "[ru]修改时间",
  "155563420f0f3cc67d6f423ae9eb5966": "[ru]只能选择一条数据进行审核",
  "baef4f17967520820bec771b53194bce": "[ru]请选择一条数据进行审核",
  "87120c71637d6408a0ffd68bcaf37568": "[ru]请选择待审核的数据进行审核",
  "fbd2495eab4cb34b3a6eedc8b0c5fed4": "[ru]保存成功！",
  "e00969fda329c1ec6d132141f72bac86": "[ru]只能选择一条数据进行修改",
  "94830ab8f77c94d1932ba574fab52876": "[ru]只有有效或打回状态可修改",
  "3ebac0e8706fcf1168ba5276ae32bd01": "[ru]只能选择一条数据进行查看",
  "2c9541e7b64b0f9a9523a114ccf9fb0b": "[ru]物料号:",
  "e3c21c15b98b3b64f1c4ec2bbce13081": "[ru]系统自动",
  "60e13539b8212e2697e4db36cd49b117": "[ru]检验标识历史2024.01.16前",
  "9d86690b34c4cb5a8ca698ea36c88a18": "[ru]批量检验策略",
  "4bb888b4519818edbb9ed04f147e0986": "[ru]检验批次审核",
  "79bf6bc38fab9f99df22c064cf511030": "[ru]修改后",
  "86ae3444eb43fcd8f62c3a33bf7ac841": "[ru]修改前",
  "da97f76b49267ea63489349ab219961f": "[ru]1/连续",
  "84f818d175aab9e6dbce5e1226a9f8c1": "[ru]是否通过：",
  "12f5e04e7a1fe83bf3f85abd31fe2df6": "[ru]请输入审核意见",
  "82021f8130f6531409c6274ac93c49e4": "[ru]确定提交当前数据?",
  "a71fc6aab4af4c6b6e7e3487adca2ec1": "[ru]审核提交成功！",
  "d0af0b8dcbb507feb126836795217433": "[ru]N1 - 报验中的全新物料",
  "788bf73eaaad7171355f566c778edfb4": "[ru]N2 - 报验中的双点物料",
  "9addd599f73110416af0183c473daa96": "[ru]NEW - 报验合格的新物料",
  "7366b5cb06cee6672542226728940ccb": "[ru]IQC-C - 重点物料",
  "647fae2235bf2db368773c55cfbe3d9b": "[ru]RDI - 免检物料",
  "93118057b8d8451406e8daa47e5bdc9a": "[ru]检验标识查看",
  "dfa929b4850b27902c264c36a9833b63": "[ru]权重修改",
  "e6412bb668b43a549add3fd7ab994b56": "[ru]手工策略转换",
  "c79c7392923537961f24064de80b1436": "[ru]请输入详细的缺陷描述（最长200字符）",
  "b30d4541481ade99bd8787d423a4e741": "[ru]质量信息历史记录查询",
  "5a7825a5e49e178875ed2268a7c6f541": "[ru]缺陷描述最少输入四个字符!",
  "b76984361776f84e6eef812e6aae55e8": "[ru]确定修改当前策略吗?",
  "9e916928b6d99a1198da9d53dbe776a9": "[ru]请选择一条数据！",
  "42529d923df8374e02705289b94c9e90": "[ru]只能选择一条数据！",
  "024ed836b77cdcb93ad2ea8a2701f845": "[ru]检验标识列表导出中...",
  "1866a1fb42e1362d61c82306e0cfe901": "[ru]仅支持当前检验标识为RDI、IQC-A、IQC-B的策略转化!",
  "fe66e18c42d46d52ea898226aa9390d8": "[ru]用户抱怨",
  "caa8b723d917fe015604bd93db88f788": "[ru]质量信息历史记录",
  "3aa1da3f28bbf090b4bf964c63ff518a": "[ru]转换前检验标识",
  "e0c879aa19e7b302ca745dd455d20f71": "[ru]转换后检验标识",
  "beaee8097ef321362d97212728eeb1e3": "[ru]调用结果",
  "b3ae9fd59bfdee850a82d5fb0af95feb": "[ru]调用时间",
  "59c8056d7ee0282929a2f50d1a1d1a7a": "[ru]调用信息",
  "f38d81379d608b046ac4a8db8764920a": "[ru]RDI → IQC策略审核",
  "6d4248ddf0b11d731285a4020342d79e": "[ru]市场PPM超标",
  "86b9bda0a87ded3daf94664df6f43b49": "[ru]检验标示",
  "b51d166ef0e0f0df4aca8571884ef099": "[ru]不检测",
  "991d5e29be322940c40a0b01e5ddcb98": "[ru]最终判定:",
  "0576a9149ec01e289e8e1eeb4f6c2b92": "[ru]不合格图片查看",
  "615e3012db5814b4231d439170cd9500": "[ru]数据查询失败！",
  "17b80e2f8c0f550fa4442de5e3141e6a": "[ru]不合格项",
  "6145165d22a09191c7da1c32fa80efc8": "[ru]入厂不合格导出中...",
  "ba9c46fbe9354e0f2e58b4e2a2ebb31e": "[ru]入厂不合格.xlsx",
  "0a908c72c159b95fc39793f6c52dddf2": "[ru]按供应商引入",
  "a22afc15bbac6c5b6713ad0c232512e5": "[ru]一级行业类",
  "3122abd8ea7e1ddce1bec7792d835c6b": "[ru]二级行业类",
  "185d08d725508b5606e568fcb8192f36": "[ru]三级行业类",
  "fac54c3430528339ac075d688db27ce8": "[ru]模块",
  "f6a1df12a6839b6bb5aac750ccd94138": "[ru]产地编码",
  "c21ed1790840823501ff0cd6a916b97d": "[ru]自承诺通过时间",
  "d11e285bae95512a447279593c405db1": "[ru]计划互联时间",
  "28b91ebbe679450939cedd4d557f30bb": "[ru]实际互联时间",
  "1c4d2bdc3f2be7d5340e46967ecdce47": "[ru]质量保障能力",
  "1ec8e803bb4ac9dc755f93a739dd6835": "[ru]研发能力",
  "54ff283836ca6657213388f4391315a2": "[ru]二三级供应商管理能力",
  "c2a8a0db85f55f5a459de8f654d44174": "[ru]线体制造能力",
  "607826b7c8b93655b9384a2b0290c505": "[ru]互联结论",
  "3d5abb407f7585dec834e706814252c3": "[ru]社会责任",
  "b824f01b651909961a31639639314d85": "[ru]报告录入时间",
  "28481b1875367da443aab243f9e58f86": "[ru]整改合格时间",
  "77e7dd68f93c649fc734f91f7cc7981f": "[ru]问题闭环数",
  "a1528b9e3e68f1d9e5553f2b1a6e7702": "[ru]问题闭环率",
  "9a7ec37bd214d5cee8087ffe17cf691c": "[ru]互联报告详情",
  "03232cbe63ad9075fe3ae4faf4713cfe": "[ru]问题整改详情",
  "873ecc36105cf51a0a5f5cb10abb0939": "[ru]查看现场互联评",
  "4b84fb41b97ac6306668aab327378323": "[ru]模板名称：--",
  "6d6d812fdc209f48106de9293d6d82dc": "[ru]模板编码：--",
  "368a851bbe1d07ce0f64b2c9ad27ea9f": "[ru]现场互联评分",
  "42ef3cf0cfb884468c1722909947ebb5": "[ru]实际互联时间：",
  "99f28a94778c86945143a9853678b364": "[ru]随行人：",
  "b520a63062ab50ba3f466026f059d75c": "[ru]廉政说明书：",
  "8acf713b322df3e0ec6b6c957e27de26": "[ru]供应商现场互联总结：（PPT/PDT版）",
  "bf43bfb1cbe0eba6543b211ed15e144c": "[ru]现场审核报告：",
  "339d37d373d3bdf4c447189d5647367b": "[ru]评分详情",
  "767fa455bb6826f4b550c21a6bca7182": "[ru]目录",
  "3816d479eb8f35ec239058525af58ed8": "[ru]汇总得分",
  "4726ff4e62d3fcfa4b090aaefc393229": "[ru]暂无内容",
  "58418357c2a5fa6661d7e190c6655737": "[ru]有害物质管控能力",
  "ffbede5ba4c3a38b7fa0293a08554f40": "[ru]现场互联评分：",
  "a5d1c511d740fca6ced0bc02bb5a5343": "[ru]模板名称",
  "642ddffc3f70d6c5efd212c2714a618f": "[ru]模版编码",
  "2e5e5fa5d2cc11426c0232adc65f6a14": "[ru]莉丝",
  "720a877c104e7a0183fb52648db19713": "[ru]介绍介绍",
  "7ac0ef07da54d5ad48f675c039910c72": "[ru]总结总结总结总结",
  "cbc7279107ea9fcce5aac846e2777fe2": "[ru]报告报告",
  "b9211b0f5ff87bdd4646f7e81e5efecc": "[ru]厂区名称",
  "397a13e6ca2b65d06d23a668703c7c4d": "[ru]新建厂区",
  "95559444109d4dcb9322ae8aeac7db73": "[ru]通道号",
  "a93c2bd3c83630e3508fa75ad1d9b7dc": "[ru]萤石绑定状态",
  "906ad18b48f07a0cc2ea9f4f809e1254": "[ru]未绑定",
  "aa71a61cef0adb769436cde6d379b02c": "[ru]已绑定",
  "2179e04b069fe7d20d2af0f68991f300": "[ru]输入厂区名称",
  "41913f24b0842a07ff5757ba37910e06": "[ru]省份选择",
  "ba6a6f2cdb46e8f80fbfd4fed20eafac": "[ru]城市选择",
  "9b711a7b854bda16a2339fc9bb887736": "[ru]地区选择",
  "050be593da24c47dd95493b19e687e0f": "[ru]街道选择",
  "80d6852f33be98a024f8e28128ee63ed": "[ru]请输入详细地址",
  "571bb2d9866b69c543b6fae837641060": "[ru]请输入AppKey",
  "6cc0b20df938435d79ca718e60fd7592": "[ru]请输入Secret",
  "4419e8a1ba26ab60adc3572dcd5be78c": "[ru]设备序列号",
  "007aeb71de765993f8bbde4635a42d04": "[ru]请输入设备序列号",
  "dfc894e3592ab700f7a1e94523519341": "[ru]请输入设备型号",
  "05fc98e2ae533822e4738bf085a5d1fe": "[ru]点击查看操作说明书",
  "919c190d10a36936e0383a3f84a11f80": "[ru]暂无位置信息",
  "e4575bf1152f871cdf53e9786efda661": "[ru]*网络摄像头或录像机单摄像头用户\"通道号\"可忽略，录像机多通道用户，请准确填入通道号（通道号见萤石PC端后台）",
  "42987c4e824fedc33d20d91af36e91be": "[ru]厂区名称不能为空",
  "134026d3376cb5c2a888779112c30ff8": "[ru]省份不能为空",
  "f168e7facce3c54389bc09e2c3e13b6d": "[ru]城市不能为空",
  "a31683fc708db2d5f6fa6d75985b819c": "[ru]地区不能为空",
  "361ce46f1fc778a36f50f916b79d0e84": "[ru]街道不能为空",
  "a95544272ec106cd637f4690ea5649c0": "[ru]详细地址不能为空",
  "87cff763038d9065ab3e24ce5ddac4a5": "[ru]appKey不能为空",
  "c28aadc2fadce43cc4c18a9bd39cf958": "[ru]Secret不能为空",
  "af0fad7f9a5709e112f2a2d79c5729d0": "[ru]设备序列号不能为空",
  "80018d8c24add6882b7b8cf5c2dd323e": "[ru]设备型号不能为空",
  "c0f2a654866dcef0323065e21c5f7e7f": "[ru]厂区新建",
  "ec7ad058bb0b8269b6535333512f1567": "[ru]厂区修改",
  "9084b53e918cdc4e663473a22ea139fd": "[ru]登录已过期，请登录后重试",
  "c004971dc1a114b46bd5ae55e9c26b16": "[ru]厂区名称重复，请修改后重试",
  "9652cad83cb49ebe7dc68241d83a3088": "[ru]保存成功:",
  "4d57314ab901e94823f4d85d32b17eb9": "[ru]保存失败:",
  "395c105bdfe2a65e51f0bbdb91c7719e": "[ru]厂区名称重复，请修改",
  "1d7f39d3a313ed5b4b03eb676e8801df": "[ru]试验样品跟踪单",
  "dbb19766f02f9b41af421dc1176d01b3": "[ru]试品专用号：",
  "d5806ce2a12d6803c99dbabddc7f96ac": "[ru]送样部门：",
  "9149081f011ae77183277b4c0f9a411a": "[ru]送样人：",
  "122a769916c42ccfbe0e1d4b59d8460a": "[ru]委托日期：",
  "8722c5eb7fbb163e281b8a080277191f": "[ru]试验编号：",
  "558b1a00fd90bc9029d7b6b303bc0f68": "[ru]测试实验室：",
  "1b528fb0e70183fce80e05c948729502": "[ru]数据查询...",
  "7b2180c2843cc93ce48b42ea19dd3704": "[ru]发布日期",
  "a6091978e15331cc6c9ee9784f58cbf1": "[ru]实验室能力",
  "384f30b6a9c949b3a2c82bfb3e5a3b04": "[ru]同步实验报告",
  "b316f8e3fd0e07ae87e0d13605680356": "[ru]标准和实验室关联关系",
  "58b72d79db54edd97190de28b761bdaa": "[ru]标准编号/名称",
  "52e3ef528ca5899fb63bd7bff387d7ae": "[ru]检验标准编号",
  "3e84bf965453e8acf71f490f440ff9f4": "[ru]检验标准名称",
  "575cc68b43e2cf55d3dfa3cfb9d69455": "[ru]请至少选择一条数据打印",
  "4cfd2bc5f1af24041be4353a38295bce": "[ru]同步实验报告...",
  "11dbd900005469b019effdbda3a1b1d9": "[ru]请选择一条数据同步实验报告",
  "3c3dd9539f60b11ea09867e74242779d": "[ru]正常状态的实验报告不能同步",
  "b82ad5f3315e8b5e62decbd8300dd131": "[ru]同步实验报告成功",
  "b438892e9f8ed60dc97b5fc3ae5468db": "[ru]同步实验报告出错",
  "1de70f0d7e57a72082e5dc6c2bdd59e5": "[ru]请选择一条数据查看委托单",
  "1abe59f77e1247aa9e420804b3ab0d4c": "[ru]同一性查询中...",
  "aafcbfb7852a4b7325117c73264898dc": "[ru]同一性查询失败",
  "4514fd039a6796c84c9134e2ea871116": "[ru]检验标准查询失败",
  "6d590b9c106004ce7e9a43987137cf40": "[ru]只有审核完成的报告才可以查看明细",
  "53dc71ba9e540389aabf0dddb857fd5d": "[ru]请选择一条数据查看明细",
  "4276d0c3b1af5aa9d7d560b70990cc5d": "[ru]标准编号：",
  "1e8b72668a3b6cf80b793391965c2267": "[ru]标准名称：",
  "98c613b0da6fc2420be124b355f54027": "[ru]请返回实验报告页面下载并安装打印所需驱动，然后刷新或重新打开页面后再试",
  "12824bba9ee6859e3db702f5975dd9b9": "[ru]先关闭前面的窗口，才能打开新的窗口。",
  "a2124e285ea4428ce978b177b8e7431b": "[ru]能力项目",
  "568849ed2d08484c938609a996d1e724": "[ru]有无能力",
  "ecd76cb3d7315fb8114eb44613ebdff6": "[ru]费用",
  "d090045ce6341ea4efa8d01c2684a4ba": "[ru]周期/天",
  "a5fb0877f4fe5a599a19f699e88d57b1": "[ru]实验目的",
  "c53cfe836ea7ba07f308a714a33d4e34": "[ru]实验室",
  "15d2236a212c310fc4f9669e573f786e": "[ru]审核退回",
  "e8c469d1a4732dae943e0c66840e0198": "[ru]导出模版",
  "a75779bda05eba0ac70ed7446a62e41e": "[ru]请先选择标准类别",
  "1f24c8d42ec38aaf942509eff8c6b758": "[ru]请从下拉列表中选择标准编号/名称",
  "9c647915087c42663e140d555d22e102": "[ru]专用号依据明细",
  "33eab55f76de2e52cc1c202d7c14692a": "[ru]专用号依据",
  "a47ad542ab95f38de75f0f51a31092d7": "[ru]对照物料号",
  "ff0a7822728d63cc77b5333dee975e4a": "[ru]请从代办页面进入或者从下拉框选择专用号维护专用号依据",
  "879b7d8c35217825ea154830aef4afb6": "[ru]判別水平",
  "07f72236253b638cac219e5bc1e0c80a": "[ru]周期(天)",
  "33a235ddd0ca1b316a8f442493f1274e": "[ru]易出现的缺陷",
  "47cbfea5ff0c1a8e6ccec45850cfced1": "[ru]检验标准类型：",
  "524726069d4d0a917287873b4515b7db": "[ru]检验标准：",
  "75ec5b5f8b5a4d3e4508e1fb9e91bc3c": "[ru]入厂&型式",
  "2b1c6525f8306d39c387bd6b9ecbf830": "[ru]型式",
  "e774acbd9bf520d1e3bf404fbde3272e": "[ru]添加检验标准",
  "cb88c72a3df9e59ec9363b495503bae2": "[ru]添加自定义检验标准",
  "e71e0622595d028e18eb5f13f6d5b346": "[ru]各标准暂存最少选择一条明细",
  "79d5d7ae21d4e63b3358da84d522f9f5": "[ru]暂存中...",
  "f7437308fb33b9244e4bfe9a67b30688": "[ru]暂存失败",
  "c322edb884724d04842fc35f4d29a24e": "[ru]最小值",
  "5da893141114a59da868052b3a17a79a": "[ru]最大值",
  "8869f958c0f1e09ee1e7220fbfe3c888": "[ru]请添加检验标准",
  "845de5389431e84e0fb68d67da3fd56d": "[ru]<br> 序号",
  "599cad0821b9a453ab020ceef5443ce5": "[ru]提交成功，待新增出货模版",
  "38ce27d84639f3a6e07c00b3b4995c0e": "[ru]下一步",
  "3cef2a61f831891f67155c21c4cd1e5a": "[ru]标准类别：自定义检验标准  标准编号：自定义检验标准  标准名称：自定义检验标准",
  "5a842d4e2b1c3566cc290a83803bbdc0": "[ru]自定义检验标准",
  "671dee78660b7027aacbe7628559c379": "[ru]模板已存在，请勿重复操作",
  "b72eba00fc7044ea1407d6abf3dd645e": "[ru]检验标准查询中...",
  "d791820f42f2b29d5ed49a7dd197b94e": "[ru]专用号查询失败",
  "30c00fd2bfd83b8a8ed4596c10ce5701": "[ru]专用号查询中...",
  "fad6a1bad3fc2cf2144be5f1039b84de": "[ru]标志/包装/运输/贮存",
  "7dde1631c2e77c328a7e9b355e686f01": "[ru]符合企标、图纸、规格书、新品自检资料等文件规定的相关要求。",
  "f436c1834cc5966798d6082c81f757ce": "[ru]材质/子件一致性",
  "b9e94fc081b438780465a654c383a8e8": "[ru]模块的材质、关键子件等规格型号与标准一致。",
  "3d9ee12429fdc3d439155f20ebee2d98": "[ru]具备有效的符合性声明、宣告表、第三方测试报告，材质、子件与宣告表一致。",
  "57a3f0bc21be4b304569214dadfbeebb": "[ru]产品已通过CCC、UL等认证，并在有效期内。",
  "739a87cea9e787c478807eb41fbdd2ac": "[ru]模块商按企标、图纸要求进行出货检验并提供出货自检报告。",
  "ba6b2efee09375b06620d69a72118510": "[ru]检验标准类型：入厂通用要求  检验标准：入厂通用要求  标准名称：入厂通用要求",
  "2fec1c3fd09e03e822c12745fa21cd63": "[ru]审核不通过请填写结论",
  "fe3661a6546706d0d3754d2dc27322d2": "[ru]审核失败",
  "9a374942b1dce3eeb1c2db80a300885e": "[ru]标准类别：自定义类别  标准编号：自定义类别  标准名称：自定义类别",
  "042fbed1cad7fb224d2ce118648effa2": "[ru]标准编号：",
  "b3f606be13bbf83a5104508ffc129fee": "[ru]标准名称：",
  "5ac8efd16cf422b8d4b08690289f767f": "[ru]查看出厂模版",
  "24f4f0616fdca1df27e96bc68ec535c4": "[ru]待新增出货模板",
  "34c5085b5257227c852762507b195c90": "[ru]新增出厂模版",
  "0e9f47fb3bf6d1fd23e3e5913153bc9c": "[ru]当前用户无操作权限，请联系工厂外检经理进行操作",
  "ae72054e80a1b9cfc9fa890ddea366a4": "[ru]请选择一条数据进行新增出厂模版",
  "1d7ee3bc75b9180232a34daa1b679288": "[ru]请选择待新增出厂模版的数据",
  "f13a0bcd95c4bcc2e2f4cdc733919ec0": "[ru]请至少选择一条数据删除",
  "65f949c9401a9878779bc682f32b890b": "[ru]待审核或审核不通过的数据不能删除",
  "1e34587de5bd3ccdcd4b68aded80954a": "[ru]正在执行删除，请确定操作",
  "a7717d594688d88c97f71572ffd5ea90": "[ru]请选择一条数据修改",
  "13b9fd768e1d23d5957fb09c9033050c": "[ru]请选择已审核或暂存的数据进行修改",
  "d3c8bab432eb466a0ced0c20ade29ff6": "[ru]请选择一条数据进行审核!",
  "c4fcb9f1f8a8cb6772fb6cbec23f7539": "[ru]只能选择待审核的数据进行审核!",
  "adc227ca0cecf2509e9c5cea609ec1ef": "[ru]当前用户无操作权限，请联系[",
  "945e9c339d92d4ab2ba4faec8710477a": "[ru]]进行操作",
  "519bb8cd7b576be38c7993ee73fee042": "[ru]PPAP检验计划.xlsx",
  "eabccd835e3298fe30b57004f86a2f12": "[ru]检验标准明细",
  "2a0c4740f156a9536049f4610da25400": "[ru]文件",
  "eb16d8100547f2e25793d3eb88b19c18": "[ru]查询出错",
  "20310c9b8e44c95452473e2b352012b8": "[ru]标准明细",
  "1abea6722c22c1eb4990ab22d640e098": "[ru]抽检周期",
  "4003a39360c8f04a4d70a4203d63c923": "[ru]查看只能选择一条数据",
  "6b29905954e02ce7d7a6fdbf10c48b4e": "[ru]<span class='blueColor'>待审核</span>",
  "4385598cf11b03f9957f21190aa05aaa": "[ru]<span class='successColor'>有效</span>",
  "eb2ec1d78abc08e01091d693a93447ac": "[ru]<span class='dangerColor'>无效</span>",
  "34ec4c1bdb9360a46b2fad6440b33100": "[ru]<span class='dangerColor'>打回</span>",
  "0232c427c2c4c59267b9d5ef69d74df9": "[ru]<span class='blueColor'>暂存</span>",
  "50bacd17606df81493ad646602c5b0cb": "[ru]实验记录",
  "beb44b5db841f29c9c300f23230b4bef": "[ru]请重新登陆！",
  "bb2cdfacbf5a6019eaff1a9449a8fb24": "[ru]登录账号",
  "78cbe8d9a6ab8f96b90f8df12e7edd92": "[ru]登录类型",
  "9fca7c455fbfcab7cacd994c7933ff70": "[ru]登录时间",
  "3fb2e5ec7b19f9fb4878df676b65332b": "[ru]登录日志",
  "e07c29caec43a23839a7cb8d03270fae": "[ru]登录人角色",
  "5f8be4da82799638a320984402232d21": "[ru]老海达源",
  "1847c8bf88d98458b52fde1153cbde93": "[ru]新海达源",
  "10e335c90a25fee9552e618224031d1f": "[ru]旧版用户",
  "559448b5a1cbb8aa7f6cab8828aca6ee": "[ru]日志列表导出中...",
  "ecb6d217e2524a5823e9008b2b83fc7a": "[ru]日志列表.xlsx",
  "13ef7828361c8aebbf6ebe09370f5e41": "[ru]请选择年",
  "9b062f59aafd2b97f3e3505a8d87c13d": "[ru]请选择月",
  "ba2558aa432f5e5c4b7d79da98d6c827": "[ru]市场认责单一级报表",
  "a1c7f2aca21dfef28179d5a1582e9ee4": "[ru]注：自动认责单一级报表每天晚上10点之后统计一次本天的所有数据。",
  "ad8a2c31cb88584865b8e8888567f7fe": "[ru]凭证上传",
  "a97f19e4335cd4390058a39820b3aaca": "[ru]上传率",
  "75ea8fbcdfd12e288021bea6989b792c": "[ru]索赔率",
  "3013ff83b8f34903198f5fbfcfa70a36": "[ru]市场认责单一级报表导出中...",
  "68d0daf8a5601b1b3b33b6e30337a827": "[ru]扣款年月",
  "cccc69ce2f283b665e56deb8d7e968ee": "[ru]请选择年月",
  "82e5f593549456c9d1b43b3cfc06cb13": "[ru]重大市场事故",
  "c5121e776e06db9c079d504392d18421": "[ru]水、电、火安全问题",
  "9d9bea512fa7e48f2d3a27f42534a5ee": "[ru]请输入至少两位模糊查询",
  "6d6998c1a589c3da7fdeba139c43ed98": "[ru]是否生效",
  "9a72cff1377b70d464b221a57129742e": "[ru]生效",
  "43b9093771b54bc5e3490844cc8ba262": "[ru]不生效",
  "53cfd5a69d173754a72edafa881169a9": "[ru]市场自动认责",
  "8e3d2aa8f851c761e389765ee96b79af": "[ru]市场自动认责单",
  "f43e6e2b294258c55b9db921f4e08619": "[ru]《市场自动索赔操作指导书》",
  "e968ad6c1ecd13d10a14dbe34ee3175c": "[ru]不良个数",
  "95ffadb8c1daf248d7f1627c54e9022b": "[ru]金额(元)",
  "81b95002b24a9fc4579270eeb0b61f84": "[ru]签章时间",
  "91d5e5a8236e72af007dcfbf1e799b56": "[ru]交互结果",
  "d1f1b35b46080de518e44a4bed0b7634": "[ru]供应商待确认",
  "3913e7c968ca888ebceff3715077c615": "[ru]申诉中",
  "e71b44aae6625925a4cd463d420f2fb8": "[ru]供应商已确认",
  "801759cbd2cd6400747a8d4edc83b42b": "[ru]申诉成功",
  "6f058a99d24d36098a688e5e27a89de6": "[ru]申诉失败",
  "fcf082ba3d56fd68f65915a75163008d": "[ru]凭证是否上传",
  "d996bf06fa7714d7b848fc708ca0afc7": "[ru]会计凭证号",
  "782bb0424439805f2bb64439201609c4": "[ru]反冲结果",
  "6605c65da3f1cddb183f92c7042c7c4f": "[ru]反冲",
  "4343bed384191f181c8c65d1e465c29a": "[ru]UPP反冲",
  "9f447de653ce3a6b8054b75cd067cf39": "[ru]上传凭证",
  "499eaa97ef29ecd68d78d5008f8074c3": "[ru]只能选择已扣款或已返款的数据!",
  "fbb2c73a7875fd01bc1998053e8ffb8a": "[ru]反冲成功",
  "e07feb85aaeb1cef9effaa9cfe052a30": "[ru]反冲失败",
  "a3ca5fe4745718cd480bb4df6f14cb04": "[ru]只能选择已反冲的数据!",
  "a1af0fcb9eeb87ba6374bd8434c3c18b": "[ru]UPP反冲失败",
  "f532b7c4a739377b1708ca355c36ea09": "[ru]只能选择一条认责单进行上传!",
  "ab5a3505c12838df279f09b4cd923cd3": "[ru]只有供应商待确认或申诉失败的数据才可以手工上传凭证!",
  "3afa6daaf9661a4d53c331f82fd7bbe5": "[ru]URL查询中",
  "6813f329008ceffe84ea0bb170f6c521": "[ru]上传凭证失败",
  "b2da2f6bbab0a265cb056a5c0533ce5c": "[ru]市场自动认责导出中...",
  "349e3d4395fceaa195adccd5bc0e2ccd": "[ru]市场认责单",
  "9d55519f789d23c2fd770990eab9ac8f": "[ru]请选择工厂小微",
  "031776b3bd3afdf1cec704355372c5f9": "[ru]公司不能为空",
  "536311b1a7bae2e9dbcbba111d532ca9": "[ru]根据工厂小微自动带出",
  "650e38811dd862d27c7260e78e623f5d": "[ru]请输入至少2位模糊查询",
  "552cacb8043adc182c107be1712b7a79": "[ru]市场",
  "26321ae7c8caa98636b8638714050381": "[ru]不良明细",
  "d0ad6bf9759de79a1c1640b478796dd1": "[ru]雷区：不允许多个专用号录为一个专用号，并且专用号不可以录入错误。",
  "cf693bbe6d517313b92052579e7cea4d": "[ru]请填写不良单号",
  "37d3d77a5ef42f515a1103ec3fb493df": "[ru]请填写机器编码",
  "f874eea0868eccdbb3ba002e5f726195": "[ru]请从模糊查询中选择专用号",
  "b774a831a9103e2d72d594b5526b5ad1": "[ru]根据专用号自动带出,请选择专用号",
  "e659f30739162b4342fc9f66d59781eb": "[ru]请填写不良个数",
  "a373d3f44d25a9fcc5bf04655599b7bb": "[ru]请填写产品大类",
  "d9e89116600ba3d747e71968f028bf2a": "[ru]请选择不良类别",
  "111f70957034c5985c900cbeb90facfb": "[ru]冰冷压缩机不良品",
  "5bb2675323da1e82179abca803068a5f": "[ru]洗涤不良品",
  "b2bd7eabd34c6cd785b92160535d974f": "[ru]请填写不良原因",
  "41a4d59522b47e1810186244d1d2f5cd": "[ru]请填写金额",
  "44e3be798855d575b5a61eaa583ac44d": "[ru]不良件批量导入",
  "88efc49eb771b6d850d8cb142ee28655": "[ru]点击导入模版",
  "64269267dd427673e87dc705f2316d17": "[ru]请注意文件导入的格式（.xlsx/.xls）",
  "3ef0db984c2ee179f561eab988d2e99b": "[ru]不良单号重复，请检查后重新提交！",
  "859b2cdb2dc56b08eb6a8487e01a164c": "[ru]请填写数值",
  "dab39511c461ab017aa6c40788c6d76a": "[ru]我司认可上述质量问题，并同意按照双方合同约定，从我司应收货款中自动扣除上述款项。",
  "ddceb433eb78320505946713a6b8ff86": "[ru]EIS影像",
  "06d2fe55b166f72fe48394b17f678747": "[ru]查看扫描件",
  "8e91254d3e902cfb87839ad08a907e0e": "[ru]无扫描件",
  "fb18d2e22339587d544c763f20925214": "[ru]注：点击或复制链接，直接跳到geam系统查看上传的凭证信息（EIS影像每天晚上更新一次）",
  "24d4d26090e1b822159ffb1bc43aaf6f": "[ru]CA电子签章",
  "e39481adaf2591cceb8ffea118f40dcc": "[ru]机器生产日期",
  "f2a08244410d1c8ef71dfddf470f9f48": "[ru]EMR待确认",
  "98bd16f96b3c8bfedadf906f099c6e25": "[ru]SQE待确认",
  "91272f3224622b5ba83ffc0500e2836b": "[ru]SQE已确认",
  "5ea550ec97ca330cfe524b9f05d0e171": "[ru]供应商认可",
  "89eb83b5ceaac597735e5121c29b32cb": "[ru]超5天未操作",
  "eb66bf9394dad0ca21b9fcbba2142fd5": "[ru]EMR判断结果",
  "5fd955a90bccb0b5182f278905ceb6fa": "[ru]SQE终判结论",
  "ae0785738f077a2b589dbd07a84109d9": "[ru]部件",
  "ccbb7801eeb1f61b0d4e9282f2c5e645": "[ru]物流",
  "184219e01bc9df50cc3783cd0b9b9411": "[ru]制造",
  "cc2177391a48aa3ac5484ce5a0cc70e0": "[ru]自动生成",
  "8446ec4ccf98969d665d4d157c58dbc6": "[ru]手动生成",
  "da3b420e7877432c0ffe563a3eeabf6b": "[ru]未生成",
  "e3b2a6ba7ab2c7c3ac246233f919f0b5": "[ru]专用号描述",
  "819767ada1805b0f0117f10967b94d4d": "[ru]用户名",
  "e87d85d554f3a72a73b49639a1da9314": "[ru]网点编号",
  "7c13bfe73f52a5e1011a1b4489b9f70c": "[ru]退换原因",
  "3c28c55cc8c5d914b031889488743c05": "[ru]网点鉴定描述",
  "b1de0c57faa02578b1519ea19ea372da": "[ru]工贸鉴定时间",
  "0e28821625dab8cf6305d2f464ef28b3": "[ru]工贸确认出库标志",
  "880842d5c5f285b34abe1b09cb1ca1f9": "[ru]购买日期",
  "523be04a4dfc39dcb3f960066fe6c28d": "[ru]返厂出库时间",
  "e6f45c67f1e66e30c0a1f311f0d61f37": "[ru]SQE确认人",
  "0fd8d6aa050930b05cca5ce5f42e1119": "[ru]SQE确认时间",
  "c2b14f82dcc965dea5692ced87d00e45": "[ru]互联工厂代码",
  "63e045f9cf28b9ac33848c71aa2d3690": "[ru]供应商确认人",
  "220babf49c688781c866d87e204f73b0": "[ru]EMR判定结果",
  "b8dd6c1ee473fb46444bb6640775b0e9": "[ru]EMR责任位",
  "78e4e7688dd25a169d48f5c8e4434813": "[ru]初判结论",
  "feae24e1dd76ef36a8e1dc10b71ccc06": "[ru]市场不良导出中...",
  "78e141b23ce9a0937828f4fef590316b": "[ru]市场认责单查询",
  "6ec88e10e60e871e77918d86ced88afe": "[ru]市场线下认责单导出中...",
  "1c2bbf6e94720df22fc7a69a4f541e80": "[ru]注：请右键点击此链接，选择‘复制链接地址’，然后粘贴地址到IE浏览器中打开（EIS影像每天晚上更新一次）",
  "d429ae93154964b4ad9a3ca21b4e3d17": "[ru]未扣款",
  "f5636cdfb2bbd8a16c00efc1566a4c3d": "[ru]已扣款",
  "7fcc7a6d3a3db98cc83a02097474fa28": "[ru]已返款",
  "bff6626898f5c493fe27f87fdfce9927": "[ru]已反冲",
  "4c11c20b31b6b8e1e79183ad1e6fb78b": "[ru]已反冲UPP",
  "a49c9b691c212553d9b34a1b742b38b3": "[ru]供应商认责单查询",
  "fa904e8c7ec8ee40b9e82b57467c22dc": "[ru]《索赔规则》",
  "db882a3504e0ae63311ac37201abaf47": "[ru]《现场自动索赔操作手册》",
  "5f3ce365da85f34f82a7da0069744388": "[ru]现场认责单",
  "482d4913f240ea6875f645d88a192933": "[ru]问题节点不能为空",
  "05c878935671d2cd00cd41b65e70f240": "[ru]封库返修",
  "0063c51e228e58fddadbff82a79cf3c0": "[ru]上传附件",
  "8d8e166f887b1e084fd8fddd00f1cca5": "[ru]附件为成本经理对损失进行的核算：包含场景①因部件原因导致的总成报废。②因部件原因导致的封库返修",
  "ee21a3a2d080f291ab1e4aa1b0f69d03": "[ru]ROHS实验",
  "257d309f0fc0667df0049a4f38bbc50e": "[ru]请填写不良数量",
  "48e3d46923e70a579ec97f4707fa277f": "[ru]请填写至少一条不良明细",
  "e2a10bcab5c8e77886cc934194f3c27a": "[ru]获取手工策略失s败",
  "52a54562368d8e7b41ee0be1f85da214": "[ru]供应商任责单一级报表",
  "c1f60f6bdd4ddf79d5159c82026eb1a8": "[ru]现场自动认责单一级报表导出中...",
  "05f4dfa44f77ef5490293877fcd872bb": "[ru]现场线下认责单导出中...",
  "d3870ce70d809911318f2beb771dcf31": "[ru]QM历史导入记录",
  "496c29429e3e139144a0cff022b6b7c7": "[ru]创建/更新",
  "599d7afbbb3005a0aac3b1f075eb5e83": "[ru]操作人工号",
  "3b8bdd98efe3b6a80dae866ba9ee3326": "[ru]导入结果",
  "fdb82242d8ce1a305357e0fc60f555f4": "[ru]QM历史导入记录导出中...",
  "8f02fcd24a9541639728eb67e9e87886": "[ru]QM原始信息记录",
  "b0334e2b6353b1fd5e6a5503c2f3a822": "[ru]不激活数量限制",
  "fa787294e05b33309f6d236a31fd61dd": "[ru]请输入数量",
  "38eea9d308a34bddb418896b71c45bb1": "[ru]X-检验",
  "b48f5fd48f6ee84359357ae16a285f53": "[ru]X-创建",
  "2268195aec6325c88373a43f736749c4": "[ru]更新",
  "3b87c5e11f03a1f6460b6f3adee11979": "[ru]WGG/EPG标识",
  "e44070f7d91c5c92159118807b16443e": "[ru]*请注意文件上传的格式（xls、xlsx），文件名中不允许出现逗号，最多允许上传1个文件且单个文件不大于30M*",
  "21c1724d1603f1b3f52429fdc1d9bc3f": "[ru]QM导入模板.xls",
  "8ec3e8e7173af1595595967483a1009f": "[ru]专用号请下拉选择",
  "3c0ba7c03d854719c8f2b22b117a8a21": "[ru]供应商代码请从下拉数据中选择",
  "a3f9e82f130c79b34baf365549076989": "[ru]数量不能为空",
  "34742c3539e74088568484ca6841acaa": "[ru]导入成功，",
  "252bc3e8f99e143fb7f9d020f07d7f17": "[ru]新品制版设计稿审核",
  "3075e304a94a1e5bf8ef4ff07fdd9fcd": "[ru]报告信息",
  "2f4fd79b3f9b4a273afa62295ab7db6a": "[ru]制版设计稿",
  "826326e317a1b6e22df225e69995d82c": "[ru]型号经理审核",
  "0f92aa87e67a05ae265c051295105197": "[ru]审核原因",
  "b0b1756de4a667a22488698b6a6cf4e6": "[ru]审核原因不能为空",
  "62cea74981b60712a7cd869a9a021869": "[ru]作者",
  "a66495dd41df04103d92d6d2601c18bc": "[ru]供方自检信息",
  "a86b76d1ac7e23fbe6811914dddedd66": "[ru]I级",
  "50657dd5fba0f4c56301994b9435ed73": "[ru]II级",
  "6d29d5c1c563430c254a0571e5498a5f": "[ru]III级",
  "1ca7175c20c07333353d66197609f2ce": "[ru]自检应完成时间",
  "31f3cda12f66898443a5cbae5a59a54f": "[ru]自检待审核",
  "b1d80f4be451870aad10bd88b42f4c27": "[ru]自检审核驳回",
  "ad99be837949c976c9442b08d5fe0983": "[ru]自检待校核",
  "9e859f946a67b072165a8447cd662dff": "[ru]自检校核通过",
  "b1b793381d349ecd6b67cfacc2b0ab40": "[ru]自检待批准",
  "2cf37ff600fbfd0f0728b6202b1f328c": "[ru]自检批准驳回",
  "749ad86b2e655706785f3e38b9e7031c": "[ru]二三级物料",
  "72f21ebb9b237f248844dde337548450": "[ru]二三级物料结论",
  "d95cf47ff6633b3bea0c6b2c82f50107": "[ru]物料等级",
  "82428b489879f605914215b9876caa40": "[ru]零件号码",
  "2bb79b0b11fb5f902349598676e2060e": "[ru]零件名称",
  "9ee1d06b4fb650c3e5fcc49929675caf": "[ru]材料名称",
  "40c9875bd7978fac4de81ef58a454d28": "[ru]规格参数",
  "ed765ced3449b75aa70a4f5c10ad1334": "[ru]自制/外协零件",
  "4dfbb9aa4ac63454b70dfd8bbe09def7": "[ru]产品/材料供应商",
  "23e0cee4c780d1d70657b0b32005fed2": "[ru]检验测试",
  "2c2aa6cab81f0b72ba963b4c8cc04329": "[ru]检验测试结论",
  "9e8000cd455f4ea2b6793aff2c6d0957": "[ru]根据单项结论自动生成",
  "6c3d4f5a0a2b4d7de6ed3deaa5841213": "[ru]外检判定",
  "542c3a3ec2d96f011386760d7382940f": "[ru]技术标准",
  "4a95f1dad44389dd923b677b7b00317e": "[ru]技术标准结论",
  "ca8668db1e1461091b88cd30fd945a0e": "[ru]有害物质结论",
  "c2cf8689fd0e8203797dbbd7f8475ff0": "[ru]宣告表编号",
  "a7066d14dbecb8438eee7da329399ee3": "[ru]自检提交人",
  "7fa237d83a94fe7209821ea208df1e40": "[ru]自检提交时间",
  "2a93d8a5aab49700f324be988b99d1c3": "[ru]自检批准时间",
  "358341109d9d21e43f9478f6d4fcb6c7": "[ru]外检收样",
  "c730b9c4a45b8f0ba89b636292769251": "[ru]不合格需要填写备注",
  "259b0360082d896ec7f4476163135987": "[ru]提交成功，请联系外检负责人校核",
  "d66647170feb4bb8e040ced4626bfdaa": "[ru]只有不合格才能打回",
  "431040529acbb8f594b4c13e3bb5005a": "[ru]打回成功，请联系质量经理重新提交",
  "14549269b0a467264df7f2154eac1877": "[ru]打回失败",
  "762f7d6568ff7dcbccb00c818e08c451": "[ru]外协",
  "d3bf0339f631f273fed53fab1adc060d": "[ru]新品模板库文件审核",
  "eda1ed64d0b056b855397956d73f02c4": "[ru]模板库属性",
  "d196c72826e21cb830aad6aed32478db": "[ru]大类",
  "e86da95db59395cf9770af483fde29b5": "[ru]盘膜",
  "e3623348d276b8fa54e772581fac9cae": "[ru]材质",
  "5f84a2040ec3476882e06ed9baec08e3": "[ru]胶型",
  "d8861b4035e7616b0650b10f35282a8d": "[ru]模板库ID",
  "1f08ac8f42c807aa697b5c721dd69165": "[ru]说明书",
  "cc14f91613bf7e8f816ff7a6a825e1c2": "[ru]不干胶贴",
  "ec9875c10f408999de612355983da20c": "[ru]工艺",
  "9c5d49bda7000887a8d10670ef1b1ed7": "[ru]用途",
  "79a63d3eb8a197bd61b470fbab1c86ce": "[ru]文件审核",
  "5c1fdc0499d6971eb7111b473f98e6d6": "[ru]模板库项目",
  "603a2318abf247f1630a85069eb46c45": "[ru]是否必须",
  "b93ac8440b8dcf767fe726a42ed6a508": "[ru]）项，不合格（",
  "ac563d7914e241e9346e2f41d9774191": "[ru]负责人审核",
  "6904637b7139bfdd05d311ed3df27743": "[ru]负责人提交",
  "5d38125264a73da673686a081ff94094": "[ru]打回修改",
  "f152313ac12d0d3f8e0281fcc551e155": "[ru]您没有审核权限",
  "af4521b8862b76095560f5d119d3c7ab": "[ru]新品制版设计稿明细",
  "82986e32f727e00d92e77745e709bb57": "[ru]审核描述",
  "7f0a75e23d640925d89a7151c9de060e": "[ru]外检审核结论",
  "77112d99f3debb6b40c6d7dc6f71c1eb": "[ru]外检审核人",
  "16eabef9d8dacf4bf38c671adf4ff374": "[ru]外检审核时间",
  "869d895592a6bc276fd716de5097ad5d": "[ru]新品模板库文件明细",
  "ca663fd1a51a779d74e8c9d6544374e8": "[ru]文件审核人",
  "e280e758fefd483f6755273793738cb8": "[ru]试验委托单",
  "e4dd8976d73873d8b3a5022fc86f14aa": "[ru]委托实验单位领导（签字）",
  "81c8364faab1d36d3d502dae25705bfd": "[ru]企标 标准编号：",
  "cfbd75e3fc6e3340887dba6a36950437": "[ru]实验室能力查询...",
  "d629d0f9d6e112d54853ab2299a23325": "[ru]实验室能力查询失败",
  "ec94f669a10779f265123cfe175fc5b1": "[ru]实验数据查询中...",
  "6c362c2ca98f9457a5f0910615869a46": "[ru]实验下达成功",
  "99aa48e695c7467cb9a6df74982ee50e": "[ru]实验下达失败",
  "a18986cb31f887c1ada79a99ec8b1085": "[ru]产品编码",
  "35cc819ca8799287c139db6b3dec483f": "[ru]可借",
  "4403fca0c0117e8321811bb48222a926": "[ru]清除",
  "63dd6155ebbc17999e33d2e6a0ab8736": "[ru]对标母本",
  "0412a10894f1e51148ba36c347ec03e3": "[ru]参照新品快速检验流程，按照检验BOM检",
  "ec9404953effc0395b940e69ace2e00a": "[ru]检测人",
  "191f21b6c15eb2862e9d0acd1691eba5": "[ru]尺寸见证资料",
  "1005faca0d52b7eab7da8d6553f44ef7": "[ru]*无能力实验项请上传第三方报告及快速报验申请资料",
  "826cbc390628f6a52a5644f7c44e221c": "[ru]对标专用号：",
  "1a5bc5064d1934216a34c7ad6cd6e7d8": "[ru]原专用号：",
  "9e6f2ec2c0e0def8b8a0ce6087804b27": "[ru]*最多允许上传10个文件且单个文件不大于30M*",
  "529ef70f117b975815aa43b4662f939a": "[ru]报告查询中...",
  "32dcc67853ed6ae34a9f0d37ed2141ae": "[ru]请先填写报告号",
  "ef51542dd7d9f6d15dc28feb367f16df": "[ru]报告号应该以HR开头",
  "860c31139e636c2fc05e6dc5faf071bf": "[ru]新品免检",
  "aaedacb2e922bd7a5b98f05e4e6c06f6": "[ru]新品加速检",
  "6af02ad416e5589fcc3fcb9e89d30e31": "[ru]新品停检",
  "ceded7c08d6ac5cbc388ce6648990504": "[ru]明细查询失败",
  "ef3ada7103e6f2a15540beb4bfc344ef": "[ru]请至少上传一份尺寸见证资料",
  "33d74146b3d137addaa23acd51bdfa62": "[ru]实验报告状态为 正常 或 检测-已发布 才能提交",
  "12607e4b2cc866f7a69e84319b26f31e": "[ru]请上传尺寸见证资料",
  "7ca3d20b6df0d10179e222f202da6bc8": "[ru]产品编码：",
  "71659f5eaba3d094009a9be961059e43": "[ru]计划生成时间：",
  "50870b5c342d62e61dad40cafd007ace": "[ru]外检负责人校核结论",
  "67cff284a29663057baa6c1d3043ad53": "[ru]负责人校核时间",
  "ac42ce6b7e74022c9a7a77037b138f30": "[ru]外检负责人校核意见",
  "f3fc633edbae2e1c3841d6250db952c3": "[ru]新品状态",
  "e4e83fc681331d795f06a7099f9fa845": "[ru]物料状态",
  "643fa2316cd848db2e70c79b21d67f09": "[ru]图纸状态",
  "383fd52bb3610e73466991722c2ac65b": "[ru]请输入人名",
  "dc4f216b0284e8c2e72058b5680ef2b9": "[ru]是否双点",
  "035e41f89b4b6678530e83f008503f5a": "[ru]供应商应送样日期",
  "19fde6e4eac33cf5a9befed79c2309c8": "[ru]新品检验计划",
  "7d5e6aa3a1ba494f0e68c41fd8e7c6fb": "[ru]工厂收样确认",
  "476bdff58513bb4384d9dc385d62797d": "[ru]研发收样确认",
  "f501ea53c3dacda1034f8b5c5f1016e2": "[ru]物料结论校核",
  "b0e0d4c7e464a97c86bf750a9ed88b4f": "[ru]图纸审核",
  "717327f61a8d5ef8802eca69da61a263": "[ru]实验数量",
  "027c72c524eae3b5d8b7d564e18ffa0d": "[ru]开发结论",
  "e947ef6cc1adb8a003db48e42a669368": "[ru]型号经理",
  "aeb33d895ba0cc30f8123ff460a96d79": "[ru]对应项目名称",
  "8bd610aa34aeb4cf94d371fef2236562": "[ru]对应产品型号",
  "c521080d3a5c7de0d8de7b179d3a4b61": "[ru]对应产品编码",
  "bdebfb9d9cf51aa41f821d7b2a6890c0": "[ru]供方自检日期",
  "9b5739beaa10baecbc928653d1243c19": "[ru]自检审核日期",
  "b7f7ec8161db69beee7dde3b24d168c1": "[ru]供方应送样时间",
  "b297619e7b724d9e22738b73353f5c94": "[ru]供方送样日期",
  "8b8586eac6d0080f4ca5c6d82f0b9fba": "[ru]外检收样日期",
  "01f2fb3709f5db28bef78c0991cac6cb": "[ru]预计检验完成日期",
  "ef897de9ae383b5f77794a8715f4694f": "[ru]实际检验完成日期",
  "e22e4436620c4e7ada703d3202176ce4": "[ru]是否开双点",
  "34c72e66817caffd316dd317494b542e": "[ru]新供应商首次",
  "38b3f0b01f6b05e21dd8d29bdff6ed6b": "[ru]报验次数",
  "92d37ed9bbc65e45ae193b81d82c7431": "[ru]SAP查询",
  "3f1117987bafa90be3d3bf79f503a7ce": "[ru]QM查看",
  "8e20b70327602db813a03df90b7a9ed8": "[ru]供方计划送样时间",
  "6a52ae8d38d65d94a9673129041ca156": "[ru]供方送样人",
  "0a5b1df588a1e061097183d52c2d585b": "[ru]供方送样数量",
  "195fe52c72f3f8c6be34c497b47c94bc": "[ru]送样方式",
  "ccfd94405616cab3f474c47930246646": "[ru]填写快递单号",
  "5ad67a9e2faec80e40f03e924c59dc43": "[ru]预计送样时间",
  "1bde84c9de69d3fb8ad01e70a14455df": "[ru]送样样件照片",
  "95cc6dccd100504563f588ffa2bee106": "[ru]外检收样数量",
  "07dfd2b0d14db693b9e842cfdb95c1c8": "[ru]检验收样人",
  "296b2d40f689d423ab3dd66889c76fde": "[ru]检验收样时间",
  "20f9d8827d23c3d7851bded420281f88": "[ru]收样",
  "b9bca46ff88c72b2d00059ff9b2ed396": "[ru]收样意见",
  "9ef6672642da46a5ebde23c48761cebe": "[ru]确认收样",
  "73d2659e184ad2720b1dadf7679b48f4": "[ru]样品打回",
  "46e8da056bdca777d47d3743d4b229e0": "[ru]新品流程",
  "0f6634460c8378eb46405d6afad4c330": "[ru]实验流程追踪",
  "2566b6fdfa170399e1dff7feb6cde78a": "[ru]这里是标题",
  "b66a5a5214f34e1e4c042a817d20402f": "[ru]外检实验订单下达",
  "3aa9d9ef4b6973e14519ec1a37189e27": "[ru]自检合格",
  "fe9cbe5433b77ade8db68484af57bdeb": "[ru]自检不合格",
  "612f26540bddbbe41705f80dfd0daae2": "[ru]待供方送工厂样",
  "002d8aec555ce70842bb11318f936af5": "[ru]待外检收样",
  "9ec6d1e0c2004c5f49888ad7dcb7458d": "[ru]外检收样打回",
  "e771189942bf1e33fd504cb61f4c3588": "[ru]待型检",
  "434199950dc930a3c37a8704e92e5abd": "[ru]物料结论待校核",
  "5f870cf3eae682a525fc1d9e7faa7974": "[ru]物料结论校核合格",
  "afcee1719825c03efed9b69401b8eb90": "[ru]物料结论校核不合格",
  "79437e22333ba2c6540785dcc6505bea": "[ru]无标准",
  "db5b1b081eddcc2d18e616a584ffecb7": "[ru]型号经理待收样",
  "2afa2b6b1e3ec05ae85ac424dccf540b": "[ru]新品验证中",
  "9836c4fc9e7c3ccd923e9c38398f07f7": "[ru]待开发验证",
  "4670d511ddd1a8a08afe3dd94c3624d2": "[ru]开发验证合格",
  "94a5b792b84403b3a2d6b1210b62e1bd": "[ru]开发验证不合格",
  "83e1892061e0b1aac61f13d6e8331c44": "[ru]待供方送研发样",
  "27237c2d1f400fd0f84f7f441cf150c3": "[ru]待研发确认",
  "edcde12352579ed9ebaa60f38b5044bc": "[ru]研发驳回",
  "b5604801d0e1a631aea3d1d26bcd1e4f": "[ru]研发已确认",
  "1eed88d4a2282a7a675fb8f3bef615fc": "[ru]型号经理审核打回",
  "86759825d4385b3d8ed0025908076db9": "[ru]型号经理审核通过",
  "14eecb4675218b6a3ab7ac2537540edb": "[ru]流程查询中...",
  "c5f997d45b90a0ac502a8431b5802e83": "[ru]流程图查询失败",
  "e74fde23cc31794e490a94880928c554": "[ru]实：--",
  "a42a12540ed5c0edb159624c70e1bd2f": "[ru]应：",
  "55dad963ce47b01b5587e1a628922467": "[ru]实验流程查询",
  "074cad5276eae5529adbbd3248f88335": "[ru]暂无实验流程",
  "35bb5b9f67afb4c0c64e9dbc2cfe9f63": "[ru]实验流程查询失败",
  "27b4947200edbaa265b87e1de87e9a16": "[ru]打回成功",
  "71935035712588ba6a7d2756d29d463b": "[ru]收样成功",
  "d46b29512328c0f82937a80359505b17": "[ru]供方送样数量与收样数量不一致，请认真核实，慎重确认！",
  "eb518c18f96b62dfa31cde45747c6a5e": "[ru]确定提交",
  "efe3a2151e17cf494a7b79b31e8d60c3": "[ru]'收样意见'不允许为空",
  "57948b8976253507671ccbda37e1fc01": "[ru]文件生成中，请移步下载中心查看进度",
  "6c8d54aae6318f882ca36c6e8628631b": "[ru]下载中心调用失败，请稍后再试",
  "7463152c99c30e6ea8ff42196256ab57": "[ru]样检单无效",
  "425e6ac0840109addb855f98be048d46": "[ru]图纸审核只能选择一条数据！",
  "014b6fda01e20c8ba5622f209992e36a": "[ru]只有模板库流程的样检计划可以执行该操作！",
  "13e177d3c2b12c18c64d821f5cf0faa4": "[ru]外检权限不足，请联系",
  "44199476ef3214c7b12ef7cac7fc07c5": "[ru]只能选择图纸状态待审核的数据",
  "062bff4f6aa40f23d033a126a02ddcf0": "[ru]自检审核只能选择一条数据！",
  "d7fdb6d1c3b6f6ed6fd13c5038246cb8": "[ru]您的权限不足，请联系外检",
  "37f1febd9ee224d3bf21256a4ed195d2": "[ru]进行操作",
  "28d44ce43d287980630e3dffdac343f8": "[ru]只能选择自检待审核的数据",
  "f4d04584a532ae69ffbe39d45a2f0b48": "[ru]物料结论校核只能选择一条数据！",
  "011045518f8e388db700292a9ff0f658": "[ru]只有自检待校核状态的数据可以执行该操作！",
  "3f4541f5047e79989e9c6c43f4fdb794": "[ru]您的权限不足，请联系外检负责人",
  "f5d1c5532dcce3aeaf693d0ddcfd0205": "[ru]新品免检只能选择自检待校核的数据",
  "cb6e9b45ecfc29d1af733ef84bcaae09": "[ru]只能选择自检待校核,物料结论待校核的数据",
  "48912830782470cc5857134034641549": "[ru]分工只能选择一条数据！",
  "6362ae78c77b708307860c7aa3450805": "[ru]工厂收样确认只能选择一条数据！",
  "c99f2807777de0473d1fb510808354ab": "[ru]只能选择待外检收样的数据",
  "a37b04450df52673bb06735d74081db6": "[ru]自检报告查看只能选择一条数据！",
  "86f15460e554addb968551d53312541e": "[ru]图纸查看只能选择一条数据！",
  "ece6b1fbffcab0f39d7ffaf1f824c296": "[ru]功能暂未开放",
  "d9e87444bb4f508ba789e3b0d8e3b4aa": "[ru]检验只能选择一条数据！",
  "0164279f82938d5028437f9baa0dfae9": "[ru]只有待型检才能进检验",
  "b4da3d5dd7a97415b0b80986372e6983": "[ru]异常类型",
  "044a9995eb8fa37655ce9eab8bf289ab": "[ru]工厂不存在",
  "2a7f7ba6b3493caefebbf19273a2b644": "[ru]连线3次不合格",
  "79b7b25d969728e35f87f7c64e41f646": "[ru]样检单下达日期",
  "e8af5c8a32ef0840c47c7082764583c4": "[ru]中标时间",
  "d4f43aa32ef607474ddad4492a4834f3": "[ru]供应商行业类",
  "f6ef08d35df7a465a265e6283ce8b80c": "[ru]物料检验",
  "1bdf6f558f9eb1263e87c3c9fe5e6285": "[ru]供方-自检报告提交人",
  "fa90bfa297d7dc848da99773b14b53f4": "[ru]供方-自检报告应提交时间",
  "29e537a133d4a67b4d224bf99d75e903": "[ru]供方-自检报告实提交时间",
  "d0369226173d7af9468abf95f7a922b6": "[ru]供方-自检报告批准人",
  "4fa8081656262410fe25f38dadb66b5c": "[ru]供方-自检报告批准时间",
  "e0e6e103e2c87c7e7c5a03226d587c9f": "[ru]供方-自检报告批准结论",
  "8b7a5a162942b830d5b7868355f9f719": "[ru]自检报告审核人",
  "08509f6e5a221d7f12852aaaf81c3433": "[ru]自检报告审核时间",
  "21aae0f4fa55c7e1ccc74821973449da": "[ru]供方预计送样时间",
  "b82ccc7824d23dbf6a23550e8c0ab741": "[ru]外检收样时间",
  "8ddd98ea8c1604d7f5a40026c5b7d6e1": "[ru]供方样件照片",
  "b79c2c2ca46c980cddc5577c8c7d260b": "[ru]供方送样方式",
  "0194826fc76658fc273a589852d214c0": "[ru]收样状态",
  "f55ed1536d7552ac5b5af0e0ec249537": "[ru]已收样",
  "59d24d279109b32e1cec5ff0a59214bd": "[ru]检验预计完成时间",
  "212f8bba9d13b569b55e5ebe0b194af4": "[ru]检验实际完成时间",
  "35701b1a6d9b76322ff8d119f30f1e4b": "[ru]供方应提交图纸时间",
  "10b6b78deec63fc39cf930fc4984ff9d": "[ru]供方实际提交图纸时间",
  "270ff3cc55c27268462dcb1be435f07e": "[ru]图纸应审核时间",
  "5a9bd753d29a489cd5b79db0b23fc5c0": "[ru]图纸实际审核时间",
  "74670833f2aec8ebfa4c3fcc8d8a6966": "[ru]图纸审核人",
  "5962362a73afd08516227f7c03471ed5": "[ru]检验校核结论",
  "bef4e672fa8aea92fa0c41b2ee6ec3fc": "[ru]结论校核时间",
  "fa8fb80c5ae113eb08763648b79a2bf3": "[ru]结论校核人",
  "8f64f3e8f07e9b00a0eca21f01a208c6": "[ru]数据查询中",
  "dbd955d91b14ef66d5c48aad043e3080": "[ru]不合格请填写意见",
  "cab978669de417fe325440c388ac4099": "[ru]提交失败，",
  "23928ed42a148cce2253f2fe636b6b2b": "[ru]样检单查看",
  "ae0a6cd4dc95ffac4ef5ec67199d363a": "[ru]物料描述：",
  "100cf1ffb5463c11b5a447658c092cf5": "[ru]资料审核",
  "74efc164b99926adcc8746ded2434e15": "[ru]开发总结论",
  "0f9e7f25f268037327547e57aeae6d4a": "[ru]自检报告提交人",
  "1e91d74546aa6c4473ea637476e8497f": "[ru]自检报告应提交时间",
  "3b3b38dad08af058e8beeb6815aa35b8": "[ru]自检报告实提交时间",
  "05f9e2c7f925879b0a65e11c61e855b9": "[ru]自检报告应审核时间",
  "fba16084b4fffdff164a06e4f7f750e3": "[ru]不合格",
  "a6f05a1df8aa6847742902a687f161d1": "[ru]合格",
  "5f00a767c925cce7674c32811ee23a9d": "[ru]打回",
  "933ab8a51d8119aa7c08431786478d2c": "[ru]供方实际送样时间",
  "0ddd4226a4bd92090a29418b1972ca2e": "[ru]外检应收样时间",
  "cc09e4e1448e3d5a1ca884a76f846cd5": "[ru]供方应提交制版设计稿时间",
  "87dd7ebd36d4b5948f3c5f313dd4e331": "[ru]供方实际提交制版设计稿时间",
  "25586c3416312378ba9c49161a9d120e": "[ru]制版设计稿应审核时间",
  "33f90c1809e0dde6c985bf4bd2b2dc94": "[ru]制版设计稿实际审核时间",
  "935f047ef8b4e85f896e69d7d497604a": "[ru]制版设计稿审核人",
  "044c5a725f39e24a5253e784e48c97ee": "[ru]制版设计稿审核结论",
  "e0cbe57ef236d52e7fa5bd3e9469f82f": "[ru]文件结论：",
  "81ba6fb7bdd608d11a62f36c64d566cf": "[ru]负责人应校核时间",
  "817c4f1106e7b95004de04245da617dd": "[ru]负责人实校核时间",
  "1b7be964f24efcfde45415a360f5cfa6": "[ru]物料结论：",
  "85ab5b4c4d5bc07d47293c99cbc3f3f6": "[ru]开发结论确认人",
  "0159b339fa426e9d955243e870b8ba02": "[ru]开发结论确认时间",
  "5533165b2374c16d0a8d93a70c5d9e60": "[ru]开发意见",
  "dd811bb7db3872285166bbd376ef6d36": "[ru]周期（天）",
  "20ece3e4d1d0b00af4c7c6e2f81acf1b": "[ru]专用号依据.xlsx",
  "bc8fe2d1e2a6424c7a88234c68e32db1": "[ru]制版设计稿状态",
  "21aef4b20ab9d79ef20a4e8e56bda209": "[ru]物料结论",
  "738f945f74701261355a9a9038aee82f": "[ru]送样状态",
  "31c4e3275f4dbe2eb82ae02c7739736f": "[ru]已送样",
  "1c9a150fc31786c2ecba42ca6ae00d7e": "[ru]供方应送样日期",
  "480314fec74c7ad31c65e15658d015fa": "[ru]送样",
  "ef56762cdbe4eb9317ad296787abfb2a": "[ru]制版设计稿查看",
  "10a54b7cfc3ee0b8120adc93e8a76052": "[ru]自检上传",
  "145b2c31081ad6d14147640003961c6f": "[ru]自检批准",
  "65d2b4cc69ee0d7fa8706a074b5b2b39": "[ru]制版设计稿上传",
  "dd3a693650e8cd18af7acf4fef901bb8": "[ru]应送样日期",
  "70c23f9ec38abbfda9cdb4ead0829a2d": "[ru]实际送样日期",
  "733b8117d62ea1566ed893e9d0aaac2b": "[ru]应自检完成日期",
  "793d7e923db847db90796b85c94eac20": "[ru]实自检完成日期",
  "fdeccb03565bc84a3d4225e42063c32f": "[ru]送工厂样",
  "6cde0390f53aa56bfbc28a6576a41055": "[ru]待送工厂样",
  "a422d41b065897069e72f1d2560fbe67": "[ru]制版设计稿实上传",
  "0ea78e42790049d9f9397826c8c07718": "[ru]查看日志",
  "c8b3a9beb5a20cfe42ef990b80b0eb4f": "[ru]操作方",
  "ce6f9d37666ec725365acdf682b3f125": "[ru]操作日期",
  "cde14d8fb1c3b27a5fc67c030f98b646": "[ru]供应商送样",
  "67c83d436e9086e71a2d1440d1c4cac8": "[ru]请填写供方送样人",
  "e56a3f881fb48d3f68ae7cbf578ac285": "[ru]注：送样数量请确保真实准确",
  "705d54db81f6eaf23b9c56eb0b4b40d4": "[ru]快递",
  "98789c2803dd7db3c272916eb1a2afae": "[ru]自送",
  "416ddc927e1406f5e80ae9bac4b50727": "[ru]请填写快递单号",
  "c2e40619f0ce7fd31e3ac102ead76a6b": "[ru]选择照片",
  "711ed4f497816c2d1219e8f76d1fa76e": "[ru]支持上传格式：.jpg.jpeg.png，最少上传2张。单个文件不大于30M。",
  "381a4e1e66828f7b451be3926311aefe": "[ru]实验室派单",
  "de6ecaf5eab587fbc5fe2be3618ff040": "[ru]实验接单",
  "698c44e467a3d91264af8d6afd854b06": "[ru]实验测试",
  "c2620c9a894b90f916e967f938fee9f3": "[ru]模板库资料上传",
  "6f8671d19993689a8ca83bc0eca7cf91": "[ru]模板库资料查看",
  "5224dc5b23899579541c61008a2b0f59": "[ru]模板库资料",
  "c811b6a0427ea764d9cf1c52bff7d0aa": "[ru]打回备注",
  "a14efa27c74b8de344fb306f9e2bc3bc": "[ru]*最多允许上传一个文件且单个文件不大于50M*",
  "a5473898b0523299c9d8b8f715693a6c": "[ru]数据查询错误！",
  "44fa23d8664edf3f7af6178d95cc7c34": "[ru]有必传项附件未上传！",
  "199f4ae28e2c114a0c5368e74d579d5b": "[ru]制版设计稿未上传！",
  "a0884977cecc929a114780560daf7de6": "[ru]您不具备权限！请联系质量经理提交",
  "7037b6ed8fde796eef3c9757e6cad55a": "[ru]您不具备权限！请联系质量经理重新提交",
  "b63bb501dce4e9d14de36228feef0a0a": "[ru]请选择一条数据查看!",
  "a049665892467b0b048c8ac659438838": "[ru]样简单日志查询失败",
  "92b25dcbfe70f7780600c92802ffa488": "[ru]请选择待送工厂样或收样驳回的数据进行操作！",
  "4e529cf79d56c438f1d62ff9e3d12377": "[ru]您不具备权限！",
  "cbbb150bd58f9e91ae9c27dc45b40daa": "[ru]'不允许为空",
  "f46acd2184c364d2d920fdda392ae4ad": "[ru]'快递单号'不允许为空",
  "e59dff3a1da309948ada1d83a0b44cef": "[ru]请至少上传两张送样样件照片",
  "e71a11c45ba66452589198143db14727": "[ru]送样成功",
  "2fe09c5e2f9b6c10edafe92ac54d263c": "[ru]新品检验.xlsx",
  "c1a2bf463dcd58ae2b5032ef458170ee": "[ru]请选择一条数据进行自检上传!",
  "dfd80837bde1624c811df27b978624bb": "[ru]请选择自检待上传、自检审核驳回、自检批准驳回的数据进行自检上传！",
  "a4bada44a9c408d4ca8bc1c048218d6a": "[ru]请选择一条数据进行自检批准!",
  "e3993a0db14e060546e460e0d7a0d243": "[ru]请选择自检待批准进行自检批准！",
  "fbddd51d87a9b798193bda360b4ef671": "[ru]暂无制版设计稿数据！",
  "73a6033da13e5c531a4a0bbc78e8678d": "[ru]请选择一条数据上传制版设计稿!",
  "b4e18d6e679381f05e9825da33bc8860": "[ru]请选择新品免检的数据进行制版设计稿上传!",
  "0ad2500c989bddf84cb11d9daba2412e": "[ru]请勿重复上传制版设计稿!",
  "2ee8586bacb0d0b29fcd45c0288c5f43": "[ru]请选择一条数据送样!",
  "a72197fb103f478c2836146341851806": "[ru]暂无送样数据！",
  "0985401cbacaabafcfe3365628af9393": "[ru]产地：",
  "ebd4ade3e13cb533ba22e82e8172e47b": "[ru]注意：二三级物料包含供应商自制物料和外协采购物料（必填项）、说明：I级：供应商自制II级：供应商采购III级：供应商的供应商采购",
  "61a26fd20db8541f06a7ff277b5d75f7": "[ru]不合格原因",
  "85f3189774581e5dcd697cfced4251d3": "[ru]添加一项",
  "2e64fa07cef87c82c0adacb0dc31a75f": "[ru]注意：检验测试模块只能保存填写完整的行信息。",
  "95b351c86267f3aedf89520959bce689": "[ru]编辑",
  "1470d600e4e06f5ea0100fc0bd2a363c": "[ru]报告出具人",
  "ce5be64e3ed4f800b03b83d527bfadfc": "[ru]注意：技术标准模块只能保存填写完整的行信息。",
  "f893acad539b7573e24937852be3ecd6": "[ru]注意：1、请填写外检审核通过的宣告表编号（首页-有害物质-RoHS-宣告表）2、如涉及到REACH或毒性报告等，需上传附件。",
  "97e203313843643e68a5225ae227359e": "[ru]宣告表详情",
  "833e219602121ac56bace95cf6806311": "[ru]我司承诺提交资料真实有效，否则愿承担相应责任。",
  "809d202445fc06a46b04ac9e030cce30": "[ru]自检报告提交时间",
  "906ec6118874910a54fe78a78ad83b7e": "[ru]质量部长批准结论",
  "4c07c7c2e7d50070e864c66bd9b9e21c": "[ru]质量部长批准时间",
  "6ea134b93bc09696acf1b5a29777d3ad": "[ru]*请注意文件上传的格式(pdf,xls,xlsx,ppt,doc,docx,pptx,txt,png,jpg,jpeg,rar,zip)，文件名中不允许出现逗号，文件不大于200M*",
  "3365f22fb92ca9e0c7acfe00767d0c23": "[ru]新品报验批准",
  "c8fecf8b1438559e9914fbc473c15ae3": "[ru]批准结论",
  "7435bdcd1a5956a38b04f15fef15d086": "[ru]不是有效的宣告表编号, 请输入外检审核通过的宣告表编号。",
  "abee8ba959290abc34b8cb12bd4f46d5": "[ru]二三级物料导入模版.xlsx",
  "a1fa355af4de9de33a401ebb044bffb3": "[ru]数据查询中，请等待...",
  "e9666b0e4405da3fe0aa1c46b2c42700": "[ru]提交成功，请联系质量部长批准！！",
  "04863f191ef8f2b2b6c60a787213a611": "[ru]勾选我司承诺，并且提交",
  "70896fd0dc60a7d9a5ae22217130ba33": "[ru]请确认是否保存",
  "bf8fa96b224c11bc9ec04def0304ca26": "[ru]，第",
  "860622be568ef6ba9ce20b0da1baa698": "[ru]行中，'",
  "ee68958200b067557acc666757b4bcaa": "[ru]'不允许为空！",
  "911b9a994284ec787f4f24d6f25f3fe2": "[ru]I/II/III级",
  "7a2da0b634d265ea106f5dc6b670cb54": "[ru]请先选择产地",
  "7f8d2de5a7210365dbc66eabdbfc0315": "[ru]模块商编码：",
  "7d652e44d79974973925e54ae93c8393": "[ru]模块商名称：",
  "e9578dda62b775c828a9cc05e05bbf61": "[ru]自检类别：",
  "cfff4b0c9ca7597fcf9d6e88d6aaece1": "[ru]产业线：",
  "acea584c9d462f33c473cd327b1fafdd": "[ru]自检应完成时间：",
  "1be8b03ef2808b91ee3198b2fd219167": "[ru]文件状态：",
  "adfeeda281aa7bc55d1e0da277c87538": "[ru]自检校核驳回",
  "508477ae34698ffece847464ca2539cb": "[ru]供方制版设计稿提交人",
  "ed158b5b8cf3beebc4e770762ad0cdd2": "[ru]资料库状态",
  "8e808f51e7025756613a867dee579ab3": "[ru]模块类别",
  "58e34bb503890b10f69243b88dbf8557": "[ru]资料库文件",
  "cfdab880d0419e67bde0b21ea84f192f": "[ru]设计稿状态",
  "7a712b9a4574166830b69a07ce78056e": "[ru]批准",
  "6e1f2b26e45ca8f4db473a426446d3e6": "[ru]不通过请填写备注说明！",
  "980d3f78d2864cfaac910e12f4f1442f": "[ru]请联系质量经理提交！！",
  "4e19ab5c19c7a68a759cebf044abe3eb": "[ru]请联系海尔方审核！！",
  "3de8595b2d04a698b8dd68e9c964ee0f": "[ru]，有",
  "ecc2661c26065854bcbf5ca8153a14cb": "[ru]测试认可-检验标准",
  "f1728af6ff0737b74b63d2238de7b5ca": "[ru]待送样",
  "533c77e44a32571f6884f699a84b0a56": "[ru]衍生资料模板库",
  "a66103b6a51221b9341e695ca1f7458e": "[ru]新品质量-图纸",
  "3d2b8f26985da529d76b6d898ae3b6fe": "[ru]RoHS宣告表",
  "397b239eeb88a8796b1f8bbf58de351e": "[ru]质量部长驳回",
  "1528b37e0e4ccb55ed708b9f1fbf1dbd": "[ru]海尔校核打回",
  "3e269bfd5b2d084877f3cf2566229e07": "[ru]RoHS报告库",
  "563a074d504b50767d2a52844ba7d4b6": "[ru]<p>模拟 Ajax 异步设置内容</p>",
  "cdd6fe7d2f5b543696d8841e2abd2315": "[ru]请输入内容...",
  "9970ad07468267e2f309f1467c75bb80": "[ru]主题",
  "8915845d00976200bea46b0bfafa3bbd": "[ru]系统通知",
  "a1e95935384f2eb9eeb3ec9b4fde6759": "[ru]案例分享",
  "7e433388e035bd9bc82d0d3262528f7d": "[ru]知识库",
  "f5862129118bd928672e3c5eb21ad095": "[ru]企标通知",
  "c9663c9542537c0cfa5041212958016e": "[ru]周期检验计划",
  "be28717bf623b239f90ebdb0a5bd92fc": "[ru]下次周期检验时间",
  "f4bd12ebcbfff36b00ba892656234bd9": "[ru]抽验频次",
  "bff0de47c2d6d46eee89e9bf550de748": "[ru]周期单号",
  "47e09a605af90f7d654e1b010eba8201": "[ru]创建起止日期",
  "7e6d0bc30b06b8055c959914308b4d7e": "[ru]周期检验任务",
  "7311f09a7590e926a38cb96674a80ee5": "[ru]实际送货日期",
  "25645d02eab065e2b87bfa9a399b70b6": "[ru]任务创建日期",
  "af4f975c3310f3ed252fe6419ce6115b": "[ru]当前用户无操作权限，请联系",
  "b47e122b70b9de559f1c611d822243b3": "[ru]) 进行操作",
  "52d7968c58943cace1c6d85ef08b7870": "[ru]系统异常，请联系管理员",
  "21fa3c755c12813d7b2a370b9662d016": "[ru]周期检验任务导出中...",
  "eb7b006e251108f0b00325303c9512c0": "[ru]*请注意文件上传的格式(png,jpg,jpeg,gif),文件名中不允许出现逗号，最多允许上传一个文件且单个文件不大于30M*",
  "103caceb21d1ccdd2246924b0e82745f": "[ru]母本",
  "26ad3deafd5c80376a2b682bb61a0cc4": "[ru]周期验收记录单打印",
  "b3b14d334f3fc995b1abe3b8d44e3a5b": "[ru]PPAP适用性评价",
  "13667f31c58766d157ef45c4580b87f6": "[ru]修改历史",
  "d316330b742ea7b420665a3df7ec374d": "[ru]阶段",
  "5a0397a0d8242ae4786400e0940b7046": "[ru]PPAP要求项目",
  "18eba50a63e54f245e803da4fb65fd84": "[ru]海尔端角色权限",
  "ead1b501527ef31f0e6d779d10d27f00": "[ru]电子、电器",
  "5fc9de04f6d3fe83c71a09176fac2e1d": "[ru]塑料、钣金",
  "2ab123036ccd25685fc06fa4dac80448": "[ru]包装、印刷",
  "fd05ec99e6c85414f2bc1c2aedd9497c": "[ru]辅料、螺钉",
  "3bbbd69361578314fe25b9371ae68042": "[ru]新增文件清单",
  "3eb25280452a44644cc8137c9b3c247d": "[ru]第一阶段",
  "c3b62511ecfaa5caa454304f2cd60ad8": "[ru]第二阶段",
  "385fc63a49de9576e68c1838efce62ce": "[ru]第三阶段",
  "b7fcfaf05a772a4baf2e9509d9f434be": "[ru]第四阶段",
  "1f4922976cb776e5d302cc4813d01f2e": "[ru]使用文件名",
  "3c11535b5271962327a48d5fafba2dac": "[ru]项目序号",
  "2d070f6fcd3f4787512ac79f9b05ecf2": "[ru]文件清单历史",
  "a6f9f534bb85d3df5e1c3f8ff1561669": "[ru]请先上传文件",
  "0050e7fcccb5506f3e2e9ba240196f0e": "[ru]文件上传中...",
  "0485aead504350668166e85d02f48115": "[ru]请选择数据进行删除",
  "b762e60fafb10bb1247d210c9ac9f6fd": "[ru]文件删除失败",
  "e7f300df521157639e2ecc586af5efef": "[ru]数据更新失败",
  "9de789482f879b5df8c7355c7ed0c45b": "[ru]历史查询中...",
  "edcbcceb3beb1ff36424d7e7296b8e74": "[ru]历史查询失败",
  "3a420f8818cebe6cfd1f7a0e804a2ef9": "[ru]PPAP适用性评估报告明细",
  "cf6ea1baa52799e6fd50bae579004503": "[ru]物料基本信息:",
  "424063a13488ae654f8e77f2e799c88e": "[ru]项目名称:",
  "d9dc618e2d645a6717bb6b72837c1ba2": "[ru]图纸:",
  "5bd1a4c34d0b6c92521962fb9b202add": "[ru]模块:",
  "94d550539c46eaa8ebffb27af4e552a9": "[ru]图纸版本:",
  "0d399c2b57594c204b3539658922a6f6": "[ru]海尔事业部:",
  "3b8b8fe43ec8f6ce293e3296fc609f50": "[ru]新品下达日期:",
  "c360590c779e1138a42c9d8f35938e56": "[ru]物料专用号:",
  "fc15ca6dd8d6225352885c6915429466": "[ru]海尔SQE:",
  "fbe26342011ea01a7a7a1f733a3a5a23": "[ru]开发经理:",
  "e66a355f3c6eee59b0fcc69addf26c7d": "[ru]适用性评估说明:",
  "4c2a45a4debb69e281eca6b6a487c117": "[ru]是否为全新物料:",
  "64f68aaf8399cfc06a7e04ee9c56f885": "[ru]是否为衍生号:",
  "7dc89074d77b06353c5da176d1ec1ec7": "[ru]母本号:",
  "234a083412c8b997c2df1c2e83462111": "[ru]是否为主关件:",
  "c436bd21dd2a128300f61f9a4d5236cd": "[ru]是否为GEA品牌等特殊项目及模块:",
  "26519d5b94a2a2b6fb862ea7deca00bc": "[ru]是否为市场损失大，产线评估需要重点控制的模块:",
  "c3b1af42cd0c4df2d8f7f906e49bdbeb": "[ru]适用性评估结论:",
  "b4a02eea14f47a8b387883f759530577": "[ru]需要进行PPAP验证",
  "8f29ade52dff8a62013548a6c4f4859d": "[ru]不需要进行PPAP验证",
  "4453839356561ed8351421d373d577b4": "[ru]SQE评估:",
  "e41af60f5a6e586d9c365f228824f3bb": "[ru]签字:",
  "7501567af9e3ab38d02ed6e2420a7225": "[ru]日期:",
  "349c6e7f74e0470e70f06d2761ea80ee": "[ru]评估意见:",
  "d068e71bbae2dbea6bbd4518fceaad2e": "[ru]PPAP适用性评估报告",
  "7be4fdb51d3505b2454a82efadea95d4": "[ru]数据明细查询中",
  "aa148f2467dc65f528e1f463e7204a8e": "[ru]数据提交中",
  "52867004f0d1aaa808a747a24a3f5b1b": "[ru]PPAP适用性评价提交成功",
  "d5dd7d654e5c3c0196456f260c804259": "[ru]请求失败，请稍后重试",
  "100a5de2f59600b678e5cd461f16c54a": "[ru]SQE接口人",
  "ccc283935d96abaa8e596aae9e7460a7": "[ru]评价状态",
  "a273806230179b4d5195ff389352a4b6": "[ru]SQE经理评估通过",
  "8d26c107fcadf707adc1de3964879272": "[ru]SQE接口人审核通过",
  "f600bcf6a5f3fae8c785298411bcc066": "[ru]SQE接口人审核打回",
  "0412ae66146f048687481e8a52a91d71": "[ru]不需要做PPAP",
  "725aac5d3fc7a09c17056e7d9a7c5ae1": "[ru]批量评估",
  "a48d8212746f19fa505c68db2f40c09e": "[ru]适用性评价状态",
  "fe8ddd4bf179f4ea34f473dd9d379dd4": "[ru]暂无SQE",
  "20eba8965371e944305faf592b574d49": "[ru]评估请选择一条数据！",
  "30335a1f0b3227f874e5a95fa01b723d": "[ru]只能选择待评估或被打回的数据进行评估",
  "effc60a3da0fa4d4201d96e7cfe6799d": "[ru]SQE经理权限不足，需[",
  "2f6c03174f6d838bed04a7c8dd2adefc": "[ru]SQE经理权限不足，单号[",
  "8ccb099fea6909e5efa97e78c711aba9": "[ru]]需[",
  "2e06ef8b3802c82ab4bf1be4fe1c96e2": "[ru]SQE负责人权限不足，需权限[",
  "7c47c24ceacc2a85edd61a93da06ba7a": "[ru]请选择SQE",
  "0e1bbfc7b5c6597d8d0941ef61958cca": "[ru]待办查询中...",
  "cac93db486636d28f9604b67a6c30a92": "[ru]批量评估成功",
  "23cced475e9cd9eca8c1a40fa3ca3cf6": "[ru]请输入工号",
  "18e47ddfb4b1c01cef46ef12a8aecdec": "[ru]PPAP状态",
  "ce91e71085bbb53294bc5d42dccb3ad6": "[ru]应完成日期",
  "37364a5eaeeb6d3e71f37db67e3d6240": "[ru]新品计划不合格作废",
  "fc5ecc71980d4cc4fda19b68c36ff24f": "[ru]供方自检待上传",
  "ec0f21e9a413fbf6981b9493f491a0f4": "[ru]一阶段待校核",
  "f36eee9f74af1265e1432aa8d16f162d": "[ru]一阶段校核打回",
  "0ba20a53e30704b398dd4860007f38a7": "[ru]二阶段待审核",
  "8ee1ef6733881283d7f5e377c0099e6d": "[ru]二阶段审核打回",
  "5dbc0e98a1fe504621f94e7856d19d6e": "[ru]三阶段待审核",
  "f127f73b1bae123e2970a5221776a0ba": "[ru]三阶段审核打回",
  "9f2d6bb35d511ea1454aa384dbf3c098": "[ru]四阶段待审核",
  "ad348437522cc104c998cea0b68e373e": "[ru]四阶段审核通过",
  "79d049eefefcabd2f4da4be4ac4e2d37": "[ru]四阶段审核打回",
  "0737ae75a2dd50d9768cdb884441e6c5": "[ru]待发布",
  "482bc9be1a99158278c87b6fe698bcc6": "[ru]审核不合格",
  "0cb4d0f2885776a1ebe7fa9c835fc3c5": "[ru]校核不合格",
  "da75e56f9912c83e7014974e8d36f2bc": "[ru]您不具备权限",
  "a79ea7ff86447e95351399da1900da98": "[ru]权限查询...",
  "83611abd5f806cb2db7cb992e91186dd": "[ru]发布",
  "966e7cdd840bbbfbea1299df9007fde5": "[ru]系列",
  "e3452eba8e848e0019818a56062c7346": "[ru]标准评审(一阶段)",
  "134ca59583858032ddafd01199eb3dd1": "[ru]一阶段待提交",
  "c0eee4469985714eb439737ef65f3914": "[ru]一阶段待发布",
  "23722becf2ec2be4038c05158d2675c3": "[ru]注意：过程控制模块只能保存填写完整的行信息",
  "5b7fe94eb8c9dd382866a54435a9680e": "[ru]是否提交",
  "8ac399bf0a389c62337625923649b685": "[ru]过程控制(二阶段)",
  "62b7467cd12515fe99f13c1de3467b49": "[ru]二阶段待提交",
  "37d0b6e16a5d4a1f7d49e33d4a4e6aca": "[ru]二阶段待发布",
  "abae9d71c5e25a5655320875b4008e2f": "[ru]二三级物料清单",
  "cc457a70b129995efbebe2217b0f441d": "[ru]检验测试(三阶段)",
  "0f54d33972d848d109176079002ce401": "[ru]二阶段待校核",
  "d44e607f716209d68d46f0893573765d": "[ru]三阶段待提交",
  "bd984b2f1c602bdfe4e0ac85fbc08c84": "[ru]三阶段待发布",
  "412b229f1c250942327245f08107154b": "[ru]PPAP批准(四阶段)",
  "3bb42fb3bde4e184bdc1f15509ceea30": "[ru]三阶段待校核",
  "d185247bb225dc9262c4ed96ea4f9e26": "[ru]四阶段待提交",
  "7f6f3d244f368e2a9922df729eba0488": "[ru]四阶段待发布",
  "15efc64c8e8760bc029f83ee59efa351": "[ru]文件下载失败",
  "f431bb4d3fbcfaa6a4b81656353752b7": "[ru]您没有权限",
  "f6d82db21bb1cd18e55b032c931564f6": "[ru]阶段信息校核中...",
  "2bf129c11ead652c5877dbdbf2dbdca9": "[ru]阶段信息校核成功",
  "e384d8a4b57ec431f652abf54006256c": "[ru]校核失败",
  "62f0a4475c709e26de8f34c82bc23d40": "[ru]阶段信息",
  "06e42f074ce85f3e30fee119a5d491ed": "[ru]行审核打回需要填写备注",
  "33a27ce63557fbc5d3fb6b163b03968f": "[ru]1.是否为全新物料?",
  "0035214fc61c2df770dfb691a9a8bebf": "[ru]2.是否为衍生号?",
  "3f82485214cdeac81f7e4c5f8986ceea": "[ru]3.是否为主关件?",
  "b3a6da80f5f6b06d734194bf75424c69": "[ru]4.是否为GEA品牌等特殊项目及模块?",
  "6139aff0565d406c904b81a514e856f5": "[ru]5.是否为市场损失大，产线评估需要重点控制的模块?",
  "3fdbff5fb33202e37efe7ee12a25a3f2": "[ru]型号经理收样日期",
  "b4df83ecd83bb48345deea3e67527cce": "[ru]文件清单",
  "402b4d145a29cc0cddd6c5cf70ccba8e": "[ru]PPAP适用性评价.xlsx",
  "cd634a2b4c9d2ca636c2cb4dd74a357b": "[ru]PPAP审核通过",
  "dbd50d982590555ba1a796939ed3025a": "[ru]您不具备权限，请联系质量经理进行提交！",
  "572025dd8eb3bd12e116ee4c2fba388c": "[ru]您不具备权限，请联系质量部长进行审核！",
  "f7a8825ce6af26bf22ad6ff332d52406": "[ru]注意：标准评审模块只能保存填写完整的行信息",
  "f2f6965f535dc9b2e0c14ad1fe521d5c": "[ru]海尔校核结论",
  "6dfa721bf8e1c030997a72faeb4f5310": "[ru]海尔校核部门",
  "8fce8f8923ab0343df4f1a0eb374a839": "[ru]海尔校核日期",
  "6a64cef2c9cb2c04294df46180ac44b5": "[ru]海尔校核记录",
  "e24db6254b0f2d9a44f1fb23e0af1cd3": "[ru]注意：二三级物料请先保存后返回",
  "a3014170b8e17131ab796f2c555232c2": "[ru]注意：校验测试模块只能保存填写完整的行信息",
  "c86bb3a1ee637dcd53ff09712096fdad": "[ru]注意：PPAP批准模块只能保存填写完整的行信息",
  "1fa3b4da2615f089fd31e473dc45c8d6": "[ru]二三级物料模版.xls",
  "bd08bc882566e593d5b65e04ef64dbb7": "[ru]校核部门",
  "5a98b64b0d0c8c704b66d494ea784ab4": "[ru]校核日期",
  "8cc060fe901a77ab411cfb727b7737f2": "[ru]海尔校核记录查询中...",
  "8318ed1b717596337d72e5ba947ac668": "[ru]海尔校核记录查询失败",
  "08f0a82aa36c318dacdedcee9b806277": "[ru]上一阶段未提交",
  "3f857eda07a6620e08718c1b8006c989": "[ru]阶段信息提交成功",
  "fdba238fda77ef87e8078ec2bff6bab3": "[ru]阶段信息提交失败",
  "5e4ef330d5b9bef23a1dfd3a061ea0e3": "[ru]阶段第",
  "b9aefc41bfc3eb9e300a2b701c93d776": "[ru]行附件不允许为空",
  "20695f5c7b95247cbf2eb10b2f801392": "[ru]二三级物料为空不允许提交",
  "818271f0ff1329a5a9861667f49fb393": "[ru]二三级物料第",
  "c417fea71ed52185abf98c5491966b49": "[ru]阶段信息保存中...",
  "7d38dd0a52a64fdfcb285ec5d32c0c82": "[ru]阶段信息保存成功",
  "0e7d5040053dd3beb2dfcb80a3c9709f": "[ru]二三级物料保存中...",
  "bcc4a63d7ead76d6dc740e5711a6a3a0": "[ru]二三级物料没有数据，不需可以保存",
  "cf9d30c657186638082beaa10994f001": "[ru]二三级物料保存成功",
  "30d81c0e90b14603b20b5bdc6e139791": "[ru]二三级物料保存失败",
  "72649d75afec4f4ddbc7987cf765bcec": "[ru]已打回",
  "ecfa64c174d344d58f31a839c26bd7f9": "[ru]已通过",
  "419f6a8037e450ae67f8716acf6171ff": "[ru]阶段信息发布中...",
  "0851d90e3305a8a8e5aacb84daa3702c": "[ru]阶段信息发布成功",
  "250688d7c9bd56b8ab11592fa83d670b": "[ru]发布失败",
  "107baa8ea76589b7a73b782a2e93bc0b": "[ru]维护",
  "6b5b9ac50c2247bc1c2deb89427a4e16": "[ru]二三级物料为空不允许提交，请先维护二三级物料清单！",
  "ec07d69d1e8351930d42d6c984bb4e4e": "[ru]问题编码：",
  "d08dac6aa3b35afb0f9d03a94d89d485": "[ru]产业：",
  "a737f7b5e7d60775ce5e602200d93d59": "[ru]品类：",
  "d8a3eb6a25463300adc18145fee803f9": "[ru]型号编码：",
  "71a1bc186b06397474e4fa3ab3f1b0c4": "[ru]型号名称：",
  "ef26a1fb19399370abc278c0d925a299": "[ru]上市日期：",
  "8cab09760948ba5cf48bff05c1ac1821": "[ru]故障现象：",
  "44a6d37c6a3bd3c22dd297109fc7984e": "[ru]故障对象：",
  "9b8625fcdfa7a1f29b7fd62771c60d2e": "[ru]不良数：",
  "a7ed0a8addd39bf67667705cd8232c9d": "[ru]图片：",
  "1ab854a6c5e44cf872a67c8d6ebfcd7f": "[ru]登记时间",
  "7573bc975256743573bfa34f3dfbb498": "[ru]实际服务类型",
  "6cea890c808b958b0e810f65f02cca6b": "[ru]整改信息",
  "0930f58e63ea8266cb6b05d10a18cfeb": "[ru]原因分析：",
  "3fbd2f0ddf71b3917e88b12b05333c8b": "[ru]责任人：",
  "971a1f056e9eebbd1e2cad935f770a57": "[ru]整改措施：",
  "6a484d5d1f047b9144f6afa90d1a4a26": "[ru]整改人：",
  "4557608d97c71092a27c03ba7da249f4": "[ru]整改提交日期：",
  "855ed5486087cc4d2064b64d4ca1325d": "[ru]措施到位时间：",
  "de43b17725ec9b8096e4c1c3ead55798": "[ru]问题归零信息",
  "c9fc7f167d986b801fba2c66611f19df": "[ru]问题归零次数：",
  "cf88713eba227fbfa0cb67e9ff0f9827": "[ru]问题归零：",
  "6e4fa32739233e513c5d34fef30d2644": "[ru]终端回访及评价说明：",
  "0193c68433325b78e48f38bb546ee3b1": "[ru]品类",
  "ad635a95657a8ec8bf7802706951324a": "[ru]型号名称",
  "d2d1c63c68aaa20ec0c8c593648061e4": "[ru]是否闭环",
  "2ace607d80da0535ff9987d2d66bab63": "[ru]问题详情",
  "4cd514f974e7a7ab1181812cba4983ab": "[ru]问题反馈",
  "145396d399addb577c25efa0e21eed76": "[ru]责任分类",
  "f5edd796f396bfd962ee34bad50a11ac": "[ru]问题来源",
  "0729569f1b8d511876e232eef601034e": "[ru]未必环",
  "6f8a1ced4590d6f80a5039cc19c10241": "[ru]接收处理",
  "71c1ff3fa9744d7877d93d2f60e4ae9c": "[ru]问题归零",
  "3d58b295fa1fd1013162a6f1cb80d652": "[ru]请选择问题状态为接收处理的数据进行整改！",
  "c73990590a70db02e16c0546ac62260b": "[ru]原因分析不能为空！",
  "a2b3e415826b8ef8865c7fb2eaa16825": "[ru]责任人不能为空！",
  "646b1f9455c865c7cedb5023ba4ad9c3": "[ru]整改措施不能为空！",
  "9df6f2a6fca7ae8d498a75b22c61ccec": "[ru]整改人不能为空！",
  "723486394a2c4a1e561f57c962b056b0": "[ru]措施到位时间不能为空！",
  "199c964f4a5d7e530aa49aa1cc5c4092": "[ru]整改成功！",
  "76f8f12c36f57e34cff5731319047c27": "[ru]自检类别查看",
  "8d9f47978f4750523eec9826a5c68f2c": "[ru]供方自检类别",
  "c6c178c0086141c34afd40c2d3ac3a8f": "[ru]基础数据",
  "49e97380fb91b87cbaa463f6ea709bfa": "[ru]*必填",
  "af119ce2cbac886550bea1d961d292ca": "[ru]自检类别不能为空！",
  "05e3432fb31ab926625dc3c52d4ac217": "[ru]自检报告类别",
  "b759b942f26a060b59dd7ab95f26a24f": "[ru]自检报告名称",
  "d9f0e0a87fcc27524e4d4fbf1e9ca9b6": "[ru]自检报告名称不能为空！",
  "04d815a5d4b803d6bb956d2da5a82688": "[ru]是否必填",
  "b49c63fa871a242672520014dcb31c99": "[ru]？",
  "665d7776fdeab69fe6d513479a9a8334": "[ru]供方自检BOM",
  "73012c95c021fa86514ffccdef4a3a3b": "[ru]入场预警线",
  "dc4a1e90d1e4418c6a7aac25c5509eac": "[ru]入厂跳闸线",
  "cb5f3bfcd9ea855966b14b0e2a96ab3a": "[ru]现场预警线",
  "c2714316f6b8d2b375c187b2feef568a": "[ru]现场跳闸线",
  "bf9fac9b327ec4c758ecc2369518e0f5": "[ru]市场预警线",
  "685486daa5bb1a67649f686a20acf196": "[ru]市场跳闸线",
  "b7ad914406810924d9ae8450153c7417": "[ru]入厂预警线",
  "e843eee4df06d880b9f599bb47cf6c54": "[ru]供方自检BOM导出中...",
  "49a76ce2dc9ca733346b0350c0721abd": "[ru]物料大类不能为空！",
  "eee34ef16ca42aa3a57171ee83dd514b": "[ru]物料组不能为空！",
  "5963b87cab0b6ceed577c725f6fd80d2": "[ru]入厂预警线不能为空！",
  "45384db0a3e23d9efb3861f00d9cb8bc": "[ru]入厂跳闸线不能为空！",
  "c7ae3948e95d54d8ae00915cb3c67410": "[ru]现场预警线不能为空！",
  "864fa5fb954c0438d920e7903c07a934": "[ru]现场跳闸线不能为空！",
  "389db0fa1ca2c01291e651fd548cbf96": "[ru]市场预警线不能为空！",
  "db5b9dec52ac8a15cb5a03037a18f914": "[ru]市场跳闸线不能为空！",
  "506b4a1b206d499dcf26bc0d89200a2a": "[ru]新品检验策略",
  "71a9f78ccd44589f82cf3255d52599d7": "[ru]PLM物料类",
  "2c887c02ecf145a2f61fc5fa98cedc46": "[ru]PLM物料大类",
  "ff509f89196dd89dff4ccdde326f9a97": "[ru]检验策略维护",
  "fa3844763516183d8e9847034f718bf0": "[ru]供方检验资格不能为空！",
  "bac6ab4c6aecb604a63c956c9687c203": "[ru]PLM物料类不能为空！",
  "48be78fa6fb7cc22c57a29069f170c82": "[ru]产品线不能为空！",
  "40d64d55497c0ad326b0746742506377": "[ru]检验策略不能为空！",
  "f42263b896e0665d8c2a0b91ee29ebf6": "[ru]检验策略审核",
  "3a158a47493850e2cb079686825a82ac": "[ru]检查策略：",
  "069d710c7cb4fcb5f8c24e6ef2c6cfbb": "[ru]PLM物料类：",
  "3044575ff0905d5fd0860e9ac7707f26": "[ru]产品线：",
  "bf76c7c7a8c46ec86c0a438021c33272": "[ru]创建人：",
  "312f45014aa0dfbd72e0597b3b82c88c": "[ru]创建时间：",
  "a168975c94c6cfeec032dd015ab7f2d9": "[ru]更新人：",
  "780fb9f3d026e685c8b68ace23fd51ad": "[ru]更新时间：",
  "63903ae653e6b7c5c026eb772e7d2310": "[ru]请输入审核结论",
  "971129ffba70d78d3e451260710fbc08": "[ru]请选择未审核的数据",
  "962e5cef79cfd0a3f44d6736bd24c938": "[ru]检验策略查询失败",
  "c1a4e05f89ddacd8b377258dd0cbc8cb": "[ru]供方检验资格查询失败",
  "c8b9f29e2ed87e0775c39b54de548f56": "[ru]PLM物料类查询失败",
  "4fcdbfe56e37c51ba9012fc8d7271cf9": "[ru]未通过",
  "53a33dee8e524f459157b8138daaeaf5": "[ru]修改QM信息记录",
  "476876f5e0299f42de48e08784b55ef7": "[ru]限制数量",
  "67c600624b20de386468083c53faa346": "[ru]申请修改数量",
  "adaf94c06bccba9300458195660223ff": "[ru]执行结果",
  "7c204d4b8f9566efcb600724f0d04edd": "[ru]只有审核未通过的数据可以进行修改",
  "c76b70bd2ab2f40c755a2f3cc126d53a": "[ru]没有修改权限",
  "d4c9faf52b40a75994e93d8186196f32": "[ru]只能审核待审核状态的数据",
  "dbcb5342bad83b9e1d905a63d676e95f": "[ru]没有审核权限",
  "5aa34e09391008ca0750714a82ac4247": "[ru]QM信息记录审核",
  "41a70d9b3a1ccaaf3974fba4cade9b8a": "[ru]调整申请审核",
  "c480e3d43091e496a1831de2c2bd2a1c": "[ru]限制物料数量",
  "56325b65be0be68dc6d0b020faf28077": "[ru]承诺：",
  "e0f1454a81b945156d03087ca25522dd": "[ru]1.保证申请修改订单为新品样机订单/QM200台数量限制订单。",
  "9b9d41dfd7f876d3a4f773114197ed9e": "[ru]2.保证申请物料质量风险已评估并有完善的跟踪机制保证产品质量。",
  "e5289afc83d08845504441c53d7a3157": "[ru]审核状态不允许为空",
  "06bc3a22cf53bbd0c1d38c8f0ea2ffb9": "[ru]审核意见不允许为空",
  "ba190d1259e11af8c487c826007081e7": "[ru]QM信息扩充申请创建",
  "64cbef6bf94607c85133c20229ca13cc": "[ru]请输入完整专用号",
  "521f572ce178dbede1ab63c85c5650e4": "[ru]下达激活控制",
  "6183b1790f1533a870e63b3b9e4b2e0b": "[ru]不检验",
  "889d6e56f6c631a751ad76f981c5b028": "[ru]1.选择专用号，系统自动带出这个专用号对应的工厂小微，供应商，限制物料数量信息。",
  "b7722ccd67ded8f1698e5649ce35720a": "[ru]2.系统自动锁定工厂小微，只能选择到自己工厂小微对应工厂的专用号供应商在SAP中有数量限制信息记录。",
  "cc77331898a4a95eeb90ab5e266716a8": "[ru]申请修改数量不允许为空",
  "29ea5f7a6a103d3b2bb81f5846903249": "[ru]修改原因不允许为空",
  "138bcbef4c16b7a85c1afb0e158c4f1b": "[ru]QM信息记录修改",
  "b9f08df400290a2161aed01c9abd3643": "[ru]调整申请修改",
  "78dc44a88fcac093def623eb58a236f2": "[ru]QM手工扩充查看明细",
  "7fcd12523601d16fba51bfcdd3853be9": "[ru]QM手工扩充",
  "3186bbccda129450c211496c7020cd5a": "[ru]*请注意，最多允许上传1个文件且单个文件不大于30M*",
  "2bb8c7aa0659f14e4c6dafb3f07010b4": "[ru]QM信息记录表导出中...",
  "1d69062cdc1bcd9a0c9d851992e74d11": "[ru]专用号请从下拉中选择",
  "77c0d2241dabe2a09700f29221b7dba1": "[ru]供应商代码请从下拉中选择",
  "0711149d58a816e78e59eef8fbff46fd": "[ru]激活下达数量时，下达数量不能为0",
  "999fd3214311bb713962f86a6f3ff592": "[ru]详情查询失败",
  "511b323e7b19248daf1b4691695a24f6": "[ru]不良品策略维护",
  "3e6f5833824a852788f190e928f5ab43": "[ru]PL不能为空！",
  "d6c2e455c97368702074b3e8363544ed": "[ru]不合格项不能为空！",
  "66eeacd93a7c1bda93906fe908ad11a0": "[ru]全选",
  "f1c5d977fe7e5ec734d74d5254f7b457": "[ru]周期（天）不能为空！",
  "1dcb1e6fc1d168ac538cd42c45886e40": "[ru]数量≥",
  "df84aaa31dda38da55cc39fb1e853736": "[ru]数量不能为空！",
  "7185820be719a919c264f77345aba305": "[ru]次数≥",
  "e3a31f4142818b48115db17100bdf426": "[ru]次数不能为空！",
  "2ba19482f54d5ddefade492cf8acecb0": "[ru]管控策略",
  "e9c204f6b8fafe2f654c41aa23ba0f84": "[ru]管控策略不能为空！",
  "aa3d57c0b27554b376fa928ca385402b": "[ru]每月",
  "20e6dc1092b3e86bd76f25aa95182d80": "[ru]--全部--",
  "0c0eb4e2903fcbbbb8b532cdd0997f73": "[ru]不良品策略",
  "402e34f03269c71f61246ceb8119b65d": "[ru]查看抱怨单",
  "b060eca2b49819ee8ccebe9df36f3a2c": "[ru]抱怨性质",
  "7da53c134906667f0f41bfc4ffc3a332": "[ru]重大违约",
  "8ebcc275e6f0191070f991439d6be6cb": "[ru]非重大违约",
  "a0ecbfa1e4cdb310961027f6ab4083dd": "[ru]抱怨类型",
  "12fd7edf0f9783427f8bbf8113ed2b4a": "[ru]重大质量降标",
  "1967fed0fd54bc07843c301ff2d060c6": "[ru]不认损不担责",
  "6b8a7ec3797f56ce960c06dde05b90eb": "[ru]弄虚作假",
  "0b7aaf3f0230aa297fda6eafe47ebc40": "[ru]有害物质不合格",
  "4220e1ddc42458b5b5ae0bba313957a9": "[ru]重复发生抱怨",
  "2d4b2c6a6673b0508f2b1b4e1e5bbc34": "[ru]私自变更",
  "fc673133331353ca7fbc655919c732e6": "[ru]水火电等安全事故",
  "d8361dd95cf2096a020431a406f49820": "[ru]重大/批量抱怨",
  "e414a703a6ae0f7031fd968aab0a5b52": "[ru]市场重大批量/重复发生问题（抢单）",
  "8552ca527b5abdfc16727e8886b194f5": "[ru]发生工厂小微",
  "a8e450d03efd4f33232169538abcec3e": "[ru]发生环节",
  "5be77cbffda8cb572d17e7cccfde5dd4": "[ru]入厂质量",
  "0653329dcfb42539677f84b3bd94b826": "[ru]现场质量",
  "a3c853b28fc22514a82e9b97550a5bb8": "[ru]市场质量",
  "eb7b9e9f7281fe68d0dc4c631a522eca": "[ru]满意度",
  "13f7745f1c4f6c0fe0335ba69d87f53e": "[ru]发生时间",
  "318fac0104c51cb87071ef7d581dd75c": "[ru]抱怨描述",
  "9790cf50803f2dcecf21ab335cf53ac3": "[ru]抱怨资料",
  "b52322e39e0214deef7d2b8515e9dd92": "[ru]整改要求",
  "ecbd3df43afb03834741469f71ea5d02": "[ru]整改时间",
  "5e33e487aa949c424f6a4cf84a2d6fab": "[ru]录入人角色",
  "0575a1fbdb1473cf7d2323ad5236bca3": "[ru]抱怨单审批",
  "c01118aca90af005f7a2995094fe82b5": "[ru]供应商分析举证",
  "69feda8df973863d8e60cd99fd78aee0": "[ru]供应商意见：",
  "dec24919c1b59709fdbc4ba9b07ec304": "[ru]抱怨成立",
  "d2789a2b65299b014e886dffa351aefb": "[ru]抱怨不成立",
  "9b7d101b02b97a50adb1d49a73a22493": "[ru]举证描述：",
  "475f4da6b16ab2600a50251dc033ba6b": "[ru]举证资料：",
  "717e182f9fbde852fd53755f1958a076": "[ru]举证人：",
  "077fdb544616c15bffeec14c8be49597": "[ru]举证时间：",
  "912e78c99aa49cef26e6e7e45fc32ca8": "[ru]获利调查",
  "ed8e2a400bdde2f84ca5c559ae057769": "[ru]获利调查结论：",
  "ef219f63c1584fc7f07b6a410312cedc": "[ru]获利",
  "d8d1ce48ed7da1794ff296b81305580f": "[ru]未获利",
  "ad2cca889618988787c7d88ef203202b": "[ru]获利调查说明：",
  "fb12c20bf409f92f5344258a8042a44d": "[ru]获利资料：",
  "b58b0ea735eddc2f440897f7f0be232d": "[ru]获利金额：",
  "f2ff33afb2323d3e5b2cd173390dbac1": "[ru]请输入获利金额",
  "bfdb2c6bef48d40d0280c4107100c9e0": "[ru]/元",
  "90c013f1de564ee7d842a30ce80fe15d": "[ru]获利调查人：",
  "610ecc9cdfa6f08b7e7a7076b75a7ff1": "[ru]获利调查时间：",
  "0a3af28cc7fc240604cb038327aba175": "[ru]问题评审",
  "a6c324eeea0ab23978e276c4a1ea755f": "[ru]问题结论：",
  "5b7978d25946bd1c3a43e8e9246edeea": "[ru]结论判定说明：",
  "7c81502f8a870cc513442c199d8a59f0": "[ru]问题评审资料：",
  "4e6cf2c796a94b4594e5765391563cdd": "[ru]问题评审人：",
  "8bb27ddcbc6d3b95c61742caf264ff43": "[ru]问题评审时间：",
  "230e49a0a929b7cb836b9a290780b118": "[ru]损失录入",
  "15071246e9fe3936b91768dfc6ff7bbf": "[ru]损失金额：",
  "01b0fd6a3490c037876c5a4cbe1fdc51": "[ru]请输入损失金额",
  "6b72cb52801553df39212a56a35167e1": "[ru]索赔金额异常原因：",
  "7b9e06b16f19f1940f61893f7a36dc7c": "[ru]请输入索赔金额异常原因",
  "3aed95390184fa80edb3d1e49c5182a2": "[ru]注：重大质量降标低于50万，弄虚作假低于10万，水火电类低于10万，私自变更低于5万，必须写明索赔额异常原因！",
  "d126f09905e0946d5c4bd29c36fd0fe2": "[ru]认责单号：",
  "c69da12eece53492bf1d99f5eb70d3dc": "[ru]认责单状态：",
  "36371681c443d37a7ece524d3f235f4a": "[ru]损失录入后，会同步生成认责单",
  "0952db81acc5afce272fb22a5edb72dd": "[ru]整改闭环",
  "b45ad8768d8bad8717e55311a7ce24fc": "[ru]供应商整改",
  "3a6d63fcef1225692c8528e41335d512": "[ru]应急方案：",
  "58ff4976d648d06f121067f27e756f6e": "[ru]请输入获利调查说明",
  "d1f3d079f67765e4747ce1d38daeeb19": "[ru]根治方案：",
  "963408aee55ba80aaa3c7c11b454e257": "[ru]整改资料：",
  "46db60fbae3bc08e0a1533f2fb7a566d": "[ru]整改时间：",
  "95b30ef53f1e57a45c0ec0bf13e35d59": "[ru]注：该抱怨单生成的认责单请及时签章，否则会影响贵公司抱怨单闭环！",
  "f7df04cce2faa1fd15a9248bbb1cdd8e": "[ru]闭环确认",
  "bf0e36f5ffbd72ed50aff29c9c441c50": "[ru]闭环确认结论：",
  "6daccf6cc3c5642bf3e84c3e0d7b2a49": "[ru]闭环确认意见：",
  "5fa2904fb2978b512d126372d11e850f": "[ru]请输入闭环确认意见",
  "a9d316fe0808a031ace6cf6c47e678fe": "[ru]闭环确认人：",
  "60eda1c4f694a5d8c50b33f71a0a7392": "[ru]闭环确认时间：",
  "34703294e4e43c16172cd0e34cf35efc": "[ru]请填写闭环确认意见",
  "e9efd587925b76eb081a4558cb090535": "[ru]确定提交当前录入的闭环结论？",
  "1f73decc72722fbef91b1ba9bf7920c7": "[ru]闭环确认通过！",
  "0382dcfd738c860020027fcbc1a7e098": "[ru]闭环确认打回成功！",
  "53956090bf2b52ad009431ad6b9fb0ab": "[ru]请录入损失金额!",
  "a58c6f260a72bafe8ee45e577624aa3b": "[ru]重大质量降标低于50万，弄虚作假低于10万，水火电类低于10万，私自变更低于5万，必须写明索赔额异常原因!",
  "6194104b242dcce521db8703e4359446": "[ru]确定提交当前录入的损失金额？",
  "f13ab8ca438a94d2f94326fefe52c1c3": "[ru]损失录入成功！",
  "5731676c3cf0da7c1110bb8161b6cb46": "[ru]1.必须经过质量小微主审批通过，且录入之前需提前邮件通知产线SQE。2. 单个文件不大于30M",
  "624b39b4f84ad5b69ebf406c50ef3a9b": "[ru]请输入结论判定说明",
  "e385a660b68e720ca1f426602505d30a": "[ru]问题调查资料：",
  "9c2cdeaa40d05c0298bc9b4f79bb622e": "[ru]请填写获利调查说明!",
  "477a35561fc6de43f1db3ae04003ad9d": "[ru]请上传获利资料!",
  "8579a751c60ca3c07b847955d25425cd": "[ru]请填写获利金额!",
  "663a4a77ca657774697075309d9ac5fc": "[ru]确定提交当前调查结果？",
  "c060b309edc7da5d127fd5513b63d7c6": "[ru]请填写结论判定说明!",
  "319c4cf99e79c5bccb421da530310289": "[ru]请上传问题评审资料!",
  "6f3c649d22a67397e0e864c6502782e8": "[ru]确定提交当前评审结果？",
  "08d1f534d90444d8c94c7d10a11067f6": "[ru]供应商问题评审通过！",
  "7a63fe3bdf774eedc7bce1552e3be422": "[ru]抱怨单录入",
  "7797bec74bae36f533776d9a07eca47b": "[ru]请输入物料描述",
  "e15df358e6631da3033a64e81ec71a76": "[ru]请选择抱怨性质",
  "b002d0301001489266059f85d62a10f3": "[ru]请选择抱怨类型",
  "dda7a81e664a14ec816355d82c0f5a57": "[ru]请先选择抱怨性质",
  "75c033cb6f14d5a479dbe40d527ff47d": "[ru]请选择发生工厂小微",
  "a28d1e7734bc14247d5e8362bddd12d2": "[ru]请选择发生环节",
  "168905f43d80682e308d6563782ed2a5": "[ru]请选择发生时间",
  "f5f01e0a055dd40ed9fad4a1e10080aa": "[ru]请选择认责单",
  "aee5edfbf203eeaaaebb40343397943e": "[ru]请输入抱怨描述",
  "cd234d4828cbae45d338074439bb3ccf": "[ru]*1.必须经过质量小微主审批通过，且录入之前需提前邮件通知产线SQE。2. 单个文件不大于30M",
  "b44d92dde73b804b3da414c283f12b29": "[ru]请输入整改要求",
  "919d63afd257c04538720ba853b978b2": "[ru]请选择整改时间",
  "ba043b43bc580315d51c9001b0d7037c": "[ru]请输入录入人",
  "3afbd1da88337d86977d49d434f2b88d": "[ru]请选择录入时间",
  "84c9bf1519d3e0afe92c3fe81dce724f": "[ru]请输入录入人角色",
  "bd93bb63af15ddca5afb7346a8664509": "[ru]确定保存当前数据？",
  "7bceadff9f30371831a982370149c138": "[ru]提交成功！",
  "322d32f2e97a78162baf787f1a13eae9": "[ru]请填写审批意见!",
  "47b504c1766d972f1e6473a033f6edbd": "[ru]确定提交当前审批结果？",
  "64513cd6cdbba95599ed1dae6462e8bd": "[ru]审批成功！",
  "0e0ab4ecf3679493d91ca2c5e67057b7": "[ru]抱怨单号",
  "04dfec04046b56ef0e5750747c939ca6": "[ru]抱怨单状态",
  "2f9b711bef9804685e0e6191b01b32b5": "[ru]抱怨驳回",
  "513b6792ab1b098737892c968f310c33": "[ru]调查打回",
  "c70ea1488347582ad751c05e3d7cefd9": "[ru]抱怨待审批",
  "4d930df9b18b10175e0e8c58eddf5bcc": "[ru]待供应商分析",
  "df99e7c37bf1e2a7a2e42d89a62e8cb6": "[ru]抱怨待调查",
  "ecd315279157b91464ddaa0ab4216ede": "[ru]抱怨待整改",
  "ef266d79a27abfe89fc49f8b34f4959e": "[ru]获利待调查",
  "e5a4ca803044e6242a8119923a9f96a1": "[ru]问题评审待确认",
  "804255ab38a71fa39ec5fe9440c085fc": "[ru]损失待录入",
  "aab018815ec542a4212117dc869d8e42": "[ru]整改待确认",
  "154af03de06d11bda8bb45af76572a30": "[ru]整改打回",
  "6e87c13749a4684c3e79c39e8f58f2ba": "[ru]抱怨单结论",
  "302543f5fc83b9831710d3412fa01a16": "[ru]非获利&不成立",
  "82371d6e462c972cd2940254c4856416": "[ru]非获利&成立",
  "406f3f0801f5273c18b4c8cdaa10f665": "[ru]获利&不成立",
  "5dc6db08424a779498e7d47330aff6e9": "[ru]获利&成立",
  "b6307063367a403379617c8f6ad43a3b": "[ru]闭环时间",
  "b1b3a37705497b49f330710167e01724": "[ru]抱怨单查询",
  "0d0bec3e7dd7f654e9d24b4d9b24b61f": "[ru]《重大违约规则》",
  "d5739b99d722539d230c10a6b79a3d3a": "[ru]整改打回",
  "6fa5b80c24fb6af77d5c700cf3ed34ef": "[ru]索赔金额(元)",
  "e0cd426632e687f45f03f49407367f49": "[ru]获利调查人",
  "4f22887de39fe4b2eab54e08b900c89e": "[ru]获利调查时间",
  "7db62a1ab06d9ca942e6b194e616b095": "[ru]问题评审人",
  "cb3e17bedd3fda06b4741c37c132fbef": "[ru]问题评审时间",
  "237f10329b0c51250d382e40cb88db4a": "[ru]最终闭环时间",
  "7698a5a61284ef6ee1c57965c75a1cdd": "[ru]抱怨单操作日志",
  "cd2599b50e25acb6017cebce8abe5fb2": "[ru]只能选择一条数据进行审核!",
  "f75bd188e9deabaf20212af5c86a798b": "[ru]请选择“抱怨待审批”的数据进行审批!",
  "136ca2e44dbe1f0e95f6c078886425ba": "[ru]只能选择一条数据进行获利调查!",
  "52ad91f38b744cef49007e082102b9fd": "[ru]请选择“抱怨待调查”或“获利待调查”并且抱怨类型为“重大质量降标”数据进行获利调查！",
  "4833a8fc66c3c3fffc6505c9611cc5fe": "[ru]只能选择一条数据进行问题评审!",
  "236eedcf9c165fb0e664916d5505dd82": "[ru]请选择“抱怨待调查”或“问题评审待确认”数据进行问题评审！",
  "29328686c74a832792891da75f53c41d": "[ru]只能选择一条数据进行损失录入!",
  "d8ec542f85fb93fdded65eb3740bfae4": "[ru]请选择“损失待录入”数据进行损失录入！",
  "6cfa71c2229479dde0b95b5a3380af73": "[ru]请选择“整改待确认”数据进行整改闭环!",
  "7c4b0bddeadbb3ca7adaa3f5ed1d7333": "[ru]抱怨单导出中...",
  "bc89a15ad1b8f1e18a2a620a529b7dc7": "[ru]供应商质量抱怨信息",
  "fc889bb1c8d1c8190d64beb59341820b": "[ru]索赔金额",
  "c16655df815cf59b03075baa5999a2bf": "[ru]元",
  "2e309212ea3cd4c4ac5c5810e8737cec": "[ru]录入单位",
  "5960f97b2f81462565de62e52ba9ad1d": "[ru]质量小微主审批",
  "29defff86bab9b0c1537e411f39e6e84": "[ru]注：因流程升级，抱怨单录入已迁移至“抱怨单（新）”，老功能抱怨单请尽快闭环。",
  "c852df6b19811c526adf5bd774b2d0df": "[ru]整改期限",
  "37c356f85613c01a79bbe51ede1b892b": "[ru]分析结论",
  "0780b822291d73c370688ea1cda76b16": "[ru]分析时间",
  "91822d2fcc8dbddc3f2337f092d09af7": "[ru]确认结论",
  "4945e9d7e48ef34ee612bf930966c6f3": "[ru]SQE判定结论",
  "be6970e437146dcd1831c82b37fdc46f": "[ru]SQE判定时间",
  "3cdea1bb0f30aa0ca0eb9d07118b76ef": "[ru]闭环结论",
  "010e174d02a4a28f6f0eb2df0cab1fec": "[ru]冻结时间",
  "80d0e2aaf0c6883e2a6e6078619385b1": "[ru]解冻时间",
  "1c42e6cbb34709fc90974a6ec1a3497e": "[ru]获取抱怨状态失败",
  "017ade634e8dc53cb5f828254de984a4": "[ru]抱怨单.xlsx",
  "f6671bd136737270c2720e3b2a152039": "[ru]审批资料：",
  "3ad1f84dc1dcb23365af5ad058c7e2ce": "[ru]请输入举证描述",
  "72b87a11e32f6d8fb74639e6c62e9a0c": "[ru]*1. 单个文件不大于30M",
  "c00b6cb475df4eeafe30023ecce8e217": "[ru]请填写举证描述!",
  "15a9327b7c87c763d616b373b1c498d0": "[ru]请上传举证资料!",
  "34dd24120e620abac9d7fec78b9db030": "[ru]确定提交当前举证资料？",
  "f73c2ac441b41ca02ed3f16962a22ed3": "[ru]供应商分析举证成功！",
  "9965f0847a7b738dba28cd35333b1fc8": "[ru]是否触发停检单",
  "ae3e3cb154d57b7238b0014ad9683c66": "[ru]停检状态",
  "4f5a6b5e44df705921048a85680b1a26": "[ru]停检中",
  "b70e8e43e3deed10c24d7724f4e39efb": "[ru]已恢复",
  "8bc58efe05bfb5e7b83fd3ac9ba2c225": "[ru]已复查",
  "6fdc324cb8f44d09df230c6ed55759f5": "[ru]只能选择一条数据进行举证分析!",
  "ffbc2ffbfbb462f8b7b48bda80def1df": "[ru]只请选择“待供应商分析”或“调查打回”数据进行分析!",
  "d5a04174aba4aacd2758269c4718d602": "[ru]只有供应商质量部长才可执行此操作!",
  "49b46833a1f019db1d1f4ac2c8d31dd4": "[ru]只能选择一条数据进行整改!",
  "c553d3bfff5da399ac9b85defda9c695": "[ru]请选择“抱怨待整改”或“整改打回”数据进行分析!",
  "47c6cd21c0da0a5d8d93dabca1308e1b": "[ru]虚假资料",
  "fac16803189fd34f3a696b5fd568ad93": "[ru]现场重大抱怨",
  "ce029f16177727ae2eb2fa4fb5183ad2": "[ru]市场重大抱怨",
  "354e6e87cbca63ea2448224ddcd83e9b": "[ru]重复发生",
  "caecb9a1e83a3721229a444c690fbcd6": "[ru]废旧箱/门体",
  "776bace4f99ea2bf8cdc3803c26e0da8": "[ru]请输入应急方案",
  "719e8936240bb061c55e87c7953163a8": "[ru]请输入根治方案",
  "935392f57b7f90fd608e0e83753fedba": "[ru]请填写应急方案!",
  "efc1129c6cafaffd2af17aa4a4e123b1": "[ru]请填写根治方案!",
  "53d4ceb1453c80383ebd14e69a6eb1cf": "[ru]请上传整改资料!",
  "7827642badf424cbd20d4e484becb4b4": "[ru]确定提交当前整改资料？",
  "75731b7c92cd20032e80cd9ca42aead2": "[ru]供应商整改成功！",
  "3dde9f07687ceaf1f576fa4bf9be88a2": "[ru]公告主题",
  "26eeade07d2a919662bfd2fd8f992ec3": "[ru]请输入主题",
  "3d60cacde965a00c555b8a1f84720110": "[ru]只能修改一条数据",
  "947139f97f8246d9f3ebaf215bec966f": "[ru]请选择至少一条数据！",
  "7fb62b30119c3797a843a48368463314": "[ru]批量删除",
  "c4c65e9be72a8af16fca7cff278865c7": "[ru]通知公告详情",
  "80417431f1f07941d2b1ec7c436d5b63": "[ru]发布时间：",
  "e847c4a33edbbd303db7be4269d81449": "[ru]发布人：",
  "01b107d40334c2de94fc736e00aa32bc": "[ru]附件下载:",
  "e51a1e8cafdcaf134d44d5008c88f024": "[ru]修改通知公告",
  "3e6035d46b59dab6fdbe546aa170a122": "[ru]添加通知公告",
  "086d0403e62d321be50e46bb202a01c2": "[ru]请填写通知标题，长度不超多200字！",
  "f1bd8b053770a696fc8646ca911c9520": "[ru]通知类别",
  "86780ebdd5023a3428e75644be0366ae": "[ru]经典案例",
  "ff04d85348387d7c072b460005283a0f": "[ru]请选择通知类别！",
  "4e3db49f7ad071de623695d16456fa04": "[ru]排列顺序",
  "215aaabd61e631acdbe6900b95514712": "[ru]请输入排序",
  "0f11e53b307ac7c42d14f7d6e6b631f7": "[ru](由低到高)",
  "ba72a9ed1784c73c7df749816da68c1b": "[ru]通知内容",
  "0728fee2305b16ac40a063a558ec367d": "[ru]请输入公告标题",
  "de5e388a3153f05315598ee6b5815308": "[ru]请选择通告类别",
  "2fff079bc780f5650bc2dd276920591c": "[ru]发布成功",
  "a088c064f86f805ee6c3cd871e68653d": "[ru]查看更多    >",
  "3163744dbe361887056da8250aadd67a": "[ru]通知公告",
  "0467cc920966aa06d289d8bbd511c9eb": "[ru]查看全部",
  "68c16e022cb7f60e89de9a1478030416": "[ru]姓名/工号",
  "fa0c6a02259cd117872dbe395d6d4399": "[ru]请输入姓名、工号进行搜索",
  "c95211a540a0570e8c4b0282b84ee528": "[ru]录入",
  "f39f787647db858992ee3d0b8860b26b": "[ru]金牌讲师",
  "a83ce9973ccaf93ffdc636e995ca245c": "[ru]讲师信息录入",
  "c052ec8a98102ba1df4b51a29da3e82f": "[ru]讲师信息修改",
  "7ccc06ef23da1eeb6e8c6210f0dee098": "[ru]@/assets/img/占位图.png",
  "aaf8edb099c4520b7494dfa21fa9e0c1": "[ru]*请注意文件上传的格式（JPG、JPEG、PNG），最多允许上传一个文件且单个文件不大于30M*",
  "96f06b50062b8612ffd471bc50c31220": "[ru]请输入8位员工号",
  "7aec83f17af99dec8563119f6f5fc2f2": "[ru]输入工号获取姓名",
  "59cd8642aeeab1dfbb6324a40d26124d": "[ru]选择事业部获取产线",
  "b652de80d6a54f83ce3cb04aaddc0c7e": "[ru]职位",
  "d1ae757941c2ee27fdbc71e13a3d0e3b": "[ru]铜牌讲师",
  "ea870fdf6b1c2b90cbbb39ae90fa97c4": "[ru]银牌讲师",
  "b971621ea27365b3e3f19a47aaee8df0": "[ru]所授课程",
  "d2803aded6aaf9227cb7f5295c341dff": "[ru]讲师简介",
  "fc9474f8d11b5053869d20133a7c2e84": "[ru]限文字不超过200字",
  "1fcdab905fa3691aea9526b3b69ebca1": "[ru]您已赞过此位导师，不可重复对同一导师点赞",
  "319b56f26a38610bc9f34b3eb3b9ea63": "[ru]点赞成功",
  "0dc17383ea6f186394eed3708d30e767": "[ru]请上传录入人照片信息",
  "adc75dec0b1e070e4094d07b679a3fb3": "[ru]录入成功",
  "bf250d0a0a7487d5723cda460c4d3902": "[ru]讲师风采详情展示",
  "3d6c396cf4dea3ba2ddb255499dc356a": "[ru]喜欢",
  "3511b2d2e0406b442dbcf8b03bcee3ce": "[ru]事业部|",
  "2cab1bdc679fcb6df2c31c096c11534a": "[ru]讲师介绍",
  "e21ea26afc3efca1893b2d1e92aa3e11": "[ru]讲师所授课程",
  "58acf8076e2f8f41daed23583463a46a": "[ru]人员信息查看",
  "c1032f1fda4cb7adf1a8f1c7cd66c7d6": "[ru]赋能认定",
  "727190ad734e6dc9fcc55236742e41af": "[ru]实习",
  "36a4908a557796858a347c063a73ce60": "[ru]男",
  "87c835a6b1749374a7524a596087b296": "[ru]女",
  "f8447c7c7e02bfb7c18da00c9d577a73": "[ru]学历",
  "b219148728a63a21d891b4d15225371a": "[ru]初中",
  "c7689824eb4d6ebca3745901f10ba11a": "[ru]中专",
  "fefa7c8483548820022dd0066bdadacc": "[ru]高中",
  "50ab51c60223d88bf8d10b4fd05df99a": "[ru]专科",
  "40b14fc519ebae0a15c31b0297b405d8": "[ru]本科",
  "e6de6983db8790f7fa79283aa2416bd1": "[ru]硕士",
  "7d27be0093106d240d92a3991c3a84f4": "[ru]博士",
  "61854b7949752e2c59afc14ddb445643": "[ru]入职海尔时间",
  "f0362aab4a77f9810f3fad0d508609b2": "[ru]请选择入职海尔时间",
  "a3cc0588162b93f2e324b0a9c7960ca0": "[ru]入职外检时间",
  "365dcf3ef3f63e45bd9795024f04ff6d": "[ru]请选择入职外检时间",
  "e87127525f6fe75415d43a66c5b21937": "[ru]外检接口",
  "bb6d960f297eb359f6683e82712f0c65": "[ru]外检体系(QSE)",
  "3a1043bd2be7044835e5fc4f51842829": "[ru]材料工程师(MQE)",
  "112886d930519c4e0d5f2ebd05b9cbc8": "[ru]电控模块检验(IQE)",
  "a899fc1afb9c456cdd00afc46204eaa4": "[ru]动力模块检验(IQE)",
  "92e32a584778591654ddeaed3ae99a7d": "[ru]电器模块检验(IQE)",
  "61336fee441b66150056090c9aa61c3e": "[ru]系统模块检验(IQE)",
  "a32b3521acc090346d98f2d8310da909": "[ru]塑料模块检验(IQE)",
  "1d2345b22301a73ebab2b89c29f8ba78": "[ru]钣金模块检验(IQE)",
  "ce8058fd6aece670256157770e5e7c97": "[ru]包辅模块检验(IQE)",
  "985c687c52b2ac976a60a47e93c18013": "[ru]其他模块检验(IQE)",
  "f42e3d88ee31855fbb1496d785e9f067": "[ru]岗位级别",
  "f373efbcc7d5fc8cb168db4e2a4d553f": "[ru]非管理岗",
  "4fa0f74efaa2a4dec6c3a77c2113bd41": "[ru]小单岗",
  "da23f306543da21039eae99842ca5aab": "[ru]中小单岗",
  "e3bef18b08fa46a896a3c8f73f88cdd2": "[ru]岗位状态",
  "c91c2e04976fb35424e697dc61f460c0": "[ru]在岗",
  "94ddaa842a70130282dfb7376b05b3de": "[ru]调岗",
  "583e7924e9c53894fc35102d521a12a0": "[ru]离职",
  "4c89100e1a5f428983f8742ab1243f09": "[ru]HMQM有无权限",
  "76a01495fa2964eac9ba15d5bb167c5a": "[ru]离职/转岗时间",
  "bab70613c7ab423e08dccb20ff9ac9d7": "[ru]请选择离职/转岗时间",
  "004538e85502b1df6245105d17c78d53": "[ru]赋能信息",
  "17e961a9485203990f098d5b77df5f46": "[ru]实习阶段无赋能模块",
  "f4d7e4806bb50de083cdd86efe3b58ea": "[ru]赋能模块",
  "66846af9f7b1fd62138411209b53ae3e": "[ru]初级",
  "99c8f454e1e8d6b93175b83b195df876": "[ru]中级",
  "dfac151de712ab0b3618072c8a7f0a0f": "[ru]高级",
  "6f2f898fc21d6ccf06070fc4989eea3d": "[ru]证件编号",
  "4850fec1e45e09f25906df5a705fff3f": "[ru]发证时间",
  "962fd2396eb82efd706b5fd195e1c34f": "[ru]赋能证书",
  "d352119f570f6c1d5cf2e92f94068cba": "[ru]模块检验员赋能证",
  "75d15251ab7048d305b33eae0892444c": "[ru]姓名:",
  "899792134e81f802eb6ffb88bedd97e6": "[ru]工号:",
  "98d5a06c2425a5bb69d9a85cc44a3859": "[ru]发证时间:",
  "e3bd601c2ce35260cdae6e1d7d309291": "[ru]证件编号:",
  "3c06008d7f01a3f4a966202ad8abfd92": "[ru]有无赋能证",
  "77aa8d09eac5578c328999c501aa1b58": "[ru]赋能证书列表",
  "2fdb0f782fc3d31b2e22b48cd69c4cc6": "[ru]人员信息列表导出中...",
  "160a11de9ff4a93d55328b67a27b67cf": "[ru]人员信息修改",
  "ab228850c8ac2f8f118a2e03f1a0e6f5": "[ru]人员信息录入",
  "f665df0903764f5cab921a4d01a2c14a": "[ru]请检查工号输入是否正确",
  "a065a62bfe8c5065c0f8c9c6ed0a4673": "[ru]入职外检时间不能早于入职海尔时间",
  "69bcdd8a12f1c70b3c24770671de7d5f": "[ru]请选择离职/调岗时间",
  "1b04d1ffb0a6c637ffa8aaa65fc4fa98": "[ru]开始考试",
  "08d4e8d42759a10395352d351e198635": "[ru]-测试记录",
  "e18634c12003c514593c6f41e93fd65c": "[ru]判断题目",
  "dec8928f8c698032440ce2ecbca10247": "[ru]：",
  "2fb0e0980a2d7a1b909c672865be055b": "[ru]正确",
  "7030ff64701a938becbc5aa67ddb86e8": "[ru]错误",
  "209a755c62b042c6134f600f496661fc": "[ru]回答正确",
  "b59d715bfc68106354f1c5ea3a08560a": "[ru]回答错误——",
  "e1edc144a272774e6ca17de6511e5c92": "[ru]正确答案：",
  "0524f9c5b2bd4b1e1165a50822413092": "[ru]单选题目",
  "6bce6a9e1041181e5769dd774e92e83f": "[ru]A：",
  "840a28b99d866875efc23b742e6b7062": "[ru]B：",
  "0557af3a842478960b5607bb7748b1ea": "[ru]C：",
  "9245e50e6c72b61dc5c9c497f5d458f4": "[ru]D：",
  "20b52e1e1facb70ef7ba8e238ede774c": "[ru]多选题目",
  "64bc5f4b1f5cb1fda9ad0fa1c1128f7a": "[ru]该课程尚未上传试题",
  "8679f378bf6f852a8f15f8217a058ddf": "[ru]答题剩余时间：",
  "cd3038a877cf27310441aca46cf0fe8b": "[ru]温馨提示：考试开始后，请一次性完成考试，不可中断考试！",
  "0634415c62448b0dc9ec7c9f622c9789": "[ru]考试时间：40分钟",
  "2c053b0777561eb25d36f04a27fba806": "[ru]考生：",
  "bdc187b1905b464f9bba9e92f221b50d": "[ru]总分100分",
  "ca9df2a8d49a2ffbaa280d2dcb002d6d": "[ru]交卷",
  "e1947c5f903bde77d3951083ad74feaa": "[ru]您在页面编辑了未保存，是否确认离开",
  "0d8ec184c6a1de574f76e81a74cf689f": "[ru]考试时间到，自动交卷，轻点击确定获取成绩",
  "2f1ba8cc1cc007ad82ad3a4a9ab5713e": "[ru]考试完成",
  "c4113d5cf728029697b1558de3adb797": "[ru]考试完成，您的成绩为",
  "a08fc991d1ae7c9b52d23ef473ab91f2": "[ru]点击文件开始学习：",
  "0e9525b2bb1493c567c114dd61b69095": "[ru]温馨提示：",
  "7d4410af184e42559a8bda7b33a1a98d": "[ru]1.只有在同一级别的所有通用课程和任意一门专业课程学习、考试完成之后，才能获得该级别的资格证书。",
  "046415c16aa346482e0546e4b41fbad4": "[ru]2.初级资格获得2年后才能进行中级资格证的考试，中级资格获得1年后才能进行高级资格证的考试。",
  "ef41c45e862340ff19324f878944b824": "[ru]3.考试开始前请先认真学习相关课程的课件，确认已掌握课件内容后再进行考试。",
  "db8909851f0c4147d6c03ae350d080df": "[ru]4.考试时间为40分钟，考试一旦开始，不可中断，请自主分配好时间。",
  "22ad1e4b2bf6aa16afa818e604482a72": "[ru]5.每门课程总成绩为100分，80分及以上为合格。",
  "12313a0bb15fbdb4df16d9ad5aec777b": "[ru]已学习",
  "b77dec8a513233f5d9936c31e12d845d": "[ru]去考试",
  "bf404961d22bf34df86cd9a78c52bab3": "[ru]确认已学习完成后将无法查看学习课件，请确认！",
  "c6ff8e5631d1e77c65b602ec5c1eb0a9": "[ru]课程名称",
  "f1dd9550bb741d796c475301bb3bce99": "[ru]课程类别",
  "aa05fd09a619ddbf07d8d903e6d32c5e": "[ru]通用",
  "a7ad35acaea5046dd8a61010c6d30111": "[ru]专业",
  "a475fd6c8604ccf73e61f251f979d293": "[ru]课程等级",
  "3addf4180623310d9088b3de0f3c0e30": "[ru]进修类型",
  "748fdd1e6a4b9159b938e8579d6274de": "[ru]必修",
  "2e691348fc58eff2569ef764ea61797b": "[ru]选修",
  "d25a5c4535ddb00a5b2a19ab1ae4bdac": "[ru]学习考试",
  "aa6b015ab13acc71121b767d214097e9": "[ru]课程进修类型",
  "8488e5ce91ea92ed8f57400cc1f4a762": "[ru]学习成绩",
  "44cc5582c212330faddb6d80f6b6c9af": "[ru]考试时间",
  "1601d96f259bd4e7df51ad9f29978e5f": "[ru]考试成绩",
  "5a1fd09b70c359c251f573ac5f991914": "[ru]课程录入",
  "b79ef819081a4b9792a5a0721af2caef": "[ru]持证上岗学习考试模块题库模板",
  "fa5cabc338f447249a6dd8e17f3a349a": "[ru]一次只能学习一门课程",
  "c2793c7b95dea60dd1ae8d065b91b2c3": "[ru]请选择要学习的课程",
  "df8fcdf428cdc1383169a56ea0965e71": "[ru]课程删除",
  "6c580b88d68221bc1ae0d03a85185c33": "[ru]进入学习",
  "d3e15bc5fe3ae1683ca1719a593d81df": "[ru]我的成绩",
  "d81bca697205ae3e8704a21ae39b5cc6": "[ru]题库导入",
  "49f1e4897b63690d1edd78ed7ab80c8b": "[ru]下达纠偏单",
  "2728d46b4421bb0bae1be83db46e454d": "[ru]供应商质量纠偏单",
  "61d17adb98591a45a7fb7ad40368a914": "[ru]请先输入专用号",
  "c91d772079b87af1633a3fe3dbf9b277": "[ru]贵公司",
  "f6fb74d34681e4583fa96dd44e837f98": "[ru]产品，在",
  "b11da5de8b333b3dd1db8470b870b1e6": "[ru]中，存在问题，应立即整改，保证同一问题不再发生。",
  "555b0c0a0633ff6bdf718c00ae67de2f": "[ru]发生地点",
  "6bf4fac0bf71b3c93bf9a4b73b7a13f1": "[ru]，数量",
  "ff02e4e972ffd4215e6dc443876429e8": "[ru]，本问题属于第",
  "a2dee2e0f9a7c0f1b82ba38440f98ee6": "[ru]问题现象具体描述",
  "fde811d44409a40bedeb6d5b77c75025": "[ru]对缺陷现象的处理方法",
  "030ef93656e4bcfd4ea9225fcf2a4697": "[ru]如何处理该现象",
  "d169ee0a511265364b4c041110d07b2b": "[ru]纠偏附件上传照片",
  "af43762aa34c112f593538e1d0d634a6": "[ru]请注意文件上传的格式（JPG、JPEG、PNG），文件名中不允许出现逗号，文件不大于30M",
  "8f69462822936abc72854495ffc903a7": "[ru]是否同时索赔",
  "b22c4a1102b856b459bae67cb5dac3e4": "[ru]不整改",
  "8cf61b3333b21fcaf300c53ee466cf7b": "[ru]，金额",
  "10e5307350e05f4ce623725eaea7f344": "[ru]元。",
  "b1f6ff103540ebb5db5681090c60bcdd": "[ru]数量只能为正整数",
  "058c6611ec381e5e1ae6f3773a63d8f8": "[ru]次数只能为正整数",
  "3b58b64ffa6df7541631734be793aca4": "[ru]金额不能为负数",
  "e2003ec39d2c5ba0ab345956fcd01fb5": "[ru]金额只支持3位小数",
  "2630ba9952cefae62c3d9138daa85e66": "[ru]发生地点",
  "de1d8ea2cefe27d313c5b87a6a55fa94": "[ru]发生次数",
  "1bf4270813dbf1c00bcc1b99b48379e1": "[ru]要求闭环日期",
  "147283c2d0b4086f08baea7f347c5a67": "[ru]是否同时索赔",
  "2b14844af2f3efc5bbad16e79483bfc3": "[ru]下达纠偏单成功",
  "852c8308c04834a17b29e64a8094b79d": "[ru]下达失败",
  "caae71978efbd01a1ab9289b29a34ca9": "[ru]审核权限获取异常，请重试",
  "8617bb0fd54ace894b2e78c1f2c390f0": "[ru]获取纠偏单号异常，请重试",
  "2e0c3e85c35dd1c5ff2c19eea0176502": "[ru]是否模具原因",
  "6ae2774138bb01f104a2b991ecdbb874": "[ru]供应商累计整改天数",
  "2f7abbd3855b7078d7eab7185ae8bf1f": "[ru]供应商剩余整改天数",
  "85b27e4371ee91d45dd8c85948d6c2c4": "[ru]供应商分工",
  "fdabb1ea7dcf4084d4d0ac32d0510ba2": "[ru]模具信息",
  "b3f39934f0d5c3dd565662f0689a920c": "[ru]涉及模具编码",
  "e4ce58044256a96ac51b24d8ff981029": "[ru]模具改进类",
  "fa6da27aa435d4c6b6f4573e93407fb3": "[ru]纠偏单导出中...",
  "6ae2dd971f9d94f9b5f93d66f3e71931": "[ru]请选择一条数据进行分工",
  "0e37f9d906b747ea8a0d77c0d9a3fbc9": "[ru]只能选择一条数据进行分工",
  "6e3adf0fd8e861a3fe4b48469d0087de": "[ru]请选择待分工数据进行分工",
  "253f96c390150a08b0ac9ddfd092e5ed": "[ru]您没有分工权限",
  "bae4f7c22c7cdc9fdeb2f3aa9fda8998": "[ru]权限查询失败，请稍后再试",
  "671f04fed9b167f5f7c435e932122c3f": "[ru]无法分工",
  "dcfa4a3f46bee9250cbaaad684d7379b": "[ru]请选择一条数据查看整改历史",
  "0d6de265bedb63c3f55a1064d428c844": "[ru]只能选择一条数据查看整改历史",
  "89933f7a7788af94c8672ef605220350": "[ru]要求反馈日期",
  "c827d8dbb76ce33219f64c6749893159": "[ru]历史",
  "91f741b843d731948ee812176615fd53": "[ru]不良",
  "10582832fb1a43f8737fe74c26d605f0": "[ru]纠偏单.xlsx",
  "4a4f22abeb51b7b42f8b200f326e93ed": "[ru]无法获取纠偏单号！",
  "546c94a15ca89b535daacf9416f84ae9": "[ru]纠偏",
  "8db401ce7157681e3fd5777655cb2b57": "[ru]供应商代码：",
  "39d659e801e0853ffd03f957a9878e8d": "[ru]供应商名称：",
  "b211ab79686ebec3ee3004428a558883": "[ru]贵公司",
  "ed7df27aa8382795054d90b59b795204": "[ru]中存在问题，应立即整改，保证同一问题不再发生。",
  "0309380176ac71faa473583ae519a86f": "[ru]问题现象具体描述：",
  "4367f79551ed99b5d608a743043d53a7": "[ru]。数量：",
  "3f365cdde01684413243468812c72887": "[ru]。地点：",
  "29c9a1491bbd4ee36008b6b086a7da88": "[ru]。本问题属于",
  "c17cdde2e0ac43c1fc35ae52e205cba7": "[ru]对缺陷现象的处理方法：",
  "b549dc29e6553b9af2fb43a10dedbbab": "[ru]要求整改日期：",
  "72e2e91b5d5b0022fa69a136e4a4975f": "[ru]日期：",
  "95157b6039f6b9bae6f4d953b9a2fd4f": "[ru]../../../assets/img/占位图.png",
  "6ed4f5ed2adee04cac1be818c41ca308": "[ru]是否是模具原因",
  "7ab7a062aaf1ce29cc26f9d8b481bac0": "[ru]注：自修即供应商自行维保或修理，报修/报废需沟通海尔方",
  "02bed0c96b35ac93cb0beb30707987ea": "[ru]纠正及防止再发生的对策",
  "b9c0835594cc1913fc85732d7078c308": "[ru]管理责任人确认(首次发生)",
  "ead664e07f59b2a6341abc5a86a909ba": "[ru]总经理签字(二次/三次发生)",
  "50d8338dcd4da1ac32368f7b1e7fac30": "[ru]改善资料",
  "81517ef60c878ca575010135983bb8ee": "[ru]已上传资料回显",
  "279b17948b896dfdb7dbe8f47638e8fc": "[ru]资料上传操作",
  "a6fc9e3ae6f4333a43ffc1774a0b4347": "[ru]上传文件",
  "d31727f75a1914db1ca1bf74a465e862": "[ru]供应商提交人",
  "fc26cf0ac388b855c4e6290bc0f8d9fa": "[ru]供应商提交时间",
  "bf24e2953b0f44e4c6735d2901f5f2d4": "[ru]签字",
  "574f1f71394916dfe6ce47995032414b": "[ru]*请注意文件上传的格式(png,jpg,jpeg)，文件名中不允许出现逗号，最多允许上传1个文件且单个文件不大于30M*",
  "d31648a4df506ae717c25b2383dad4ce": "[ru]应急措施整改内容",
  "54c6a1f01bb7266e973da6e980bb096a": "[ru]应急措施进度",
  "ec209483c85ba4d8b4fe0a6bb9a19661": "[ru]应急措施负责人",
  "7cb23dc5363d7e6c623c4eaac17ceac6": "[ru]过渡措施整改内容",
  "5a749842eec5b0f6d35a0ebc1161ecf2": "[ru]过渡措施进度",
  "7562601714e915abddbac252a4b831e1": "[ru]过渡措施负责人",
  "8d32ea2592f27ea89605f1d62d081aba": "[ru]根治措施整改内容",
  "5a42d766cb48596305c93de13d0f2ac3": "[ru]根治措施进度",
  "3652ef72dfcb47e3088727dbccb1d4ae": "[ru]根治措施负责人",
  "8b096cd8b82b471b6c938f0656dc4375": "[ru]模具编码：",
  "8ae6b038d88f62e729669c9fab190423": "[ru]的",
  "9b535fd7874de069309f566e91bb42f8": "[ru]涉及模具编码,mouldCode",
  "0e617d665d7642a2a285f379f3a1623b": "[ru]8D Report 问题解决报告",
  "f5aa174d5a4ea33ebdaf179919d9f4b3": "[ru]发生节点",
  "39125539fd41060d2983ab512b49681f": "[ru]问题现象",
  "c4e4d17f02c02af7addef4bf35c7358b": "[ru]问题照片",
  "860c07ecd4a10201919ad7c60a8305b8": "[ru]其他附件",
  "bc083abed8c4b4e93dfbe11dc777d3e9": "[ru]不良数量不能为负数",
  "bbb16b07f2adf11e352b8a659904cd66": "[ru]不良数量只支持3位小数",
  "77775ce7aa3390fc98a52122e217d71a": "[ru]发生次数只能为正整数",
  "9d7e889697d5bae9d7f084bf83d7883b": "[ru]审核中...",
  "d13f37453a9c5140320a9e324df77f72": "[ru]8D整改状态不是待审核，请查看详情",
  "b9efb190eb9bc5a3608f5e0476cffce3": "[ru]获取8D单号异常，请重试",
  "f36ba1d2f48d6077c20eac94ead421b4": "[ru]现场审核报告(Execl版)",
  "f0bd6e721c07f9b2beeafee9b12b94fd": "[ru]现场廉政声明(盖章会签版)",
  "f3ab1051631ccc215e37624f9574e285": "[ru]D3阶段待整改",
  "dfc2cded0e87d1d023746ee92c4ef143": "[ru]D3外检经理待审核",
  "8cebfdadf0905251e613dde86940bf2f": "[ru]D3外检经理打回",
  "dd639492319811f67e28a550b5ee120c": "[ru]D4阶段待整改",
  "6e7129e2703d6dca68e7a2bd1f369590": "[ru]D4SQE经理待审核",
  "b50becd4599e95d8086541d97b400dd2": "[ru]D4SQE经理打回",
  "70a4cb3343653d96e17ba2c251c68b53": "[ru]D5阶段待整改",
  "7713db72dc8ffea98cf10105f3f1c685": "[ru]D5SQE经理待审核",
  "30d3b2b381941ac1dcf76448e2f860b5": "[ru]D5SQE经理打回",
  "28196eed44d105874d713d15e2c4a816": "[ru]D6阶段待整改",
  "f68b14eff4301792293c6c437cff0b77": "[ru]D6外检经理待审核",
  "7b0af4cc150b2b7fc36eedb9fe90a3da": "[ru]D6外检经理打回",
  "7bd5402aa1ea69971e2f4cca645481c0": "[ru]D7阶段待整改",
  "e7e3ab7455517a4e248fd81add085236": "[ru]D7SQE经理待审核",
  "682e022806e58a448a975b1aa9aa079f": "[ru]D7SQE经理打回",
  "1ef222016beac05f890e7224fd6e68cb": "[ru]是否自动创建",
  "5ec06a63e1ae74757563cd0923af7c6b": "[ru]实际闭环日期",
  "2a219c2f02cb8eacbd589a136183f273": "[ru]录入人工号",
  "ae762b31e735d05f32b0f8aef726da64": "[ru]流程节点",
  "cdf4c338d7a7bd075be9224a8acbabf5": "[ru]请选择一条数据查看8D报告",
  "b430bf6a5b06fb0b980fe3820c3a5a9b": "[ru]8D整改单导出中...",
  "65e42fa4e113c64a4c6da7ebb7bf2aa1": "[ru]D3待整改",
  "7aaa551969e05fdeebf81e9865c2c813": "[ru]D3待审核",
  "fa73df47a9f7e88c23e4fb592b15b8a7": "[ru]D3审核打回",
  "63360bb16bb52f1e2234603ea37e1002": "[ru]D4待整改",
  "bbb7f44a862c3875ae857cd080bc4c42": "[ru]D4待审核",
  "407c1ab8a02df55a0e0ce61180f76fb2": "[ru]D4审核打回",
  "1b7679d158eaa255e35d80c65a56dec1": "[ru]D5待整改",
  "c6d38da672e5cc6f315b27ca61361f34": "[ru]D5待审核",
  "ac3a319d16af41c97653ccd0ac6e7e8f": "[ru]D5审核打回",
  "65268b512a2c54379b200058df94490d": "[ru]D6待整改",
  "8aed3e417bf3464b2047043475c951ac": "[ru]D6待审核",
  "227803b7875fb91af7d3a0d8826b2770": "[ru]D6审核打回",
  "b0a13d1082935b1ed383e40e4cb298f5": "[ru]D7待整改",
  "cf5cb17196114224bdb77eec5175c43c": "[ru]D7待审核",
  "60bd8705d63b21b483874cb9ce85a343": "[ru]D7审核打回",
  "b78687d00c3cddc61ef7a691491f8a84": "[ru]D7审核通过",
  "5b45f92ecdfe2b29d9ca0494605f6824": "[ru]实际整改日期",
  "d796b8fab939d645220fccb4613e501e": "[ru]无法整改",
  "44722d5fa7ea0b0e23bd9e0692358dc2": "[ru]8D整改报告导出中...",
  "a9461c2f94d7f5c933ff2af4ec45d775": "[ru]8D整改报告.xlsx",
  "dfe56f61cf4d943cebb1374aa646a9bc": "[ru]无法获取8d整改单号！",
  "6b10dc4dad442b0484d09b2b37e6b36d": "[ru]审核",
  "f13734dc95b473a0ee810dce3de5ea94": "[ru]审核人/审核时间：",
  "1b3caa74c2c1d29de60b91d59fef652e": "[ru]产线SQE经理",
  "382c22846aaa969700a733e7c339a826": "[ru]维修备件月TOP不良",
  "f8170638df3115a87aeaef696d49c7e9": "[ru]要求整改日期",
  "08d9761d7fb9848bb94f48818f0e3c7d": "[ru]点击查看",
  "8b9092f5446b60b4a283b5e05394fba9": "[ru]备注：请工厂关注市场不良件的返厂。",
  "02c91077a933bfe3073f8d48e838ba9c": "[ru]备注：请按“故障现象”的分类对用户抱怨逐条分析、整改。",
  "d09466ead935e18965477af0cf389a4f": "[ru]D1 成立团队",
  "408bc01772a1ac37ceb1dda67966fe00": "[ru]团队成员",
  "1e1459eeed6da94506631a690c7efeab": "[ru]部门",
  "5a93d3f72d13b6f878f30be38a9faa68": "[ru]电话",
  "125e7b5993a904464e00c0dd8d58efc6": "[ru]点击请求完整电话号码",
  "36141e200cd59be79afa99f19b89e543": "[ru]D2 描述问题",
  "61c71ab134cd5c03977ad7f1f9b94be9": "[ru]整改",
  "9d277bc2c8bdef874509ef6e63c763a1": "[ru]问题描述：",
  "e0ed0085b05af43214f019af7c6f907d": "[ru]描述人：",
  "39807a5007e1517466765effcaa1ccdb": "[ru]描述日期：",
  "8c7b534441120d03f01139a47566b797": "[ru]D3 临时围堵措施",
  "dba74eb22caafd71230fadbfab5bce8e": "[ru]临时围堵措施：",
  "e4c5f1ac6eb9e65722c7faf4b6183660": "[ru]执行人：",
  "0b9da7f965d525ffbd33b9b7fca5d692": "[ru]执行日期：",
  "aa231a87eec9b43490f0dca2db74064e": "[ru]d3资料上传",
  "7ab6cd8ece2281455c317fe34b26ba4b": "[ru]D4 原因分析",
  "0ee799e069d063cabcc24cb99ec351e0": "[ru]寻找真因（利用质量工具）：",
  "477c4caad13c44bac66439a3bb8020da": "[ru]是否模具原因：",
  "3b8805d16e9b8ceb301f9a734ea3f1ee": "[ru]涉及模具编码：",
  "326921e1ea0aeee5c74547ab89113f99": "[ru]请注意文件上传的格式（JPG、JPEG、PNG），文件名中不允许出现逗号，每行上传1个文件且不大于30M",
  "5ec29ad00c59a9f8b5fd6b081e87ad5a": "[ru]请选择照片...",
  "ef4b789a2e4069354f0ae6aa157e023e": "[ru]分析人：",
  "7e5ab3ac532e69f65363e457baccb43d": "[ru]分析日期：",
  "04d03035ec9598ea22c52d8dce4cbc1f": "[ru]d4资料上传",
  "7863191369235499f42cbf8553246bbb": "[ru]D5 选择及确认纠正",
  "6322cb338f9d6790b832c0e231c6d918": "[ru]纠正措施：",
  "7f062dfb8078b59b49ffea9526fa5fe2": "[ru]完成日期：",
  "72cc0b8bea29242a49429b23ecdb2fe8": "[ru]d5资料上传",
  "9e9d0a2e85f27b2c9a0ccd8458ada87e": "[ru]D6 执行及验证纠正措施",
  "a19fa4b1bf30b36470262f068bfae7c7": "[ru]纠正措施效果确认（数据证明问题解决）：",
  "e71023dfb4104e8bc23e8ce84325ba95": "[ru]d6资料上传",
  "8d6f9ed8f522b325d0e7bb255220b25e": "[ru]D7 系统性预防措施",
  "ab2acf45e8ccb6ac2fe0caf8879cfd9d": "[ru]预防措施（通过修改工艺、方法、相应审核计划防止类似问题再次出现）：",
  "3ec2a6a87f3525711be8be88542e8fcd": "[ru]验证/确认：",
  "9e88e36f8b85c74a8c30501d8503c517": "[ru]d7资料上传",
  "a8568a584b8e5d8c229d5a4e86a7eeba": "[ru]D8 课题关闭",
  "2e0940e621b79b549f77cc53ad864dbb": "[ru]闭环",
  "9a6fd0158ae38068ee54a2642935324d": "[ru]所有相关负责人签字（海尔端）：",
  "d166e0509f872cd5037f7e6ac244a5f7": "[ru]所有相关负责人签字：",
  "8da857462485c3b7c493174add5a6155": "[ru]问题关闭日期（海尔端）：",
  "d080da011bfe8d9cdf36b74cd62049f0": "[ru]问题关闭日期：",
  "f8708d9b1d0730d78312dfc4de072db0": "[ru]提交当前页",
  "afb18d69b95858c63542921fccbd62ca": "[ru]附件列表",
  "d1a00e28e741687fa52a0e0abc3e362f": "[ru]附件名称",
  "76638bc5735ffd70ec28dde6c4ce0793": "[ru]附件地址",
  "00480a12952453a390ca55050b34f4dc": "[ru]工单号:",
  "684540bbdd83f3b604ffba5b392cfd7e": "[ru]故障现象:",
  "bd350d17301366b44170008c99c8c6d2": "[ru]对象:",
  "83cd88551261ced84c69c43d09c3a3b8": "[ru]请先上传模具问题照片",
  "609fe89d564865bd399d9e249f9cb186": "[ru]D1成立团队请填写至少一人！",
  "adb1983c6d9174a44142709d2d86de74": "[ru]D2描述人为空！",
  "5f43647456b6f3d33cf1c3e4635ba9e2": "[ru]D3执行人为空！",
  "f4915aa360effc8b22cec64a0ffdaddc": "[ru]D4分析人为空！",
  "f850a16fd9b4eabb17a6c619a7201c5f": "[ru]D5责任人为空！",
  "b1b0ead0ed28dba81528190d4de6eecf": "[ru]D6确认人为空！",
  "9e3960d0032cffa0174e80f79466f1d4": "[ru]D7执行人为空！",
  "808c1a71e4912816bba06a754de13f19": "[ru]请上传D7附件文件！",
  "88057b3812428711752c1e09435e83ef": "[ru]请选择是否模具原因！",
  "a4608bcc4afa0d7d081e81537cf23345": "[ru]为空！",
  "dc0068b76d006deaabddd1f7def438c7": "[ru]审核意见为空！",
  "15560024fc3929053239f43e7b2a217c": "[ru]查看号码为：",
  "29bf54454881359631814cf2fabef2da": "[ru]未找到电话号码",
  "be9dbca034a23a8b674af53671e2219a": "[ru]暂无数据！",
  "5c4cc96baf654ad1cdf4e96df50fd975": "[ru]维修备件不良明细导出中...",
  "36fde23f7d0f76ac30126f5a761c874c": "[ru]维修备件不良明细.xlsx",
  "a73c370174d2302a4e2f30d84c1bcbf9": "[ru]整改详情",
  "8dc6cfb878253af0e0547a4e52cb254c": "[ru]整改审核",
  "e3e417b412a4ee1bcd18070935d3cb70": "[ru]停止检验通知单",
  "3fa530780baa7ca2cf7d7ace341d41dc": "[ru]物料名称不能为空",
  "212c65050fc6c98b56bad4329c2f1e4a": "[ru]工厂小微不能为空",
  "bab1beec415fe29a88634eb2e34c8ff5": "[ru]问题类别：",
  "a4074f8a07e037ec3010d020a4219752": "[ru]若选“重大质量降标、材质不符、型检不合格、RoHS不合格”，",
  "36b30d9468d0f418614f8b511032afbf": "[ru]系统自动关联，实现同供应商、同专用号，在所有供货工厂叫停。",
  "1427355a868b830dac8d1a5cd693bc6b": "[ru]问题类别不能为空",
  "bd7258d987eed5971edb642db1dc11c5": "[ru]现场不合格",
  "26a4703b71cc62f9acd8a58277900f2f": "[ru]停止检验原因：",
  "fd1e0f9e8250e80d2aab0a151800b567": "[ru]停止检验原因不能为空",
  "751ce6b81f5a06cd38c9b508565566a5": "[ru]备注：",
  "aa94a1e2f4f366552c992c68b10e2fb3": "[ru]备注不能为空",
  "6beec3d1bef41566e4688f83f01a3be7": "[ru]编制：",
  "ab304ac0acfd01f2d2e411c07463fdbd": "[ru]编制日期：",
  "629e25507af644df3203fa228b40aaaf": "[ru]停止检验日期：",
  "b6dae3bc073df0698f9d10f31bd3d063": "[ru]停止检验日期不能为空",
  "962e1e9f2b5038064a8608e1efb96386": "[ru]要求整改闭环时间：",
  "e8e61cf6780e78e53531758ef37f1a72": "[ru]要求整改闭环时间不能为空",
  "7c1a74fd29d1d95027573aa726f8dfbf": "[ru]邮件通知：",
  "1582ef1b7a0ffe2963df7f9c0ca178f5": "[ru]停止检验预警通知单下达之后，必须邮件告知",
  "e3b2ecc58cb2dad77623dee3e032b446": "[ru]GO采购经理、JIT、配送、质量小微主、工厂小微主、供应链长，",
  "72bfd83868a6f68ae94beb066dda0cd4": "[ru]确保相关部门提前做好相关准备；",
  "1c70df08eacf42c988120ed10d2d9d24": "[ru]邮箱以英文分号分割（如：zhangsan@haier.com;lisi@haier.com）。",
  "48f3a7dde5ae60aad0832938211c5deb": "[ru]邮箱地址不能为空",
  "90bb728b0d74403d1662b4e217d8b27a": "[ru]上传附件：",
  "1d5fcd074aa1b2c889f62333dfacec5e": "[ru]下达",
  "4d8b6d7b890f088e863577a6608e3678": "[ru]申诉单创建",
  "1adff36d28b18111c04cd459cd26a5e7": "[ru]申诉内容：",
  "b95874a69f53985b0f1723a46462a494": "[ru]闭环检验(具体见停检流程)",
  "46977ac070c55d50cb055a4a773f87d2": "[ru]1.整改：",
  "6b507bd5ba58d54b1873f34398950b45": "[ru]是否供应商（责任方）提供整改分析报告、零缺陷承诺书、整改物料，交工厂小微验证；是否GO经理（主管人）督办供应商（责任方）整改，承诺整改真实、到位；",
  "4542ea5974e4e48b80d17dd07a8f78bd": "[ru]2.验证：",
  "005ca3271cb9b698f0ed6943ec2387d6": "[ru]是否审查供应商（责任方）整改报告、承诺书合格；是否组建验证团队，去供应商（责任方）现场审查验证合格；是否验证整改物料合格；",
  "5df3ecf6db8d52ab424e3b43bf0e49c3": "[ru]3.闭环检验：",
  "ff59f0a06da5aecb0d3b8ba32ef2544f": "[ru]闭环说明",
  "ac63d506cf4dce4b8b201170b8ccbe4d": "[ru]闭环人",
  "e4372d7b42c7d5899019c3160b56e1a4": "[ru]闭环日期",
  "f531963172b2eb318f7452d448b23a24": "[ru]质量小微主闭环审核",
  "47c82d8a1d5e3fe61cf6f7e4c8ed906a": "[ru]质量小微主闭环审核人",
  "734c9153371d3c782eb2402e96fdabc6": "[ru]质量小微主闭环审核日期",
  "bc50786c52f189359fcbd4b193c1a3aa": "[ru]闭环审核",
  "a36efc14dd33504d559a7f6990afe43c": "[ru]请选择闭环审核结果",
  "9e9618443fb9bdec13dd19a7a354dee6": "[ru]闭环审核说明",
  "beeed4c01436e7af631688717fce7826": "[ru]本部质量小微主闭环审核",
  "931d1d2efd96010afb416f7166d74445": "[ru]本部质量小微主闭环审核人",
  "c0aeba59b833778c0bc62fabb069f51f": "[ru]本部质量小微主闭环审核日期",
  "44db30b36ff2ba44a3b1aa752ce0b883": "[ru]登录信息获取异常，请重新登录！",
  "153bf2ee8b97f87496a78fda181e63de": "[ru]确认提示",
  "9b7881ef278aa52c990f52a9e8cc6fd3": "[ru]闭环审核成功",
  "e12a3630be263185d2e5c4418427aae4": "[ru]获取停检单号异常，请重试",
  "0036ec828b0eb3147242d87b0cce5941": "[ru]停检恢复",
  "62bd4ea4fe542fa2437d0f7f8fa98a56": "[ru]停检复查",
  "d769fd8578e09c0d6305c3a2c155f2f5": "[ru]恢复人",
  "f6e1577e70d7b852d6395bab4f8902ca": "[ru]恢复日期",
  "29f7def48a9783ddbd21b560ff8ad556": "[ru]恢复说明",
  "de4ef724e7feaa971721ded74660d470": "[ru]恢复见证资料",
  "0114d1965f3c868f3e707b64adb4fd10": "[ru]复查人",
  "3ca8315fd45ea0711d5bf47a37d54de8": "[ru]复查日期",
  "9fa449699ad1d463ce1b23bd265b7303": "[ru]复查方式",
  "a55918f2c52fd13a1cfd607af5db35dd": "[ru]请选择复查方式",
  "8adcda5245ef59624924203d57fa44ea": "[ru]复查结论",
  "5703c9ce1ff181d46a5242a681781465": "[ru]请选择复查结论",
  "3670ea3a70b70211210a550a930f9199": "[ru]复查说明",
  "1db042d1c0a54c38380ca7e1eb9061d7": "[ru]复查见证资料",
  "94e0b6da2852aaeae284333bc92311c7": "[ru]复查见证资料不能为空",
  "2d6a33453af1a921beb3f33b6f1632d7": "[ru]停检复查成功",
  "32e17309a4eb6cf3577396ea10647877": "[ru]停检复查失败!",
  "8d617bb5a56d7a37075ea034f9ddedcd": "[ru]请选择是否闭环",
  "f52eb19cc823218b6b93a1a54b462c10": "[ru]要求整改日期不能为空",
  "a50b39addb427175fbcb3d46c1c5080e": "[ru]确认进行闭环操作？",
  "4d5fa09d8e1d8ab91978ff1c8d1f066c": "[ru]闭环成功",
  "fe44aec7f0f46a49fcb11119b0407f61": "[ru]闭环失败",
  "cbdba878d17090b8feae391f103e1ad2": "[ru]问题类别",
  "43f4b1c67ba8f2c2a16e0cf34a2c7de6": "[ru]试验",
  "4364e2f1ab6b3c5e4a2ae0171cdb96e0": "[ru]手动创建",
  "5bbe8e75b7c8c3fe53bb9e5023cdf744": "[ru]自动跳闸",
  "fda80c6291fda13f91297a5a39040c4d": "[ru]关联停检",
  "675c9d1fffc102463bfc11e74f76ccb7": "[ru]现场PPM",
  "3cc69b5bf423fbc0f0746b43ca7ce0b3": "[ru]是否备案",
  "55ebf36b676c9893d645d6447fe97824": "[ru]编制日期",
  "21135ce9bd851afc61c126940f09ed84": "[ru]停检下达邮件通知暂不支持QQ邮箱，为避免影响业务运行，请供应商及时更换可用邮箱。",
  "9f8e275297ae5e7fcbb73a12bee17fb8": "[ru]待",
  "57187972b89fde3ceca4aeb7847fc8cd": "[ru]是否恢复",
  "bd51532715200bf11b6437f0d7590a96": "[ru]未恢复",
  "c0de82e6d2c3df1b0fbc6a7ebece0c8b": "[ru]编制",
  "a490659b0cc49464ae2ca5348304abc3": "[ru]累计停检次数",
  "dae79202f316da91602133e7c3a6a6b7": "[ru]应复查日期",
  "650004574dad368e57b528a8d37b20a4": "[ru]实复查日期",
  "c6278ef07ae975b229e03b2205f2670b": "[ru]复查结果",
  "14638c3090ed989442ad2276b900401d": "[ru]未查询到流程记录",
  "e0f035a67d1ac7b3f5c75838db08922f": "[ru]请选择一条数据执行此操作",
  "5a9218f5af08aea2313890e31d64b47e": "[ru]请选择待闭环或质量小微主审核打回的停检单执行此操作",
  "120555d09c31e27c15f6c85351de2622": "[ru]当前用户没有停检闭环权限！请联系",
  "237ededb0a639669748a3a60b3e891b7": "[ru]当前用户没有停检闭环权限！",
  "bec8776591060ba6654cbc967da9761d": "[ru]请选择质量小微主/本部质量小微主待审核或本部质量小微主审核打回的停检单执行此操作",
  "7741f84fd1d7f3032816bdfec3027dce": "[ru]当前用户没有停检闭环审核权限！请联系",
  "b2af8d87f04aab69f5934f91c1846847": "[ru]当前用户没有停检闭环审核权限！",
  "4c36191adc9db97c98f52634ae0f1c11": "[ru]只能选审核择状态为\"质量小微主审核通过\"或者\"本部质量小微主&SQE审核通过\"且未恢复的数据进行恢复",
  "4ef23d2dd9b75e2da5b16b4048cc87a8": "[ru]请选择停检状态为\"已恢复\"且未复查的数据进行复查",
  "6e0f0d935f4efdb2a9e06be2ccee5321": "[ru]请选择待分工的停检单执行此操作",
  "040a2cc4c10a83d3c49795e1f0b9d836": "[ru]当前用户没有停检分工权限！请联系",
  "b9f50efc5365ac89a2aa42e634f1386d": "[ru]当前用户没有停检分工权限！",
  "6d37ba6ddf6f1df5d6aef5be7d268d87": "[ru]停检分工成功",
  "a274c17922f630552bdb9707bfcac52d": "[ru]停检分工失败",
  "fe0be8de33bd8dda68ddc037da08bdbf": "[ru]停检单导出中...",
  "0eacd7f27bb95431fa76b7b106f297d9": "[ru]停检下达",
  "c30e375bd60856ac7d2a871a1af0cc6b": "[ru]停检分工",
  "f50082f373125ff2f09eab1f4d78adcd": "[ru]停检闭环",
  "0ae5f30bec0cea320fff0023eca24cce": "[ru]停检闭环审核",
  "e12f7582fcf4a28351f6e059a3800082": "[ru]SAP记录",
  "1035cce005b951d34d215e8a89628236": "[ru]恢复见证资料不能为空",
  "f9ed8ada59f28fa41428e88f7c5bffdc": "[ru]停检恢复成功",
  "f5aae3b0e88c991f48e2d187ed8d25a5": "[ru]停检恢复失败",
  "a44609294d73280ea41e181cfb2cf0fb": "[ru]调用类型",
  "8401ac7e9a7b99c00d8c2fbf6b707b21": "[ru]解除标志",
  "d8c7e04c8e2be23dd3b81a31db6e04f1": "[ru]信息",
  "d8d7ca77e957a505e5f4e78ca64a047f": "[ru]中断",
  "c5be7285cfbb8db86adacca60325a8d0": "[ru]默认查询编制日期1个月的数据。",
  "a9136d28a841943b5e954d9131a70835": "[ru]无法获取停检单号！",
  "5790266c2afb64c88b3d7d537d57a471": "[ru]停检单.xlsx",
  "f218d8e773a5c9bdf6d7f6f3f67c8480": "[ru]停止检验原因",
  "69eebddeb52a7e749f41b3259e313f3f": "[ru]停止检验日期",
  "21fcf3e1a68d074169f73dcebdf31c55": "[ru]要求整改闭环时间",
  "9bf0a8746b56b471e5171610dcb512fd": "[ru]要求通知到部门",
  "e33a85b78c79888a2abddf47e51685fb": "[ru]维修备件ppm超底线",
  "a5141424bf5f347c34af071f86e105f2": "[ru]GO采购经理、JIT、配送、质量小微主、工厂小微主",
  "cba5ea450ff9504a55853e7f6c6eeeb4": "[ru]GO采购经理、JIT、配送、质量小微主、工厂小微主、供应链长",
  "a387575fefbbdf1383cc1ca6a57d2b00": "[ru]见证资料(需经质量小微主会签确认)",
  "bdab0ed517165ad8afce629632313a57": "[ru]PPM底线",
  "f6f3d1ed8f90006c1180a3dfca10928a": "[ru]年不良量",
  "8d6f6532e39e34a28881c293e15bc937": "[ru]年供货量",
  "2371f6af1a8666a36f746d0dfcc132d2": "[ru]年PPM",
  "c7db6d4f1a42987a0df962e927926f14": "[ru]恢复",
  "1235ea8893e90b8e0d74b6004fbbdb6c": "[ru]复查",
  "276074b30c8b1696dff88bc93acc6287": "[ru]补料指示书",
  "4933ca41e65042dac0c6e02a476017ea": "[ru]待收货",
  "906b4355509b94469b91bdb04908323c": "[ru]现场退次号",
  "430f7d75f762ff6f05589bdf98b25cb6": "[ru]收货",
  "c800c8e36bd543ebf7520ba90c9422db": "[ru]默认展示生成日期1个月之内的数据，可选择查询条件查询更多数据",
  "c712266ab06ef96d008cadd501ac4d88": "[ru]物料",
  "6aea70a330451c728283e4765fdeca2c": "[ru]收货人",
  "f20a1464e69b8beb7706725bb8557bed": "[ru]收货日期",
  "872ad7fd54128128bfc4651fb9f86a7b": "[ru]请先选择工厂小微",
  "2cf61ad2243e83158d6104caa77c0f03": "[ru]线体查询中",
  "5487a005aff32a7ac4a1d12e789196f9": "[ru]线体查询失败",
  "e702c89134f48faed108f7d9b0a6be18": "[ru]请选择待分工的数据进行分工",
  "639164ce6b39fbd4289a9ac4c56aa6ee": "[ru]权限不足需工号",
  "62f9ad4ceceb394ca7ce4b14f083ee9a": "[ru]检验只能选择一条数据",
  "0032155f2abb1d5159720ba3bb4d59fe": "[ru]只能选择待检验的数据",
  "2c8c7effc83dda6141748b0b43dc76c9": "[ru]收货请选择一条数据",
  "283ea0641cfad2abb9ed2a5f43979bba": "[ru]只能选择待收货状态的数据",
  "4787ccf134a89cc4b4a7f204384ddceb": "[ru]只能选择同一供应商的数据",
  "dfb6b2c3ef1b244fca804c2627b24680": "[ru]确定收货吗？",
  "7df8bb73f6fd91eef34e58bebba66c47": "[ru]收货中...",
  "44cd2f0bc182fd55c4f5095b30799b9c": "[ru]收货成功",
  "4e3b4e58e11b6b50da43ddedc7ef9ef7": "[ru]收货失败",
  "557c58a319d9083afe1f4694e6951535": "[ru]确定一键合格吗？",
  "5cc9da1bbb619711f402e9ccbac77428": "[ru]合格中...",
  "0b83c0b30001cba2fa57b3040b63f1fc": "[ru]封库",
  "0e2fdc19c024d3eb0d5fc6f4a37df69f": "[ru]补料检验",
  "4777d9c4105359c79a66b594284acfbd": "[ru]企标信息为空",
  "e932464ba5d01d8b285712e06f83fba4": "[ru]请上传不合格照片",
  "41efe2acf2bd1d1c12e09a058cc20bab": "[ru]请上传其他见证性资料",
  "b07f810d473ff5dc2be3f3a84aec71bb": "[ru]样本大小只允许输入正整数和0",
  "02ad5eb5fae9e3ecf27801ee61f7e720": "[ru]外检网格分析报表-人员",
  "fb60aa32e0869b09eca5508d6e9f9ce2": "[ru]新品检验完成率",
  "a7c7cebbf4e217706bebe8584402460e": "[ru]完成率%",
  "b32b8d5d6c9ebb35587c8e6e812bbf26": "[ru]入厂检出能力",
  "ce879f32b86dfff29fa7c2b26b7a3661": "[ru]同期",
  "06f26e9d1d33084b79545b332234d2b6": "[ru]实际",
  "c0b4e781297634c75aa854af5d6043d4": "[ru]应闭环数",
  "b9481e101ac0fb52a2cbf39b9c5dbea3": "[ru]实闭环数",
  "63354e168133d55b286ff958977e42a0": "[ru]激励考核项目",
  "1ccde956168bc3790a8cdabd7ed5be82": "[ru]正向",
  "72fd25a0fc2ad61ec693a3514cc05f1a": "[ru]负向",
  "b3122621f05a6a0fb0e484808d461c0e": "[ru]4M1E模块验证完成率",
  "8ef83f772c480b655ec65c7361e15319": "[ru]导入数据",
  "ad4656eb61c7bb651f6d3964f53aa900": "[ru]外检网格人员维度导入模板.xls",
  "1679a878917fefa113ba540c8a78dc51": "[ru]外检员维度报表导出中...",
  "86b541f104bcc09abfe01d61fc8c6584": "[ru]外检网格分析报表-人员(全)",
  "da1837def01a0bc6f2c67a2edb0f72d6": "[ru]监督检验完成率",
  "7c3c039752600a6c63983dbd743476d0": "[ru]周期检验完成率",
  "8efab171fc8790ca554c9ac549222479": "[ru]现场批量漏检数",
  "16262098674d8f835c41f78e40961814": "[ru]不合格叫停",
  "fc3bcf3b6b0c59d9794849edaea7f7d9": "[ru]权重维度",
  "d1504cd2a2a1fd790afb05929bf6bbf8": "[ru]新品检验权重",
  "8687fcab39bca53c654c7551c7e02887": "[ru]监督检验权重",
  "36d3b0315cec76217a884117dcdb25e7": "[ru]周期检验权重",
  "f1060e0f6be491b4bc9c12730bad0c27": "[ru]入厂检出能力权重",
  "a2a50df3fa089e80f1ffe97a53c914b4": "[ru]现场批量漏检数权重",
  "f24356105b4444d2a892f16c57547929": "[ru]不合格叫停权重",
  "523ecb7e1ecb5287ee0be34f25d38f06": "[ru]问题闭环权重",
  "3da149d03be3fdc177b93faac984236d": "[ru]外检员维度",
  "8d6e742b24c3029f2ca6e40f4806aee1": "[ru]外检员维度报表(全)导出中...",
  "559dce077030e42f801f200aae7ad93e": "[ru]外检网格分析报表-工厂小微",
  "0ec94a3708ad990830d08ed033d28b86": "[ru]本月",
  "c5d35890464bc324d1c4a75612fd17b6": "[ru]上月",
  "257b0e40beae66e07d3a19077142ad0c": "[ru]人员达标率",
  "c9088f43cfb2740656651f4ce7d082fb": "[ru]总人数",
  "735b1839299ac162e8a7c6424f379633": "[ru]达标数",
  "b4da525f8480dcca7410d31f3f6c2e9e": "[ru]符合率%",
  "c3f9a172e49d33421617c0da6b8e041d": "[ru]下载模板",
  "529115740bb69d1a77a72f2657493e4d": "[ru]工厂小微维度报表导出中...",
  "204777574531704b8caa3889d5e28342": "[ru]外检网格分析报表-工厂小微(全)",
  "408dc4e5acb8cba0701cd837ed58f318": "[ru]市场损失额（当年）",
  "5ee9605b44f097f23a923f279297bb7a": "[ru]市场损失额（当月）",
  "399e8da91d447ac2aaa1f2b63b9bf892": "[ru]损失换回率",
  "b8d3d7aa0f89239b5c6c7e1457734136": "[ru]现场ppm",
  "999519cb981388ea2847f391ab4e11d7": "[ru]外检体系",
  "73e82552c8c15694ce789056f5278f9e": "[ru]目标",
  "1ee047967707ab1a3ee0bac1366c0802": "[ru]新品计划BOM导出中...",
  "7141c150d2110024629d8ba86e499e44": "[ru]物料基础属性报表",
  "f0657f3d9e304bdafd0e4fc52cbb4141": "[ru]样件单下达时间",
  "6f9f9056a0ee7b12cb1f6751c0ae73a5": "[ru]物料基础属性报表 导出中...",
  "6b9a572b32fe1c16ee8831759548551f": "[ru]请输入至少两位供应商编号",
  "4d78098cdf5e60427f0a77818b5517ec": "[ru]物料不良报表",
  "a2a46babc30912f42c702955c3a6395d": "[ru]是否跳闸",
  "1bf14b4232f1670791920474e68eb35a": "[ru]入厂-检验批次",
  "0f90300cd0f676f225339ad717fc9b2b": "[ru]入厂-不合格批次",
  "a50d68defaac0377ae5302d954f6730f": "[ru]VMI-检验批次",
  "3c46af4c91c543633a6ba1252e4e3c28": "[ru]VMI-不合格批次",
  "4612ede97c5edb57aba2463b734b4d5c": "[ru]入厂-当月入厂不良PPM",
  "f381fdb779c9e1130897aac8e4359efe": "[ru]入厂-跳闸线",
  "cc847e9b504b07863c9ee81e79e7462a": "[ru]现场-不合格数",
  "a0fc4918a8740e1426d1597722769219": "[ru]现场-当月现场不良PPM",
  "a6642604624a3727fcd1f62fda505dfb": "[ru]现场-预警线",
  "7409c772f1d1ed4343e943dd06e14ea1": "[ru]现场-跳闸线",
  "706bbb5b959427b56298686468855ac9": "[ru]市场-不合格数",
  "54ea34d8036e01d8d2973eacd93e16b0": "[ru]市场-当月市场不良PPM",
  "d27b85510a98d96370196c6808b70531": "[ru]市场-跳闸线",
  "b3e5d86fa178197e132a668520235551": "[ru]事业部单双点",
  "7395e6c4bbce057b94c926588ab05ce6": "[ru]物料不良报表导出中...",
  "7db94f6bc76f5a3493cddbb4c6f09680": "[ru]样检单状态",
  "1313dc2234ab613c969d3944e1dab5cb": "[ru]分工未维护",
  "d064b911bf12167e58cbd8a4e02d8979": "[ru]标准未维护",
  "d75edee2155191a3b856ce3a28b80262": "[ru]开发未收样",
  "84ea3d2a3c452550ef181ddd9785a41c": "[ru]报告未提交",
  "20bf70f9cd92d2ca07b4589b86814e40": "[ru]报告未审核",
  "0d967132abf0ab868264f623c7646c6b": "[ru]供方未送样",
  "4ea63e4f4b1f9b84d1ff00343afd70bd": "[ru]检验未收样",
  "6638ed28b746feebcfaa8df0e877438c": "[ru]实验未完成",
  "2c99ea615c9dd06841bf23acf6610091": "[ru]检验未完成",
  "7c774ba82565bef4de1b13798ab67102": "[ru]新品未结论",
  "ef017728bd290c72b6693a91f4a9ee48": "[ru]新品已完成",
  "ff5917ad1291c57cebf59059e2c58183": "[ru]新品未完成",
  "581dbcd0fea617e90ed531e3a7cbb84a": "[ru]新品计划BOM",
  "4ed381e93c44a9ce90e8ab35e8043612": "[ru]新品基本属性",
  "041a07e45228a36e04bc43ace7de4140": "[ru]新品类别",
  "c518641f05390a5099421e4253db7751": "[ru]开发经理",
  "0a06a7e482105e59a0ff11eaf41f5987": "[ru]供应商引进日期",
  "18d16d8b3c14e44b7028d169b18f7937": "[ru]新品应报验完成日期",
  "ef2c4c0e3bae48b1c535573a6575c234": "[ru]S1新品准备",
  "3e7e9a3632d2783ae129d0793cb34753": "[ru]S11维护分工",
  "66f1435ef4fbb74eed9f240283116a27": "[ru]实际日期",
  "83f159a8a1b3e845b803047bd096669c": "[ru]拖期天数",
  "da3cd1de74ebe7087f1e8032ac690554": "[ru]S12维护标准",
  "eb7b640f46411cfa86735502d35ee68f": "[ru]S13开发收样",
  "03194fdd90cf0b049d56a16c1d63ab9f": "[ru]开发收样人",
  "7f050f64822cdef30d7bbcbb9ff66f62": "[ru]S2新品报验",
  "21f48c80fbeea8751bfce3dd878f2b66": "[ru]S21报告提交",
  "718eb1665978b011a179a46e8e9583af": "[ru]S22报告审核",
  "2ca183b04937519877e5d1b13069a5a6": "[ru]S23供方送样",
  "77e55bcab9fc7ebb8f9a1a941befe527": "[ru]S24检验收样",
  "d75a36c97746020fc4c4d106bc3c78c7": "[ru]S3新品检验",
  "119253ece7236f5f3052f30fb5381a4e": "[ru]S31下达实验",
  "dab732bd71dc7f9d5094122c947597d9": "[ru]S32新品实验",
  "f99471bc51916d838720adfc7211660e": "[ru]S33物料结论",
  "0deee015ad2cf149d4516f9f4e9c6313": "[ru]S4新品结论",
  "6b0678180200b57516a1fa6b83ad0196": "[ru]S41外检结论",
  "725242560bd1247770106b7497ee8bc5": "[ru]检验手段",
  "eaffde622c7637144e20b89103f050f3": "[ru]S42开发结论",
  "8d70aca614ffe6db1ce3cf9803071748": "[ru]总用时",
  "141b84bda070980e7fefa2fa172c7e50": "[ru]引入日期",
  "552c2c467635e49327f79e02b411274a": "[ru]供应商基础属性报表",
  "35ad1c81c73f90c6782e00ea38e96dce": "[ru]供应商引入时间",
  "93bb83f36115112361461d89d3e292bf": "[ru]首次供货时间",
  "beb451713970d720b7e26cbb01815025": "[ru]VMI不良",
  "ca8790abd5dd73463161cad11efd4e79": "[ru]实验不良",
  "dcfb2876a84e15cd6ee40407a072e98b": "[ru]四停停检",
  "0e0a66e5703926c805e9c736aaf26154": "[ru]重大抱怨",
  "d7cc5766efa51afe8bb4e8b93a4780c1": "[ru]当年",
  "e9ed9d3e8d55ab54fa731beaf8d49607": "[ru]供应商基础属性报表导出中...",
  "ff9329467352016e2584a5ef873adedb": "[ru]供应商PL物料大类",
  "3945dbdca23d3fc59a295b8acc2ad290": "[ru]供应商工厂小微物料大类",
  "985d91833019b5dc630df6792a45dab2": "[ru]供应商物料组",
  "cde0c8f9adeb9d731cc27a3b0242cf9f": "[ru]供应商PL物料组",
  "17a30981318dd8086c2af8079e7e318a": "[ru]供应商工厂小微物料组",
  "183638922bd15da8a03cb34e0955f0bf": "[ru]供应商考评报表",
  "a545beb316baae642a3efea863b9658c": "[ru]供应商分类/物料大类",
  "036c9330eb2a4e32134e5df6dff5ad1b": "[ru]合计得分",
  "a7ca2f0c298053bddcbd40adc3c66948": "[ru]检验批次",
  "18a4a58e58f5d3ce8a7c4752081c9ad1": "[ru]不合格批次",
  "5738394a1903a52ab49a86024cb3512a": "[ru]VMI检验批次",
  "196d7121c03e8aa0db72e394a9dc0e03": "[ru]VMI不合格批次",
  "781e5d3894638aaa1c3117477dff8b91": "[ru]入厂PPM",
  "4f1f3b1f9aad7eaa7fe95ee460222a61": "[ru]检验得分",
  "1950b854825cc756d9323863c110e8f6": "[ru]停检批数",
  "cdbdad0ded0fa862e963a726dd6e126b": "[ru]停检得分",
  "a8d0eebc285bb8cb1034f8f1d83fe4b0": "[ru]退次数",
  "5cedfd604ec8f54df2b943af2c8082c3": "[ru]退次PPM",
  "46b7ee97bf48bbefd872285811cd0100": "[ru]退次得分",
  "6d21c543eaf10aea0c87f2c052c51a4f": "[ru]拒收批数",
  "567036127fdbc3dd6f6608213c6114b5": "[ru]拒收得分",
  "6485c31e292ea0c0af4012127a08505f": "[ru]当年不良件数",
  "cdb3dc4fecaf3b1a65bfa97488b33aad": "[ru]不良件PPM",
  "18d350dafdf5a7a2ca84f84473b95eda": "[ru]不良件得分",
  "068f1d8f7bad61c8f2fceb6b8543d177": "[ru]当年不良品数",
  "f3cd1ed8c1331aa9b88e46813d23098a": "[ru]不良品得分",
  "c133c742ab79f16f914e7f9db058ea98": "[ru]交互改善",
  "5f7913eda7f6b329651fbdceca97257a": "[ru]整改单应闭环",
  "bf335a76ce242e13e2be2348297ae9bf": "[ru]整改单实闭环",
  "2927b9f71d06f44e9f65d8917c351358": "[ru]整改单得分",
  "932341e2b81d49db80bed995d2e1b247": "[ru]索赔应认责数",
  "dcd76f85ac2b7c5e0094a9091ee5be58": "[ru]索赔实认责数",
  "e0a5fd54a190c7ff4a7ea6be81a01b71": "[ru]索赔得分",
  "85f25f565abd7d27b7bf543d67487618": "[ru]新品拖期天数",
  "710b099ef0d6f82d72de49b564023794": "[ru]新品不合格率",
  "93fcc7baeabc0196dc22b378e7d24c40": "[ru]质量抱怨",
  "af1ffb7e1f1365b64e2debdae2436b16": "[ru]质量抱怨数",
  "5b43d68bbc77bc399ce6aacfba60b6dc": "[ru]质量抱怨得分",
  "2eba0f862099f3f41ade48dfa62bfe56": "[ru]月均供货量",
  "d431160569d2fa6b77a475d57c478aae": "[ru]供应商考评列表导出中...",
  "2a56aa49c7068741c8fc1d1de4acbe51": "[ru]母本专用号",
  "a285ac233adee3b770dd0b2c27354eaf": "[ru]母本专用号不能为空",
  "db4c75ff2e2f1246a6d344b43fc04176": "[ru]输入专用号自动带出物料名称",
  "261aef771e0245a077599b5ca686c499": "[ru]符合企标",
  "43b96b815c5fe334f51cbc1fe8dfe74d": "[ru]如同时符合两个企标，需单独创建两条信息",
  "96db1d224b7b0e84b63a820f1165873d": "[ru]符合企标不能为空",
  "1b9b4711fd9584e570c22e0d2ae70b0b": "[ru]材料组成相同的关联专用号",
  "16f940b5376dbfaa8b83be375a7d800a": "[ru]符合性声明如果修改了符合企标Q/HR0603001的关联专用号，对应的母本专用号如果存在有效的宣告表，将会生成一条暂存状态的宣告表数据",
  "e804d34ad855fce4ec3a73d9cd4331d7": "[ru]供货工厂不能为空",
  "0f3aea21e2c35774cd749f83fd968187": "[ru]请根据选择的企标号，下载相应的附件模板，附件需加盖公章后上传",
  "c228279b5256338a5516bea4c3b02088": "[ru]1、系统权限：供应商质量经理提交，提交之后即生效；",
  "8ddab98d19d75c816532f4bcc1086677": "[ru]2、关联专用号说明：对于同材料、同配方、同工艺、同公司的物料，可以在声明文件中体现其所有专用号，即可关联使用同一份符合性声明；如果没有关联的专用号，可不用填写。",
  "5cd3736775ec126a64e902eaff487e7b": "[ru]1,请根据选择的企标号，下载相应的附件模板，然后上传填写后的模板文件。",
  "0c72b57c85c26a7f2f8d863577c63ec9": "[ru]2,如果上传操作，请点击\"选择文件\"后选择相应的文件，系统会自动上传。",
  "abc3f82e3dd428decc61fd738fdb913d": "[ru]3,如果下载操作，直接点击附件名称进行下载。",
  "626f03eea2bec1c099651204621ff494": "[ru]4,如果想上传多个文件，可打成\"压缩包\"后上传压缩包即可。",
  "3dc1bbaffb3e2b25b326a0284ce89564": "[ru]5,文件大小不能超过30M,文件支持格式包含：jpg,jpeg,png,pdf。",
  "2bc21499c9adb3d1470d91b7f7bc7351": "[ru]模板：",
  "28f6f5a5f0cd6e37a861e06b2a8cccac": "[ru]*请注意文件上传的格式(jpg,jpeg,png,pdf),文件名中不允许出现逗号，最多允许上传一个文件且单个文件不大于30M*",
  "88360d515e15c9d65fec9f5c54e168be": "[ru]此专用号对应企标",
  "873ccfa359be9006222992b68e751d17": "[ru]已经存在有效数据，请操作原数据修改!",
  "82cf9fc7681ec05069e43a426038b1ec": "[ru]请输入至少四位母本专用号",
  "e438042cf0eee10d7843c9be1ac6665f": "[ru]请从下拉中选择",
  "3d315a0384ec4acc118a104480c10f75": "[ru]所填母本专用号已经存在有效数据，请操作原数据修改!！",
  "038ab5ae486746b822d01fd7bfc65a3e": "[ru]请先填写母本专用号栏位信息！",
  "a3dc26c2b768c5f447d7f885b67f58d8": "[ru]请先勾选符合性企标！",
  "47eb473ecc8a54b7becc1200b9cba2ca": "[ru]关联专用号不能与母本专用号相同，请选择其他专用号！",
  "491411e0ae5d09d5eca25a2b2f275e3b": "[ru]增加",
  "d384c8029b5bcbca018e742a22c0bc33": "[ru]产品/部件宣告表",
  "e243c63d5df68cbe2d77f4ea5d6cd723": "[ru]生效期",
  "9cd62f1b73111b1d5ca44c8b2438b47b": "[ru]2019年7月1日",
  "adae83b8d8e2ea891da840f74a05b88f": "[ru]基本信息 Basal Information",
  "747f9e41209109f904dfa3779284b959": "[ru]产品/部件名称",
  "605404ab9ebb3385c54baf979384eaae": "[ru]QC080000体系",
  "9a311a560c9c62304ebdf6eb84b54ec3": "[ru]RoHS承诺书编号",
  "809844de5f86e5f9da3e31e24d4e5808": "[ru]宣告日期",
  "dad736217dba5b136a0dedd3e7fc18ec": "[ru]模块商联系人",
  "5d73c09499a08557279f7554a0837404": "[ru]申请审核工厂",
  "a1323cc265292654b418fd3ea7509701": "[ru]关联供货工厂",
  "2a6ba6309f86aadbbad3718136bd5c31": "[ru]子项信息",
  "9f99aead0942f4af9d3f470e5a53a30c": "[ru]导出识别码",
  "1190e465f92cd349663a4f039d1548fb": "[ru]导出子项",
  "4679ffa33e394e4f42ab24f0d8e87c28": "[ru]请添加数据",
  "0fed9b4202906fda4163ff933c720d3c": "[ru]序号\nNO",
  "38fb2c29b97df521966a02700df60a8e": "[ru]子部件/原料\n Component/Material",
  "d0b1c375d0db90c02e085d4ccafccc10": "[ru]名称\n Name",
  "5bee2cbf1c40d6fb99695f9e8ce9032c": "[ru]规格型号\n Specification/Type",
  "08b6c0f71ee1e8e9a8204fd233635417": "[ru]供应商\n Supplier",
  "eb83d6aba5c2c415f03a1f8aee74b5be": "[ru]数量\n Quantity",
  "466a2590436cfdcab94118038f193387": "[ru]重量(g)\n Weight",
  "c7de2e3478b63313d3a2ea4af705d379": "[ru]均质材料\n Homegenous Material",
  "42d031140481a7fb0b9170f9e7975da7": "[ru]第三方测试\n Third party testing",
  "d19b97d1b680f9fff517aa87b3dd4bb0": "[ru]委托单位全称\n Full name of the entrusted company",
  "6a4b4cae25dafa30c8b0b1c12a8d7f8e": "[ru]检测机构\n Testing institutions",
  "11661e826a2e94ccf98fb3454ca826cc": "[ru]测试报告编号\n Testing Report Number",
  "a381566d434103ac8ae72ba424e60612": "[ru]报告附件\n Report in attachment",
  "146d232cc075b490b8f37837aeee912b": "[ru]报告日期\n Report Date",
  "0abeeb8fd90f9152522997c9a44b58f7": "[ru]有效期至\n Expiry Date",
  "cf56e4fc36a86482c47781c7068f18a2": "[ru]限制使用物质名称\n Name of Ristricted Substance /CAS",
  "454435f8e0405217d547f97bb0af100f": "[ru]Cr\n （VI）",
  "44cb4c4e9206b52b506d7265bc2f54e8": "[ru]是否豁免项\n Exemption",
  "e364f0695cbaefb34ec6f82487cc3503": "[ru]子部件/原料",
  "d7ec2d3fea4756bc1642e0f10c180cf5": "[ru]名称",
  "6ad1b6e0043132e6ae3f8a83487836bb": "[ru]规格型号",
  "6c29d4ed37f89101dfb74f516187d05c": "[ru]均质材料",
  "a53a82c8bf8fd124b587b26bcfad50cf": "[ru]第三方测试",
  "c4f0fba1ac12ee233a6b0c1783d5a771": "[ru]委托单位全称",
  "4e20e078c1d3a0805446e70bd8b4400b": "[ru]检测机构",
  "0877751ad0ca9072aad13edca6d986d1": "[ru]测试报告编号",
  "74dbfb5126af971d4b5955e3247199d3": "[ru]报告附件",
  "75cd7f22e38d44007e8ccacf06715b85": "[ru]报告日期",
  "54652da1d2833157982155fceb688813": "[ru]限制使用物质名称",
  "5135b5a91526f3e49c5e8638f7852f58": "[ru]是否豁免项",
  "ff2db8c65fc3486eb9363385e140ea66": "[ru]承诺信息",
  "82b1fc74a306980b7cff7450034dbd05": "[ru]本公司承诺：",
  "f48e5f1fdb1928fc7a7a8fc016912c55": "[ru]1.上述产品/部品宣告中（以下简称宣告表）的产品是本公司直接或通过第三方向海尔集团所属各公司（以下称“海尔”）提供的产品，组成表中内容准确无误。如果组成表中内容有错误，由此造成的一切后果由本公司承担（包括但不限于海尔因此遭受的罚金、处理事故的花费以及因此受到的损失）。",
  "3f7e951c643367479b1ce10378b854aa": "[ru]2.宣告表中任何内容的变更，将及时更新信息并提交海尔确认。否则，愿承担《基本供货合同》的违约责任以及因宣告表内容错误给海尔造成的一切损失。",
  "f6349c441652f0e053dcde768d5c3db8": "[ru]注",
  "84c5937d98cd93e19a20c644fff24a57": "[ru]1.组成表中的限制使用物质为：欧盟的ROHS指令规定的对人类有害的化学物质，即：1）铅及其化合物2）镉及其化合物3）汞及其化合物4）六价铬化合物5）多溴联苯(PBB)6）多溴二苯醚(PBDE)7）邻苯二甲酸二（2-乙基己基）酯（DEHP）8）邻苯二甲酸二丁酯（DBP）9）邻苯二甲酸丁苄酯（BBP）10）邻苯二甲酸二异丁酯（DIBP）",
  "4ebc1644c19a819266f8b7c5c186e2b7": "[ru]2.欧盟RoHS指令中豁免的除外。",
  "bc75f2eb9f4ff9e29ff7db906eb22914": "[ru]3.组成表中均质材料指：产品中成分的每一种材料，可以是单一化合物，也可以是混合物。例如带有镀层的螺钉，镀层和内部金属为两种均质材料。",
  "5219f6e08a8e773b382df345d5fdb3a5": "[ru]4.含有限制使用物质的均质材料必须附加海尔认可的检测报告。",
  "776065a22e359dfc4b2763a454088c15": "[ru]5.本宣告表必须在产品/部品交付前提交本部开发部或产品制造中心外检。",
  "3ca51337bf18829e74c77e6697515dcc": "[ru]6.上述产品/部品宣告表中英文对照，以中文为准。",
  "dbcf806fc5b0f1478c92e7d278b4052c": "[ru]以上承诺：",
  "83dc2f2474e78bf6447f06365c0d0660": "[ru]供货状态：",
  "92dcbd51deeff39d0d37fd5323ef687e": "[ru]正常供货",
  "8c739155cca4152c2123073ae7e05da1": "[ru]不再供货",
  "d55f68b34049519d2805a2bd7dc49bca": "[ru]审批记录",
  "3b69c28ccfe587be48a621c1d2e380de": "[ru]审批信息",
  "8d7d46cc7ee94f393a02f3dae9fdd2bd": "[ru]暂存信息",
  "df09fff77b4bb5a0b77d3108072fccb4": "[ru]名称不能为空",
  "9c6c87ac4ee0fb7d652535a653613145": "[ru]规格型号不能为空",
  "72b78760aed1e31a5ebba3c994aa7df3": "[ru]重量不能为空",
  "4ef63fb2a0766fd993aeb383bd1bdbb7": "[ru]测试报告编号不能为空",
  "eb5bab1c31ce64e52ed71628cd7a0b14": "[ru]非必填",
  "6eee825d69261f9df2e56f53befb461c": "[ru]识别序号：",
  "fea1089a3aea5e70f7c643e11a1da5fc": "[ru]识别名称：",
  "900378aa37c9ed3f6a129abbb983fa68": "[ru]委托单位全称不能为空",
  "74d4e28a9e43e36aaa5aee0c97fec3c6": "[ru]检测机构不能为空",
  "1e876ebd0e60c8d3b5e4310ee97da2e6": "[ru]Pb不能为空",
  "9bce6eed8e61c50e6a308db6efb8eec1": "[ru]Cd不能为空",
  "f3392f5e32649d1e9dee3ea57d93f4cf": "[ru]Hg不能为空",
  "7cd7385150917ce56762eb49d1e6504a": "[ru]Cr（VI）",
  "966fd5a58f83f1246132a0b7e67bbf25": "[ru]Cr（VI）不能为空",
  "b461f8eef0d9f39d4b6632f3a8be590c": "[ru]PBB不能为空",
  "5344c1bd2a5f3baab6bce5efe4ae29a2": "[ru]PBDE不能为空",
  "b0e555e7cab26e6f025020a8a9c02d73": "[ru]DEHP不能为空",
  "af0051d3757696914baa4d2e4ce7ee5b": "[ru]DBP不能为空",
  "b8c602c247f2fd489b9b15350123858a": "[ru]BBP不能为空",
  "8c781cf352eccd3c165b7d03e685ccc1": "[ru]DIBP不能为空",
  "c0652a4d8a1bfdb69b751cf2630cfc25": "[ru]是否豁免项不能为空",
  "32ac152be1911e9360047dcb0898cf70": "[ru]更新",
  "3322de466da57d677d5bcb4cd7fe93be": "[ru]1、点击\"同步\"按钮即可从报告库完成文件同步，无需手工上传。",
  "79213df16a7a6e0e1404c225567f48bc": "[ru]2、若未同步到报告，请先到报告库新增报告。",
  "ab502f7a6848989c4225e12e6a93609a": "[ru]带识别码",
  "8b47eafbcaacab0760ad94363217b397": "[ru]不带识别码",
  "fbe425a5f5ee7451e425073054e82834": "[ru]*请注意文件上传的格式(xls,xlsx),文件名中不允许出现逗号，最多允许上传一个文件且单个文件不大于30M*",
  "a7101665af6b7f65cb9455c1dc5a0ec4": "[ru]该专用号存在未生效的RoHS宣告表，选择失败！",
  "b3287d15c220247d2423e691c41b9b86": "[ru]该专用号无符合性声明，选择失败！",
  "bfa45bbffb6e7b41ce5e08857a6ee16c": "[ru]该专用号查询RoHS宣告表失败！",
  "573c8985ecd7b31c465015fc3327f997": "[ru]未能查询到存在符合性声明（Q/HR0603001）的专用号，请重新输入！",
  "eec167ea0e6a49cc23a18df3bcfbcc50": "[ru]请先仔细阅读并同意承诺信息，否则将无法提交",
  "b6ffb62911529fa50f54b583cdd0db5b": "[ru]供货状态不能为空",
  "0c226c171da74e2e63719047f366b1ef": "[ru]子项信息不能为空",
  "b0374c20a49995b229754f9ec02478ab": "[ru]子部件/原料-名称",
  "e6a0219a958439953a26c9d29aed5607": "[ru]子部件/原料-规格型号",
  "ef0fd88bbf96e6537c385c3c74a3fef1": "[ru]子部件/原料-供应商",
  "5fde576e25df33b6bbf40d8a81b3e920": "[ru]子部件/原料-数量",
  "0c0121ba7e34f0deca0418cb505788bc": "[ru]子部件/原料-重量",
  "16f51b972a1a8e7bbaa77aaabc256687": "[ru]第三方测试-委托单位全称",
  "a96bb77c5999b6c2e408f79ae77dd228": "[ru]第三方测试-检测机构",
  "52142a7042d7342e3c26262ef01e8dbd": "[ru]第三方测试-测试报告编号",
  "4f64d54c8a077e48c1aa985a614eba40": "[ru]第三方测试-报告附件",
  "356411c5ce7eddbda57ea45f13604439": "[ru]第三方测试-报告日期",
  "b4e63159194976119d9717cdd65070df": "[ru]第三方测试-有效期至",
  "496d57c68cd1955a224a97f71912e42a": "[ru]均质材料-名称",
  "bd35fa97e251886d77cf093c750dc7b7": "[ru]均质材料-规格型号",
  "d7fe3347b25daf6b84e2e3ae17c7f10c": "[ru]均质材料-重量",
  "c961a63d316030126137dc9a6dbca147": "[ru]限制使用物质名称-Pb",
  "884ab8248ae323fc869714e06c6cedee": "[ru]限制使用物质名称-Cd",
  "f724c06aacf6a3d76efefda4d5fc60f2": "[ru]限制使用物质名称-Hg",
  "d6eb939b78927fa70cf97028922fdcc8": "[ru]限制使用物质名称-Cr（VI）",
  "2bc873e2d2d3ddb59c181c00c22fc167": "[ru]限制使用物质名称-PBB",
  "c9714dad1a973a5e955a8763f3d55eee": "[ru]限制使用物质名称-PBDE",
  "9cf01347d2cf9c4f8ef1fe4cddbae990": "[ru]限制使用物质名称-DEHP",
  "8998bfa28186add2790c2389551a4c57": "[ru]限制使用物质名称-DBP",
  "9c8a108771a966af3ade2c5aa0da2ca0": "[ru]限制使用物质名称-BBP",
  "b272b69044900cfb6af5baec1bdf7c93": "[ru]限制使用物质名称-DIBP",
  "73b6a05137a7c931f86577ad8091803c": "[ru]子项信息第",
  "11450bf64ef4ad46c0b17b238dd33246": "[ru]行：",
  "6f7db37c7dad2be669fe2895d3a5d701": "[ru]RoHS承诺书编号为空",
  "9d29853d07cb6840afba345ff6ff559d": "[ru]请选择审批结果！",
  "a61b51c5efd48bf65f22aeef14beedf4": "[ru]请输入审核意见！",
  "c47d3042c5f485903b7c588717df330d": "[ru]部分数据输入错误或识别码不正确，请检查模板里的数据或下载最新的识别码核对是否正确。",
  "6cd780d74f59166818ae64345545f71a": "[ru]导入失败！",
  "f25c3085c1cc5b67a9bbf50ce2b29116": "[ru]识别码.xls",
  "8082a7a79d6c746e06fd627ffbf83b30": "[ru]请选择导出内容",
  "f19f15bb801e21814a2f3451db786d21": "[ru]不带附件",
  "8afbcfdfea4d4c4ab90688df21d35893": "[ru]带附件",
  "307959cebf5c278dffc2598326ae8304": "[ru]子项信息.xls",
  "c1104bc73a3daab87d3aa8eea118dff5": "[ru]请选择一条数据进行修改！",
  "54d3aa90e7edce1476f1ded74b098626": "[ru]请至少选择一条数据进行删除！",
  "561044839be2dd433f8e6a13cc01d4cc": "[ru]请先选择测试机构！",
  "19670e0858929bb2ee38ebb4105e8540": "[ru]同步成功!!!",
  "d58b2c130d2d142894623a4ef6e15adf": "[ru]没有符合条件的报告！",
  "e1bc8a0f19c396b979403c050bd4e4dd": "[ru]该专用号没有有效的符合性声明！",
  "18f0d42ee6cabb8584f262eec975180e": "[ru]识别码",
  "c3de08e8b73d392d68282f751aed8d8b": "[ru]检测数据模版导入",
  "35e17c66aa6518681c5fa4db6bc09de8": "[ru]请勾选要删除的行",
  "409bbfe8aa43b4b3d1caf7802844d6c2": "[ru]是否豁免",
  "c95dae6f456b20178338c215dae08332": "[ru]请添加检测数据后保存！",
  "f7327186ec9f21ca0a90588360dab67a": "[ru]不能为空！",
  "904909a3bc9af14ccc46ca821a29161c": "[ru]可能有数据未保存，是否保存当前数据",
  "caebab900a91b32b337ef82d770cf132": "[ru]录入/修改",
  "ce7bce56b366d966f2622c8b35332ed4": "[ru]RoHS报告",
  "d9a98efd916b2ff29de2ea7815c849d5": "[ru]原检测机构",
  "e4f67ddee5357ad917b9137da166cdd8": "[ru]原测试报告编号",
  "3a9c6c33ba30510928d2b9c0d9660d9c": "[ru]原附件",
  "9b9c86d6b2f56e06c784802df22ecbd5": "[ru]原第三方报告委托单位",
  "74406bf625cf3141a81ec2cb00ef753c": "[ru]原报告日期",
  "41f21541fe4cf190f474efd14caf0c1a": "[ru]原有效日期至",
  "f0d8154645b18f4ee50e74dadb2607d9": "[ru]原检测数据",
  "b60d710740a0f8c78f3d481f899b4730": "[ru]1、国内供应商请“下拉选择”2、非国内供应商可“直接输入”或“下拉选择”",
  "dd69c6cede1d0a966418b4ba53de3b03": "[ru]请选择或直接输入",
  "231a2e1471eb62cac39fc761ac0d0761": "[ru]第三方报告委托单位",
  "8b13fc046b6c1324701bb261d9b6af62": "[ru]第三方报告委托单位不能为空",
  "21ee12706c2d3d106286a4bc91c29b61": "[ru]报告日期不能为空",
  "f2d9fc762d1d82dee8d1e65edbbdfbdc": "[ru]有效日期至",
  "0481ba9f8aa674d1ab7b161979ccc575": "[ru]有效日期不能为空",
  "04a00a5426cc9527dd9e7a8815113158": "[ru]有效日期",
  "63dcc6f9a84f2717e95c7821f47a318c": "[ru]是否替换旧报告",
  "bda3a5d31094b52a80d599601bb0d4a3": "[ru]选择填写，非必输项，替换多个报告用英文逗号\",\"隔开",
  "84dba55c554bd6723ba5c7c61546c586": "[ru]原测试报告编号不能为空",
  "5875ac378befd1449836c4f0983fd089": "[ru]新检测数据",
  "adac6d87277e0a558d80daa153b04cab": "[ru]检测数据不能为空",
  "8fc06f26ac38abb0c0c1eac6df2a0164": "[ru]1、请先选择“检测机构”与“测试报告编号”，点击【操作】按钮，按照弹窗说明操作；",
  "731fd942f08cbe83c02e89ed101908ec": "[ru]2、如果显示同步按钮，在已授权报告的前提下，点击【同步】按钮，系统会自动带出委托单位与日期；",
  "461aea08aa832883edca686b1f926980": "[ru]如果显示的委托单位与报告上的单位不一致，请联系检测机构修正，修正完成后，二次授权后可同步新的数据，请注意授权报告同步的时效性。",
  "868216585b3fa39f1bcd05fbe833b96b": "[ru]3、如有其他系统问题，请提交工作台到MKHL模块质量互联可视共享平台。",
  "6f531601340b2581be3c0d3074e757e8": "[ru]4、如果存在有效的宣告表，自动生成一条暂存状态的宣告表并生成提交待办。",
  "38817fc843070f0d24351a959c873138": "[ru]5、如果存在暂存、未生效、审核中和已淘汰的宣告表不再自动生成新的宣告表，但是会更新这些状态的宣告表数据。",
  "947d983961bd9a8fcc2ea78818fbd5f1": "[ru]温馨提示",
  "40888fb461d77c16e8642d2542b677df": "[ru]此报告是通过第三方机构同步的",
  "a41c182ba4eacba8662ddb0f93b95b7c": "[ru]此报告是手动上传的",
  "28713122dfba9c430042a6aa8c57f96d": "[ru]1、选择的检测机构是互联互通对接测试机构，点击\"同步\"按钮即可完成文件同步，无需手工上传。",
  "d6fb0b8b319e445cb3129bf09c07f9e8": "[ru]2、如果点击同步无报告，请先确认信息是否维护准确或按照操作指导书进行报告授权。",
  "61003266e6138b24da427c7864fab71b": "[ru]3.报告授权同步对接流程：",
  "0677d59c2208002e6f0e6c9ce65fc046": "[ru]①通过第三方检验机构对报告授权给Haier",
  "7426a8ade6a323b5f2d996ea92b3bd5e": "[ru]②在“RoHS报告库”中增加相应的报告基本信息",
  "272b6ae246425168f0a45f7a8cbcf6eb": "[ru]③提交RoHS宣告表时，同步报告即可。",
  "09657c8dbdea5c5fb453bd8441a8ba84": "[ru]授权操作指导书：",
  "0285d40023a53d64f40e2ffbadbf384e": "[ru]1,点击\"上传附件\",即可打开本页面，在本页面可以进行附件的上传操作。",
  "8c8191107bde15222f40a07c53b74874": "[ru]2,如果上传操作，请先点击\"选择文件\"后选择相应的文件，系统会自动上传。",
  "0be52f201392ee1225a8550c4113dc65": "[ru]3,如果需要修改附件，直接点击附件名称后面的删除按钮后重新选择文件上传即可。",
  "858aa820da4b659964e2f252fbc05826": "[ru]通标标准技术服务（青岛）有限公司",
  "ec1dc3bf266cdf64977cb886bc29f30c": "[ru]通标标准技术服务有限公司宁波分公司",
  "3f383bcbae60684741e67794eefba1d7": "[ru]通标标准技术服务（上海）有限公司",
  "8f08aaf0606816e02bb2f3c808dd6c93": "[ru]通标标准技术服务有限公司广州分公司",
  "5eea199767a65557b7826e5589e88f6f": "[ru]上海华测品标检测技术有限公司",
  "27c7ff37f8af3b5c3afe348cbec2e1c0": "[ru]华测检测认证集团股份有限公司",
  "3cb1f8e42209d3a38135647aa3884cbc": "[ru]宁波市华测检测技术有限公司",
  "25562d036901379f26a24bf3ac0e7395": "[ru]苏州市华测检测技术有限公司",
  "efde586fb5e1e240ee078ed4716c1f75": "[ru]谱尼测试集团股份有限公司",
  "362e880675bd199b58ec1a9619a30520": "[ru]谱尼测试集团深圳有限公司",
  "0051cda548eb9bce5d8024534a57112b": "[ru]青岛谱尼测试有限公司",
  "d9b12c0526eb4d671495d5fe91e6018c": "[ru]必维申美商品检测（上海）有限公司",
  "a8583b07a9cf6a5c19b1886b4bd43740": "[ru]广州广电计量检测股份有限公司",
  "7948ecb597771fec555132a427450b46": "[ru]广州广电计量检测无锡有限公司",
  "0908d60a875358e2173fc40cb6f221ea": "[ru]广电计量检测（无锡）有限公司",
  "97748e5e5ec0493eb1c3fcf10e9b1e75": "[ru]广电计量检测集团股份有限公司",
  "8ebddb72150295305d95330b6618e658": "[ru]威凯检测技术有限公司",
  "e737b7c6dbae959794b286958a42bbbc": "[ru]中家院（北京）检测认证有限公司",
  "051795b869c6fa081a6dd3e716d63e4e": "[ru]佛山市沃特测试技术服务有限公司",
  "9d2595d7c10abac37e525320c64cae22": "[ru]斯坦德检测集团股份有限公司",
  "4590f044958c57fc696de5da88c487a5": "[ru]杭州希科检测技术有限公司",
  "7d6aff1c8914b4bdf18dbd82f9daecc4": "[ru]通标标准技术服务（天津）有限公司",
  "47300ffba22ed2e455c9bf4942dc9b11": "[ru]天津津滨华测产品检测中心有限公司",
  "888739521d436318285a116d4ceb0751": "[ru]苏州市信测标准技术服务有限公司",
  "189827da5787d6aa2ffeb7ebedc01c84": "[ru]东莞市信测科技有限公司",
  "873effa38743958f453ff34bd199b771": "[ru]南德认证检测（中国）有限公司深圳分公司",
  "c4874fc92ed15d799a98c5111fa4f421": "[ru]广电计量.pdf",
  "3b15b1c8cb1ab8e2ebaee858527c3fb5": "[ru]1、没有符合条件的报告，请检查检测机构和测试报告编号是否正确。\\<br\\>",
  "696b857d8de038c3d6946837e73ff1be": "[ru]2、如果检测机构和测试报告编号正确，请联系检测机构或二次授权报告。",
  "5ab9ee37b6e13e689bf24d93b44dab5d": "[ru]该报告已经存在！",
  "18d1a6b8d1efac8bf994e69b45c7acde": "[ru]未在报告库中同步到报告，请手动添加新报告进行替换！",
  "9e04e32d2e1e45b904a6aaf8a5d9982b": "[ru]未查询到存在的报告，请确认报告号是否正确",
  "7530410e5185a3d663665fcbaf18d370": "[ru]该报告已增加，无法添加为新报告",
  "afa182fd6c08abb16a608d971d7c7828": "[ru]确定要替换这个报告吗?",
  "4638a6dc77e085601e70f2c750244fb3": "[ru]审核成功！",
  "1f0729004026b5d3963e8f78b6d2d85e": "[ru]审核失败！",
  "5200ed8b578c7b02a035f9b7424830d5": "[ru]供应商质量经理",
  "43e33e242b484dc4633ff7d6519c307d": "[ru]供应商质量部长",
  "bf0de2a6d0dcc7ab42c1474ea076c6d5": "[ru]专用号(关联专用号)",
  "5a6cad8da2dd7ac89b1fa990d6835848": "[ru]批量处理有效性",
  "b91b9e31633b771ab07924985af3e252": "[ru]批量处理有效性",
  "f89cae5aeed511d199de3135880c037a": "[ru]批量处理001",
  "eeb71b3d84f9333cff25a760ab49b239": "[ru]批量处理001",
  "22180b5c188904fddaa9a5285023420d": "[ru]批量处理003",
  "d21f0ff40d9297f3c97fee4a0c76bcd3": "[ru]批量处理003",
  "e0cef5be628e755725b6891eb2b7c16b": "[ru]抱歉，您没有批量处理权限！",
  "5d0cc46b97e559dd96c7ad1a80e875b3": "[ru]请选择要处理的数据",
  "138acdd0bf5c99a9c04ac29e4f571757": "[ru]符合性声明导出中...",
  "7f7c624a843b0d539a4ea59a696702f9": "[ru]批量操作",
  "341c769b32b164c53fa35e6d0c7ce809": "[ru]模块名称",
  "b86224e030e5948f96b70a4c3600b33f": "[ru]节点状态",
  "f66233940b0acfaf83a1825cf714eb55": "[ru]生效状态",
  "34fd3f101fa4ab483c50479c695fb58c": "[ru]预警状态",
  "72a2847f3b8ba821489b008459ba3e43": "[ru]已超期",
  "18fa6a85bf40c2805a1df3681c302aad": "[ru]供应商批准人",
  "872992a396d601196811a64a092e1e91": "[ru]请选择一条数据进行操作",
  "ee83af0f183b28671bc12b2f38187207": "[ru]只能选择待审核的数据！",
  "880510ae28edc31a9fd1c6d0c4a421df": "[ru]无审核权限！",
  "b4e9c5b5d93403349a535a008a22c287": "[ru]无审核权限！请联系",
  "09da60162f12d79a18c487c5a1f9d3b4": "[ru])进行审核",
  "607bb35de588d343f4e98298a7af2223": "[ru]RoHS宣告表导出中...",
  "cc245d3b0a34f7c664ca0c63c2ea0364": "[ru]RoHS 报告库",
  "3f12324c202cef331d8603466afff54c": "[ru]原测试报告号",
  "db4727195be6c4f89496427da8c54574": "[ru]请选择一条数据进行此操作!",
  "fb0a06fcc00269ebf846bb95048800aa": "[ru]RoHS报告库导出中...",
  "25934145c6a9b4068a56aaf7fe4f0c33": "[ru]查看报告",
  "24c4b4b3264f520bb653c36e9f2f3db7": "[ru]查看检测数据",
  "743bd1f425a1a76bd09185dc52d498a0": "[ru]所填母本专用号已经存在有效数据，请操作原数据修改!",
  "b2ba68a1bd6fe5433b6738ad78c7ea8f": "[ru]所填母本专用号或关联专用号，已经被当作母本专用号或者关联专用号录入过一次，不可重复录入!",
  "5a398f2938133a73de82d832ecbb0194": "[ru]所填关联专用号中，有已经存在有效数据的专用号，请删除该专用号或操作原数据修改!",
  "8abe2e7fe9b9e9ae5ade84332bf56b14": "[ru]所填关联专用号中，有已经被当作母本专用号或者关联专用号录入过一次的专用号,不可重复录入!",
  "eff16848a8faf09eee11da1d718225c0": "[ru]操作失败！",
  "8a6e408b951465dfcc89422d2c111200": "[ru]RoHS符合性声明",
  "84a84c2d77921398d7f159f5c69ecba1": "[ru]备注：自2024年7月16日起，有害物质系统升级，新版使用过程中若有问题请及时反馈。",
  "96bcfc28273a47e8dbfb74d5fdd8c2a4": "[ru]①符合性声明置为无效会同步将母本专用号对应的宣告表置为无效 ②修改符合性声明提交成功后若已存在有效的宣告表，会同步生成一条新的暂存状态的宣告表；",
  "03e0194cf9706e9e2235a069a5339e99": "[ru]符合性声明.xlsx",
  "fccf5c70302d570f96e06d4b1c25251f": "[ru]1.修改有效数据会自动新增一条相同的待提交数据；<br>2.新数据提交后，原数据自动变为无效，是否确认修改？",
  "eacae04478437ea6d4dcd66bd600e94e": "[ru]此有效数据已经点击修改创建过一次新数据，请勿重复操作！",
  "d406f9db158a30728b4a8db172e1d0a5": "[ru]请先选择要置为无效的明细，可选择一行或多行。",
  "de8fc094d64e1c566dd614ae8bf648f0": "[ru]请选择有效或待提交的数据置为无效",
  "0f1e7c68852bc8557182ac1c291992ce": "[ru]是否确定将选中的专用号符合性声明置为无效！如果确定无效后，使用该母本号的宣告表将同步作废，请谨慎操作！",
  "5e4a3678dc3837e13dde832f355a0ef9": "[ru]暂存成功！",
  "04e41e118b33dfe07b9accef7c5ab5e5": "[ru]暂存失败！",
  "02dfed76d6b2d46bda1fd3c354735a68": "[ru]提交成功！等待质量部长审核！",
  "df23063397e5b322fdfcd6b989f35273": "[ru]提交失败！",
  "437dca4e3af3ee6a1f7a76c4346d6a8d": "[ru]未查询到RoHS承诺书编号!",
  "e0f113cfcfbf79be262cf30f49ff975a": "[ru]去提交环保承诺书",
  "7b57ea55ed38bce7bff7fd7fd4b8b575": "[ru]未查询到RoHS承诺书编号",
  "a0c9eb4c87d42f5d77aedf01db3a9be3": "[ru]请先选择申请审核工厂",
  "d804c61911aff62b3bd8705571f106c1": "[ru]质量经理暂存",
  "493ea518d1c8e18ea1de0340fdee83f2": "[ru]质量经理待发布",
  "17e33ec9a1b14400f0e13a89adff6fd7": "[ru]海尔待校核",
  "8bda9bd1a1d13658f5c33f0bcab1f0dc": "[ru]海尔校核通过",
  "494312483231c1e9a576b652d348cbe3": "[ru]海尔已淘汰",
  "3bf3c0a8d631d93aee55e4e47e2b2109": "[ru]节点",
  "755aed833bf84ccc2fc2245c1bdfdd92": "[ru]质量部长待审核",
  "ea5311cf294c025c2a0024aee7c2d976": "[ru]宣告表ID",
  "39500d5fdea78a40141eaa8d77c1fbd4": "[ru]RRoHS宣告表历史导出中...",
  "22a3d3310208aef1ec10f17d5c8cf487": "[ru]RoHS宣告表历史.xls",
  "663829a6c56e9395f3ad246651e60387": "[ru]批准人",
  "afdf574f2b4f505d06b039d8c6f142ff": "[ru]RoHS宣告表.xls",
  "07c4ffe6d280578ad05f25822883859d": "[ru]作废成功！该RoHS宣告表将不再有效！",
  "5e35347d004645ee52852bc455958c5f": "[ru]作废失败！",
  "ddf4ad479c4d75ac1b28639e2a26f5f8": "[ru]保存成功！是否返回上一页",
  "61b09c7c1ee96ba34b708c65e0d2f88f": "[ru]上海出入境检验检疫局机电产品检测技术中心",
  "4f53210d98335241517a1355b54a8c9d": "[ru]浙江省检验检疫科学技术研究院",
  "61f53065ee86bd9126ece2a874394bec": "[ru]确定要作废这个报告吗？如果确定作废后，使用该报告的宣告表将同步作废，请谨慎操作！",
  "de564fc1d38beb5235dc1f4277cd54d8": "[ru]无操作权限！",
  "eb23c70a9dbc6363e8aa6012668eb2ac": "[ru]RoHS报告库.xlsx",
  "df86390ae06f20d33c5ae0c12895d4c9": "[ru]RoHS报告库预警导出中...",
  "d1e274c966117803303cfb8b757eacc9": "[ru]RoHS报告库预警.xlsx",
  "55af0564d325d4c1f7f4bf139aa8471d": "[ru]父专用号",
  "8fca7aaf21b05b059e14d87ec2d4b271": "[ru]子专用号",
  "77db6781a690ff0f3856166ae203586a": "[ru]智控RoHS宣告表BOM",
  "04eb4362a418155ec9879f63c1bc302a": "[ru]父项物料号",
  "75af7bdae033f9347d092fe18d9ffdea": "[ru]子项物料描述",
  "6ee6d21b9f83db89c2c84f84aedea2e8": "[ru]子父物料模板.xlsx",
  "03d60631e23a66cd3eef5ae36aeb4445": "[ru]智控电子RoHS宣告表BOM",
  "f9b0ddafcedda97b5b2debcd3388bf4c": "[ru]智控电子RoHS宣告表BOM明细",
  "401e24b6bd1398d268eabee698f9226d": "[ru]父项专用号",
  "9e19e7547bf3f1df98a3a92b3d1bab09": "[ru]父项物料名称",
  "a7e7b4470e34f1e262b6b0b01a8370fe": "[ru]子项专用号",
  "2af818e606fecbc7936be55a9f37bfed": "[ru]子项物料名称",
  "555203989643a3d4e7104ad31d9e975e": "[ru]查询方式",
  "82f2876874de8a2ca504e27d6fefb526": "[ru]最长有效期",
  "ce9cb0a5a36e0ec38e339f580cd4fb92": "[ru]所有有效期",
  "048f46a1d09e3d4b616249ad946b0d56": "[ru]RoHS宣告表整合",
  "af4b01881edce51dd6615839687bae82": "[ru]重量(g)",
  "0ac5e05f9fee76566bd385f6cfad3d1e": "[ru]智能电子ROHS宣告表整合导出中...",
  "dcbb1c439c5201977a42adaffffcaacb": "[ru]请输入父专用号",
  "c124d5e87a43845c79a62d071c241ad2": "[ru]存在匹配不到的专用号,是否继续？",
  "ea8134608c5274a24953170af457dfd2": "[ru]检验37样检单导出中...",
  "e9ab6b1261e8a8cb8fa61040e6272bbb": "[ru]JIT待确认",
  "43cc930b4b9a9f6a757169ac482a1e13": "[ru]JIT已确认",
  "e3003dbc34949becf7715cbca8f2804c": "[ru]JIT打回",
  "922d0efd0ad13d2a865ba516c8ace11f": "[ru]打印状态",
  "86a2c1f10784aa27f67919a8e3e54626": "[ru]JIT确认人",
  "35f377bf8a464747d221431063c19bb3": "[ru]JIT确认日期",
  "c774e36c23ea5edb7f0abf4922569097": "[ru]JIT已确认的数据不能修改",
  "68cc8def83d23b4d8bc92052f268089e": "[ru]请选择JIT待确认数据",
  "0ca971fe5f884c8066a389188d594de6": "[ru]请选择非暂存的数据",
  "5777089c9aa551667d862198f12c4390": "[ru]现场不良录入",
  "998954b35f034eb970c1b78848b8fd55": "[ru]《低错类缺陷BOM》",
  "56f460b960f3e9b4d97a98a18c99e5dd": "[ru]工厂小微不允许为空",
  "e3ae66bc1eccac9306ace75272fbd62e": "[ru]线体不允许为空",
  "7956b0a77a17ccd9e1a2dac4ab21e05b": "[ru]请选择线体",
  "a8a2925b2cf0dea8fe100149396a335d": "[ru]班组不允许为空",
  "5f81f4aedea0a6f3005a9e0165e2eebd": "[ru]请先选择线体",
  "2b984cbcbc059b8f3d4e65868aebc6b6": "[ru]专用号不允许为空",
  "63c6cb0b6ea231fb209abbcb98890a5d": "[ru]物料名称不允许为空",
  "37363211846dba665f0205a82c746b01": "[ru]班次不允许为空",
  "f20061ff2e28a5a0d65e767ed4f9e74c": "[ru]部件类别不允许为空",
  "742e4f98b7831b6c2f90863b21e28c64": "[ru]供应商代码不允许为空",
  "b0e88129051963e233aed59426c5f782": "[ru]供应商名称不允许为空",
  "113dc6739b840f1c9c7de3f06a50a418": "[ru]原因不允许为空",
  "294ef3665d637ad34b3f9713ffe9da21": "[ru]是否低错不允许为空",
  "f574ad806f68cfe2598685d417a91777": "[ru]缺陷描述不允许为空",
  "0f6c9ad8921b4cfa908be9c89fa0d8ac": "[ru]退次类别不允许为空",
  "5b01434b32d179029711baa386d5efa4": "[ru]请输入操作工",
  "a50e4989760765f08e1e7f2059657bef": "[ru]缺陷类别不允许为空",
  "6f5bf316fce211620a41e0ceaceea7ee": "[ru]不良产生原因不允许为空",
  "0f3a252acc620f29d0ff2251ef0a1186": "[ru]运输",
  "1925e5518b2cf06471f69ac21639a35e": "[ru]工厂代码不允许为空",
  "5000fbb9385bc97cc837886038e0ed2d": "[ru]数量不允许为空",
  "265a8e38980b3639c5c299a62e68ef1b": "[ru]单位不允许为空",
  "b09b815801e97c7d626bbf58b397c975": "[ru]不良物料照片",
  "186ff0673309421957f456f3c548adb0": "[ru]不良物料照片不允许为空",
  "45e9c6f424dc94d276ea5175f050eb94": "[ru]*最多允许上传一张图片且单个图片不大于30M*",
  "eeffd5bb9e7a922564755d55c2c3ed9f": "[ru]退次类别说明：",
  "2e56a6a3b6b703ead154ba4e4e31af1d": "[ru]“缺陷描述(低错类)”与“缺陷描述(非低错类)”二者只能选其一，根据《低错类缺陷BOM》选择录入。",
  "3ade4f5da98a2ce80d389db996f472cb": "[ru]退次类别TC定义：员工在装机前自检发现的不良品，FX定义：不良整机返修退下的不良品。",
  "e60373ea32ba52975558f22538f498bd": "[ru]退次录入不良品数量≥20时，需上传不良品的故障现象照片。",
  "0d24d840c8a490a3a3e4a12ae00ddff8": "[ru]此物料入厂检验数据单位为空,请手动输入",
  "0952a75ec866152841120492dc2457d1": "[ru]产业不良录入功能已转入H-work APP进行操作，如在平台操作遇到问题可提报消息至HMQM服务台-海尔模块质量管理平台",
  "8948d2704ea42f494e0a0b2471a19dcd": "[ru]查询线体失败",
  "e66db12127ce72d3795bb3ac78639893": "[ru]查询班组失败",
  "6657a04e59fb8e1427b70d0d31b5f648": "[ru]请先选择是否低错",
  "40c5cfb37b48b04b5ec6cb1a18fe195d": "[ru]料费",
  "da0016f36d44dd5cdf3c26c44df9873d": "[ru]封样记录表",
  "eb63671a4c477e379587035702024038": "[ru]封样人",
  "afd99b119b4c323feb43dc5b44f983a6": "[ru]封样内容",
  "959e7a9ad4494e3456ca6adfba16aa82": "[ru]封样时间",
  "3eb0aa2c3403e180f29c751f9de08d2e": "[ru]封样结果1",
  "9c993d5d539adf73351ea7f18319b4f5": "[ru]封样结果2",
  "2444d3ebed720e0476f99c766dd5a3ed": "[ru]封样结果3",
  "a9234872f349c6e360615e8df75c3561": "[ru]封样记录导出中...",
  "c870699ba9bfef22ed0c7d91538e003d": "[ru]封样记录",
  "a8a29a390821ae53cf576970eeef9b62": "[ru]封样记录录入",
  "aeeb650172f185a13b2bb7aaae769097": "[ru]请选择供应商代码",
  "0eeecc702c7ef93a5dcaf39231688045": "[ru]请输入封样内容",
  "5fc391dbe88bc7a3e0537092dee91cfe": "[ru]请输入封样人",
  "1a25181a6d6b6451dd05266938896bc7": "[ru]请选择封样时间",
  "48fc98900ef5dc0d12ed617cd7a14e62": "[ru]封样结果1不允许为空",
  "c1f6ad0e8ba2a19aca09ea15a97af7b6": "[ru]封样结果2不允许为空",
  "79ee8752577a17cd834327536aec3f03": "[ru]封样结果3不允许为空",
  "4ed4f252d7a2bd53fb8605a4072a874a": "[ru]封样信息",
  "51fb1f2be440e98f8927d678833b1480": "[ru]数量未确认",
  "5f76e21e71102bd2b7e45f5884886e09": "[ru]数量已确认",
  "0490bbcdfc20d7ad1f3a664a39fc59ad": "[ru]封库单号",
  "4c3a6e5c65926aa0c35aca47fc5e6dd7": "[ru]封库单",
  "81261eb970004bdf6d1eccda713388fa": "[ru]数量确认人",
  "8673dd593e7ee418db7d09e70000e97d": "[ru]数量确认时间",
  "e342cb7f7eba3c803ab1f5ac2ae2db52": "[ru]数量已确认不能删除",
  "a94eb5a9f8fb8ea16bde293acba24cb9": "[ru]该封库单数量已确认",
  "582f826e045f0dc6f1b932afd89f6cb6": "[ru]权限不足或没有待办!",
  "ac85488a23e60470b5ff84b1189cea1c": "[ru]填写封库单",
  "d67a56a0f33d42232f26fd3c68d5ba1c": "[ru]封库通知单",
  "983cb9ffbf9dbf0cdcff5e365b71739a": "[ru]进货批号",
  "a1202231a38e678e20febb561b549177": "[ru]批号不允许为空",
  "94b377eb787336ede71e1a244cf22415": "[ru]请输入批号",
  "fc0a262f77c6db4bb391e8aff3f01509": "[ru]封库原因及处理方法",
  "6c23f559409b5474530637371fe78cfc": "[ru]封库原因及处理方法不允许为空",
  "acbc10a70b693047973b1da75a90be14": "[ru]请输入封库原因及处理方法",
  "17e1f117de7cb36770293e901a4e8693": "[ru]见证性资料不允许为空",
  "f2a30ad98a3c8d824a57c8b8f43e79ab": "[ru]封库措施提出人",
  "d29ecfd5d0ac99476d12ec49b8332aeb": "[ru]请输入封库措施提出人",
  "4ddeacc391c30a18b671daf43f355b37": "[ru]封库单数量确认",
  "711b518047a16e990a827bc5055c5a51": "[ru]封库不良品数量确认",
  "b7651627076529181ab0771bd5b1c3da": "[ru]封库数量",
  "7121d224a47f17a6d595d7fdd4065fcb": "[ru]封库数量不允许为空",
  "8e28ac418dd427b4c652a55cbd5e633c": "[ru]请输入封库数量",
  "793d27f0c07873888bd3454e0fe0de78": "[ru]请输入单位",
  "826729322f3c4748196418dd72b4acae": "[ru]封库单明细",
  "b78e5305ebcec48a0cbebdac294124e1": "[ru]验证类型",
  "ecf148b318778ec56c318c41db370100": "[ru]预验证",
  "f98d407bd359d1a88bd969bd1434ec23": "[ru]整机验证",
  "8857975c8e26bc5a5c32736bc7a24262": "[ru]待收样",
  "b2a426c963841e34dae91be47d1545b9": "[ru]研发自收样",
  "a5963b0ad197761a82940c656de9f651": "[ru]整机编码",
  "44fa184da2388ae205fccc0adebec7d4": "[ru]送样计划创建时间",
  "3259d6eee4dc9fe574b73d7e67089ecd": "[ru]实际收样时间",
  "34ccac3401851bd8511ddfa1988450ee": "[ru]整机产品编号",
  "d784e4ded016c9373f4d1c41caae6fbe": "[ru]应送样件数量",
  "d7f974be4808f887a05db717fd37ea36": "[ru]供方样件应送达时间",
  "a979959a9173db24b7d2eaf0c9d86f56": "[ru]供方实送样时间",
  "3c016d36581bc71c027386cbf617722f": "[ru]快递单号",
  "b469069f8af868fe83bb5dbe51a51d47": "[ru]供方送样照片",
  "3083502563451d766d25bf6bc5a34103": "[ru]实收样数量",
  "2e85190290afbb526172b2afc62159c2": "[ru]确认收样时间",
  "380764036ee6599431fd6bf14f0e8870": "[ru]送样查看",
  "3f35655dd0d0598a1441faad74ac5d40": "[ru]实际送样时间",
  "4cc74191055a38ad8996b922a6bfecab": "[ru]送样样件图片",
  "f9c946f168fef4b7ac270ad2dee628fb": "[ru]收样数量",
  "461bf535b637a74b60a2bb48434e7bc7": "[ru]收样时间",
  "ec85f2a49644d7316f8d9f277ae6eee3": "[ru]1.至少上传3张照片，照片类型：jpeg、png、jpg",
  "1ecf378dffb1567db051d17d0bf314a2": "[ru]2.单个文件不大于30M",
  "7541792be2ecb04b3100734c96afc513": "[ru]送样数量只允许输入正整数",
  "fa96cdd2c3086ffa5331a524b2080c40": "[ru]请选择一条数据进行送样操作！",
  "6e4bd75844e7326fd476c7910b8a8979": "[ru]请选择待送样数据进行送样操作！",
  "b4dc25d4bbf432fd7ce8f615a7014341": "[ru]请输入供应商送样人",
  "bfcc3f6a4cebc0eee6d55808ee9875f9": "[ru]请输入供应商送样数量",
  "c227a14b359c4a27726be203aad7008f": "[ru]请输入送样方式",
  "12144de19a1485fa8e9856a45883f5d0": "[ru]请输入快递单号",
  "5d9006a8d1626fb33b39b3fff3cf5772": "[ru]请上传送样照片",
  "de9fdfdefb6300c50b165203f91c90df": "[ru]请至少上传三张送样照片",
  "d0e20ecf8e20fd939b75921c0a058aa3": "[ru]未找到数据，请刷新后重试",
  "34754ee7a76e74cb442f260ec5ee4753": "[ru]送样失败",
  "75120b3c39f7df993ac07f2f7dd5f96a": "[ru]整机送样导出中...",
  "294fc9ec099eaf4a65fba653ac8c2f91": "[ru]整机送样.xlsx",
  "f344099d4f51e518f8d8dd5202797784": "[ru]请重新登录！",
  "738a41f965541d6f16d2064f82e148f3": "[ru]项目名称",
  "bc071a0656c891b9e5c2cd773cd12eb7": "[ru]新供应商首次报验",
  "be16ae8c3e6b62f0a249f5f7a80592c0": "[ru]只能选择状态为待确认的数据进行确认",
  "1ed9f424c3b8dc788f865d0940dd4bfa": "[ru]您没有确认权限",
  "04f7c714c3e3c535b88b4098f13db600": "[ru]只能选择状态为待审核的数据进行审核",
  "022a10a61d87c272f1eeaf9a953775d4": "[ru]小批验证导出中...",
  "312f12fa8a82cdacb136c3eb2f36bdd6": "[ru]是否需要",
  "4dbe3564837882118666a86b170972ce": "[ru]请选择是否需要小批",
  "245c8108e404ef78fe895a5b84e37634": "[ru]见证资料不允许为空",
  "591bede5f12d1dcc356c0f5a6fca7993": "[ru]质管处长审核人",
  "a7bb695fc34220226341be7c70d743a6": "[ru]质管处长审核人不允许为空",
  "d3b31144dde8f9e5134df49618799e69": "[ru]请输入质管处长审核人",
  "12cdf93892a9f514690d0d346f7cc619": "[ru]质量小微主批准人",
  "2ab66c4efd30860d20805d628d4dfa4f": "[ru]质量小微主批准人不允许为空",
  "206d886930b1298bad95c4f3c2ef282e": "[ru]请输入质量小微主批准人",
  "c7121e0239a7e7e5f4fbf27b74204cf4": "[ru]原外检经理",
  "5a166f9e606203d27743b907c658c5c2": "[ru]授权给",
  "97ec46414198c3c4b9f6d062b871b86d": "[ru]分工授权",
  "1fbfa0377935aeb6e080fc086de487a4": "[ru]原外检经理ID",
  "adfd0ebf6d42cbc68888b54e03015c96": "[ru]新外检经理ID",
  "6b3be81ba3c97c45125310427651a8d9": "[ru]新外检经理",
  "f71c65ffefc038f3596c77660f91c4ae": "[ru]工厂小微不能为空！",
  "54c72dc151fc92da4fd6fb5bc3364d46": "[ru]原外检经理不能为空！",
  "54b9106232258372b99ac1ebe5816e57": "[ru]授权给不能为空！",
  "3e2805c8654b167adb80ea1413c728aa": "[ru]（请先至管理平台-按供应商/按类别中维护外检经理）",
  "0cc05f4268b0fc5da732e98536e26ed6": "[ru]从",
  "0397c6c7a3cd799d48cc920c18308e41": "[ru]开始时间不能为空！",
  "90fae33bc2a5ad5e69834fcb7c75adfa": "[ru]请选择开始时间",
  "e0f708cb6dffe1f1b3262351bb916c88": "[ru]结束时间不能为空！",
  "69b76a1d55487d30921f76f8e8cc1a96": "[ru]请选择结束时间",
  "efd75526ea399ceea7c00e599af7f94a": "[ru]授权范围不能为空！",
  "4ea9bfb770e5e7e1de0533b273c686fb": "[ru]查询中...",
  "1b06b20df111c6629c4e9f5d749b3f46": "[ru]授权范围查询失败",
  "9402e822f4e4f642c6fb22098a0a5b8d": "[ru]结束时间不能小于开始时间",
  "3a382c433bc5821a15b5161b39f9dfa9": "[ru]原外检经理、新外检经理查询失败",
  "d377ba3eb14d19e9fb78d771d3f9820d": "[ru]原外检负责人",
  "7e2a0bb2c4567be8e3f72a70f1916923": "[ru]分工授权信息",
  "a16ca5264188c65d0f10428b776e3f15": "[ru]原外检负责人ID",
  "27b64bf674845f69e20d2e94ec3d341e": "[ru]新外检负责人ID",
  "778db3dc40b47a46706cb389bef4c9c7": "[ru]新外检负责人",
  "a345d3f0dad015e5d30c1d8fa58f2f96": "[ru]原外检负责人不能为空！",
  "b2a9c46f68098040b166a8886c002b5f": "[ru]原外检负责人查询失败",
  "0df6f3fb92a879a0e6813210f16829c5": "[ru]新外检负责人查询失败",
  "7f2ab1d4e43a8a1aea8801d37f6e75f1": "[ru]结束日期不能小于开始日期",
  "a6177689fb5c0108faeb8f0b1e1422e9": "[ru]原外检负责人、新外检负责人查询失败",
  "a30182e8659c948ff0dd247dd1442aa4": "[ru]按类别",
  "fbd002bf860207bbb029f91b826f99b3": "[ru]外检员员工号",
  "8a219098e1d95341a5e217c923d94ad5": "[ru]外检员姓名",
  "c51dd96cd10cbd620bbe84075dba7ff2": "[ru]外检员不能为空或不存在！",
  "12d6fae8ad47748e5e21431311469806": "[ru]暂无外检人员",
  "e7bb03fc6296dd3f3e5e3ce807b20d0f": "[ru]物料大类与外检员关系列表导出中...",
  "270315eb8b9dff8a3b702c048c02e378": "[ru]检验经理不能为空或不存在！",
  "9ffdabd6bae86fc308ef0f10374fdf2b": "[ru]暂无检验经理",
  "dbda55b7ac682e19d46d7b9fdbbce68d": "[ru]按类别分工（自制件）导出中...",
  "fae6a1ed831dd269cdc1a4f1088d7231": "[ru]SQE分工",
  "d94e079cff4405d59277f29011806700": "[ru]SQE分工维护",
  "72c649e4bea93bc758114c4349831d1e": "[ru]SQE经理不能为空！",
  "84e56f1d2f8a60113892baf6f0a7e771": "[ru]SQE供应商分工",
  "3fc94a8a9eb7c7c36415b70475d6b685": "[ru]按供应商检验分工维护",
  "d3b0da7a2e01f22fbe20a68749ca956b": "[ru]供应商代码不能为空！",
  "88b12b9080599ada94cf7a18138422e2": "[ru]供应商名称不能为空！",
  "ef982891675bac52267708d9ef300a1f": "[ru]按供应商分工",
  "867855715352d91c96f94575fb4c86e9": "[ru]外检经理不能为空或不存在！",
  "38d297632d31e0b298bb08997c954559": "[ru]暂无外检经理",
  "7b95e50f98050c6cfee4c7b570dccea1": "[ru]外检员分工维护模板.xls",
  "86144f31029ac9fcab2bd36938b768ba": "[ru]请确认是否通过？",
  "261c19d01c2fb9acf953f3d53f42cef2": "[ru]请确认是否驳回？",
  "9d98c8524e1a5638c9bedd0fb5c22fde": "[ru]获取不良品分析数据异常，请重试",
  "d9c8ae7c4e67140d3921659fa8664592": "[ru]生态圈",
  "84f0188b5bf14599645d63a4d41659f6": "[ru]注：①生态圈唯一不能重复，一旦新增不可修改，请确认后操作②已绑定了物料或物料组的生态圈不能删除，请解除绑定后操作",
  "2d425fcc95e35ab7a4621b48d51e2153": "[ru]新增生态圈",
  "e2da6a8a69e2741b5ed0303b3fe16603": "[ru]唯一，不允许重复，一旦新增不可修改",
  "0bd446f880686560b81fb4d55403d4bf": "[ru]生态圈不能为空",
  "521fd3bfb389988d5d14aed83c2346dd": "[ru]请选择一条生态圈数据!",
  "f5c2a2b2f0b266e0e29c778b36dd56a8": "[ru]生态圈重复",
  "1b8114b192f51bfb38b5ed930e76dfad": "[ru]生态圈导出中...",
  "1e0084fe56c85ad7631b9a5fd123f098": "[ru]分析状态",
  "a12d192d76ca5fa6c2cbea15ebb61421": "[ru]待分析",
  "93a1037bebc7d86c5ca21ab90f39819f": "[ru]待SQE审核",
  "46953860612794b3c7857bdf9b7f7f43": "[ru]SQE审核通过",
  "b60aa3296e21bd50c64dba132cfc673c": "[ru]SQE审核驳回",
  "7667fc7a32fd671e9fee3244e0a21aff": "[ru]分工状态",
  "f0bd749fea7c163efe458ba7d593985b": "[ru]待SQE校对",
  "1b613c6a1df2e67801fd2b0eb02d9fb3": "[ru]SQE已校核",
  "36b36c83e6158cb5a9f1050b8361c85d": "[ru]每月第5个工作日，绩效锁定上月数据，第5个工作日之后分析的数据不再计入绩效评价",
  "3c092f8c2f02bb3868b167e04275403f": "[ru]SQE节点",
  "cd7b92d14b0791a00d0051332150abc8": "[ru]分析应完成时间",
  "0097d68feb35658b55feafbc17ae274b": "[ru]分析实际完成",
  "562b263d1902ecb01ae030b1c2cf1260": "[ru]是否拖期分析",
  "104254c1b29bd1eedd493570dd7d5d9f": "[ru]不良分析结果",
  "020ae67061284fe42a87f44b88725888": "[ru]缺陷照片",
  "7e991e3e14d04ed7893f3ea272a31fe6": "[ru]责任节点",
  "e6135ccba176bc6ea0c470f6824d5df1": "[ru]改善状态",
  "ab290155aa57a03a73ae84d8a2d2808f": "[ru]SQE审核结论",
  "edf071de0407fedbfe7bc32a236ccb84": "[ru]SQE审核时间",
  "7b9fa22a7fb8ed240412c78df089ed1b": "[ru]借用分析机编",
  "111252282100453600897e759fafef5a": "[ru]分析历史",
  "6469f329e15249b74f34925bdffa9f66": "[ru]生态圈校核",
  "7c0ec9a49f5b9ba89d2cb5c3918adc2f": "[ru]1.生态圈不存在的请先至“SQE物料-生态圈\"维护",
  "97556bc900da89bbd7fd6437f69ee40b": "[ru]2.新SQE经理不存在的请先至”SQE分工“中维护",
  "ece082fde04d32bcfc35dfc2285b8c36": "[ru]3.校核后会同步更新所有历史数据及物料-生态圈基础数据对照表，请核实后再提交",
  "8d0187d7274b1aa4238d11e03e092e27": "[ru]SQE节点不能为空",
  "36fdca32052de9888a4ca579d92250ba": "[ru]原SQE经理",
  "919ea280731b17a1e17c19e7c5823fbd": "[ru]新SQE经理",
  "9f479d303069e28a2111dcb6624334f8": "[ru]新SQE经理不能为空",
  "5a8996ef718747c32b9756435c81d293": "[ru]差异化供应商清单",
  "58be829254957290f4951dde031ff929": "[ru]计划分析时间",
  "97ccbb8d4088f4726ea4ed44e9558f49": "[ru]实际分析时间",
  "8e5101f96c23b1ed611d04c600ab0105": "[ru]缺陷责任节点",
  "1fd0d0d597228a279fef5997bbe78449": "[ru]供应商暂存",
  "f0b60bbac29555e46c0ad6c6452d13ba": "[ru]大产业线查询失败",
  "4f74e82381d5b1640b33381ac179034b": "[ru]请选择一条数据进行生态圈校核！",
  "4e7b9b18c4c49fb2775792e862f75d57": "[ru]请选择分工状态为\"待SQE校对\"的数据进行生态圈校核！",
  "ef953e723907e13aca9b5878dd76a7c2": "[ru]请选择一条数据进行分析审核！",
  "cd6a5cf43d257e9fb2df3bcb4e4e23d7": "[ru]请选择分析状态为\"待SQE审核\"的数据进行分析审核！",
  "ad008e486cad1e5c9fa5fac1cd3a9e24": "[ru]请至少选择一条要删除的项",
  "1eda0e3b6ad3bbbb37e2168695219067": "[ru]分析审核",
  "8f5054f4e6ab0da1b77bdd85a15b15cb": "[ru]差异化供应商",
  "d10a947c549d26f9b536eb41c80023b9": "[ru]市场不良缺陷类别",
  "3bc7734e9cc1e30087ab40ab98440408": "[ru]新增市场不良缺陷类别",
  "96f2c99cb5f8bad76973238d90957b12": "[ru]缺陷类别唯一，不允许重复。",
  "49e872d218c711bf175cfe1cbf2c68fb": "[ru]缺陷类别不能为空",
  "e589720158b8eaefe337ae0c673d2d07": "[ru]请选择一条市场不良缺陷类别数据!",
  "0da263f959d39fe7660204c8e194fe99": "[ru]市场不良缺陷类别导出中...",
  "23af2f03ced73acbc823c4546aad4a50": "[ru]大宗-通用",
  "660580db7afde24e3017ac62481cfbd4": "[ru]物料生态圈",
  "f05b2d4270ec2517cf4ca0fcf83b2f43": "[ru]新增物料生态圈",
  "703d32562c4aab5990d14e68902590d3": "[ru]更新物料生态圈",
  "00379ad9aeb46e1e553c8790a200f20c": "[ru]生态圈不存在的请先至“生态圈”页面维护（同一个产业&同一个专用号只能维护一个生态圈）。",
  "f4929beca2581daf7d830d2c6aed1bb7": "[ru]大产业线不能为空",
  "b79ef414b7f4db6c8577489ff27bf8a3": "[ru]物料生态圈导入",
  "eede5d8278229120936e56eb9ccf9045": "[ru]请选择一条物料生态圈数据!",
  "3837f10adeaf2cfe6344067c34c5459e": "[ru]物料生态圈导出中...",
  "cce2326e08880b6ea88985c8254af773": "[ru]物料组生态圈",
  "b1b9836c80da406d529970b32e183071": "[ru]物料组描述",
  "eb9944de8ff1ce766210788b7dd99ace": "[ru]新增物料组生态圈",
  "8397c9e5479b76409653c30c5adb3f3e": "[ru]更新物料组生态圈",
  "a557604958eb105f1c84aef30f7a3f93": "[ru]物料组不能为空",
  "cc710d0f59a5bc61bdeab53ce064a3f7": "[ru]物料组生态圈导入",
  "9a3e2bbeb5539de975b042571c353585": "[ru]请选择一条物料组生态圈数据!",
  "f3af43220480aa23f64f72f486acd719": "[ru]物料组生态圈导出中...",
  "bd536fb3af89b296dc28222b50a0fb76": "[ru]SQE经理分工",
  "fc7dd9cbee30e25b9e6029d5cdea0aa5": "[ru]SQE经理工号",
  "437624263e70e1a27469e86faa60343e": "[ru]新增SQE经理分工",
  "f077a01be6d404ce5e0648052ff4818d": "[ru]更新SQE经理分工",
  "6eb096db8bc6d5e93452481f6d9c37cb": "[ru]SQE经理不存在的请先申请角色“SQE经理”（同一个生态圈&同一个SQE节点只能存在一个SQE经理）。",
  "fe5890adc47ba270f40f0ff682527517": "[ru]SQE经理不能为空",
  "24f46944cff11abaf00ef871012e6bc5": "[ru]请选择一条SQE经理分工数据!",
  "a97f0c72c51c7ca8c08569fb343be4f0": "[ru]请选择一条SQE分工数据!",
  "3f63894a63f85e9bc76f00700ce0306c": "[ru]SQE生态圈导出中...",
  "17d4f56ede5d971b3908ac3d2ed21054": "[ru]工单机编",
  "fb3efdaa003c37ac0646cab99ca2ea26": "[ru]缺陷类别1级",
  "09cc8af64ed2731917a65bff55950d8f": "[ru]缺陷类别2级",
  "2665c19d46d859585811d7a9b7048947": "[ru]是否借用分析",
  "cf3971db1ac3ce6cc1b4c1ceefb2d333": "[ru]次月第5个工作日锁定上个月生态圈数据，不允许更新",
  "cebd71122a9a0fad648b05264ef5f677": "[ru]次月第1-第5个工作日 只有SQE负责人可以更新",
  "722aed885f929d4e91b20b7ad1c516d8": "[ru]次月第1-第5个工作日 只有SQE负责人可以更新生态圈数据",
  "72a8332cc511019ef5781e123774aad1": "[ru]当月数据只要有更新按钮权限即可操作",
  "22b12efe9efda2d370131efafe66b7c7": "[ru]分析历史导出中...",
  "8fa2f33866bc2854a67cc92b348aa340": "[ru]分析历史.xlsx",
  "853c3d40b7c1b6c1daeb1c3afcd17a6e": "[ru]请选择一条数据进行分析！",
  "6ac0333b8751c6acff6069e2bf191451": "[ru]请选择分析状态为暂存、待分析、审核不通过的数据进行分析！",
  "8181786d70b8fa5da4575e2ec62becd7": "[ru]市场不良品导出中...",
  "d264cc7489884f41a9ade2d517d8e633": "[ru]市场不良品.xlsx",
  "f7a153727e85665fe082b62a34c77a1f": "[ru]是否12月内不良",
  "b79302dd8bcee65f2e104c903a3f01e8": "[ru]同料\\同工厂\\同故障，改善前的退机不良件，非12个月内生产的可借用前期",
  "9dfd1938d29d57fd38b6ff28b66f1688": "[ru]年度",
  "2a1ce69739af4f61e4765c926c4bc122": "[ru]分析进度到SQE节点",
  "8b4eab304cfdc2bb6e32f714540a05a4": "[ru]年累计退机量",
  "45e0c690bd56761de120b6969edeae17": "[ru]该年EMR鉴定单据量，无效状态与申诉成功的不计",
  "eea26846fbc039def2c6f31484f85758": "[ru]实分析数",
  "a05de3d4af9c5124937383bb8e408149": "[ru]年累计退机量中分析完成的单据量",
  "2f05caae628f8820658b24fc12332437": "[ru]分析率",
  "0a43bc992d5436e83a0599429af999da": "[ru]年累本年发生不良量",
  "9dff7f7e1448934f47c0ef23b6759b65": "[ru]该年EMR鉴定单据且是否本年字段为是的数据量，无效状态与申诉成功的不计",
  "e142a3d20c0a617947f11fdf5bcc98a8": "[ru]已认责应分析数",
  "9d3e91cf238e2469d3c8cbde4bab5b84": "[ru]年累本年发生量中，已认责的数据量",
  "08105135166f6f2452cd3bbebe4327ff": "[ru]已认责实分析数",
  "1733984ebab9bf665baba47b4ddbe2b2": "[ru]年累本年发生量中，已分析的数据量",
  "951cf15a11869fe099a0474175721eab": "[ru]差异明细",
  "04e07916a9efffa25e019b649d0385b9": "[ru]分析进度到生态圈出中...",
  "068b47115c6b17a05ce70796bab41e0d": "[ru]分析进度到生态圈.xlsx",
  "2f0da6203964dcde2d14f089436bcef1": "[ru]统计维度",
  "a183ab478599ca0af9963e479ef9bd74": "[ru]到圈",
  "990e69c717662722fb8b111f67a9e229": "[ru]到物料",
  "652f8289bcda82f71c267cd7bf24b240": "[ru]分析进度到物料导出中...",
  "469450a40ea6f15d09bdaa9160e85324": "[ru]分析进度到物料.xlsx",
  "67fb0c01996aad4f78e72afa21aee6c3": "[ru]签订状态",
  "9922cfc73a496def77e16c70b221dad7": "[ru]待签订",
  "7618bb607a6aa59e9b427020af667f45": "[ru]已签订",
  "3116b821b9b7b3dc5743c8d048b2c066": "[ru]放弃待审核",
  "f8685b8039e4ee20d144107fdbbb8241": "[ru]已放弃",
  "2cd910ee2d89f790872edde1eadd6277": "[ru]已优化作废",
  "c3d7d98d03ef74edd22fbc72848f3a23": "[ru]目标签订",
  "42cb6a16f276fd9d3ee165e9a3cfa26d": "[ru]签订单号",
  "54daf15f5c072252ea615ae23cb6d0d1": "[ru]目标签订导出中...",
  "2362edd4a72a1ff92a1b1a969cfd5ba5": "[ru]目标签订.xlsx",
  "0c70a7c7f5b39e1841d51264db61d10f": "[ru]请选择一条数据进行目标签订！",
  "8554065734223af80a40d4064a8e5575": "[ru]只能优化本年的目标！",
  "be596196e1e56e8742c25b4386790322": "[ru]只能选择待签订的目标进行目标签订！",
  "bc2013c0fcd036406f59c4920b4cf011": "[ru]生态圈目标",
  "aa84ec947f0a72b161a8d27598eda21e": "[ru]优化",
  "83162eb93ac2eb9dc8ef5f18dbe50628": "[ru]损失目标优化",
  "b05c32a7d1c19cc8112d3ae9e1aefe82": "[ru]损失目标签订",
  "c860dd2df482c75e300282cbde063fb8": "[ru]同期数据以历史月锁数考核数据为准，若上年度未签定目标时，实时计算同期数据",
  "a55a7858f27d0217db05f6de766d0154": "[ru]全年",
  "fccc2b4ac9cd71904395042cd0f3fd92": "[ru]1月",
  "c1d13f1d962efb0dd59f4f1e9f9570c9": "[ru]2月",
  "c4767bc3ad5c6812a8ea302e6126d988": "[ru]3月",
  "3eaf4b307f8f2507e6849f991efe596e": "[ru]4月",
  "0545f138f0f61021efc3d3190d955015": "[ru]5月",
  "f2422a6e4299609a1b1cf3b3fcaf9282": "[ru]6月",
  "464bab7f82a4361e017a73dd6b958916": "[ru]7月",
  "81017142849e31d0ca86c31c6f62a00e": "[ru]8月",
  "4b592d5efd59199a8e6b4ad57ecc84c2": "[ru]9月",
  "f544c3992587891eaefa4dce866bfebd": "[ru]10月",
  "57c4475588f6c2c44d526eb338720c3c": "[ru]11月",
  "c0615eb33be499a472b1b1f1befd1db1": "[ru]12月",
  "4a980200488b121339185ff970d20d87": "[ru]不良量目标优化",
  "efb509d691a823af0f9796a585d21a33": "[ru]不良量目标签订",
  "a754dabb451b1668009037edfa109947": "[ru]改善目标",
  "0c78770ef512ea10e23f94be726e7c11": "[ru]改善金额（万元）",
  "3f3e62729afacaa955a69eb8615465c5": "[ru]底线目标",
  "ee2c1d22266d99192d3912036a146c85": "[ru]底线金额（万元）",
  "e8fb4ee474957b4c13ac146e38bd3c82": "[ru]同期损失（万元）",
  "820abf165feb46635ef787b2ead0b725": "[ru]改善数量",
  "1bfc8e8c4777c05b86a15254af33c859": "[ru]底线数量",
  "6598c547fe31e5f5891d4ea679218444": "[ru]同期数量",
  "a6f3d576496f350177c89486f319d969": "[ru]底线金额不能小于改善金额",
  "15dfe0fe66b3c3f0c13f458d883a963a": "[ru]底线目标不能小于改善目标",
  "e3357544371acd9ae6607a61c15bfbad": "[ru]损失目标-改善目标",
  "d015ea07e78f3fc8dd47923125891058": "[ru]月不能为空",
  "c4ac56d43b7a3256823813e150a7a2e3": "[ru]损失目标-改善金额全年不能为空",
  "285ac602a271d85486d6bf10f05caa1d": "[ru]损失目标-底线目标",
  "45228306b1bb14c58dd67f0f4011e916": "[ru]损失目标-底线金额全年不能为空",
  "0197977e8dc077cdf5b69034dd248416": "[ru]不良量目标-改善目标",
  "f6393441791f6d7a666e00ee69ee4e4e": "[ru]不良量目标-改善目标全年不能为空",
  "79d40361a0b01fc125f4fe7cd3541f71": "[ru]不良量目标-底线目标",
  "409483b06033e818116408f81d6fee4e": "[ru]不良量目标-底线目标全年不能为空",
  "1253c30c3f9dc79e8a0d378c82e502b7": "[ru]SQE节点：",
  "5419bedbbe015e4bcfb4d002cd6e30eb": "[ru]生态圈：",
  "0d69b46438697d065a597136362208cc": "[ru]年度：",
  "97cddb8e241be64dc25fd7588bd33f01": "[ru]发起时间：",
  "f81966c05e27c26bd2484ab49c1345b0": "[ru]签订单号：",
  "1b04338f38832c8fc906eca58cee865f": "[ru]SEQ审核",
  "4cfbf660bad32ab126f722e77148ca6c": "[ru]以上质量损失，专项立项研究底线方案，并配合海尔端进行降损分析，底线为达成年度降损目标，确保项目保质保量按期完成。如出现项目拖期或未完成，我司承担因此而导致的所有损失，并愿意接受由此引起的海尔对我司的策略。",
  "dfd812d92cd2d9d939e0eab104784f31": "[ru]签订意见",
  "5ac2011aeb75fda311b7c73dcf2f78d4": "[ru]放弃",
  "46586accdc521c9945f86bf1f753bf5b": "[ru]原因说明",
  "ed46275c53ea4897d4a6f89e3d6706e1": "[ru]签核资料",
  "7b5de7bdb259d9d61753193de5049dc6": "[ru]签订",
  "1302e200a2eb5c67ae22c1b511708a7c": "[ru]签订意见不能为空！",
  "84dfdc6be1127b0fc6c5fb19c785611a": "[ru]原因说明不能为空！",
  "7cef8706dc1bce8a4aa8cb8599baf624": "[ru]确认时间不能为空！",
  "d267c2e1e843a60995f11d0083f3a79f": "[ru]签核资料不能为空！",
  "fc74015d767b3889e68982b809980a55": "[ru]签订成功",
  "3d3f1bb6ecc10a27e607e6f4767819a2": "[ru]签订查看",
  "546737fbb4766ed23f23f4febc830117": "[ru]不良品分析",
  "9318d407c5835267826c7f97ac7325f9": "[ru]供货日期",
  "f929d07215c101c695da559088e73c15": "[ru]鉴定完成时间",
  "eba745696b4f04640b0b00ebd4d7309f": "[ru]供应商分析",
  "2435184086774cd5ceea54a30803c1ff": "[ru]借用机编",
  "ee48b55d9881b82024a9a41f67e9d854": "[ru]不良分析结果不能为空",
  "bbf0cfc7a049be0479d4dc439bf3c399": "[ru]缺陷类别1级不能为空",
  "dbbb5ebbcae04dbb570e0c6d472b2797": "[ru]缺陷类别2级不能为空",
  "d9de5a8ab5d67be36522a0303d8f4dfa": "[ru]供应商责任节点",
  "58ab17a28ca510581732f19dfcab9716": "[ru]供应商责任节点不能为空",
  "115bd62a3f084e5c0c300a4a1a377c70": "[ru]分析实际完成时间",
  "9b8489e92249308367b64451ddbdeaaa": "[ru]改善状态不能为空",
  "4081583fe18e92e871c989b9d1854e57": "[ru]改善前",
  "54d292c17cfabdbea14792f8cfdae207": "[ru]改善后",
  "6b415a2f731a9c3ec206f451542e62c6": "[ru]缺陷照片不能为空",
  "8d0cfb582a50e3872522d075934cff44": "[ru]添加文件",
  "865de93e8ab606461412ce83276fe180": "[ru]补充说明",
  "1482318b392834e712379d6ce33988b8": "[ru]*单个文件不大于30M，至少上传1张*",
  "7d3bf4bdd792ca6fb0ef506c06f6214f": "[ru]*不合格部件整体照片*",
  "6e6285bc701a98469a7b99c9dbd7e994": "[ru]*支持类型jpg、jpeg、png、JPG、JPEG、PNG*",
  "20c79009e600b8dab6aedf6e537e789c": "[ru]*铭牌（包含V码\\料号\\生产批次号）*",
  "1f73e98b0843f3fab480ecd8414df313": "[ru]*缺陷或失效缺陷图*",
  "c887f3e1c6cddb36ddac05c8371ad2c7": "[ru]*照片增加时间、地址水印*",
  "6f5d930c0bca7171e00a90dfffb60999": "[ru]不良分析借用",
  "ae6800a61ec1410f8bdc8720bdf6590c": "[ru]查询机编不符合借用规则，有字段展示，当年机编不可借用",
  "426ccea7fe7f595f80740f71042b330f": "[ru]请选择一条数据进行借用！",
  "8aeefba376ab3d2fdbef6567bc8df98c": "[ru]请勿重复选择！",
  "bdebd0fea7bddf84223d703a54b502e3": "[ru]该不良品分析已经审核通过，请查看详情",
  "0acb4852d898f552e7b46b2cc1305645": "[ru]请输入通知公告标题进行搜索",
  "e5f71fc31e7246dd6ccc5539570471b0": "[ru]搜索",
  "5ad2f695c4da24b49ba8a77a2bb01c5c": "[ru]可见类型",
  "0d7942407f51e1b3cb2e995a80ca4098": "[ru]全部可见",
  "b15edc81a94344441dd027c72358d605": "[ru]海尔可见",
  "7acc1680a5f6ee408eae017701ce7ccf": "[ru]供应商可见",
  "5fb17cfefdae401de0acbc52bf309042": "[ru]上传日期",
  "96641a78cfd9f9f8ba68f0524347b186": "[ru]请输入标题",
  "1be9b0e068cdce00eb5f9c9634268cc9": "[ru]请选择通知类别",
  "94499db3a370bf600e4faead59ae31fe": "[ru]请选择可见类型",
  "61b7c646a1d32f102fe2a4993eda92e9": "[ru]请选择上传日期",
  "1cf116a7aa9fef670f590827de46ea19": "[ru]*只允许上传PDF、pdf格式文件，最多允许上传一个文件且单个文件不大于30M*",
  "5e562fdf4e5bfe260750236e2eb91a25": "[ru]请输入标题！",
  "e3f7a81e5a34697bc3b735cf11893b3d": "[ru]请选择可见类型！",
  "072a4558c3d8d9d8ee8473f907458df4": "[ru]请选择上传日期！",
  "b7e1c30cb0484f828b0d3fbaa254add2": "[ru]请上传附件！",
  "f743e1e660b5174e50f127e8ac091fcd": "[ru]保存中，请稍后...",
  "1d9b45c60ba4b62726c9ea9e54b704a0": "[ru]修改成功！",
  "431abbd42aea98c96c1ef1db08b34e43": "[ru]新增成功！",
  "1dd67f0d9e6a621b76c7c330cf408268": "[ru]未获得",
  "4d7b168a15760baadbbb7385577f6f83": "[ru]用户评价绩效",
  "38c1268c392f708ac69fd07ddf15d01f": "[ru]成绩",
  "c24e2094b785d8dba169c69e7ff30aad": "[ru]问题数",
  "be8db9d1b4bc1fd6a11642fa807b47c2": "[ru]方案数",
  "4912619794a7756028574550d49588cd": "[ru]闭环率",
  "590668240abd2fbb992d3b4f7f31faf9": "[ru]开放抢单明细",
  "278a9bf11803446e67d77cee0e37e30d": "[ru]现场（当月）",
  "86e08f542b15b006e86798c980ba947f": "[ru]是否叫停",
  "21a0a73b65c35feae1888ddd81780e67": "[ru]市场3个月（当月）",
  "e99ea9e197e1f12daad1aaba2827bce7": "[ru]市场6个月（当月）",
  "6a0685793fe4cec749f9e3d1732a8783": "[ru]市场12个月（当月）",
  "ea49fbde861e2b00e0e3c44da02df907": "[ru]切换旧版",
  "9bddda2d3dcbc1842f8c4daf4eb1f038": "[ru]我的质量绩效",
  "b8c2123cf539fc379b28f02e782aa3f8": "[ru]分数：",
  "5bcbdcdd47bddaaae5f8d5a85bcdac88": "[ru]模块排名：",
  "39f3471d6d7490e532451735a007c7b9": "[ru]当日",
  "8d9f49f7ca71bebe79884bff4c1d1564": "[ru]月累计",
  "dd854a16dcdf535f42974dec3143db43": "[ru]年累计",
  "ff7504daf4d477d2591773d973f9a668": "[ru]现场损失",
  "7e887ecd01903e9ab4e5c619926cdc3a": "[ru]市场损失",
  "f9f974a713225144492248823508721b": "[ru]质量绩效走势",
  "ab6b67f18fb977d99b2e3391ef90d8fd": "[ru]产品线质量绩效",
  "b6495723c23af95d5cc5fc85992a2825": "[ru]质量得分",
  "d66346bdc412a2553258570343b85bac": "[ru]现场不良率",
  "af0a925beedce958ffd1233709c215f4": "[ru]3个月市场不良率",
  "5f8d7ec6b9ef1a06d25e9ce515bde33a": "[ru]6个月市场不良率",
  "f7b259efcb0d775bf03ac957c60218a3": "[ru]12个月不良率",
  "10c590a930ccf384da603e2325d1ef12": "[ru]入厂不合格扣分",
  "b07a0155d7a2a0c68c6a24f986164c2a": "[ru]四停扣分",
  "84f28fe48375d53f60e0fd090514f65b": "[ru]重大质量扣分",
  "7668b49ee48f29cd5ec5d45d0ff51a32": "[ru]我的执行策略",
  "a5a6f32c8950b39e8db12ac2a9245f9b": "[ru]产品线-质量不合格，需要执行总经理检讨策略",
  "59596cf5f1da8a37c2870aa9c7cfc3d4": "[ru]产品线-质量不合格，停新品3个月",
  "396cd17968db99012e4b3e306b3f0c4d": "[ru]绩效检讨",
  "f1f46525bece70cb3f788cae203c99a2": "[ru]质量绩效不达标，执行总经理检讨策略",
  "5f3ca6758c15ef228ff66160911d8066": "[ru]新品",
  "a26b5f0cbe0ad2f81e3d098c46302f9a": "[ru]①参与联合研发资格",
  "addfd08e15077a55aa459049ea84a6b3": "[ru]②有资源超市方案发布资质",
  "e7b5c9b72bf29e6ca0217feec3f42676": "[ru]③参与新品交互",
  "895558d952f104b8af7cc7fa9dc20f68": "[ru]受限",
  "4c117f2037181c74559db1829298e041": "[ru]订单",
  "83a4d6f70bb36017c0e124f02d7c3137": "[ru]①增加订单配额资质",
  "a569f8867cac701f530c3c4705a3ed91": "[ru]②参与大资源置换资质",
  "692025eea9335009f3679eb5c52438b7": "[ru]③停订单",
  "8e1a4fc6d6362b0e5921df948355ca7a": "[ru]未停",
  "5f3327477d147e70a6aa8eee8fc9ae2b": "[ru]已停",
  "70073813fad2e6cca25bdddc7f0c0d7f": "[ru]质量排名",
  "e8162294c2299c48a18424268bf496c9": "[ru]专用号统计",
  "a53a9389ecec772dc91c1de93b1d8b82": "[ru]专用号数量",
  "8e9dbc8a072321ef32c04914d69ae3fc": "[ru]达标数量",
  "6d4036b80c89607a12928f1eba735c41": "[ru]预警数量",
  "a00be2a1b06b15c78fc83ba6c8960476": "[ru]现场不良超标数量",
  "f5d501327c171a0a2d846c380eabb0a6": "[ru]市场不良超标数量",
  "2b9112c58d2dab55271368749fda8ad3": "[ru]叫停数量",
  "1927dac8abfef45780832d3409186a7e": "[ru]跳闸专用号统计",
  "3023c444773e59d5a95ee2395109d54f": "[ru]应交互",
  "2604650cae56276ebfcd86b49a8f5b66": "[ru]已交互",
  "f67f7d07d1512c4d64a97714706e1f9e": "[ru]模块不良",
  "0d80dc8935a9ed4221a6c2b06d1b460e": "[ru]非模块不良",
  "a3f5de49efbf59bc14f0035c37706f82": "[ru]交互预警",
  "dea0bb058b759a0bc368a5aa39587dd6": "[ru]策略执行",
  "53447544e9833417bb4f2430bebe8f93": "[ru]问题闭环跟踪",
  "db3321acafe6c215db4376e862f34834": "[ru]同步数据耗时较长，请耐心等待",
  "0c5e8bc6d39b08c31c2f99e6dee4a161": "[ru]同步数据",
  "80e85fe48792c56e3ffeeabbc14c40ea": "[ru]改善效果评价",
  "01973e0b565dddef1320c2e1527a91ff": "[ru]问题记录日期",
  "5dc99f6efe53adda80974655b26b8df8": "[ru]问题",
  "26c32b4018b5dd8da4a5f6edcbdcd79e": "[ru]改善方案",
  "07bae3fd1bd80c600cba12a1f74b12dd": "[ru]预计到位日期",
  "92d17650fe8a9d55e46155f5c186921d": "[ru]实际到位日期",
  "212f10ceb7a07306a09effa2223c1abc": "[ru]效果评价",
  "f4d215a696107d2870b69a53db88d504": "[ru]未改善问题",
  "d5f6c0d7a162f2a80f6bc869e346d64c": "[ru]分析方案",
  "7d7aab067adddc86eccd5514c92debcd": "[ru]改善措施提交",
  "702e7698ca9484e82406954d93829132": "[ru]改善中",
  "b82fef11048e2084d60cc4a5c17479c3": "[ru]拖期未改善",
  "56d13c9bc5aa3a2cdc814f062e9db601": "[ru]不良率判断",
  "f69a6d4f90ebba688262bef0c8203920": "[ru]市场3个月",
  "a54a7311f43580647e349a0c3bdd339b": "[ru]市场6个月",
  "bdc5aa5443d3244f514db4ab683a4210": "[ru]市场12个月",
  "c22f83d06e99f847043c118c9559fffd": "[ru]用户抱怨即时交互",
  "8c1993121379da1f4aa496e62cc19049": "[ru]信息描述",
  "bb549a34eacdc7e40a6411422ce82973": "[ru]信息来源：",
  "234138d3dc0714a3467a430bf2ac92f1": "[ru]工单号：",
  "3c5625a0344f3ed7b29ae7967d55aca1": "[ru]报表日期：",
  "6500565a54f402029dc65535fc87e1dc": "[ru]产品大类：",
  "ed6966a7afa83ed0ac72d5a42f95ec96": "[ru]制造中心：",
  "601f68f5515c15a2b444122a51a983f1": "[ru]产品编号：",
  "7a43ed283269ac2f350275a222d81faf": "[ru]生产日期：",
  "e92301c9df32a060914d9b4dc1c43284": "[ru]故障信息",
  "d81ffcad3d9585a8349075e3d6ee87c0": "[ru]用户抱怨：",
  "2c163fc6e9f68853992e6f5541225320": "[ru]故障件专用号：",
  "755e939d6806c1a20c84ad28c5fc1354": "[ru]故障名称：",
  "7df2998956788726f20cc7e0fdbab4e2": "[ru]用户：",
  "afb58de2a17924d231e8ca79db02edac": "[ru]网点：",
  "f7044a4c38fd50e967a9a21176a447fa": "[ru]区号：",
  "7d33dc005cbb20973ca97324aacea453": "[ru]联系电话：",
  "f0d58bfaf3cf5aeb894b315d8f245a0c": "[ru]用户交互",
  "0e33ba5127d4b498fc6ca3602490d517": "[ru]交互要求：",
  "728f6778e810b981f64647c7849e3672": "[ru]1、所有并联的市场信息需在接收后的2日内交互完成，请在规定时间内通过电话联系或上门处理等方式进行交互处理；",
  "b5b20d28c9b825b5045cc9b39880a26d": "[ru]2、交互结果请如实填写并提交，相关交互资料可上传附件。",
  "04e99fce60d110f3f9f503080503275c": "[ru]考核策略：",
  "f14fec3548ebe94630abf18422018806": "[ru]供应商市场信息交互率纳入海达源用户评价质量绩效考核，交互率低于60%否决质量绩效中的”并联交互”项目得分。",
  "e2edde5adbdf33f6dce59a299cbf5fad": "[ru]展开",
  "6f2709c6291cf6480bc973b2fbab5ee6": "[ru]缺陷名称",
  "7706b37df0506a197fdcc0eaa8991785": "[ru]不良现象",
  "f3e04893902761f7fa7ff4b386442223": "[ru]初步分析原因",
  "e2befc425cda043455ae50cb35c79de1": "[ru]改进状态",
  "9f83b2d486849bed5055413b4bb0f3e9": "[ru]已改进",
  "670b52e30cc3679585c3a454d1687e5b": "[ru]未改进",
  "bab38b68c5fd1c85cdffe73a6e07c47b": "[ru]责任分析",
  "326287ec677b90bd44c82931ca0158fa": "[ru]没有V码照片",
  "2180d1af0fb304a5d4d3544f8621adb3": "[ru]没有不良现象照片",
  "b95e1c7f8cd52498d1cb51c244ccdb59": "[ru]V码照片不清晰，无法识别",
  "3bdd5eb12d5ddf0f1be75569d3399872": "[ru]不良现象照片不清晰，无法识别",
  "fd5720d49f6e3f463d9a90f72c860af9": "[ru]V码错误",
  "e6486d819ebc3251f7c14ea7c8268cb1": "[ru]图片清晰，信息完整，但不能准确判责",
  "15e819888e6c20b87fec24eeb48fee54": "[ru]图片清晰，信息完整，且能准确判责",
  "df6645aa395505251665eabefcb84aa8": "[ru]备注详情",
  "4bd2dde739894e53ce6d7941febe17a1": "[ru]交互附件",
  "a563ec4069f6411dafe2af7711e6d5e4": "[ru]交互时间",
  "b69a854092c80cf2d56bccc679afc909": "[ru]信息缺失",
  "e33ee2d5e02c17f27922dbdbd38e60e9": "[ru]信息不清晰",
  "ae9fed9fcf1d522dccec91224e68ae55": "[ru]信息错误",
  "135d24ab28a52bd1f98babe43a6e4922": "[ru]不能准确判责",
  "d81e1c46f02e3aefb91d0ae3d384f59a": "[ru]准确判责非供应商责任",
  "51bc73884a48faf43d6c8afb5d4b2932": "[ru]缺陷名称不能为空！",
  "86040805bed1da531854eb6411db0852": "[ru]请选择缺陷名称!",
  "4aa5493ffd3780da536470d8b676a147": "[ru]请填写不良现象!",
  "32d4976a8b9b7b8aebb2904a2ec1c94b": "[ru]请填写不良原因!",
  "b57dac19b94415af9d3bee1aaf1cad09": "[ru]请选择改进状态!",
  "518d1a796189fa552f2162ec712302be": "[ru]请选择非模块不良类型!",
  "c380d3ddac3650cdccdf7019d457682f": "[ru]请选择非模块不良类型的子类型!",
  "d043d51739196e511703cb499594804d": "[ru]请选择是否为模块不良!",
  "beb78b132a28c880f959eba2b94ef5e4": "[ru]模块商：",
  "ace5195cd1a188320f504df8b7e0056f": "[ru]单位：日",
  "bf66939262f6f1c16b9c2a3b6ba5dfd0": "[ru]现场不良量",
  "d6e624b488ee0bca49b08e8649ff5bee": "[ru]市场不良量",
  "e141b07b4aa6311b8dbb2b2ffbc03dda": "[ru]用户差评",
  "c7f0d5d1755a82916ddbbc52cfd4918e": "[ru]导出数据",
  "1fd02a90c38333badc226309fea6fecb": "[ru]用户",
  "d5c683084117895d15e463f60b3540bf": "[ru]故障模块",
  "10d3b8f8e260d4e9cd4fe33169dfae62": "[ru]用户抱怨现象",
  "e87d947355e343245273e6cecce2adaf": "[ru]拖期",
  "e9a8d7dc794a8ea0f27c13b47316ce83": "[ru]并联交互",
  "5993e2fa495bbfe164008c9dd3203f16": "[ru]所有来源",
  "ce6dffd32bfbab7acc43b848666cd5e7": "[ru]市场并联交互",
  "53bf5360c96fa312a0da834237db369a": "[ru]重大质量问题",
  "e882d4b6032134d29a0ffe19495e0dfc": "[ru]暂未开放现场不良交互功能!",
  "69351cdb904adcdc67ce2e68aedbbbf5": "[ru]暂未开放重大质量问题交互功能!",
  "a80f42999229739c9eb9725ffa9adbfd": "[ru]列表导出中...",
  "71cca85b2825e67a961ff16bdcd5e329": "[ru]列表.xlsx",
  "0b62215958f4589082329de3dc41f604": "[ru]VMI检验卡奥斯",
  "7c2166598a1cd2603424e3e30e0a704a": "[ru]VMI仓库管理（外检）",
  "54f7ca66d7b8d52bbfde8c4bc1704535": "[ru]外检经理工号",
  "7993391df2492f42854457ce006d49a0": "[ru]新增仓库和外检的对应关系",
  "9e2000aed100c6aac9f614509e605ddf": "[ru]同一物料大类同一仓库只能配置一个外检经理",
  "4945387c457f9b41f978152a262f9b02": "[ru]带不出外检经理？请在HPC系统申请此事业部的外检经理角色权限",
  "6b2269464b09dd5876eea0cc329895df": "[ru]新增中...",
  "a1b405f801be1f10bec6939e3805630e": "[ru]新增（更新）成功",
  "5b173bbab61d42407f15de45e680bdbb": "[ru]不合格批次数",
  "c8cef6cdef723c4ad02f073b97256f20": "[ru]停检批次数",
  "4bce9ce9b6e2f34baadc06e3b759a274": "[ru]质量损失额(索赔)",
  "d7a337917a4a4c2597dcfbcdcd54b96e": "[ru]新品质量-模板",
  "2e5e238020e90cdf7ad33788f8fd9d79": "[ru]待分析驳回",
  "8ee2edef2c6b22d697fbb6846719c259": "[ru]暂无待办信息",
  "9492d64d0d71c8add4b96b11776270e8": "[ru]{c}条",
  "330a379d158db9252e21d1a6207aa296": "[ru]关联单号",
  "eb7c7c48735badff15afb2f819dc06eb": "[ru]举证资料上传中，请稍后上传成功后再进行提交!",
};